(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1435"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1435"] = parcelRequire;
}
parcelRequire.register("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $990dfc566758140d$export$f7ad0328861e2f03; }, function (v) { return $990dfc566758140d$export$f7ad0328861e2f03 = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = {};
function $990dfc566758140d$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$990dfc566758140d$var$mapping[keys[i]] = pairs[keys[i]];
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRequire.register("5x98t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $40771efc70869bb1$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $94VKa = parcelRequire("94VKa");

var $1Q2lG = parcelRequire("1Q2lG");

var $88X7R = parcelRequire("88X7R");

var $g6WWX = parcelRequire("g6WWX");

var $8Wsdf = parcelRequire("8Wsdf");

var $4jZAy = parcelRequire("4jZAy");

var $3jkEb = parcelRequire("3jkEb");

var $4ANt9 = parcelRequire("4ANt9");
var $40771efc70869bb1$export$2e2bcd8739ae039 = {
    __name: "App",
    setup (__props, { expose: __expose }) {
        __expose();
        const rubberTypes = (0, $94VKa.ref)(window.webfx.colorMixer.addonData.rubber_types);
        const activeRubberType = (0, $94VKa.ref)("EPDM") // todo -- make dynamic through WP admin
        ;
        const scrollToMixer = (0, $94VKa.ref)(0) // todo -- really hacky, gotta be better way
        ;
        // let's get all data from global var here (versus in individual components)
        const disclaimerText = (0, $94VKa.ref)(window.webfx.colorMixer.addonData.text?.disclaimer_your_mix ?? "");
        const learnMoreLink = (0, $94VKa.ref)(window.webfx.colorMixer.addonData.links?.learn_more ?? {});
        const siteLogoUrl = (0, $94VKa.ref)(window.webfx.colorMixer.addonData.images?.site_logo ?? "");
        const pdfTextDisclaimer = (0, $94VKa.ref)(window.webfx.colorMixer.addonData.text?.pdf_disclaimer ?? "");
        const pdfTextContact = (0, $94VKa.ref)(window.webfx.colorMixer.addonData.text?.pdf_contact_info ?? "");
        const flyoutInstructions = (0, $94VKa.ref)(window.webfx.colorMixer.addonData.text?.flyout_instructions ?? "");
        /**
 * Parse color data
 *
 * @return {obj}
 */ // eslint-disable-next-line arrow-body-style
        const getAllColorData = (colorData)=>{
            return colorData.map((color)=>{
                color.percentage = 0;
                color.placementIndex = null;
                return color;
            });
        };
        const allColorData = (0, $94VKa.ref)(getAllColorData(window.webfx.colorMixer.addonData.colors));
        /**
 * Get colors that are assigned to active rubber type
 *
 * @return {array}
 */ // eslint-disable-next-line arrow-body-style
        const getColorsByActiveRubberType = ()=>{
            return allColorData.value.filter((color)=>color.rubber_types.includes(activeRubberType.value));
        };
        const activeColors = (0, $94VKa.ref)(getColorsByActiveRubberType());
        /**
 * Get currently selected colors
 *
 * @param {boolean} resetPlacementIndexes
 * @param {boolean} resetPercentages
 * @return {void}
 */ const getSelectedColors = ()=>{
            // eslint-disable-next-line arrow-body-style
            const colors = activeColors.value.filter((color)=>{
                return color.selected && color.rubber_types.includes(activeRubberType.value);
            });
            // sort by index
            colors.sort((a, b)=>a.placementIndex - b.placementIndex);
            return colors;
        };
        /**
 * Process selected colors by equalizing percentages and setting initial placement indices
 *
 * @param {boolean} resetPlacementIndexes
 * @param {boolean} resetPercentages
 * @return {void}
 */ const initializeSelectedColors = ()=>{
            let selectedColors = getSelectedColors();
            let placementIndex = 0;
            // add percentages and indices
            selectedColors = selectedColors.map((color)=>{
                // eslint-disable-next-line no-plusplus
                color.placementIndex = placementIndex++;
                color.percentage = Math.floor(100 / selectedColors.length);
                return color;
            });
            // sort by placement index
            selectedColors.sort((a, b)=>a.placementIndex - b.placementIndex);
            return selectedColors;
        };
        const selectedColors = (0, $94VKa.ref)(initializeSelectedColors());
        /**
 * Update selected colors variable with latest selected color data
 *
 * @return {void}
 */ const updateSelectedColorsData = ()=>{
            selectedColors.value = getSelectedColors();
        };
        /**
 * Add new color to selected colors
 *
 * @param {number} selectedColorId
 * @param {number} percentage
 * @param {number} placementIndex
 *
 * @return {void}
 */ const addSelectedColor = (selectedColorId, percentage = 50, placementIndex = null)=>{
            const match = activeColors.value.find((color)=>selectedColorId === color.id);
            if (!match) return;
            match.selected = true;
            match.percentage = percentage;
            // todo - check if placement ID is already being used
            if (null === placementIndex) placementIndex = selectedColors.value.filter((color)=>color.selected).length;
            match.placementIndex = placementIndex;
        };
        /**
 * Add new color to selected colors
 *
 * @param {number} colorId
 * @return {void}
 */ const deleteSelectedColor = (colorId)=>{
            // update master data
            const match = activeColors.value.find((color)=>colorId === color.id);
            if (match) {
                match.selected = false;
                match.placementIndex = null;
            }
        // todo -- reset placement indexes
        };
        /**
 * Handle user selecting color for new breakout
 *
 * This color will appear at the END of the grid of colors.
 *
 * @param {number} selectedColorId
 * @return {void}
 */ const handleBreakoutSelectColor = (selectedColorId)=>{
            const remainder = 100 - selectedColors.value.reduce((total, color)=>total + color.percentage, 0);
            // if valid remainder exists, use that for the new color
            if (0 < remainder && 100 > remainder && 99 !== remainder && 3 !== selectedColors.value.length) addSelectedColor(selectedColorId, remainder);
            else {
                addSelectedColor(selectedColorId, 0);
                let colors = getSelectedColors();
                colors = colors.map((color)=>{
                    color.percentage = Math.floor(100 / colors.length);
                    return color;
                });
            }
            updateSelectedColorsData();
        };
        /**
 * Handle user updating percentage for selected color
 *
 * @param {number} colorId
 * @param {number} percentage
 *
 * @return {void}
 */ const handleBreakoutUpdatePercentage = (colorId, percentage)=>{
            const match = activeColors.value.find((color)=>color.id === colorId);
            if (match) match.percentage = percentage;
            // if only two active colors, update opposite color to show remainder
            if (2 === getSelectedColors().length) {
                const oppositeColor = selectedColors.value.find((color)=>color.id !== colorId);
                if (oppositeColor) oppositeColor.percentage = 100 - percentage;
            }
        // todo -- need to run updateSelectedColorsData?
        };
        /**
 * Handle user clearing breakout
 *
 * @param {number} colorId
 * @return {void}
 */ const handleBreakoutTrashColor = (colorId)=>{
            const match = activeColors.value.find((color)=>color.id === colorId);
            if (match) {
                match.selected = false;
                match.percentage = 0;
            }
            // remove selected color
            selectedColors.value = selectedColors.value.filter((color)=>color.id !== colorId);
            // try to re-distriubte percentages
            const remainder = 100 - getSelectedColors().reduce((total, color)=>total + color.percentage, 0);
            if (0 < remainder && 100 > remainder) selectedColors.value = selectedColors.value.map((color)=>{
                color.percentage += Math.floor(remainder / selectedColors.value.length);
                return color;
            });
            updateSelectedColorsData();
        };
        /**
 * Handle user equalizing percentages for active breakouts
 *
 * @return {void}
 */ const handleBreakoutsEqualizePercentages = ()=>{
            const totalColors = selectedColors.value.length;
            selectedColors.value = selectedColors.value.map((color)=>{
                color.percentage = Math.floor(100 / totalColors);
                return color;
            });
        // updateSelectedColorsData()
        };
        /**
 * Handle user clicking to view mixer on mobile
 *
 * @return {void}
 */ const handleBreakoutsViewMixer = ()=>{
            scrollToMixer.value += 1;
        };
        /**
 * Handle user selecting different color for (already active breakout)
 *
 * @param {number} newColorId
 * @param {number} placementIndex
 * @param {number} percentage
 * @param {number} oldColorId
 *
 * @return {void}
 */ const handleBreakoutChangeColor = (newColorId, placementIndex, percentage, oldColorId)=>{
            deleteSelectedColor(oldColorId);
            addSelectedColor(newColorId, percentage, placementIndex);
            // will update components
            updateSelectedColorsData();
        };
        /**
 * Handle user selecting rubber type
 *
 * @param {string} rubberType
 * @return {void}
 */ const handleRubberTypeChange = (rubberType)=>{
            activeRubberType.value = rubberType;
            activeColors.value = getColorsByActiveRubberType();
            // do we need to initialize colors for rubber type?
            const totalPercentage = activeColors.value.reduce((total, color)=>total + color.percentage, 0);
            if (0 === totalPercentage) selectedColors.value = initializeSelectedColors();
            // will update components
            updateSelectedColorsData();
        };
        const __returned__ = {
            rubberTypes: rubberTypes,
            activeRubberType: activeRubberType,
            scrollToMixer: scrollToMixer,
            disclaimerText: disclaimerText,
            learnMoreLink: learnMoreLink,
            siteLogoUrl: siteLogoUrl,
            pdfTextDisclaimer: pdfTextDisclaimer,
            pdfTextContact: pdfTextContact,
            flyoutInstructions: flyoutInstructions,
            getAllColorData: getAllColorData,
            allColorData: allColorData,
            getColorsByActiveRubberType: getColorsByActiveRubberType,
            activeColors: activeColors,
            getSelectedColors: getSelectedColors,
            initializeSelectedColors: initializeSelectedColors,
            selectedColors: selectedColors,
            updateSelectedColorsData: updateSelectedColorsData,
            addSelectedColor: addSelectedColor,
            deleteSelectedColor: deleteSelectedColor,
            handleBreakoutSelectColor: handleBreakoutSelectColor,
            handleBreakoutUpdatePercentage: handleBreakoutUpdatePercentage,
            handleBreakoutTrashColor: handleBreakoutTrashColor,
            handleBreakoutsEqualizePercentages: handleBreakoutsEqualizePercentages,
            handleBreakoutsViewMixer: handleBreakoutsViewMixer,
            handleBreakoutChangeColor: handleBreakoutChangeColor,
            handleRubberTypeChange: handleRubberTypeChange,
            ref: $94VKa.ref,
            ColorMixer: $1Q2lG.default,
            AllBreakouts: $88X7R.default,
            BtnGetAQuote: $g6WWX.default,
            BtnDownloadColorMix: $8Wsdf.default,
            SelectRubberType: $4jZAy.default,
            DisclaimerAside: $3jkEb.default,
            LearnMoreLink: $4ANt9.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRequire.register("ldOcC", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("aoXob")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("aoXob")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("aoXob")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("aoXob")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("aoXob")).createElementVNode; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("aoXob")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("aoXob")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("aoXob")).createVNode; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("aoXob")).Fragment; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("aoXob")).initCustomFormatter; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("eGzkv")).normalizeClass; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("aoXob")).onBeforeUnmount; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("aoXob")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("aoXob")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("aoXob")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("aoXob")).openBlock; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("94VKa")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("aoXob")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("aoXob")).renderSlot; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("aoXob")).watch; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("aoXob")).withCtx; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("br4tA")).createApp; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("eGzkv")).toDisplayString; });

var $aoXob = parcelRequire("aoXob");parcelRequire("br4tA");parcelRequire("eGzkv");
function $f731c10fb1d5042a$var$initDev() {
    (0, $aoXob.initCustomFormatter)();
}
const $f731c10fb1d5042a$export$ef7acd7185315e22 = ()=>{};

});
parcelRequire.register("aoXob", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $792a36b8a96c3882$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $792a36b8a96c3882$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $792a36b8a96c3882$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $792a36b8a96c3882$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $792a36b8a96c3882$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "withCtx", function () { return $792a36b8a96c3882$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $792a36b8a96c3882$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $792a36b8a96c3882$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "watchPostEffect", function () { return $792a36b8a96c3882$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watch", function () { return $792a36b8a96c3882$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "useTransitionState", function () { return $792a36b8a96c3882$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $792a36b8a96c3882$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $792a36b8a96c3882$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $792a36b8a96c3882$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $792a36b8a96c3882$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $792a36b8a96c3882$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $792a36b8a96c3882$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $792a36b8a96c3882$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $792a36b8a96c3882$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $792a36b8a96c3882$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $792a36b8a96c3882$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onUnmounted", function () { return $792a36b8a96c3882$export$13348a43ccacfe58; });
$parcel$export(module.exports, "renderList", function () { return $792a36b8a96c3882$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "renderSlot", function () { return $792a36b8a96c3882$export$4abee4c34694ada1; });
$parcel$export(module.exports, "createBlock", function () { return $792a36b8a96c3882$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "computed", function () { return $792a36b8a96c3882$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "createTextVNode", function () { return $792a36b8a96c3882$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $792a36b8a96c3882$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $792a36b8a96c3882$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $792a36b8a96c3882$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $792a36b8a96c3882$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createStaticVNode", function () { return $792a36b8a96c3882$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "createCommentVNode", function () { return $792a36b8a96c3882$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $792a36b8a96c3882$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $792a36b8a96c3882$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $792a36b8a96c3882$export$aed4979be6a60047; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("94VKa")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("94VKa")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("eGzkv")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("eGzkv")).normalizeClass; });

var $94VKa = parcelRequire("94VKa");

var $eGzkv = parcelRequire("eGzkv");
const $792a36b8a96c3882$var$stack = [];
function $792a36b8a96c3882$var$pushWarningContext(vnode) {
    $792a36b8a96c3882$var$stack.push(vnode);
}
function $792a36b8a96c3882$var$popWarningContext() {
    $792a36b8a96c3882$var$stack.pop();
}
function $792a36b8a96c3882$export$c106dd0671a0fc2d(msg, ...args) {
    var vnode;
    return;
}
function $792a36b8a96c3882$var$getComponentTrace() {
    let currentVNode = $792a36b8a96c3882$var$stack[$792a36b8a96c3882$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $792a36b8a96c3882$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$792a36b8a96c3882$var$formatTraceEntry(entry));
    });
    return logs;
}
function $792a36b8a96c3882$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$792a36b8a96c3882$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$792a36b8a96c3882$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $792a36b8a96c3882$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$792a36b8a96c3882$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $792a36b8a96c3882$var$formatProp(key, value1, raw) {
    if ((0, $eGzkv.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            `${key}=${value1}`
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        `${key}=${value1}`
    ];
    else if ((0, $94VKa.isRef)(value1)) {
        value1 = $792a36b8a96c3882$var$formatProp(key, (0, $94VKa.toRaw)(value1.value), true);
        return raw ? value1 : [
            `${key}=Ref<`,
            value1,
            `>`
        ];
    } else if ((0, $eGzkv.isFunction)(value1)) return [
        `${key}=fn${value1.name ? `<${value1.name}>` : ``}`
    ];
    else {
        value1 = (0, $94VKa.toRaw)(value1);
        return raw ? value1 : [
            `${key}=`,
            value1
        ];
    }
}
function $792a36b8a96c3882$export$dfbcecb440255e4a(val, type) {
    return;
}
const $792a36b8a96c3882$var$ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $792a36b8a96c3882$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $792a36b8a96c3882$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $792a36b8a96c3882$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $eGzkv.isFunction)(fn)) {
        const res = $792a36b8a96c3882$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $eGzkv.isPromise)(res)) res.catch((err)=>{
            $792a36b8a96c3882$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($792a36b8a96c3882$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $792a36b8a96c3882$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $792a36b8a96c3882$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $792a36b8a96c3882$var$logError(err, type, contextVNode, throwInDev);
}
function $792a36b8a96c3882$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $792a36b8a96c3882$var$isFlushing = false;
let $792a36b8a96c3882$var$isFlushPending = false;
const $792a36b8a96c3882$var$queue = [];
let $792a36b8a96c3882$var$flushIndex = 0;
const $792a36b8a96c3882$var$pendingPostFlushCbs = [];
let $792a36b8a96c3882$var$activePostFlushCbs = null;
let $792a36b8a96c3882$var$postFlushIndex = 0;
const $792a36b8a96c3882$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $792a36b8a96c3882$var$currentFlushPromise = null;
const $792a36b8a96c3882$var$RECURSION_LIMIT = 100;
function $792a36b8a96c3882$export$bdd553fddd433dcb(fn) {
    const p = $792a36b8a96c3882$var$currentFlushPromise || $792a36b8a96c3882$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $792a36b8a96c3882$var$findInsertionIndex(id) {
    let start = $792a36b8a96c3882$var$flushIndex + 1;
    let end = $792a36b8a96c3882$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $792a36b8a96c3882$var$getId($792a36b8a96c3882$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $792a36b8a96c3882$var$queueJob(job) {
    if (!$792a36b8a96c3882$var$queue.length || !$792a36b8a96c3882$var$queue.includes(job, $792a36b8a96c3882$var$isFlushing && job.allowRecurse ? $792a36b8a96c3882$var$flushIndex + 1 : $792a36b8a96c3882$var$flushIndex)) {
        if (job.id == null) $792a36b8a96c3882$var$queue.push(job);
        else $792a36b8a96c3882$var$queue.splice($792a36b8a96c3882$var$findInsertionIndex(job.id), 0, job);
        $792a36b8a96c3882$var$queueFlush();
    }
}
function $792a36b8a96c3882$var$queueFlush() {
    if (!$792a36b8a96c3882$var$isFlushing && !$792a36b8a96c3882$var$isFlushPending) {
        $792a36b8a96c3882$var$isFlushPending = true;
        $792a36b8a96c3882$var$currentFlushPromise = $792a36b8a96c3882$var$resolvedPromise.then($792a36b8a96c3882$var$flushJobs);
    }
}
function $792a36b8a96c3882$var$invalidateJob(job) {
    const i = $792a36b8a96c3882$var$queue.indexOf(job);
    if (i > $792a36b8a96c3882$var$flushIndex) $792a36b8a96c3882$var$queue.splice(i, 1);
}
function $792a36b8a96c3882$export$59536a0199721cab(cb) {
    if (!(0, $eGzkv.isArray)(cb)) {
        if (!$792a36b8a96c3882$var$activePostFlushCbs || !$792a36b8a96c3882$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $792a36b8a96c3882$var$postFlushIndex + 1 : $792a36b8a96c3882$var$postFlushIndex)) $792a36b8a96c3882$var$pendingPostFlushCbs.push(cb);
    } else $792a36b8a96c3882$var$pendingPostFlushCbs.push(...cb);
    $792a36b8a96c3882$var$queueFlush();
}
function $792a36b8a96c3882$var$flushPreFlushCbs(seen, i = $792a36b8a96c3882$var$isFlushing ? $792a36b8a96c3882$var$flushIndex + 1 : 0) {
    for(; i < $792a36b8a96c3882$var$queue.length; i++){
        const cb = $792a36b8a96c3882$var$queue[i];
        if (cb && cb.pre) {
            $792a36b8a96c3882$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $792a36b8a96c3882$var$flushPostFlushCbs(seen) {
    if ($792a36b8a96c3882$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($792a36b8a96c3882$var$pendingPostFlushCbs)
        ];
        $792a36b8a96c3882$var$pendingPostFlushCbs.length = 0;
        if ($792a36b8a96c3882$var$activePostFlushCbs) {
            $792a36b8a96c3882$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $792a36b8a96c3882$var$activePostFlushCbs = deduped;
        $792a36b8a96c3882$var$activePostFlushCbs.sort((a, b)=>$792a36b8a96c3882$var$getId(a) - $792a36b8a96c3882$var$getId(b));
        for($792a36b8a96c3882$var$postFlushIndex = 0; $792a36b8a96c3882$var$postFlushIndex < $792a36b8a96c3882$var$activePostFlushCbs.length; $792a36b8a96c3882$var$postFlushIndex++)$792a36b8a96c3882$var$activePostFlushCbs[$792a36b8a96c3882$var$postFlushIndex]();
        $792a36b8a96c3882$var$activePostFlushCbs = null;
        $792a36b8a96c3882$var$postFlushIndex = 0;
    }
}
const $792a36b8a96c3882$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $792a36b8a96c3882$var$comparator = (a, b)=>{
    const diff = $792a36b8a96c3882$var$getId(a) - $792a36b8a96c3882$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $792a36b8a96c3882$var$flushJobs(seen) {
    $792a36b8a96c3882$var$isFlushPending = false;
    $792a36b8a96c3882$var$isFlushing = true;
    $792a36b8a96c3882$var$queue.sort($792a36b8a96c3882$var$comparator);
    const check = (0, $eGzkv.NOOP);
    try {
        for($792a36b8a96c3882$var$flushIndex = 0; $792a36b8a96c3882$var$flushIndex < $792a36b8a96c3882$var$queue.length; $792a36b8a96c3882$var$flushIndex++){
            const job = $792a36b8a96c3882$var$queue[$792a36b8a96c3882$var$flushIndex];
            if (job && job.active !== false) $792a36b8a96c3882$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $792a36b8a96c3882$var$flushIndex = 0;
        $792a36b8a96c3882$var$queue.length = 0;
        $792a36b8a96c3882$var$flushPostFlushCbs(seen);
        $792a36b8a96c3882$var$isFlushing = false;
        $792a36b8a96c3882$var$currentFlushPromise = null;
        if ($792a36b8a96c3882$var$queue.length || $792a36b8a96c3882$var$pendingPostFlushCbs.length) $792a36b8a96c3882$var$flushJobs(seen);
    }
}
function $792a36b8a96c3882$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $792a36b8a96c3882$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $792a36b8a96c3882$var$getComponentName(instance.type);
            $792a36b8a96c3882$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $792a36b8a96c3882$var$isHmrUpdating = false;
const $792a36b8a96c3882$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $792a36b8a96c3882$var$map = /* @__PURE__ */ new Map();
function $792a36b8a96c3882$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $792a36b8a96c3882$var$map.get(id);
    if (!record) {
        $792a36b8a96c3882$var$createRecord(id, instance.type);
        record = $792a36b8a96c3882$var$map.get(id);
    }
    record.instances.add(instance);
}
function $792a36b8a96c3882$var$unregisterHMR(instance) {
    $792a36b8a96c3882$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $792a36b8a96c3882$var$createRecord(id, initialDef) {
    if ($792a36b8a96c3882$var$map.has(id)) return false;
    $792a36b8a96c3882$var$map.set(id, {
        initialDef: $792a36b8a96c3882$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $792a36b8a96c3882$var$normalizeClassComponent(component) {
    return $792a36b8a96c3882$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $792a36b8a96c3882$var$rerender(id, newRender) {
    const record = $792a36b8a96c3882$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $792a36b8a96c3882$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $792a36b8a96c3882$var$isHmrUpdating = true;
        instance.update();
        $792a36b8a96c3882$var$isHmrUpdating = false;
    });
}
function $792a36b8a96c3882$var$reload(id, newComp) {
    const record = $792a36b8a96c3882$var$map.get(id);
    if (!record) return;
    newComp = $792a36b8a96c3882$var$normalizeClassComponent(newComp);
    $792a36b8a96c3882$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $792a36b8a96c3882$var$normalizeClassComponent(instance.type);
        if (!$792a36b8a96c3882$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $792a36b8a96c3882$var$updateComponentDef(oldComp, newComp);
            $792a36b8a96c3882$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $792a36b8a96c3882$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $792a36b8a96c3882$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) $792a36b8a96c3882$var$queueJob(instance.parent.update);
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $792a36b8a96c3882$export$59536a0199721cab(()=>{
        for (const instance of instances)$792a36b8a96c3882$var$hmrDirtyComponents.delete($792a36b8a96c3882$var$normalizeClassComponent(instance.type));
    });
}
function $792a36b8a96c3882$var$updateComponentDef(oldComp, newComp) {
    (0, $eGzkv.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $792a36b8a96c3882$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $792a36b8a96c3882$export$6922d3b3a607469e;
let $792a36b8a96c3882$var$buffer = [];
let $792a36b8a96c3882$var$devtoolsNotInstalled = false;
function $792a36b8a96c3882$var$emit$1(event, ...args) {
    if ($792a36b8a96c3882$export$6922d3b3a607469e) $792a36b8a96c3882$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$792a36b8a96c3882$var$devtoolsNotInstalled) $792a36b8a96c3882$var$buffer.push({
        event: event,
        args: args
    });
}
function $792a36b8a96c3882$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $792a36b8a96c3882$export$6922d3b3a607469e = hook;
    if ($792a36b8a96c3882$export$6922d3b3a607469e) {
        $792a36b8a96c3882$export$6922d3b3a607469e.enabled = true;
        $792a36b8a96c3882$var$buffer.forEach(({ event: event, args: args })=>$792a36b8a96c3882$export$6922d3b3a607469e.emit(event, ...args));
        $792a36b8a96c3882$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $792a36b8a96c3882$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(()=>{
            if (!$792a36b8a96c3882$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $792a36b8a96c3882$var$devtoolsNotInstalled = true;
                $792a36b8a96c3882$var$buffer = [];
            }
        }, 3e3);
    } else {
        $792a36b8a96c3882$var$devtoolsNotInstalled = true;
        $792a36b8a96c3882$var$buffer = [];
    }
}
function $792a36b8a96c3882$var$devtoolsInitApp(app, version) {
    $792a36b8a96c3882$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $792a36b8a96c3882$export$ffb0004e005737fa,
        Text: $792a36b8a96c3882$export$5f1af8db9871e1d6,
        Comment: $792a36b8a96c3882$export$4d299b491347818a,
        Static: $792a36b8a96c3882$export$c1b9a1d3af45b7b6
    });
}
function $792a36b8a96c3882$var$devtoolsUnmountApp(app) {
    $792a36b8a96c3882$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $792a36b8a96c3882$var$devtoolsComponentAdded = /* @__PURE__ */ $792a36b8a96c3882$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $792a36b8a96c3882$var$devtoolsComponentUpdated = /* @__PURE__ */ $792a36b8a96c3882$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $792a36b8a96c3882$var$_devtoolsComponentRemoved = /* @__PURE__ */ $792a36b8a96c3882$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $792a36b8a96c3882$var$devtoolsComponentRemoved = (component)=>{
    if ($792a36b8a96c3882$export$6922d3b3a607469e && typeof $792a36b8a96c3882$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$792a36b8a96c3882$export$6922d3b3a607469e.cleanupBuffer(component)) $792a36b8a96c3882$var$_devtoolsComponentRemoved(component);
};
function $792a36b8a96c3882$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $792a36b8a96c3882$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $792a36b8a96c3882$var$devtoolsPerfStart = /* @__PURE__ */ $792a36b8a96c3882$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $792a36b8a96c3882$var$devtoolsPerfEnd = /* @__PURE__ */ $792a36b8a96c3882$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $792a36b8a96c3882$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $792a36b8a96c3882$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $792a36b8a96c3882$var$devtoolsComponentEmit(component, event, params) {
    $792a36b8a96c3882$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $792a36b8a96c3882$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $eGzkv.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $eGzkv.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $eGzkv.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $eGzkv.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $eGzkv.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $eGzkv.toHandlerKey)((0, $eGzkv.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $eGzkv.toHandlerKey)((0, $eGzkv.hyphenate)(event))];
    if (handler) $792a36b8a96c3882$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $792a36b8a96c3882$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $792a36b8a96c3882$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $eGzkv.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $792a36b8a96c3882$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $eGzkv.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $eGzkv.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $eGzkv.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $eGzkv.extend)(normalized, raw);
    if ((0, $eGzkv.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $792a36b8a96c3882$var$isEmitListener(options, key) {
    if (!options || !(0, $eGzkv.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $eGzkv.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $eGzkv.hasOwn)(options, (0, $eGzkv.hyphenate)(key)) || (0, $eGzkv.hasOwn)(options, key);
}
let $792a36b8a96c3882$var$currentRenderingInstance = null;
let $792a36b8a96c3882$var$currentScopeId = null;
function $792a36b8a96c3882$var$setCurrentRenderingInstance(instance) {
    const prev = $792a36b8a96c3882$var$currentRenderingInstance;
    $792a36b8a96c3882$var$currentRenderingInstance = instance;
    $792a36b8a96c3882$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $792a36b8a96c3882$export$ac020265ca2cc4cd(id) {
    $792a36b8a96c3882$var$currentScopeId = id;
}
function $792a36b8a96c3882$export$f2dc6805dc11834e() {
    $792a36b8a96c3882$var$currentScopeId = null;
}
const $792a36b8a96c3882$export$15ba313e13f3dd04 = (_id)=>$792a36b8a96c3882$export$694b237e827a3d23;
function $792a36b8a96c3882$export$694b237e827a3d23(fn, ctx = $792a36b8a96c3882$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $792a36b8a96c3882$export$c20bee82f26f1e27(-1);
        const prevInstance = $792a36b8a96c3882$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $792a36b8a96c3882$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $792a36b8a96c3882$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $792a36b8a96c3882$var$accessedAttrs = false;
function $792a36b8a96c3882$var$markAttrsAccessed() {
    $792a36b8a96c3882$var$accessedAttrs = true;
}
function $792a36b8a96c3882$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $792a36b8a96c3882$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            result = $792a36b8a96c3882$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $792a36b8a96c3882$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $792a36b8a96c3882$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $792a36b8a96c3882$var$blockStack.length = 0;
        $792a36b8a96c3882$export$d3da1ecaf1206c58(err, instance, 1);
        result = $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $eGzkv.isModelListener))) fallthroughAttrs = $792a36b8a96c3882$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $792a36b8a96c3882$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $792a36b8a96c3882$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $792a36b8a96c3882$var$setCurrentRenderingInstance(prev);
    return result;
}
const $792a36b8a96c3882$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $792a36b8a96c3882$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $792a36b8a96c3882$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $792a36b8a96c3882$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($792a36b8a96c3882$export$3868d13f8734ae81(child)) {
            if (child.type !== $792a36b8a96c3882$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $792a36b8a96c3882$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $eGzkv.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $792a36b8a96c3882$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $eGzkv.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $792a36b8a96c3882$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $792a36b8a96c3882$export$4d299b491347818a;
};
function $792a36b8a96c3882$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $792a36b8a96c3882$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$792a36b8a96c3882$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $792a36b8a96c3882$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $792a36b8a96c3882$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$792a36b8a96c3882$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $792a36b8a96c3882$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $792a36b8a96c3882$var$isSuspense = (type)=>type.__isSuspense;
const $792a36b8a96c3882$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $792a36b8a96c3882$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $792a36b8a96c3882$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $792a36b8a96c3882$var$hydrateSuspense,
    create: $792a36b8a96c3882$var$createSuspenseBoundary,
    normalize: $792a36b8a96c3882$var$normalizeSuspenseChildren
};
const $792a36b8a96c3882$export$74bf444e3cd11ea5 = $792a36b8a96c3882$var$SuspenseImpl;
function $792a36b8a96c3882$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $eGzkv.isFunction)(eventListener)) eventListener();
}
function $792a36b8a96c3882$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $792a36b8a96c3882$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $792a36b8a96c3882$var$triggerEvent(vnode, "onPending");
        $792a36b8a96c3882$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $792a36b8a96c3882$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $792a36b8a96c3882$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($792a36b8a96c3882$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $792a36b8a96c3882$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $792a36b8a96c3882$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $792a36b8a96c3882$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $792a36b8a96c3882$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $792a36b8a96c3882$var$setActiveBranch(suspense, newBranch);
    } else {
        $792a36b8a96c3882$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $792a36b8a96c3882$var$hasWarned = false;
function $792a36b8a96c3882$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $792a36b8a96c3882$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $eGzkv.toNumber)(vnode.props.timeout) : void 0;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container2, anchor2, 0);
                };
                let { anchor: anchor2 } = suspense;
                if (activeBranch) {
                    anchor2 = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
            }
            $792a36b8a96c3882$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor) $792a36b8a96c3882$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $792a36b8a96c3882$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, isSVG: isSVG2 } = suspense;
            $792a36b8a96c3882$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                isSVG2, slotScopeIds, optimized);
                $792a36b8a96c3882$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $792a36b8a96c3882$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $792a36b8a96c3882$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $792a36b8a96c3882$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $792a36b8a96c3882$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $792a36b8a96c3882$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $792a36b8a96c3882$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $792a36b8a96c3882$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $792a36b8a96c3882$var$normalizeSuspenseSlot(children.fallback) : $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$4d299b491347818a);
}
function $792a36b8a96c3882$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $eGzkv.isFunction)(s)) {
        const trackBlock = $792a36b8a96c3882$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $792a36b8a96c3882$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $792a36b8a96c3882$var$currentBlock;
            $792a36b8a96c3882$var$closeBlock();
        }
    }
    if ((0, $eGzkv.isArray)(s)) {
        const singleChild = $792a36b8a96c3882$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $792a36b8a96c3882$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $792a36b8a96c3882$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $eGzkv.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $792a36b8a96c3882$export$59536a0199721cab(fn);
}
function $792a36b8a96c3882$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $792a36b8a96c3882$var$updateHOCHostEl(parentComponent, el);
    }
}
function $792a36b8a96c3882$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $792a36b8a96c3882$export$ede35fc0e5500309(effect, options) {
    return $792a36b8a96c3882$var$doWatch(effect, null, options);
}
function $792a36b8a96c3882$export$b7f27ea67102d543(effect, options) {
    return $792a36b8a96c3882$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $792a36b8a96c3882$export$2035654f31b0e555(effect, options) {
    return $792a36b8a96c3882$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $792a36b8a96c3882$var$INITIAL_WATCHER_VALUE = {};
function $792a36b8a96c3882$export$3db5d71bdb2d5499(source, cb, options) {
    return $792a36b8a96c3882$var$doWatch(source, cb, options);
}
function $792a36b8a96c3882$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $eGzkv.EMPTY_OBJ)) {
    var _a;
    const warnInvalidSource = (s)=>{
        $792a36b8a96c3882$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = (0, $94VKa.getCurrentScope)() === ((_a = $792a36b8a96c3882$var$currentInstance) == null ? void 0 : _a.scope) ? $792a36b8a96c3882$var$currentInstance : null;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $94VKa.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $94VKa.isShallow)(source);
    } else if ((0, $94VKa.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $eGzkv.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $94VKa.isReactive)(s) || (0, $94VKa.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $94VKa.isRef)(s)) return s.value;
                else if ((0, $94VKa.isReactive)(s)) return $792a36b8a96c3882$var$traverse(s);
                else if ((0, $eGzkv.isFunction)(s)) return $792a36b8a96c3882$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $eGzkv.isFunction)(source)) {
        if (cb) getter = ()=>$792a36b8a96c3882$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $792a36b8a96c3882$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $eGzkv.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$792a36b8a96c3882$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $792a36b8a96c3882$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    let ssrCleanup;
    if ($792a36b8a96c3882$var$isInSSRComponentSetup) {
        onCleanup = (0, $eGzkv.NOOP);
        if (!cb) getter();
        else if (immediate) $792a36b8a96c3882$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $792a36b8a96c3882$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $eGzkv.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($792a36b8a96c3882$var$INITIAL_WATCHER_VALUE) : $792a36b8a96c3882$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $eGzkv.hasChanged)(v1, oldValue[i])) : (0, $eGzkv.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $792a36b8a96c3882$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $792a36b8a96c3882$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $792a36b8a96c3882$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$792a36b8a96c3882$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$792a36b8a96c3882$var$queueJob(job);
    }
    const effect = new (0, $94VKa.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $792a36b8a96c3882$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    const unwatch = ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $eGzkv.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $792a36b8a96c3882$var$instanceWatch(source, value1, options) {
    const publicThis = this.proxy;
    const getter = (0, $eGzkv.isString)(source) ? source.includes(".") ? $792a36b8a96c3882$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $eGzkv.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    const cur = $792a36b8a96c3882$var$currentInstance;
    $792a36b8a96c3882$var$setCurrentInstance(this);
    const res = $792a36b8a96c3882$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $792a36b8a96c3882$var$setCurrentInstance(cur);
    else $792a36b8a96c3882$var$unsetCurrentInstance();
    return res;
}
function $792a36b8a96c3882$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $792a36b8a96c3882$var$traverse(value1, seen) {
    if (!(0, $eGzkv.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $94VKa.isRef)(value1)) $792a36b8a96c3882$var$traverse(value1.value, seen);
    else if ((0, $eGzkv.isArray)(value1)) for(let i = 0; i < value1.length; i++)$792a36b8a96c3882$var$traverse(value1[i], seen);
    else if ((0, $eGzkv.isSet)(value1) || (0, $eGzkv.isMap)(value1)) value1.forEach((v1)=>{
        $792a36b8a96c3882$var$traverse(v1, seen);
    });
    else if ((0, $eGzkv.isPlainObject)(value1)) for(const key in value1)$792a36b8a96c3882$var$traverse(value1[key], seen);
    return value1;
}
function $792a36b8a96c3882$var$validateDirectiveName(name) {
    if ((0, $eGzkv.isBuiltInDirective)(name)) $792a36b8a96c3882$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $792a36b8a96c3882$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $792a36b8a96c3882$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $792a36b8a96c3882$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value1, arg, modifiers = (0, $eGzkv.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $eGzkv.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $792a36b8a96c3882$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $792a36b8a96c3882$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $94VKa.pauseTracking)();
            $792a36b8a96c3882$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $94VKa.resetTracking)();
        }
    }
}
function $792a36b8a96c3882$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $792a36b8a96c3882$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $792a36b8a96c3882$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $792a36b8a96c3882$var$TransitionHookValidator = [
    Function,
    Array
];
const $792a36b8a96c3882$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $792a36b8a96c3882$var$TransitionHookValidator,
    onEnter: $792a36b8a96c3882$var$TransitionHookValidator,
    onAfterEnter: $792a36b8a96c3882$var$TransitionHookValidator,
    onEnterCancelled: $792a36b8a96c3882$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $792a36b8a96c3882$var$TransitionHookValidator,
    onLeave: $792a36b8a96c3882$var$TransitionHookValidator,
    onAfterLeave: $792a36b8a96c3882$var$TransitionHookValidator,
    onLeaveCancelled: $792a36b8a96c3882$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $792a36b8a96c3882$var$TransitionHookValidator,
    onAppear: $792a36b8a96c3882$var$TransitionHookValidator,
    onAfterAppear: $792a36b8a96c3882$var$TransitionHookValidator,
    onAppearCancelled: $792a36b8a96c3882$var$TransitionHookValidator
};
const $792a36b8a96c3882$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $792a36b8a96c3882$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $792a36b8a96c3882$export$f13e630aa3915748();
        const state = $792a36b8a96c3882$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $792a36b8a96c3882$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $792a36b8a96c3882$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $94VKa.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $792a36b8a96c3882$var$emptyPlaceholder(child);
            const innerChild = $792a36b8a96c3882$var$getKeepAliveChild(child);
            if (!innerChild) return $792a36b8a96c3882$var$emptyPlaceholder(child);
            const enterHooks = $792a36b8a96c3882$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $792a36b8a96c3882$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $792a36b8a96c3882$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $792a36b8a96c3882$export$4d299b491347818a && (!$792a36b8a96c3882$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $792a36b8a96c3882$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $792a36b8a96c3882$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $792a36b8a96c3882$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $792a36b8a96c3882$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $792a36b8a96c3882$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $792a36b8a96c3882$export$abd95b5f5e8a8837 = $792a36b8a96c3882$var$BaseTransitionImpl;
function $792a36b8a96c3882$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $792a36b8a96c3882$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $792a36b8a96c3882$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $792a36b8a96c3882$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $eGzkv.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el._leaveCb) el._leaveCb(true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $792a36b8a96c3882$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $792a36b8a96c3882$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $792a36b8a96c3882$var$emptyPlaceholder(vnode) {
    if ($792a36b8a96c3882$var$isKeepAlive(vnode)) {
        vnode = $792a36b8a96c3882$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $792a36b8a96c3882$var$getKeepAliveChild(vnode) {
    return $792a36b8a96c3882$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $792a36b8a96c3882$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $792a36b8a96c3882$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $792a36b8a96c3882$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $792a36b8a96c3882$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($792a36b8a96c3882$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $792a36b8a96c3882$export$4d299b491347818a) ret.push(key != null ? $792a36b8a96c3882$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $792a36b8a96c3882$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $eGzkv.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $eGzkv.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $792a36b8a96c3882$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $792a36b8a96c3882$export$d75d499b4c16cf21(source) {
    if ((0, $eGzkv.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $792a36b8a96c3882$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $792a36b8a96c3882$var$currentInstance;
            if (resolvedComp) return ()=>$792a36b8a96c3882$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $792a36b8a96c3882$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $792a36b8a96c3882$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$792a36b8a96c3882$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $792a36b8a96c3882$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $94VKa.ref)(false);
            const error = (0, $94VKa.ref)();
            const delayed = (0, $94VKa.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $792a36b8a96c3882$var$isKeepAlive(instance.parent.vnode)) $792a36b8a96c3882$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $792a36b8a96c3882$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $792a36b8a96c3882$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $792a36b8a96c3882$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $792a36b8a96c3882$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $792a36b8a96c3882$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $792a36b8a96c3882$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $792a36b8a96c3882$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $792a36b8a96c3882$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $792a36b8a96c3882$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $eGzkv.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $792a36b8a96c3882$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $eGzkv.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $792a36b8a96c3882$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $792a36b8a96c3882$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$792a36b8a96c3882$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $792a36b8a96c3882$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $792a36b8a96c3882$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$792a36b8a96c3882$var$matches(include, name));
            exclude && pruneCache((name)=>!$792a36b8a96c3882$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $792a36b8a96c3882$var$getInnerChild(instance.subTree));
        };
        $792a36b8a96c3882$export$6d1641039221b5cb(cacheSubtree);
        $792a36b8a96c3882$export$5876c47052fb88b1(cacheSubtree);
        $792a36b8a96c3882$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $792a36b8a96c3882$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $792a36b8a96c3882$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $792a36b8a96c3882$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$792a36b8a96c3882$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $792a36b8a96c3882$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $792a36b8a96c3882$var$getComponentName($792a36b8a96c3882$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$792a36b8a96c3882$var$matches(include, name)) || exclude && name && $792a36b8a96c3882$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $792a36b8a96c3882$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $792a36b8a96c3882$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $792a36b8a96c3882$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $792a36b8a96c3882$export$70eb8a58709972df = $792a36b8a96c3882$var$KeepAliveImpl;
function $792a36b8a96c3882$var$matches(pattern, name) {
    if ((0, $eGzkv.isArray)(pattern)) return pattern.some((p)=>$792a36b8a96c3882$var$matches(p, name));
    else if ((0, $eGzkv.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $eGzkv.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $792a36b8a96c3882$export$ba52d824b95a2154(hook, target) {
    $792a36b8a96c3882$var$registerKeepAliveHook(hook, "a", target);
}
function $792a36b8a96c3882$export$bf1440eeaf5fa709(hook, target) {
    $792a36b8a96c3882$var$registerKeepAliveHook(hook, "da", target);
}
function $792a36b8a96c3882$var$registerKeepAliveHook(hook, type, target = $792a36b8a96c3882$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $792a36b8a96c3882$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($792a36b8a96c3882$var$isKeepAlive(current.parent.vnode)) $792a36b8a96c3882$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $792a36b8a96c3882$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $792a36b8a96c3882$var$injectHook(type, hook, keepAliveRoot, true);
    $792a36b8a96c3882$export$13348a43ccacfe58(()=>{
        (0, $eGzkv.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $792a36b8a96c3882$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $792a36b8a96c3882$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $792a36b8a96c3882$var$injectHook(type, hook, target = $792a36b8a96c3882$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $94VKa.pauseTracking)();
            $792a36b8a96c3882$var$setCurrentInstance(target);
            const res = $792a36b8a96c3882$export$dae85862a8d94378(hook, target, type, args);
            $792a36b8a96c3882$var$unsetCurrentInstance();
            (0, $94VKa.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $792a36b8a96c3882$var$createHook = (lifecycle)=>(hook, target = $792a36b8a96c3882$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$792a36b8a96c3882$var$isInSSRComponentSetup || lifecycle === "sp") && $792a36b8a96c3882$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $792a36b8a96c3882$export$23b7aeb0d671f804 = $792a36b8a96c3882$var$createHook("bm");
const $792a36b8a96c3882$export$6d1641039221b5cb = $792a36b8a96c3882$var$createHook("m");
const $792a36b8a96c3882$export$ab91988a13872e4c = $792a36b8a96c3882$var$createHook("bu");
const $792a36b8a96c3882$export$5876c47052fb88b1 = $792a36b8a96c3882$var$createHook("u");
const $792a36b8a96c3882$export$40c420df62d2614 = $792a36b8a96c3882$var$createHook("bum");
const $792a36b8a96c3882$export$13348a43ccacfe58 = $792a36b8a96c3882$var$createHook("um");
const $792a36b8a96c3882$export$ebf0c601f267bceb = $792a36b8a96c3882$var$createHook("sp");
const $792a36b8a96c3882$export$898295a813d662eb = $792a36b8a96c3882$var$createHook("rtg");
const $792a36b8a96c3882$export$2b41f4235363e921 = $792a36b8a96c3882$var$createHook("rtc");
function $792a36b8a96c3882$export$6a3a15856e50ad19(hook, target = $792a36b8a96c3882$var$currentInstance) {
    $792a36b8a96c3882$var$injectHook("ec", hook, target);
}
const $792a36b8a96c3882$var$COMPONENTS = "components";
const $792a36b8a96c3882$var$DIRECTIVES = "directives";
function $792a36b8a96c3882$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $792a36b8a96c3882$var$resolveAsset($792a36b8a96c3882$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $792a36b8a96c3882$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $792a36b8a96c3882$export$b44c564a05ca975(component) {
    if ((0, $eGzkv.isString)(component)) return $792a36b8a96c3882$var$resolveAsset($792a36b8a96c3882$var$COMPONENTS, component, false) || component;
    else return component || $792a36b8a96c3882$var$NULL_DYNAMIC_COMPONENT;
}
function $792a36b8a96c3882$export$a1989e995cd481be(name) {
    return $792a36b8a96c3882$var$resolveAsset($792a36b8a96c3882$var$DIRECTIVES, name);
}
function $792a36b8a96c3882$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $792a36b8a96c3882$var$currentRenderingInstance || $792a36b8a96c3882$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $792a36b8a96c3882$var$COMPONENTS) {
            const selfName = $792a36b8a96c3882$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $eGzkv.camelize)(name) || selfName === (0, $eGzkv.capitalize)((0, $eGzkv.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $792a36b8a96c3882$var$resolve(instance[type] || Component[type], name) || // global registration
        $792a36b8a96c3882$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $792a36b8a96c3882$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $eGzkv.camelize)(name)] || registry[(0, $eGzkv.capitalize)((0, $eGzkv.camelize)(name))]);
}
function $792a36b8a96c3882$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $eGzkv.isArray)(source) || (0, $eGzkv.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $eGzkv.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $792a36b8a96c3882$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $eGzkv.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $792a36b8a96c3882$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($792a36b8a96c3882$var$currentRenderingInstance.isCE || $792a36b8a96c3882$var$currentRenderingInstance.parent && $792a36b8a96c3882$var$isAsyncWrapper($792a36b8a96c3882$var$currentRenderingInstance.parent) && $792a36b8a96c3882$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $792a36b8a96c3882$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $792a36b8a96c3882$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $792a36b8a96c3882$var$ensureValidVNode(slot(props));
    const rendered = $792a36b8a96c3882$export$9f2dfe8048dfb22b($792a36b8a96c3882$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $792a36b8a96c3882$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$792a36b8a96c3882$export$3868d13f8734ae81(child)) return true;
        if (child.type === $792a36b8a96c3882$export$4d299b491347818a) return false;
        if (child.type === $792a36b8a96c3882$export$ffb0004e005737fa && !$792a36b8a96c3882$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $792a36b8a96c3882$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $eGzkv.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $792a36b8a96c3882$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($792a36b8a96c3882$var$isStatefulComponent(i)) return $792a36b8a96c3882$var$getExposeProxy(i) || i.proxy;
    return $792a36b8a96c3882$var$getPublicInstance(i.parent);
};
const $792a36b8a96c3882$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $eGzkv.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$792a36b8a96c3882$var$getPublicInstance(i.parent),
    $root: (i)=>$792a36b8a96c3882$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $792a36b8a96c3882$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$792a36b8a96c3882$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $792a36b8a96c3882$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $792a36b8a96c3882$var$instanceWatch.bind(i) : (0, $eGzkv.NOOP)
});
const $792a36b8a96c3882$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $792a36b8a96c3882$var$hasSetupBinding = (state, key)=>state !== (0, $eGzkv.EMPTY_OBJ) && !state.__isScriptSetup && (0, $eGzkv.hasOwn)(state, key);
const $792a36b8a96c3882$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($792a36b8a96c3882$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $eGzkv.EMPTY_OBJ) && (0, $eGzkv.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $eGzkv.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $eGzkv.EMPTY_OBJ) && (0, $eGzkv.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $792a36b8a96c3882$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $792a36b8a96c3882$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $94VKa.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $eGzkv.EMPTY_OBJ) && (0, $eGzkv.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $eGzkv.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value1) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($792a36b8a96c3882$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value1;
            return true;
        } else {
            if (data !== (0, $eGzkv.EMPTY_OBJ) && (0, $eGzkv.hasOwn)(data, key)) {
                data[key] = value1;
                return true;
            } else if ((0, $eGzkv.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value1;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $eGzkv.EMPTY_OBJ) && (0, $eGzkv.hasOwn)(data, key) || $792a36b8a96c3882$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $eGzkv.hasOwn)(normalizedProps, key) || (0, $eGzkv.hasOwn)(ctx, key) || (0, $eGzkv.hasOwn)($792a36b8a96c3882$var$publicPropertiesMap, key) || (0, $eGzkv.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $eGzkv.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $792a36b8a96c3882$var$target;
const $792a36b8a96c3882$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $eGzkv.extend)({}, $792a36b8a96c3882$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $792a36b8a96c3882$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $eGzkv.isGloballyWhitelisted)(key);
        return has;
    }
});
function $792a36b8a96c3882$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($792a36b8a96c3882$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$792a36b8a96c3882$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $eGzkv.NOOP)
        });
    });
    return target;
}
function $792a36b8a96c3882$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $eGzkv.NOOP)
        });
    });
}
function $792a36b8a96c3882$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $94VKa.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($792a36b8a96c3882$var$isReservedPrefix(key[0])) {
                $792a36b8a96c3882$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $eGzkv.NOOP)
            });
        }
    });
}
const $792a36b8a96c3882$var$warnRuntimeUsage = (method)=>$792a36b8a96c3882$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $792a36b8a96c3882$export$80b33eababae110e() {
    return null;
}
function $792a36b8a96c3882$export$51ecece22fc17ddc() {
    return null;
}
function $792a36b8a96c3882$export$da25b65ca24b518a(exposed) {}
function $792a36b8a96c3882$export$77e79129327f3d0d(options) {}
function $792a36b8a96c3882$export$1b3acd4bb805b712() {
    return null;
}
function $792a36b8a96c3882$export$acd55aa037e791bb() {}
function $792a36b8a96c3882$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $792a36b8a96c3882$export$9203a8e84125433c() {
    return $792a36b8a96c3882$var$getContext().slots;
}
function $792a36b8a96c3882$export$75e29435042cd2ea() {
    return $792a36b8a96c3882$var$getContext().attrs;
}
function $792a36b8a96c3882$export$fb78bd113157f1a1(props, name, options) {
    const i = $792a36b8a96c3882$export$f13e630aa3915748();
    if (options && options.local) {
        const proxy = (0, $94VKa.ref)(props[name]);
        $792a36b8a96c3882$export$3db5d71bdb2d5499(()=>props[name], (v1)=>proxy.value = v1);
        $792a36b8a96c3882$export$3db5d71bdb2d5499(proxy, (value1)=>{
            if (value1 !== props[name]) i.emit(`update:${name}`, value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit(`update:${name}`, value);
        }
    };
}
function $792a36b8a96c3882$var$getContext() {
    const i = $792a36b8a96c3882$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $792a36b8a96c3882$var$createSetupContext(i));
}
function $792a36b8a96c3882$var$normalizePropsOrEmits(props) {
    return (0, $eGzkv.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $792a36b8a96c3882$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $792a36b8a96c3882$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $eGzkv.isArray)(opt) || (0, $eGzkv.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $792a36b8a96c3882$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $eGzkv.isArray)(a) && (0, $eGzkv.isArray)(b)) return a.concat(b);
    return (0, $eGzkv.extend)({}, $792a36b8a96c3882$var$normalizePropsOrEmits(a), $792a36b8a96c3882$var$normalizePropsOrEmits(b));
}
function $792a36b8a96c3882$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $792a36b8a96c3882$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $792a36b8a96c3882$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $792a36b8a96c3882$var$unsetCurrentInstance();
    if ((0, $eGzkv.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $792a36b8a96c3882$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$792a36b8a96c3882$var$setCurrentInstance(ctx)
    ];
}
function $792a36b8a96c3882$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $792a36b8a96c3882$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $792a36b8a96c3882$var$shouldCacheAccess = true;
function $792a36b8a96c3882$var$applyOptions(instance) {
    const options = $792a36b8a96c3882$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $792a36b8a96c3882$var$shouldCacheAccess = false;
    if (options.beforeCreate) $792a36b8a96c3882$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $792a36b8a96c3882$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $eGzkv.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $eGzkv.isObject)(data)) ;
        else instance.data = (0, $94VKa.reactive)(data);
    }
    $792a36b8a96c3882$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $eGzkv.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $eGzkv.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $eGzkv.NOOP);
        const set = !(0, $eGzkv.isFunction)(opt) && (0, $eGzkv.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $eGzkv.NOOP);
        const c = $792a36b8a96c3882$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$792a36b8a96c3882$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $eGzkv.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $792a36b8a96c3882$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $792a36b8a96c3882$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $eGzkv.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($792a36b8a96c3882$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($792a36b8a96c3882$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($792a36b8a96c3882$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($792a36b8a96c3882$export$5876c47052fb88b1, updated);
    registerLifecycleHook($792a36b8a96c3882$export$ba52d824b95a2154, activated);
    registerLifecycleHook($792a36b8a96c3882$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($792a36b8a96c3882$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($792a36b8a96c3882$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($792a36b8a96c3882$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($792a36b8a96c3882$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($792a36b8a96c3882$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($792a36b8a96c3882$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $eGzkv.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $eGzkv.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $792a36b8a96c3882$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $eGzkv.NOOP)) {
    if ((0, $eGzkv.isArray)(injectOptions)) injectOptions = $792a36b8a96c3882$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $eGzkv.isObject)(opt)) {
            if ("default" in opt) injected = $792a36b8a96c3882$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $792a36b8a96c3882$export$a976684a0efeb93f(opt.from || key);
        } else injected = $792a36b8a96c3882$export$a976684a0efeb93f(opt);
        if ((0, $94VKa.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $792a36b8a96c3882$var$callHook(hook, instance, type) {
    $792a36b8a96c3882$export$dae85862a8d94378((0, $eGzkv.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $792a36b8a96c3882$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $792a36b8a96c3882$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $eGzkv.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $eGzkv.isFunction)(handler)) $792a36b8a96c3882$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $eGzkv.isFunction)(raw)) $792a36b8a96c3882$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $eGzkv.isObject)(raw)) {
        if ((0, $eGzkv.isArray)(raw)) raw.forEach((r)=>$792a36b8a96c3882$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $eGzkv.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $eGzkv.isFunction)(handler)) $792a36b8a96c3882$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $792a36b8a96c3882$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$792a36b8a96c3882$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $792a36b8a96c3882$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $eGzkv.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $792a36b8a96c3882$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $792a36b8a96c3882$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$792a36b8a96c3882$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $792a36b8a96c3882$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $792a36b8a96c3882$var$internalOptionMergeStrats = {
    data: $792a36b8a96c3882$var$mergeDataFn,
    props: $792a36b8a96c3882$var$mergeEmitsOrPropsOptions,
    emits: $792a36b8a96c3882$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $792a36b8a96c3882$var$mergeObjectOptions,
    computed: $792a36b8a96c3882$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $792a36b8a96c3882$var$mergeAsArray,
    created: $792a36b8a96c3882$var$mergeAsArray,
    beforeMount: $792a36b8a96c3882$var$mergeAsArray,
    mounted: $792a36b8a96c3882$var$mergeAsArray,
    beforeUpdate: $792a36b8a96c3882$var$mergeAsArray,
    updated: $792a36b8a96c3882$var$mergeAsArray,
    beforeDestroy: $792a36b8a96c3882$var$mergeAsArray,
    beforeUnmount: $792a36b8a96c3882$var$mergeAsArray,
    destroyed: $792a36b8a96c3882$var$mergeAsArray,
    unmounted: $792a36b8a96c3882$var$mergeAsArray,
    activated: $792a36b8a96c3882$var$mergeAsArray,
    deactivated: $792a36b8a96c3882$var$mergeAsArray,
    errorCaptured: $792a36b8a96c3882$var$mergeAsArray,
    serverPrefetch: $792a36b8a96c3882$var$mergeAsArray,
    // assets
    components: $792a36b8a96c3882$var$mergeObjectOptions,
    directives: $792a36b8a96c3882$var$mergeObjectOptions,
    // watch
    watch: $792a36b8a96c3882$var$mergeWatchOptions,
    // provide / inject
    provide: $792a36b8a96c3882$var$mergeDataFn,
    inject: $792a36b8a96c3882$var$mergeInject
};
function $792a36b8a96c3882$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $eGzkv.extend)((0, $eGzkv.isFunction)(to) ? to.call(this, this) : to, (0, $eGzkv.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $792a36b8a96c3882$var$mergeInject(to, from) {
    return $792a36b8a96c3882$var$mergeObjectOptions($792a36b8a96c3882$var$normalizeInject(to), $792a36b8a96c3882$var$normalizeInject(from));
}
function $792a36b8a96c3882$var$normalizeInject(raw) {
    if ((0, $eGzkv.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $792a36b8a96c3882$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $792a36b8a96c3882$var$mergeObjectOptions(to, from) {
    return to ? (0, $eGzkv.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $792a36b8a96c3882$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $eGzkv.isArray)(to) && (0, $eGzkv.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $eGzkv.extend)(/* @__PURE__ */ Object.create(null), $792a36b8a96c3882$var$normalizePropsOrEmits(to), $792a36b8a96c3882$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $792a36b8a96c3882$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $eGzkv.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $792a36b8a96c3882$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $792a36b8a96c3882$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $eGzkv.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $792a36b8a96c3882$var$uid$1 = 0;
function $792a36b8a96c3882$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $eGzkv.isFunction)(rootComponent)) rootComponent = (0, $eGzkv.extend)({}, rootComponent);
        if (rootProps != null && !(0, $eGzkv.isObject)(rootProps)) rootProps = null;
        const context = $792a36b8a96c3882$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $792a36b8a96c3882$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $792a36b8a96c3882$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $eGzkv.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $eGzkv.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $792a36b8a96c3882$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $792a36b8a96c3882$var$devtoolsInitApp(app, $792a36b8a96c3882$export$83d89fbfd8236492);
                    }
                    return $792a36b8a96c3882$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $792a36b8a96c3882$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext (fn) {
                $792a36b8a96c3882$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $792a36b8a96c3882$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
let $792a36b8a96c3882$var$currentApp = null;
function $792a36b8a96c3882$export$abe1e183e22e10ad(key, value1) {
    if (!$792a36b8a96c3882$var$currentInstance) ;
    else {
        let provides = $792a36b8a96c3882$var$currentInstance.provides;
        const parentProvides = $792a36b8a96c3882$var$currentInstance.parent && $792a36b8a96c3882$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $792a36b8a96c3882$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $792a36b8a96c3882$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $792a36b8a96c3882$var$currentInstance || $792a36b8a96c3882$var$currentRenderingInstance;
    if (instance || $792a36b8a96c3882$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $792a36b8a96c3882$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $eGzkv.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $792a36b8a96c3882$export$caf6761f24fc571a() {
    return !!($792a36b8a96c3882$var$currentInstance || $792a36b8a96c3882$var$currentRenderingInstance || $792a36b8a96c3882$var$currentApp);
}
function $792a36b8a96c3882$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $eGzkv.def)(attrs, $792a36b8a96c3882$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $792a36b8a96c3882$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $94VKa.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $792a36b8a96c3882$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $792a36b8a96c3882$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $94VKa.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($792a36b8a96c3882$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value1 = rawProps[key];
                if (options) {
                    if ((0, $eGzkv.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $eGzkv.camelize)(key);
                        props[camelizedKey] = $792a36b8a96c3882$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($792a36b8a96c3882$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $eGzkv.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $eGzkv.hyphenate)(key)) === key || !(0, $eGzkv.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $792a36b8a96c3882$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $eGzkv.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $94VKa.trigger)(instance, "set", "$attrs");
}
function $792a36b8a96c3882$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $eGzkv.isReservedProp)(key)) continue;
        const value1 = rawProps[key];
        let camelKey;
        if (options && (0, $eGzkv.hasOwn)(options, camelKey = (0, $eGzkv.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$792a36b8a96c3882$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $94VKa.toRaw)(props);
        const castValues = rawCastValues || (0, $eGzkv.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $792a36b8a96c3882$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $eGzkv.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $792a36b8a96c3882$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $eGzkv.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $eGzkv.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $792a36b8a96c3882$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $792a36b8a96c3882$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $eGzkv.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $792a36b8a96c3882$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $eGzkv.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $792a36b8a96c3882$var$normalizePropsOptions(raw2, appContext, true);
            (0, $eGzkv.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $eGzkv.isObject)(comp)) cache.set(comp, (0, $eGzkv.EMPTY_ARR));
        return 0, $eGzkv.EMPTY_ARR;
    }
    if ((0, $eGzkv.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $eGzkv.camelize)(raw[i]);
        if ($792a36b8a96c3882$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $eGzkv.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $eGzkv.camelize)(key);
        if ($792a36b8a96c3882$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $eGzkv.isArray)(opt) || (0, $eGzkv.isFunction)(opt) ? {
                type: opt
            } : (0, $eGzkv.extend)({}, opt);
            if (prop) {
                const booleanIndex = $792a36b8a96c3882$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $792a36b8a96c3882$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $eGzkv.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $eGzkv.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $792a36b8a96c3882$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $792a36b8a96c3882$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $792a36b8a96c3882$var$isSameType(a, b) {
    return $792a36b8a96c3882$var$getType(a) === $792a36b8a96c3882$var$getType(b);
}
function $792a36b8a96c3882$var$getTypeIndex(type, expectedTypes) {
    if ((0, $eGzkv.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$792a36b8a96c3882$var$isSameType(t, type));
    else if ((0, $eGzkv.isFunction)(expectedTypes)) return $792a36b8a96c3882$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $792a36b8a96c3882$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $94VKa.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $792a36b8a96c3882$var$validateProp(key, resolvedValues[key], opt, !(0, $eGzkv.hasOwn)(rawProps, key) && !(0, $eGzkv.hasOwn)(rawProps, (0, $eGzkv.hyphenate)(key)));
    }
}
function $792a36b8a96c3882$var$validateProp(name, value1, prop, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $792a36b8a96c3882$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $eGzkv.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $792a36b8a96c3882$var$assertType(value1, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $792a36b8a96c3882$export$c106dd0671a0fc2d($792a36b8a96c3882$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $792a36b8a96c3882$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $792a36b8a96c3882$var$isSimpleType = /* @__PURE__ */ (0, $eGzkv.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $792a36b8a96c3882$var$assertType(value1, type) {
    let valid;
    const expectedType = $792a36b8a96c3882$var$getType(type);
    if ($792a36b8a96c3882$var$isSimpleType(expectedType)) {
        const t = typeof value1;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $eGzkv.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $eGzkv.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $792a36b8a96c3882$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $eGzkv.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $eGzkv.toRawType)(value1);
    const expectedValue = $792a36b8a96c3882$var$styleValue(value1, expectedType);
    const receivedValue = $792a36b8a96c3882$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $792a36b8a96c3882$var$isExplicable(expectedType) && !$792a36b8a96c3882$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($792a36b8a96c3882$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $792a36b8a96c3882$var$styleValue(value1, type) {
    if (type === "String") return `"${value1}"`;
    else if (type === "Number") return `${Number(value1)}`;
    else return `${value1}`;
}
function $792a36b8a96c3882$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $792a36b8a96c3882$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $792a36b8a96c3882$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $792a36b8a96c3882$var$normalizeSlotValue = (value1)=>(0, $eGzkv.isArray)(value1) ? value1.map($792a36b8a96c3882$var$normalizeVNode) : [
        $792a36b8a96c3882$var$normalizeVNode(value1)
    ];
const $792a36b8a96c3882$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $792a36b8a96c3882$export$694b237e827a3d23((...args)=>{
        return $792a36b8a96c3882$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $792a36b8a96c3882$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($792a36b8a96c3882$var$isInternalKey(key)) continue;
        const value1 = rawSlots[key];
        if ((0, $eGzkv.isFunction)(value1)) slots[key] = $792a36b8a96c3882$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            const normalized = $792a36b8a96c3882$var$normalizeSlotValue(value1);
            slots[key] = ()=>normalized;
        }
    }
};
const $792a36b8a96c3882$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $792a36b8a96c3882$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $792a36b8a96c3882$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $94VKa.toRaw)(children);
            (0, $eGzkv.def)(children, "_", type);
        } else $792a36b8a96c3882$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $792a36b8a96c3882$var$normalizeVNodeSlots(instance, children);
    }
    (0, $eGzkv.def)(instance.slots, $792a36b8a96c3882$var$InternalObjectKey, 1);
};
const $792a36b8a96c3882$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $eGzkv.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $eGzkv.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $792a36b8a96c3882$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $792a36b8a96c3882$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$792a36b8a96c3882$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $792a36b8a96c3882$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $eGzkv.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$792a36b8a96c3882$var$setRef(r, oldRawRef && ((0, $eGzkv.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($792a36b8a96c3882$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $792a36b8a96c3882$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value1 = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $eGzkv.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $eGzkv.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $eGzkv.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $94VKa.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $eGzkv.isFunction)(ref)) $792a36b8a96c3882$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        const _isString = (0, $eGzkv.isString)(ref);
        const _isRef = (0, $94VKa.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $eGzkv.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $eGzkv.isArray)(existing) && (0, $eGzkv.remove)(existing, refValue);
                    else {
                        if (!(0, $eGzkv.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $eGzkv.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $eGzkv.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $792a36b8a96c3882$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $792a36b8a96c3882$var$hasMismatch = false;
const $792a36b8a96c3882$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $792a36b8a96c3882$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $792a36b8a96c3882$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $792a36b8a96c3882$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $792a36b8a96c3882$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $792a36b8a96c3882$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($792a36b8a96c3882$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $792a36b8a96c3882$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $792a36b8a96c3882$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $792a36b8a96c3882$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $792a36b8a96c3882$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $792a36b8a96c3882$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $792a36b8a96c3882$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $792a36b8a96c3882$var$isSVGContainer(container), optimized);
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    if (nextNode && $792a36b8a96c3882$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    if ($792a36b8a96c3882$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $792a36b8a96c3882$export$22f9b5ffd89dac9("") : $792a36b8a96c3882$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $792a36b8a96c3882$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $792a36b8a96c3882$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        const forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $eGzkv.isOn)(key) && !(0, $eGzkv.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $792a36b8a96c3882$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $792a36b8a96c3882$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $792a36b8a96c3882$var$hasMismatch = true;
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $792a36b8a96c3882$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $792a36b8a96c3882$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $792a36b8a96c3882$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $792a36b8a96c3882$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $792a36b8a96c3882$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $792a36b8a96c3882$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $792a36b8a96c3882$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $792a36b8a96c3882$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $792a36b8a96c3882$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $792a36b8a96c3882$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
let $792a36b8a96c3882$var$supported;
let $792a36b8a96c3882$var$perf;
function $792a36b8a96c3882$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $792a36b8a96c3882$var$isSupported()) $792a36b8a96c3882$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsPerfStart(instance, type, $792a36b8a96c3882$var$isSupported() ? $792a36b8a96c3882$var$perf.now() : Date.now());
}
function $792a36b8a96c3882$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $792a36b8a96c3882$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $792a36b8a96c3882$var$perf.mark(endTag);
        $792a36b8a96c3882$var$perf.measure(`<${$792a36b8a96c3882$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $792a36b8a96c3882$var$perf.clearMarks(startTag);
        $792a36b8a96c3882$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsPerfEnd(instance, type, $792a36b8a96c3882$var$isSupported() ? $792a36b8a96c3882$var$perf.now() : Date.now());
}
function $792a36b8a96c3882$var$isSupported() {
    if ($792a36b8a96c3882$var$supported !== void 0) return $792a36b8a96c3882$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $792a36b8a96c3882$var$supported = true;
        $792a36b8a96c3882$var$perf = window.performance;
    } else $792a36b8a96c3882$var$supported = false;
    return $792a36b8a96c3882$var$supported;
}
function $792a36b8a96c3882$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $eGzkv.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $eGzkv.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $792a36b8a96c3882$var$queuePostRenderEffect = $792a36b8a96c3882$var$queueEffectWithSuspense;
function $792a36b8a96c3882$export$53ae2f996c64e9a(options) {
    return $792a36b8a96c3882$var$baseCreateRenderer(options);
}
function $792a36b8a96c3882$export$200524cf0d997ff0(options) {
    return $792a36b8a96c3882$var$baseCreateRenderer(options, $792a36b8a96c3882$var$createHydrationFunctions);
}
function $792a36b8a96c3882$var$baseCreateRenderer(options, createHydrationFns) {
    $792a36b8a96c3882$var$initFeatureFlags();
    const target = (0, $eGzkv.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $eGzkv.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$792a36b8a96c3882$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $792a36b8a96c3882$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $792a36b8a96c3882$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $792a36b8a96c3882$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $792a36b8a96c3882$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $792a36b8a96c3882$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, isSVG)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $eGzkv.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $792a36b8a96c3882$var$queuePostRenderEffect(()=>{
            vnodeHook && $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $792a36b8a96c3882$var$cloneIfMounted(children[i]) : $792a36b8a96c3882$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $eGzkv.EMPTY_OBJ);
        const newProps = n2.props || (0, $eGzkv.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $792a36b8a96c3882$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $792a36b8a96c3882$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $792a36b8a96c3882$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $792a36b8a96c3882$var$queuePostRenderEffect(()=>{
            vnodeHook && $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $792a36b8a96c3882$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $792a36b8a96c3882$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$792a36b8a96c3882$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $eGzkv.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $eGzkv.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $eGzkv.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $792a36b8a96c3882$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $792a36b8a96c3882$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($792a36b8a96c3882$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $792a36b8a96c3882$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($792a36b8a96c3882$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $792a36b8a96c3882$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $792a36b8a96c3882$var$isAsyncWrapper(initialVNode);
                $792a36b8a96c3882$var$toggleRecurse(instance, false);
                if (bm) (0, $eGzkv.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $792a36b8a96c3882$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $792a36b8a96c3882$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $792a36b8a96c3882$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $792a36b8a96c3882$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $792a36b8a96c3882$var$queuePostRenderEffect(()=>$792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $792a36b8a96c3882$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $792a36b8a96c3882$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                $792a36b8a96c3882$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $eGzkv.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $792a36b8a96c3882$var$toggleRecurse(instance, true);
                const nextTree = $792a36b8a96c3882$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $792a36b8a96c3882$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $792a36b8a96c3882$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $792a36b8a96c3882$var$queuePostRenderEffect(()=>$792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $94VKa.ReactiveEffect)(componentUpdateFn, ()=>$792a36b8a96c3882$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        $792a36b8a96c3882$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $792a36b8a96c3882$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $792a36b8a96c3882$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $94VKa.pauseTracking)();
        $792a36b8a96c3882$var$flushPreFlushCbs();
        (0, $94VKa.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $eGzkv.EMPTY_ARR);
        c2 = c2 || (0, $eGzkv.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $792a36b8a96c3882$var$cloneIfMounted(c2[i]) : $792a36b8a96c3882$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $792a36b8a96c3882$var$cloneIfMounted(c2[i]) : $792a36b8a96c3882$var$normalizeVNode(c2[i]);
            if ($792a36b8a96c3882$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $792a36b8a96c3882$var$cloneIfMounted(c2[e2]) : $792a36b8a96c3882$var$normalizeVNode(c2[e2]);
            if ($792a36b8a96c3882$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $792a36b8a96c3882$var$cloneIfMounted(c2[i]) : $792a36b8a96c3882$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $792a36b8a96c3882$var$cloneIfMounted(c2[i]) : $792a36b8a96c3882$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $792a36b8a96c3882$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $792a36b8a96c3882$var$getSequence(newIndexToOldIndexMap) : (0, $eGzkv.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $792a36b8a96c3882$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $792a36b8a96c3882$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $792a36b8a96c3882$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $792a36b8a96c3882$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$792a36b8a96c3882$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $792a36b8a96c3882$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $792a36b8a96c3882$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $792a36b8a96c3882$var$queuePostRenderEffect(()=>{
            vnodeHook && $792a36b8a96c3882$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $792a36b8a96c3882$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $792a36b8a96c3882$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $792a36b8a96c3882$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $eGzkv.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $792a36b8a96c3882$var$queuePostRenderEffect(um, parentSuspense);
        $792a36b8a96c3882$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $792a36b8a96c3882$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $792a36b8a96c3882$var$flushPreFlushCbs();
        $792a36b8a96c3882$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $792a36b8a96c3882$var$createAppAPI(render, hydrate)
    };
}
function $792a36b8a96c3882$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $792a36b8a96c3882$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $eGzkv.isArray)(ch1) && (0, $eGzkv.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $792a36b8a96c3882$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $792a36b8a96c3882$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $792a36b8a96c3882$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $792a36b8a96c3882$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $792a36b8a96c3882$var$isTeleport = (type)=>type.__isTeleport;
const $792a36b8a96c3882$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $792a36b8a96c3882$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $792a36b8a96c3882$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $eGzkv.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $792a36b8a96c3882$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $792a36b8a96c3882$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $792a36b8a96c3882$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $792a36b8a96c3882$var$isTargetSVG(target);
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $792a36b8a96c3882$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $792a36b8a96c3882$var$isTargetSVG(target);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $792a36b8a96c3882$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $792a36b8a96c3882$var$moveTeleport(n2, container, mainAnchor, internals, 1);
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $792a36b8a96c3882$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $792a36b8a96c3882$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $792a36b8a96c3882$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $792a36b8a96c3882$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        if (doRemove || !$792a36b8a96c3882$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $792a36b8a96c3882$var$moveTeleport,
    hydrate: $792a36b8a96c3882$var$hydrateTeleport
};
function $792a36b8a96c3882$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $792a36b8a96c3882$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $792a36b8a96c3882$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $792a36b8a96c3882$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($792a36b8a96c3882$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $792a36b8a96c3882$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $792a36b8a96c3882$export$76d55a0304a371f4 = $792a36b8a96c3882$var$TeleportImpl;
function $792a36b8a96c3882$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $792a36b8a96c3882$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $792a36b8a96c3882$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $792a36b8a96c3882$export$4d299b491347818a = Symbol.for("v-cmt");
const $792a36b8a96c3882$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $792a36b8a96c3882$var$blockStack = [];
let $792a36b8a96c3882$var$currentBlock = null;
function $792a36b8a96c3882$export$e7eaa45e502fe5cc(disableTracking = false) {
    $792a36b8a96c3882$var$blockStack.push($792a36b8a96c3882$var$currentBlock = disableTracking ? null : []);
}
function $792a36b8a96c3882$var$closeBlock() {
    $792a36b8a96c3882$var$blockStack.pop();
    $792a36b8a96c3882$var$currentBlock = $792a36b8a96c3882$var$blockStack[$792a36b8a96c3882$var$blockStack.length - 1] || null;
}
let $792a36b8a96c3882$var$isBlockTreeEnabled = 1;
function $792a36b8a96c3882$export$c20bee82f26f1e27(value1) {
    $792a36b8a96c3882$var$isBlockTreeEnabled += value1;
}
function $792a36b8a96c3882$var$setupBlock(vnode) {
    vnode.dynamicChildren = $792a36b8a96c3882$var$isBlockTreeEnabled > 0 ? $792a36b8a96c3882$var$currentBlock || (0, $eGzkv.EMPTY_ARR) : null;
    $792a36b8a96c3882$var$closeBlock();
    if ($792a36b8a96c3882$var$isBlockTreeEnabled > 0 && $792a36b8a96c3882$var$currentBlock) $792a36b8a96c3882$var$currentBlock.push(vnode);
    return vnode;
}
function $792a36b8a96c3882$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $792a36b8a96c3882$var$setupBlock($792a36b8a96c3882$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $792a36b8a96c3882$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $792a36b8a96c3882$var$setupBlock($792a36b8a96c3882$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $792a36b8a96c3882$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $792a36b8a96c3882$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $792a36b8a96c3882$var$vnodeArgsTransformer;
function $792a36b8a96c3882$export$83beccd3afeeb809(transformer) {
    $792a36b8a96c3882$var$vnodeArgsTransformer = transformer;
}
const $792a36b8a96c3882$var$createVNodeWithArgsTransform = (...args)=>{
    return $792a36b8a96c3882$var$_createVNode(...$792a36b8a96c3882$var$vnodeArgsTransformer ? $792a36b8a96c3882$var$vnodeArgsTransformer(args, $792a36b8a96c3882$var$currentRenderingInstance) : args);
};
const $792a36b8a96c3882$var$InternalObjectKey = `__vInternal`;
const $792a36b8a96c3882$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $792a36b8a96c3882$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $eGzkv.isString)(ref) || (0, $94VKa.isRef)(ref) || (0, $eGzkv.isFunction)(ref) ? {
        i: $792a36b8a96c3882$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $792a36b8a96c3882$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $792a36b8a96c3882$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $792a36b8a96c3882$var$normalizeKey(props),
        ref: props && $792a36b8a96c3882$var$normalizeRef(props),
        scopeId: $792a36b8a96c3882$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $792a36b8a96c3882$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $792a36b8a96c3882$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $eGzkv.isString)(children) ? 8 : 16;
    if ($792a36b8a96c3882$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $792a36b8a96c3882$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $792a36b8a96c3882$var$currentBlock.push(vnode);
    return vnode;
}
const $792a36b8a96c3882$export$bf5c4cf060303d58 = $792a36b8a96c3882$var$_createVNode;
function $792a36b8a96c3882$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $792a36b8a96c3882$var$NULL_DYNAMIC_COMPONENT) type = $792a36b8a96c3882$export$4d299b491347818a;
    if ($792a36b8a96c3882$export$3868d13f8734ae81(type)) {
        const cloned = $792a36b8a96c3882$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $792a36b8a96c3882$var$normalizeChildren(cloned, children);
        if ($792a36b8a96c3882$var$isBlockTreeEnabled > 0 && !isBlockNode && $792a36b8a96c3882$var$currentBlock) {
            if (cloned.shapeFlag & 6) $792a36b8a96c3882$var$currentBlock[$792a36b8a96c3882$var$currentBlock.indexOf(type)] = cloned;
            else $792a36b8a96c3882$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($792a36b8a96c3882$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $792a36b8a96c3882$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $eGzkv.isString)(klass)) props.class = (0, $eGzkv.normalizeClass)(klass);
        if ((0, $eGzkv.isObject)(style)) {
            if ((0, $94VKa.isProxy)(style) && !(0, $eGzkv.isArray)(style)) style = (0, $eGzkv.extend)({}, style);
            props.style = (0, $eGzkv.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $eGzkv.isString)(type) ? 1 : $792a36b8a96c3882$var$isSuspense(type) ? 128 : $792a36b8a96c3882$var$isTeleport(type) ? 64 : (0, $eGzkv.isObject)(type) ? 4 : (0, $eGzkv.isFunction)(type) ? 2 : 0;
    return $792a36b8a96c3882$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $792a36b8a96c3882$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $94VKa.isProxy)(props) || $792a36b8a96c3882$var$InternalObjectKey in props ? (0, $eGzkv.extend)({}, props) : props;
}
function $792a36b8a96c3882$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $792a36b8a96c3882$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $792a36b8a96c3882$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $eGzkv.isArray)(ref) ? ref.concat($792a36b8a96c3882$var$normalizeRef(extraProps)) : [
            ref,
            $792a36b8a96c3882$var$normalizeRef(extraProps)
        ] : $792a36b8a96c3882$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $792a36b8a96c3882$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $792a36b8a96c3882$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $792a36b8a96c3882$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $792a36b8a96c3882$var$deepCloneVNode(vnode) {
    const cloned = $792a36b8a96c3882$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $eGzkv.isArray)(vnode.children)) cloned.children = vnode.children.map($792a36b8a96c3882$var$deepCloneVNode);
    return cloned;
}
function $792a36b8a96c3882$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$5f1af8db9871e1d6, null, text, flag);
}
function $792a36b8a96c3882$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $792a36b8a96c3882$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($792a36b8a96c3882$export$e7eaa45e502fe5cc(), $792a36b8a96c3882$export$9f2dfe8048dfb22b($792a36b8a96c3882$export$4d299b491347818a, null, text)) : $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$4d299b491347818a, null, text);
}
function $792a36b8a96c3882$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$4d299b491347818a);
    else if ((0, $eGzkv.isArray)(child)) return $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $792a36b8a96c3882$var$cloneIfMounted(child);
    else return $792a36b8a96c3882$export$bf5c4cf060303d58($792a36b8a96c3882$export$5f1af8db9871e1d6, null, String(child));
}
function $792a36b8a96c3882$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $792a36b8a96c3882$export$ee4f9e12c0a92a1a(child);
}
function $792a36b8a96c3882$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $eGzkv.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $792a36b8a96c3882$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($792a36b8a96c3882$var$InternalObjectKey in children)) children._ctx = $792a36b8a96c3882$var$currentRenderingInstance;
            else if (slotFlag === 3 && $792a36b8a96c3882$var$currentRenderingInstance) {
                if ($792a36b8a96c3882$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $eGzkv.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $792a36b8a96c3882$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $792a36b8a96c3882$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $792a36b8a96c3882$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $eGzkv.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $eGzkv.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $eGzkv.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $eGzkv.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $792a36b8a96c3882$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $792a36b8a96c3882$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $792a36b8a96c3882$var$emptyAppContext = $792a36b8a96c3882$var$createAppContext();
let $792a36b8a96c3882$var$uid = 0;
function $792a36b8a96c3882$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $792a36b8a96c3882$var$emptyAppContext;
    const instance = {
        uid: $792a36b8a96c3882$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $94VKa.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $792a36b8a96c3882$var$normalizePropsOptions(type, appContext),
        emitsOptions: $792a36b8a96c3882$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $eGzkv.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $eGzkv.EMPTY_OBJ),
        data: (0, $eGzkv.EMPTY_OBJ),
        props: (0, $eGzkv.EMPTY_OBJ),
        attrs: (0, $eGzkv.EMPTY_OBJ),
        slots: (0, $eGzkv.EMPTY_OBJ),
        refs: (0, $eGzkv.EMPTY_OBJ),
        setupState: (0, $eGzkv.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $792a36b8a96c3882$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $792a36b8a96c3882$var$currentInstance = null;
const $792a36b8a96c3882$export$f13e630aa3915748 = ()=>$792a36b8a96c3882$var$currentInstance || $792a36b8a96c3882$var$currentRenderingInstance;
let $792a36b8a96c3882$var$internalSetCurrentInstance;
let $792a36b8a96c3882$var$globalCurrentInstanceSetters;
let $792a36b8a96c3882$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($792a36b8a96c3882$var$globalCurrentInstanceSetters = (0, $eGzkv.getGlobalThis)()[$792a36b8a96c3882$var$settersKey])) $792a36b8a96c3882$var$globalCurrentInstanceSetters = (0, $eGzkv.getGlobalThis)()[$792a36b8a96c3882$var$settersKey] = [];
$792a36b8a96c3882$var$globalCurrentInstanceSetters.push((i)=>$792a36b8a96c3882$var$currentInstance = i);
$792a36b8a96c3882$var$internalSetCurrentInstance = (instance)=>{
    if ($792a36b8a96c3882$var$globalCurrentInstanceSetters.length > 1) $792a36b8a96c3882$var$globalCurrentInstanceSetters.forEach((s)=>s(instance));
    else $792a36b8a96c3882$var$globalCurrentInstanceSetters[0](instance);
};
const $792a36b8a96c3882$var$setCurrentInstance = (instance)=>{
    $792a36b8a96c3882$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
const $792a36b8a96c3882$var$unsetCurrentInstance = ()=>{
    $792a36b8a96c3882$var$currentInstance && $792a36b8a96c3882$var$currentInstance.scope.off();
    $792a36b8a96c3882$var$internalSetCurrentInstance(null);
};
const $792a36b8a96c3882$var$isBuiltInTag = /* @__PURE__ */ (0, $eGzkv.makeMap)("slot,component");
function $792a36b8a96c3882$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $eGzkv.NO);
    if ($792a36b8a96c3882$var$isBuiltInTag(name) || appIsNativeTag(name)) $792a36b8a96c3882$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $792a36b8a96c3882$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $792a36b8a96c3882$var$isInSSRComponentSetup = false;
function $792a36b8a96c3882$var$setupComponent(instance, isSSR = false) {
    $792a36b8a96c3882$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $792a36b8a96c3882$var$isStatefulComponent(instance);
    $792a36b8a96c3882$var$initProps(instance, props, isStateful, isSSR);
    $792a36b8a96c3882$var$initSlots(instance, children);
    const setupResult = isStateful ? $792a36b8a96c3882$var$setupStatefulComponent(instance, isSSR) : void 0;
    $792a36b8a96c3882$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $792a36b8a96c3882$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $94VKa.markRaw)(new Proxy(instance.ctx, $792a36b8a96c3882$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $792a36b8a96c3882$var$createSetupContext(instance) : null;
        $792a36b8a96c3882$var$setCurrentInstance(instance);
        (0, $94VKa.pauseTracking)();
        const setupResult = $792a36b8a96c3882$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $94VKa.resetTracking)();
        $792a36b8a96c3882$var$unsetCurrentInstance();
        if ((0, $eGzkv.isPromise)(setupResult)) {
            setupResult.then($792a36b8a96c3882$var$unsetCurrentInstance, $792a36b8a96c3882$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $792a36b8a96c3882$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $792a36b8a96c3882$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $792a36b8a96c3882$var$handleSetupResult(instance, setupResult, isSSR);
    } else $792a36b8a96c3882$var$finishComponentSetup(instance, isSSR);
}
function $792a36b8a96c3882$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $eGzkv.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $eGzkv.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $94VKa.proxyRefs)(setupResult);
    }
    $792a36b8a96c3882$var$finishComponentSetup(instance, isSSR);
}
let $792a36b8a96c3882$var$compile;
let $792a36b8a96c3882$var$installWithProxy;
function $792a36b8a96c3882$export$667bb5a67822b941(_compile) {
    $792a36b8a96c3882$var$compile = _compile;
    $792a36b8a96c3882$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $792a36b8a96c3882$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $792a36b8a96c3882$export$c93a9c496c5211fa = ()=>!$792a36b8a96c3882$var$compile;
function $792a36b8a96c3882$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $792a36b8a96c3882$var$compile && !Component.render) {
            const template = Component.template || $792a36b8a96c3882$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $eGzkv.extend)((0, $eGzkv.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $792a36b8a96c3882$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $eGzkv.NOOP);
        if ($792a36b8a96c3882$var$installWithProxy) $792a36b8a96c3882$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $792a36b8a96c3882$var$setCurrentInstance(instance);
        (0, $94VKa.pauseTracking)();
        $792a36b8a96c3882$var$applyOptions(instance);
        (0, $94VKa.resetTracking)();
        $792a36b8a96c3882$var$unsetCurrentInstance();
    }
}
function $792a36b8a96c3882$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $94VKa.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $792a36b8a96c3882$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $94VKa.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $792a36b8a96c3882$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $792a36b8a96c3882$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $792a36b8a96c3882$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $94VKa.proxyRefs)((0, $94VKa.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $792a36b8a96c3882$var$publicPropertiesMap) return $792a36b8a96c3882$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $792a36b8a96c3882$var$publicPropertiesMap;
        }
    }));
}
const $792a36b8a96c3882$var$classifyRE = /(?:^|[-_])(\w)/g;
const $792a36b8a96c3882$var$classify = (str)=>str.replace($792a36b8a96c3882$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $792a36b8a96c3882$var$getComponentName(Component, includeInferred = true) {
    return (0, $eGzkv.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $792a36b8a96c3882$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $792a36b8a96c3882$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $792a36b8a96c3882$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $792a36b8a96c3882$var$isClassComponent(value1) {
    return (0, $eGzkv.isFunction)(value1) && "__vccOpts" in value1;
}
const $792a36b8a96c3882$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $94VKa.computed)(getterOrOptions, debugOptions, $792a36b8a96c3882$var$isInSSRComponentSetup);
};
function $792a36b8a96c3882$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $eGzkv.isObject)(propsOrChildren) && !(0, $eGzkv.isArray)(propsOrChildren)) {
            if ($792a36b8a96c3882$export$3868d13f8734ae81(propsOrChildren)) return $792a36b8a96c3882$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $792a36b8a96c3882$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $792a36b8a96c3882$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $792a36b8a96c3882$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $792a36b8a96c3882$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $792a36b8a96c3882$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $792a36b8a96c3882$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $792a36b8a96c3882$export$a976684a0efeb93f($792a36b8a96c3882$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $792a36b8a96c3882$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $792a36b8a96c3882$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $94VKa.toRaw)(instance.props)));
        if (instance.setupState !== (0, $eGzkv.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $eGzkv.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $94VKa.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $eGzkv.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $eGzkv.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $94VKa.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $eGzkv.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $eGzkv.isArray)(opts) && opts.includes(key) || (0, $eGzkv.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($792a36b8a96c3882$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $792a36b8a96c3882$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $792a36b8a96c3882$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $792a36b8a96c3882$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $eGzkv.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($792a36b8a96c3882$var$isBlockTreeEnabled > 0 && $792a36b8a96c3882$var$currentBlock) $792a36b8a96c3882$var$currentBlock.push(cached);
    return true;
}
const $792a36b8a96c3882$export$83d89fbfd8236492 = "3.3.4";
const $792a36b8a96c3882$var$_ssrUtils = {
    createComponentInstance: $792a36b8a96c3882$var$createComponentInstance,
    setupComponent: $792a36b8a96c3882$var$setupComponent,
    renderComponentRoot: $792a36b8a96c3882$var$renderComponentRoot,
    setCurrentRenderingInstance: $792a36b8a96c3882$var$setCurrentRenderingInstance,
    isVNode: $792a36b8a96c3882$export$3868d13f8734ae81,
    normalizeVNode: $792a36b8a96c3882$var$normalizeVNode
};
const $792a36b8a96c3882$export$a9679033567b336d = $792a36b8a96c3882$var$_ssrUtils;
const $792a36b8a96c3882$export$83cf26e06ea620e1 = null;
const $792a36b8a96c3882$export$dc678eddf276286e = null;

});
parcelRequire.register("94VKa", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $69c147723d682a8b$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "getCurrentScope", function () { return $69c147723d682a8b$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $69c147723d682a8b$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $69c147723d682a8b$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $69c147723d682a8b$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $69c147723d682a8b$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $69c147723d682a8b$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $69c147723d682a8b$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $69c147723d682a8b$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $69c147723d682a8b$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $69c147723d682a8b$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $69c147723d682a8b$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $69c147723d682a8b$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $69c147723d682a8b$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $69c147723d682a8b$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $69c147723d682a8b$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "proxyRefs", function () { return $69c147723d682a8b$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "computed", function () { return $69c147723d682a8b$export$2983e091f1a1e8e2; });

var $eGzkv = parcelRequire("eGzkv");
function $69c147723d682a8b$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $69c147723d682a8b$var$activeEffectScope;
class $69c147723d682a8b$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $69c147723d682a8b$var$activeEffectScope;
        if (!detached && $69c147723d682a8b$var$activeEffectScope) this.index = ($69c147723d682a8b$var$activeEffectScope.scopes || ($69c147723d682a8b$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $69c147723d682a8b$var$activeEffectScope;
            try {
                $69c147723d682a8b$var$activeEffectScope = this;
                return fn();
            } finally{
                $69c147723d682a8b$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $69c147723d682a8b$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $69c147723d682a8b$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $69c147723d682a8b$export$7056603ea81600be(detached) {
    return new $69c147723d682a8b$export$1168ed9dbc71ddbd(detached);
}
function $69c147723d682a8b$var$recordEffectScope(effect, scope = $69c147723d682a8b$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $69c147723d682a8b$export$c7be4b0125a10cba() {
    return $69c147723d682a8b$var$activeEffectScope;
}
function $69c147723d682a8b$export$a780418acd4762da(fn) {
    if ($69c147723d682a8b$var$activeEffectScope) $69c147723d682a8b$var$activeEffectScope.cleanups.push(fn);
}
const $69c147723d682a8b$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $69c147723d682a8b$var$wasTracked = (dep)=>(dep.w & $69c147723d682a8b$var$trackOpBit) > 0;
const $69c147723d682a8b$var$newTracked = (dep)=>(dep.n & $69c147723d682a8b$var$trackOpBit) > 0;
const $69c147723d682a8b$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $69c147723d682a8b$var$trackOpBit;
};
const $69c147723d682a8b$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($69c147723d682a8b$var$wasTracked(dep) && !$69c147723d682a8b$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$69c147723d682a8b$var$trackOpBit;
            dep.n &= ~$69c147723d682a8b$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $69c147723d682a8b$var$targetMap = /* @__PURE__ */ new WeakMap();
let $69c147723d682a8b$var$effectTrackDepth = 0;
let $69c147723d682a8b$var$trackOpBit = 1;
const $69c147723d682a8b$var$maxMarkerBits = 30;
let $69c147723d682a8b$var$activeEffect;
const $69c147723d682a8b$export$3c41b1a4e06acc14 = Symbol("");
const $69c147723d682a8b$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $69c147723d682a8b$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $69c147723d682a8b$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $69c147723d682a8b$var$activeEffect;
        let lastShouldTrack = $69c147723d682a8b$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $69c147723d682a8b$var$activeEffect;
            $69c147723d682a8b$var$activeEffect = this;
            $69c147723d682a8b$var$shouldTrack = true;
            $69c147723d682a8b$var$trackOpBit = 1 << ++$69c147723d682a8b$var$effectTrackDepth;
            if ($69c147723d682a8b$var$effectTrackDepth <= $69c147723d682a8b$var$maxMarkerBits) $69c147723d682a8b$var$initDepMarkers(this);
            else $69c147723d682a8b$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($69c147723d682a8b$var$effectTrackDepth <= $69c147723d682a8b$var$maxMarkerBits) $69c147723d682a8b$var$finalizeDepMarkers(this);
            $69c147723d682a8b$var$trackOpBit = 1 << --$69c147723d682a8b$var$effectTrackDepth;
            $69c147723d682a8b$var$activeEffect = this.parent;
            $69c147723d682a8b$var$shouldTrack = lastShouldTrack;
            this.parent = void 0;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        if ($69c147723d682a8b$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $69c147723d682a8b$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $69c147723d682a8b$var$cleanupEffect(effect2) {
    const { deps: deps } = effect2;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $69c147723d682a8b$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $69c147723d682a8b$export$28352bb4dd362521(fn);
    if (options) {
        (0, $eGzkv.extend)(_effect, options);
        if (options.scope) $69c147723d682a8b$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $69c147723d682a8b$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $69c147723d682a8b$var$shouldTrack = true;
const $69c147723d682a8b$var$trackStack = [];
function $69c147723d682a8b$export$938a971395fef855() {
    $69c147723d682a8b$var$trackStack.push($69c147723d682a8b$var$shouldTrack);
    $69c147723d682a8b$var$shouldTrack = false;
}
function $69c147723d682a8b$export$1f8ffc6fd33b1d16() {
    $69c147723d682a8b$var$trackStack.push($69c147723d682a8b$var$shouldTrack);
    $69c147723d682a8b$var$shouldTrack = true;
}
function $69c147723d682a8b$export$c39176b1babaa8b8() {
    const last = $69c147723d682a8b$var$trackStack.pop();
    $69c147723d682a8b$var$shouldTrack = last === void 0 ? true : last;
}
function $69c147723d682a8b$export$6b2a7d5132615086(target, type, key) {
    if ($69c147723d682a8b$var$shouldTrack && $69c147723d682a8b$var$activeEffect) {
        let depsMap = $69c147723d682a8b$var$targetMap.get(target);
        if (!depsMap) $69c147723d682a8b$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $69c147723d682a8b$var$createDep());
        const eventInfo = void 0;
        $69c147723d682a8b$var$trackEffects(dep, eventInfo);
    }
}
function $69c147723d682a8b$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack2 = false;
    if ($69c147723d682a8b$var$effectTrackDepth <= $69c147723d682a8b$var$maxMarkerBits) {
        if (!$69c147723d682a8b$var$newTracked(dep)) {
            dep.n |= $69c147723d682a8b$var$trackOpBit;
            shouldTrack2 = !$69c147723d682a8b$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($69c147723d682a8b$var$activeEffect);
    if (shouldTrack2) {
        dep.add($69c147723d682a8b$var$activeEffect);
        $69c147723d682a8b$var$activeEffect.deps.push(dep);
    }
}
function $69c147723d682a8b$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $69c147723d682a8b$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $eGzkv.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $eGzkv.isArray)(target)) {
                    deps.push(depsMap.get($69c147723d682a8b$export$3c41b1a4e06acc14));
                    if ((0, $eGzkv.isMap)(target)) deps.push(depsMap.get($69c147723d682a8b$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $eGzkv.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $eGzkv.isArray)(target)) {
                    deps.push(depsMap.get($69c147723d682a8b$export$3c41b1a4e06acc14));
                    if ((0, $eGzkv.isMap)(target)) deps.push(depsMap.get($69c147723d682a8b$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $eGzkv.isMap)(target)) deps.push(depsMap.get($69c147723d682a8b$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $69c147723d682a8b$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $69c147723d682a8b$var$triggerEffects($69c147723d682a8b$var$createDep(effects));
    }
}
function $69c147723d682a8b$var$triggerEffects(dep, debuggerEventExtraInfo) {
    const effects = (0, $eGzkv.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect2 of effects)if (effect2.computed) $69c147723d682a8b$var$triggerEffect(effect2, debuggerEventExtraInfo);
    for (const effect2 of effects)if (!effect2.computed) $69c147723d682a8b$var$triggerEffect(effect2, debuggerEventExtraInfo);
}
function $69c147723d682a8b$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $69c147723d682a8b$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $69c147723d682a8b$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $69c147723d682a8b$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $69c147723d682a8b$var$isNonTrackableKeys = /* @__PURE__ */ (0, $eGzkv.makeMap)(`__proto__,__v_isRef,__isVue`);
const $69c147723d682a8b$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $eGzkv.isSymbol)));
const $69c147723d682a8b$var$get$1 = /* @__PURE__ */ $69c147723d682a8b$var$createGetter();
const $69c147723d682a8b$var$shallowGet = /* @__PURE__ */ $69c147723d682a8b$var$createGetter(false, true);
const $69c147723d682a8b$var$readonlyGet = /* @__PURE__ */ $69c147723d682a8b$var$createGetter(true);
const $69c147723d682a8b$var$shallowReadonlyGet = /* @__PURE__ */ $69c147723d682a8b$var$createGetter(true, true);
const $69c147723d682a8b$var$arrayInstrumentations = /* @__PURE__ */ $69c147723d682a8b$var$createArrayInstrumentations();
function $69c147723d682a8b$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $69c147723d682a8b$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$69c147723d682a8b$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($69c147723d682a8b$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $69c147723d682a8b$export$938a971395fef855();
            const res = $69c147723d682a8b$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $69c147723d682a8b$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $69c147723d682a8b$var$hasOwnProperty(key) {
    const obj = $69c147723d682a8b$export$ab18938b9fc5f28e(this);
    $69c147723d682a8b$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
function $69c147723d682a8b$var$createGetter(isReadonly2 = false, shallow = false) {
    return function get2(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $69c147723d682a8b$var$shallowReadonlyMap : $69c147723d682a8b$var$readonlyMap : shallow ? $69c147723d682a8b$var$shallowReactiveMap : $69c147723d682a8b$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $eGzkv.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $eGzkv.hasOwn)($69c147723d682a8b$var$arrayInstrumentations, key)) return Reflect.get($69c147723d682a8b$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $69c147723d682a8b$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $eGzkv.isSymbol)(key) ? $69c147723d682a8b$var$builtInSymbols.has(key) : $69c147723d682a8b$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $69c147723d682a8b$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($69c147723d682a8b$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $eGzkv.isIntegerKey)(key) ? res : res.value;
        if ((0, $eGzkv.isObject)(res)) return isReadonly2 ? $69c147723d682a8b$export$6ec456bd5b7b3c51(res) : $69c147723d682a8b$export$90a44edba14e47be(res);
        return res;
    };
}
const $69c147723d682a8b$var$set$1 = /* @__PURE__ */ $69c147723d682a8b$var$createSetter();
const $69c147723d682a8b$var$shallowSet = /* @__PURE__ */ $69c147723d682a8b$var$createSetter(true);
function $69c147723d682a8b$var$createSetter(shallow = false) {
    return function set2(target, key, value, receiver) {
        let oldValue = target[key];
        if ($69c147723d682a8b$export$92d09b48637741e7(oldValue) && $69c147723d682a8b$export$4f9f5282de18fc69(oldValue) && !$69c147723d682a8b$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$69c147723d682a8b$export$7f3fe6025abfa26e(value) && !$69c147723d682a8b$export$92d09b48637741e7(value)) {
                oldValue = $69c147723d682a8b$export$ab18938b9fc5f28e(oldValue);
                value = $69c147723d682a8b$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $eGzkv.isArray)(target) && $69c147723d682a8b$export$4f9f5282de18fc69(oldValue) && !$69c147723d682a8b$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $eGzkv.isArray)(target) && (0, $eGzkv.isIntegerKey)(key) ? Number(key) < target.length : (0, $eGzkv.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $69c147723d682a8b$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $69c147723d682a8b$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $eGzkv.hasChanged)(value, oldValue)) $69c147723d682a8b$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $69c147723d682a8b$var$deleteProperty(target, key) {
    const hadKey = (0, $eGzkv.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $69c147723d682a8b$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $69c147723d682a8b$var$has$1(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $eGzkv.isSymbol)(key) || !$69c147723d682a8b$var$builtInSymbols.has(key)) $69c147723d682a8b$export$6b2a7d5132615086(target, "has", key);
    return result;
}
function $69c147723d682a8b$var$ownKeys(target) {
    $69c147723d682a8b$export$6b2a7d5132615086(target, "iterate", (0, $eGzkv.isArray)(target) ? "length" : $69c147723d682a8b$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $69c147723d682a8b$var$mutableHandlers = {
    get: $69c147723d682a8b$var$get$1,
    set: $69c147723d682a8b$var$set$1,
    deleteProperty: $69c147723d682a8b$var$deleteProperty,
    has: $69c147723d682a8b$var$has$1,
    ownKeys: $69c147723d682a8b$var$ownKeys
};
const $69c147723d682a8b$var$readonlyHandlers = {
    get: $69c147723d682a8b$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $69c147723d682a8b$var$shallowReactiveHandlers = /* @__PURE__ */ (0, $eGzkv.extend)({}, $69c147723d682a8b$var$mutableHandlers, {
    get: $69c147723d682a8b$var$shallowGet,
    set: $69c147723d682a8b$var$shallowSet
});
const $69c147723d682a8b$var$shallowReadonlyHandlers = /* @__PURE__ */ (0, $eGzkv.extend)({}, $69c147723d682a8b$var$readonlyHandlers, {
    get: $69c147723d682a8b$var$shallowReadonlyGet
});
const $69c147723d682a8b$var$toShallow = (value)=>value;
const $69c147723d682a8b$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $69c147723d682a8b$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $69c147723d682a8b$export$ab18938b9fc5f28e(target);
    const rawKey = $69c147723d682a8b$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $69c147723d682a8b$export$6b2a7d5132615086(rawTarget, "get", key);
        $69c147723d682a8b$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $69c147723d682a8b$var$getProto(rawTarget);
    const wrap = isShallow ? $69c147723d682a8b$var$toShallow : isReadonly ? $69c147723d682a8b$var$toReadonly : $69c147723d682a8b$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $69c147723d682a8b$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $69c147723d682a8b$export$ab18938b9fc5f28e(target);
    const rawKey = $69c147723d682a8b$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $69c147723d682a8b$export$6b2a7d5132615086(rawTarget, "has", key);
        $69c147723d682a8b$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $69c147723d682a8b$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $69c147723d682a8b$export$6b2a7d5132615086($69c147723d682a8b$export$ab18938b9fc5f28e(target), "iterate", $69c147723d682a8b$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $69c147723d682a8b$var$add(value) {
    value = $69c147723d682a8b$export$ab18938b9fc5f28e(value);
    const target = $69c147723d682a8b$export$ab18938b9fc5f28e(this);
    const proto = $69c147723d682a8b$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $69c147723d682a8b$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $69c147723d682a8b$var$set(key, value) {
    value = $69c147723d682a8b$export$ab18938b9fc5f28e(value);
    const target = $69c147723d682a8b$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $69c147723d682a8b$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $69c147723d682a8b$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $69c147723d682a8b$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $eGzkv.hasChanged)(value, oldValue)) $69c147723d682a8b$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $69c147723d682a8b$var$deleteEntry(key) {
    const target = $69c147723d682a8b$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $69c147723d682a8b$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $69c147723d682a8b$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $69c147723d682a8b$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $69c147723d682a8b$var$clear() {
    const target = $69c147723d682a8b$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $69c147723d682a8b$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $69c147723d682a8b$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $69c147723d682a8b$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $69c147723d682a8b$var$toShallow : isReadonly ? $69c147723d682a8b$var$toReadonly : $69c147723d682a8b$var$toReactive;
        !isReadonly && $69c147723d682a8b$export$6b2a7d5132615086(rawTarget, "iterate", $69c147723d682a8b$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $69c147723d682a8b$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $69c147723d682a8b$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $eGzkv.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $69c147723d682a8b$var$toShallow : isReadonly ? $69c147723d682a8b$var$toReadonly : $69c147723d682a8b$var$toReactive;
        !isReadonly && $69c147723d682a8b$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $69c147723d682a8b$var$MAP_KEY_ITERATE_KEY : $69c147723d682a8b$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $69c147723d682a8b$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : this;
    };
}
function $69c147723d682a8b$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $69c147723d682a8b$var$get(this, key);
        },
        get size () {
            return $69c147723d682a8b$var$size(this);
        },
        has: $69c147723d682a8b$var$has,
        add: $69c147723d682a8b$var$add,
        set: $69c147723d682a8b$var$set,
        delete: $69c147723d682a8b$var$deleteEntry,
        clear: $69c147723d682a8b$var$clear,
        forEach: $69c147723d682a8b$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $69c147723d682a8b$var$get(this, key, false, true);
        },
        get size () {
            return $69c147723d682a8b$var$size(this);
        },
        has: $69c147723d682a8b$var$has,
        add: $69c147723d682a8b$var$add,
        set: $69c147723d682a8b$var$set,
        delete: $69c147723d682a8b$var$deleteEntry,
        clear: $69c147723d682a8b$var$clear,
        forEach: $69c147723d682a8b$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $69c147723d682a8b$var$get(this, key, true);
        },
        get size () {
            return $69c147723d682a8b$var$size(this, true);
        },
        has (key) {
            return $69c147723d682a8b$var$has.call(this, key, true);
        },
        add: $69c147723d682a8b$var$createReadonlyMethod("add"),
        set: $69c147723d682a8b$var$createReadonlyMethod("set"),
        delete: $69c147723d682a8b$var$createReadonlyMethod("delete"),
        clear: $69c147723d682a8b$var$createReadonlyMethod("clear"),
        forEach: $69c147723d682a8b$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $69c147723d682a8b$var$get(this, key, true, true);
        },
        get size () {
            return $69c147723d682a8b$var$size(this, true);
        },
        has (key) {
            return $69c147723d682a8b$var$has.call(this, key, true);
        },
        add: $69c147723d682a8b$var$createReadonlyMethod("add"),
        set: $69c147723d682a8b$var$createReadonlyMethod("set"),
        delete: $69c147723d682a8b$var$createReadonlyMethod("delete"),
        clear: $69c147723d682a8b$var$createReadonlyMethod("clear"),
        forEach: $69c147723d682a8b$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $69c147723d682a8b$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $69c147723d682a8b$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $69c147723d682a8b$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $69c147723d682a8b$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$69c147723d682a8b$var$mutableInstrumentations, $69c147723d682a8b$var$readonlyInstrumentations, $69c147723d682a8b$var$shallowInstrumentations, $69c147723d682a8b$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $69c147723d682a8b$var$createInstrumentations();
function $69c147723d682a8b$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $69c147723d682a8b$var$shallowReadonlyInstrumentations : $69c147723d682a8b$var$shallowInstrumentations : isReadonly ? $69c147723d682a8b$var$readonlyInstrumentations : $69c147723d682a8b$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $eGzkv.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $69c147723d682a8b$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $69c147723d682a8b$var$createInstrumentationGetter(false, false)
};
const $69c147723d682a8b$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $69c147723d682a8b$var$createInstrumentationGetter(false, true)
};
const $69c147723d682a8b$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $69c147723d682a8b$var$createInstrumentationGetter(true, false)
};
const $69c147723d682a8b$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $69c147723d682a8b$var$createInstrumentationGetter(true, true)
};
function $69c147723d682a8b$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $69c147723d682a8b$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $eGzkv.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $69c147723d682a8b$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $69c147723d682a8b$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $69c147723d682a8b$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $69c147723d682a8b$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $69c147723d682a8b$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $69c147723d682a8b$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $69c147723d682a8b$var$targetTypeMap((0, $eGzkv.toRawType)(value));
}
function $69c147723d682a8b$export$90a44edba14e47be(target) {
    if ($69c147723d682a8b$export$92d09b48637741e7(target)) return target;
    return $69c147723d682a8b$var$createReactiveObject(target, false, $69c147723d682a8b$var$mutableHandlers, $69c147723d682a8b$var$mutableCollectionHandlers, $69c147723d682a8b$var$reactiveMap);
}
function $69c147723d682a8b$export$8d81cefd22d22260(target) {
    return $69c147723d682a8b$var$createReactiveObject(target, false, $69c147723d682a8b$var$shallowReactiveHandlers, $69c147723d682a8b$var$shallowCollectionHandlers, $69c147723d682a8b$var$shallowReactiveMap);
}
function $69c147723d682a8b$export$6ec456bd5b7b3c51(target) {
    return $69c147723d682a8b$var$createReactiveObject(target, true, $69c147723d682a8b$var$readonlyHandlers, $69c147723d682a8b$var$readonlyCollectionHandlers, $69c147723d682a8b$var$readonlyMap);
}
function $69c147723d682a8b$export$7c4b5f2b50f09f6b(target) {
    return $69c147723d682a8b$var$createReactiveObject(target, true, $69c147723d682a8b$var$shallowReadonlyHandlers, $69c147723d682a8b$var$shallowReadonlyCollectionHandlers, $69c147723d682a8b$var$shallowReadonlyMap);
}
function $69c147723d682a8b$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $eGzkv.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $69c147723d682a8b$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $69c147723d682a8b$export$352205f445242f02(value) {
    if ($69c147723d682a8b$export$92d09b48637741e7(value)) return $69c147723d682a8b$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $69c147723d682a8b$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $69c147723d682a8b$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $69c147723d682a8b$export$5f3ca29d057519b3(value) {
    return $69c147723d682a8b$export$352205f445242f02(value) || $69c147723d682a8b$export$92d09b48637741e7(value);
}
function $69c147723d682a8b$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $69c147723d682a8b$export$ab18938b9fc5f28e(raw) : observed;
}
function $69c147723d682a8b$export$995ab8b13ad7a9d0(value) {
    (0, $eGzkv.def)(value, "__v_skip", true);
    return value;
}
const $69c147723d682a8b$var$toReactive = (value)=>(0, $eGzkv.isObject)(value) ? $69c147723d682a8b$export$90a44edba14e47be(value) : value;
const $69c147723d682a8b$var$toReadonly = (value)=>(0, $eGzkv.isObject)(value) ? $69c147723d682a8b$export$6ec456bd5b7b3c51(value) : value;
function $69c147723d682a8b$var$trackRefValue(ref2) {
    if ($69c147723d682a8b$var$shouldTrack && $69c147723d682a8b$var$activeEffect) {
        ref2 = $69c147723d682a8b$export$ab18938b9fc5f28e(ref2);
        $69c147723d682a8b$var$trackEffects(ref2.dep || (ref2.dep = $69c147723d682a8b$var$createDep()));
    }
}
function $69c147723d682a8b$var$triggerRefValue(ref2, newVal) {
    ref2 = $69c147723d682a8b$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $69c147723d682a8b$var$triggerEffects(dep);
}
function $69c147723d682a8b$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $69c147723d682a8b$export$eff4d24c3ff7876e(value) {
    return $69c147723d682a8b$var$createRef(value, false);
}
function $69c147723d682a8b$export$9b7bc5fe3b17c8b3(value) {
    return $69c147723d682a8b$var$createRef(value, true);
}
function $69c147723d682a8b$var$createRef(rawValue, shallow) {
    if ($69c147723d682a8b$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $69c147723d682a8b$var$RefImpl(rawValue, shallow);
}
class $69c147723d682a8b$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $69c147723d682a8b$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $69c147723d682a8b$var$toReactive(value);
    }
    get value() {
        $69c147723d682a8b$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $69c147723d682a8b$export$7f3fe6025abfa26e(newVal) || $69c147723d682a8b$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $69c147723d682a8b$export$ab18938b9fc5f28e(newVal);
        if ((0, $eGzkv.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $69c147723d682a8b$var$toReactive(newVal);
            $69c147723d682a8b$var$triggerRefValue(this, newVal);
        }
    }
}
function $69c147723d682a8b$export$f402f86588575ccc(ref2) {
    $69c147723d682a8b$var$triggerRefValue(ref2, void 0);
}
function $69c147723d682a8b$export$a239a76781616204(ref2) {
    return $69c147723d682a8b$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $69c147723d682a8b$export$30bdcc2218aa9458(source) {
    return (0, $eGzkv.isFunction)(source) ? source() : $69c147723d682a8b$export$a239a76781616204(source);
}
const $69c147723d682a8b$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$69c147723d682a8b$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($69c147723d682a8b$export$4f9f5282de18fc69(oldValue) && !$69c147723d682a8b$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $69c147723d682a8b$export$f353fd1b97db3fa0(objectWithRefs) {
    return $69c147723d682a8b$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $69c147723d682a8b$var$shallowUnwrapHandlers);
}
class $69c147723d682a8b$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$69c147723d682a8b$var$trackRefValue(this), ()=>$69c147723d682a8b$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $69c147723d682a8b$export$a20c2dd6199824cb(factory) {
    return new $69c147723d682a8b$var$CustomRefImpl(factory);
}
function $69c147723d682a8b$export$2e9533675e5e70e0(object) {
    const ret = (0, $eGzkv.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $69c147723d682a8b$var$propertyToRef(object, key);
    return ret;
}
class $69c147723d682a8b$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $69c147723d682a8b$var$getDepFromReactive($69c147723d682a8b$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $69c147723d682a8b$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $69c147723d682a8b$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($69c147723d682a8b$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $eGzkv.isFunction)(source)) return new $69c147723d682a8b$var$GetterRefImpl(source);
    else if ((0, $eGzkv.isObject)(source) && arguments.length > 1) return $69c147723d682a8b$var$propertyToRef(source, key, defaultValue);
    else return $69c147723d682a8b$export$eff4d24c3ff7876e(source);
}
function $69c147723d682a8b$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $69c147723d682a8b$export$4f9f5282de18fc69(val) ? val : new $69c147723d682a8b$var$ObjectRefImpl(source, key, defaultValue);
}
class $69c147723d682a8b$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $69c147723d682a8b$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $69c147723d682a8b$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $69c147723d682a8b$export$ab18938b9fc5f28e(this);
        $69c147723d682a8b$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function $69c147723d682a8b$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $eGzkv.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $eGzkv.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $69c147723d682a8b$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
const $69c147723d682a8b$var$tick = /* @__PURE__ */ Promise.resolve();
const $69c147723d682a8b$var$queue = [];
let $69c147723d682a8b$var$queued = false;
const $69c147723d682a8b$var$scheduler = (fn)=>{
    $69c147723d682a8b$var$queue.push(fn);
    if (!$69c147723d682a8b$var$queued) {
        $69c147723d682a8b$var$queued = true;
        $69c147723d682a8b$var$tick.then($69c147723d682a8b$var$flush);
    }
};
const $69c147723d682a8b$var$flush = ()=>{
    for(let i = 0; i < $69c147723d682a8b$var$queue.length; i++)$69c147723d682a8b$var$queue[i]();
    $69c147723d682a8b$var$queue.length = 0;
    $69c147723d682a8b$var$queued = false;
};
class $69c147723d682a8b$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $69c147723d682a8b$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $69c147723d682a8b$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $69c147723d682a8b$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                for (const e of this.dep)if (e.computed instanceof $69c147723d682a8b$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $69c147723d682a8b$var$trackRefValue(this);
        return $69c147723d682a8b$export$ab18938b9fc5f28e(this)._get();
    }
}
function $69c147723d682a8b$export$483264c4ec4c46ce(getter) {
    return new $69c147723d682a8b$var$DeferredComputedRefImpl(getter);
}

});
parcelRequire.register("eGzkv", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $ab1064ab098eae22$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $ab1064ab098eae22$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $ab1064ab098eae22$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $ab1064ab098eae22$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $ab1064ab098eae22$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $ab1064ab098eae22$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $ab1064ab098eae22$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $ab1064ab098eae22$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $ab1064ab098eae22$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $ab1064ab098eae22$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $ab1064ab098eae22$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $ab1064ab098eae22$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $ab1064ab098eae22$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $ab1064ab098eae22$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $ab1064ab098eae22$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $ab1064ab098eae22$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $ab1064ab098eae22$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $ab1064ab098eae22$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $ab1064ab098eae22$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $ab1064ab098eae22$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $ab1064ab098eae22$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $ab1064ab098eae22$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $ab1064ab098eae22$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $ab1064ab098eae22$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $ab1064ab098eae22$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $ab1064ab098eae22$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $ab1064ab098eae22$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $ab1064ab098eae22$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $ab1064ab098eae22$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $ab1064ab098eae22$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $ab1064ab098eae22$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $ab1064ab098eae22$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $ab1064ab098eae22$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $ab1064ab098eae22$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $ab1064ab098eae22$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "normalizeStyle", function () { return $ab1064ab098eae22$export$8756898546458274; });
$parcel$export(module.exports, "normalizeClass", function () { return $ab1064ab098eae22$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "toDisplayString", function () { return $ab1064ab098eae22$export$b5b1545233b45293; });
function $ab1064ab098eae22$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $ab1064ab098eae22$export$cf583d23ab39677c = {};
const $ab1064ab098eae22$export$6bd8558f433f1cc1 = [];
const $ab1064ab098eae22$export$5702a91a6f42969f = ()=>{};
const $ab1064ab098eae22$export$c01351c0af048e39 = ()=>false;
const $ab1064ab098eae22$var$onRE = /^on[^a-z]/;
const $ab1064ab098eae22$export$1a2d97de39ecbb75 = (key)=>$ab1064ab098eae22$var$onRE.test(key);
const $ab1064ab098eae22$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $ab1064ab098eae22$export$8b58be045bf06082 = Object.assign;
const $ab1064ab098eae22$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $ab1064ab098eae22$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $ab1064ab098eae22$export$b5a638e9b3fff9f3 = (val, key)=>$ab1064ab098eae22$var$hasOwnProperty.call(val, key);
const $ab1064ab098eae22$export$43bee75e5e14138e = Array.isArray;
const $ab1064ab098eae22$export$5c90113a285f2241 = (val)=>$ab1064ab098eae22$export$1dccc787cc36538b(val) === "[object Map]";
const $ab1064ab098eae22$export$6750766a7c7ec627 = (val)=>$ab1064ab098eae22$export$1dccc787cc36538b(val) === "[object Set]";
const $ab1064ab098eae22$export$871608497c498473 = (val)=>$ab1064ab098eae22$export$1dccc787cc36538b(val) === "[object Date]";
const $ab1064ab098eae22$export$49841c62b9eff15 = (val)=>$ab1064ab098eae22$export$1dccc787cc36538b(val) === "[object RegExp]";
const $ab1064ab098eae22$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $ab1064ab098eae22$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $ab1064ab098eae22$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $ab1064ab098eae22$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $ab1064ab098eae22$export$4369c812aac99591 = (val)=>{
    return $ab1064ab098eae22$export$a6cdc56e425d0d0a(val) && $ab1064ab098eae22$export$f6e2535fb5126e54(val.then) && $ab1064ab098eae22$export$f6e2535fb5126e54(val.catch);
};
const $ab1064ab098eae22$export$830c053460e5ddf6 = Object.prototype.toString;
const $ab1064ab098eae22$export$1dccc787cc36538b = (value)=>$ab1064ab098eae22$export$830c053460e5ddf6.call(value);
const $ab1064ab098eae22$export$5ad0a3c360b8fbb5 = (value)=>{
    return $ab1064ab098eae22$export$1dccc787cc36538b(value).slice(8, -1);
};
const $ab1064ab098eae22$export$53b83ca8eaab0383 = (val)=>$ab1064ab098eae22$export$1dccc787cc36538b(val) === "[object Object]";
const $ab1064ab098eae22$export$e2a2b93446ec9fe = (key)=>$ab1064ab098eae22$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $ab1064ab098eae22$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $ab1064ab098eae22$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $ab1064ab098eae22$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $ab1064ab098eae22$var$camelizeRE = /-(\w)/g;
const $ab1064ab098eae22$export$161d051f5dd25de7 = $ab1064ab098eae22$var$cacheStringFunction((str)=>{
    return str.replace($ab1064ab098eae22$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $ab1064ab098eae22$var$hyphenateRE = /\B([A-Z])/g;
const $ab1064ab098eae22$export$6e6a0a3676c4b8bb = $ab1064ab098eae22$var$cacheStringFunction((str)=>str.replace($ab1064ab098eae22$var$hyphenateRE, "-$1").toLowerCase());
const $ab1064ab098eae22$export$9a00dee1beb8f576 = $ab1064ab098eae22$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
const $ab1064ab098eae22$export$8c022799eeaaefcd = $ab1064ab098eae22$var$cacheStringFunction((str)=>str ? `on${$ab1064ab098eae22$export$9a00dee1beb8f576(str)}` : ``);
const $ab1064ab098eae22$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $ab1064ab098eae22$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $ab1064ab098eae22$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $ab1064ab098eae22$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $ab1064ab098eae22$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $ab1064ab098eae22$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $ab1064ab098eae22$var$_globalThis;
const $ab1064ab098eae22$export$ff5f2eeb11fc7e14 = ()=>{
    return $ab1064ab098eae22$var$_globalThis || ($ab1064ab098eae22$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $ab1064ab098eae22$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $ab1064ab098eae22$export$53d5e12f9a1d3cde(name) {
    return $ab1064ab098eae22$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $ab1064ab098eae22$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $ab1064ab098eae22$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $ab1064ab098eae22$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $ab1064ab098eae22$export$d6571a1911e4f27e = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8($ab1064ab098eae22$var$GLOBALS_WHITE_LISTED);
const $ab1064ab098eae22$var$range = 2;
function $ab1064ab098eae22$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $ab1064ab098eae22$var$range; j <= i + $ab1064ab098eae22$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $ab1064ab098eae22$export$8756898546458274(value) {
    if ($ab1064ab098eae22$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $ab1064ab098eae22$export$844ec244b1367d54(item) ? $ab1064ab098eae22$export$76a205ce979d066a(item) : $ab1064ab098eae22$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($ab1064ab098eae22$export$844ec244b1367d54(value)) return value;
    else if ($ab1064ab098eae22$export$a6cdc56e425d0d0a(value)) return value;
}
const $ab1064ab098eae22$var$listDelimiterRE = /;(?![^(]*\))/g;
const $ab1064ab098eae22$var$propertyDelimiterRE = /:([^]+)/;
const $ab1064ab098eae22$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $ab1064ab098eae22$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($ab1064ab098eae22$var$styleCommentRE, "").split($ab1064ab098eae22$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($ab1064ab098eae22$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $ab1064ab098eae22$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $ab1064ab098eae22$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $ab1064ab098eae22$export$6e6a0a3676c4b8bb(key);
        if ($ab1064ab098eae22$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $ab1064ab098eae22$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($ab1064ab098eae22$export$844ec244b1367d54(value)) res = value;
    else if ($ab1064ab098eae22$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $ab1064ab098eae22$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($ab1064ab098eae22$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $ab1064ab098eae22$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$ab1064ab098eae22$export$844ec244b1367d54(klass)) props.class = $ab1064ab098eae22$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $ab1064ab098eae22$export$8756898546458274(style);
    return props;
}
const $ab1064ab098eae22$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $ab1064ab098eae22$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $ab1064ab098eae22$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $ab1064ab098eae22$export$1ccf854a0984f890 = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8($ab1064ab098eae22$var$HTML_TAGS);
const $ab1064ab098eae22$export$6328ce7565ea1049 = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8($ab1064ab098eae22$var$SVG_TAGS);
const $ab1064ab098eae22$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8($ab1064ab098eae22$var$VOID_TAGS);
const $ab1064ab098eae22$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $ab1064ab098eae22$export$d186f5eb2e810715 = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8($ab1064ab098eae22$var$specialBooleanAttrs);
const $ab1064ab098eae22$export$f763ba3b84e9cd8c = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8($ab1064ab098eae22$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $ab1064ab098eae22$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $ab1064ab098eae22$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $ab1064ab098eae22$var$attrValidationCache = {};
function $ab1064ab098eae22$export$d55ef77660f30d12(name) {
    if ($ab1064ab098eae22$var$attrValidationCache.hasOwnProperty(name)) return $ab1064ab098eae22$var$attrValidationCache[name];
    const isUnsafe = $ab1064ab098eae22$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $ab1064ab098eae22$var$attrValidationCache[name] = !isUnsafe;
}
const $ab1064ab098eae22$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $ab1064ab098eae22$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $ab1064ab098eae22$export$80da416f43933831 = /* @__PURE__ */ $ab1064ab098eae22$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $ab1064ab098eae22$var$escapeRE = /["'&<>]/;
function $ab1064ab098eae22$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $ab1064ab098eae22$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $ab1064ab098eae22$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $ab1064ab098eae22$export$7b105034a53bde5f(src) {
    return src.replace($ab1064ab098eae22$var$commentStripRE, "");
}
function $ab1064ab098eae22$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $ab1064ab098eae22$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $ab1064ab098eae22$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $ab1064ab098eae22$export$871608497c498473(a);
    let bValidType = $ab1064ab098eae22$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $ab1064ab098eae22$export$a244864fd9645c7f(a);
    bValidType = $ab1064ab098eae22$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $ab1064ab098eae22$export$43bee75e5e14138e(a);
    bValidType = $ab1064ab098eae22$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $ab1064ab098eae22$var$looseCompareArrays(a, b) : false;
    aValidType = $ab1064ab098eae22$export$a6cdc56e425d0d0a(a);
    bValidType = $ab1064ab098eae22$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$ab1064ab098eae22$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $ab1064ab098eae22$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$ab1064ab098eae22$export$ae8015769846262c(item, val));
}
const $ab1064ab098eae22$export$b5b1545233b45293 = (val)=>{
    return $ab1064ab098eae22$export$844ec244b1367d54(val) ? val : val == null ? "" : $ab1064ab098eae22$export$43bee75e5e14138e(val) || $ab1064ab098eae22$export$a6cdc56e425d0d0a(val) && (val.toString === $ab1064ab098eae22$export$830c053460e5ddf6 || !$ab1064ab098eae22$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $ab1064ab098eae22$var$replacer, 2) : String(val);
};
const $ab1064ab098eae22$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $ab1064ab098eae22$var$replacer(_key, val.value);
    else if ($ab1064ab098eae22$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($ab1064ab098eae22$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($ab1064ab098eae22$export$a6cdc56e425d0d0a(val) && !$ab1064ab098eae22$export$43bee75e5e14138e(val) && !$ab1064ab098eae22$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});



parcelRequire.register("br4tA", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("aoXob")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("aoXob")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("aoXob")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("eGzkv")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("aoXob")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("aoXob")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("aoXob")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("aoXob")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("aoXob")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("aoXob")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("aoXob")).createRenderer; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("aoXob")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("aoXob")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("aoXob")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("aoXob")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("aoXob")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("aoXob")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("aoXob")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("aoXob")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("aoXob")).initCustomFormatter; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("aoXob")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("aoXob")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("eGzkv")).normalizeClass; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("aoXob")).onBeforeUnmount; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("aoXob")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("aoXob")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("aoXob")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("aoXob")).openBlock; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("94VKa")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("aoXob")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("aoXob")).renderSlot; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("aoXob")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("aoXob")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("aoXob")).Static; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("94VKa")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("aoXob")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("aoXob")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("aoXob")).watch; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("aoXob")).watchPostEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("aoXob")).withCtx; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("eGzkv")).toDisplayString; });

$parcel$export(module.exports, "createApp", function () { return $8535b02e916aea73$export$4e373c34abfa8c68; });
parcelRequire("aoXob");
var $eGzkv = parcelRequire("eGzkv");
var $aoXob = parcelRequire("aoXob");
var $94VKa = parcelRequire("94VKa");parcelRequire("eGzkv");

var $lfOsO = parcelRequire("lfOsO");
const $8535b02e916aea73$var$svgNS = "http://www.w3.org/2000/svg";
const $8535b02e916aea73$var$doc = typeof document !== "undefined" ? document : null;
const $8535b02e916aea73$var$templateContainer = $8535b02e916aea73$var$doc && /* @__PURE__ */ $8535b02e916aea73$var$doc.createElement("template");
const $8535b02e916aea73$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $8535b02e916aea73$var$doc.createElementNS($8535b02e916aea73$var$svgNS, tag) : $8535b02e916aea73$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$8535b02e916aea73$var$doc.createTextNode(text),
    createComment: (text)=>$8535b02e916aea73$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$8535b02e916aea73$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $8535b02e916aea73$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $8535b02e916aea73$var$templateContainer.content;
            if (isSVG) {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
function $8535b02e916aea73$var$patchClass(el, value, isSVG) {
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $8535b02e916aea73$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $lfOsO.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $lfOsO.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $8535b02e916aea73$var$setStyle(style, key, "");
        }
        for(const key in next)$8535b02e916aea73$var$setStyle(style, key, next[key]);
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $8535b02e916aea73$var$semicolonRE = /[^\\];\s*$/;
const $8535b02e916aea73$var$importantRE = /\s*!important$/;
function $8535b02e916aea73$var$setStyle(style, name, val) {
    if ((0, $lfOsO.isArray)(val)) val.forEach((v)=>$8535b02e916aea73$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $8535b02e916aea73$var$autoPrefix(style, name);
            if ($8535b02e916aea73$var$importantRE.test(val)) style.setProperty((0, $lfOsO.hyphenate)(prefixed), val.replace($8535b02e916aea73$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $8535b02e916aea73$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $8535b02e916aea73$var$prefixCache = {};
function $8535b02e916aea73$var$autoPrefix(style, rawName) {
    const cached = $8535b02e916aea73$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $eGzkv.camelize)(rawName);
    if (name !== "filter" && name in style) return $8535b02e916aea73$var$prefixCache[rawName] = name;
    name = (0, $lfOsO.capitalize)(name);
    for(let i = 0; i < $8535b02e916aea73$var$prefixes.length; i++){
        const prefixed = $8535b02e916aea73$var$prefixes[i] + name;
        if (prefixed in style) return $8535b02e916aea73$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $8535b02e916aea73$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $8535b02e916aea73$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($8535b02e916aea73$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($8535b02e916aea73$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $lfOsO.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $lfOsO.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $8535b02e916aea73$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        const oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $lfOsO.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $8535b02e916aea73$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $8535b02e916aea73$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $8535b02e916aea73$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $8535b02e916aea73$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $8535b02e916aea73$var$createInvoker(nextValue, instance);
            $8535b02e916aea73$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $8535b02e916aea73$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $8535b02e916aea73$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $8535b02e916aea73$var$parseName(name) {
    let options;
    if ($8535b02e916aea73$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($8535b02e916aea73$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $lfOsO.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $8535b02e916aea73$var$cachedNow = 0;
const $8535b02e916aea73$var$p = /* @__PURE__ */ Promise.resolve();
const $8535b02e916aea73$var$getNow = ()=>$8535b02e916aea73$var$cachedNow || ($8535b02e916aea73$var$p.then(()=>$8535b02e916aea73$var$cachedNow = 0), $8535b02e916aea73$var$cachedNow = Date.now());
function $8535b02e916aea73$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $aoXob.callWithAsyncErrorHandling)($8535b02e916aea73$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $8535b02e916aea73$var$getNow();
    return invoker;
}
function $8535b02e916aea73$var$patchStopImmediatePropagation(e, value) {
    if ((0, $lfOsO.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $8535b02e916aea73$var$nativeOnRE = /^on[a-z]/;
const $8535b02e916aea73$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $8535b02e916aea73$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $8535b02e916aea73$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $lfOsO.isOn)(key)) {
        if (!(0, $lfOsO.isModelListener)(key)) $8535b02e916aea73$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $8535b02e916aea73$var$shouldSetAsProp(el, key, nextValue, isSVG)) $8535b02e916aea73$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $8535b02e916aea73$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $8535b02e916aea73$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $8535b02e916aea73$var$nativeOnRE.test(key) && (0, $lfOsO.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($8535b02e916aea73$var$nativeOnRE.test(key) && (0, $lfOsO.isString)(value)) return false;
    return key in el;
}
function $8535b02e916aea73$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $aoXob.defineComponent)(options);
    class VueCustomElement extends $8535b02e916aea73$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $8535b02e916aea73$export$6debb2e68f212638 = (options)=>{
    return $8535b02e916aea73$export$a00e2346eabbdbef(options, $8535b02e916aea73$export$fa8d919ba61d84db);
};
const $8535b02e916aea73$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $8535b02e916aea73$export$b337c1a55163dbe3 extends $8535b02e916aea73$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $aoXob.nextTick)(()=>{
            if (!this._connected) {
                $8535b02e916aea73$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $lfOsO.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $lfOsO.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $lfOsO.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $lfOsO.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $lfOsO.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $lfOsO.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $lfOsO.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $lfOsO.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $lfOsO.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $lfOsO.hyphenate)(key));
            }
        }
    }
    _update() {
        $8535b02e916aea73$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $aoXob.createVNode)(this._def, (0, $lfOsO.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $lfOsO.hyphenate)(event) !== event) dispatch((0, $lfOsO.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $8535b02e916aea73$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $8535b02e916aea73$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $aoXob.getCurrentInstance)();
        if (!instance) return 0, $lfOsO.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $lfOsO.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $lfOsO.EMPTY_OBJ;
        return mod;
    }
}
function $8535b02e916aea73$export$ef28b76f07940108(getter) {
    const instance = (0, $aoXob.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$8535b02e916aea73$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $8535b02e916aea73$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $aoXob.watchPostEffect)(setVars);
    (0, $aoXob.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $aoXob.onUnmounted)(()=>ob.disconnect());
    });
}
function $8535b02e916aea73$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $8535b02e916aea73$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $8535b02e916aea73$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $aoXob.Fragment)) vnode.children.forEach((c)=>$8535b02e916aea73$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $aoXob.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $8535b02e916aea73$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $8535b02e916aea73$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $8535b02e916aea73$var$TRANSITION = "transition";
const $8535b02e916aea73$var$ANIMATION = "animation";
const $8535b02e916aea73$export$be58926105124dd4 = (props, { slots: slots })=>(0, $aoXob.h)((0, $aoXob.BaseTransition), $8535b02e916aea73$var$resolveTransitionProps(props), slots);
$8535b02e916aea73$export$be58926105124dd4.displayName = "Transition";
const $8535b02e916aea73$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $8535b02e916aea73$var$TransitionPropsValidators = $8535b02e916aea73$export$be58926105124dd4.props = /* @__PURE__ */ (0, $lfOsO.extend)({}, (0, $aoXob.BaseTransitionPropsValidators), $8535b02e916aea73$var$DOMTransitionPropsValidators);
const $8535b02e916aea73$var$callHook = (hook, args = [])=>{
    if ((0, $lfOsO.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $8535b02e916aea73$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $lfOsO.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $8535b02e916aea73$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $8535b02e916aea73$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $8535b02e916aea73$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $8535b02e916aea73$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $8535b02e916aea73$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $8535b02e916aea73$var$removeTransitionClass(el, leaveFromClass);
        $8535b02e916aea73$var$removeTransitionClass(el, leaveToClass);
        $8535b02e916aea73$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $8535b02e916aea73$var$callHook(hook, [
                el,
                resolve
            ]);
            $8535b02e916aea73$var$nextFrame(()=>{
                $8535b02e916aea73$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $8535b02e916aea73$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$8535b02e916aea73$var$hasExplicitCallback(hook)) $8535b02e916aea73$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $lfOsO.extend)(baseProps, {
        onBeforeEnter (el) {
            $8535b02e916aea73$var$callHook(onBeforeEnter, [
                el
            ]);
            $8535b02e916aea73$var$addTransitionClass(el, enterFromClass);
            $8535b02e916aea73$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $8535b02e916aea73$var$callHook(onBeforeAppear, [
                el
            ]);
            $8535b02e916aea73$var$addTransitionClass(el, appearFromClass);
            $8535b02e916aea73$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $8535b02e916aea73$var$addTransitionClass(el, leaveFromClass);
            $8535b02e916aea73$var$forceReflow();
            $8535b02e916aea73$var$addTransitionClass(el, leaveActiveClass);
            $8535b02e916aea73$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $8535b02e916aea73$var$removeTransitionClass(el, leaveFromClass);
                $8535b02e916aea73$var$addTransitionClass(el, leaveToClass);
                if (!$8535b02e916aea73$var$hasExplicitCallback(onLeave)) $8535b02e916aea73$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $8535b02e916aea73$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $8535b02e916aea73$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $8535b02e916aea73$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $8535b02e916aea73$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $8535b02e916aea73$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $lfOsO.isObject)(duration)) return [
        $8535b02e916aea73$var$NumberOf(duration.enter),
        $8535b02e916aea73$var$NumberOf(duration.leave)
    ];
    else {
        const n = $8535b02e916aea73$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $8535b02e916aea73$var$NumberOf(val) {
    const res = (0, $lfOsO.toNumber)(val);
    return res;
}
function $8535b02e916aea73$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function $8535b02e916aea73$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = void 0;
    }
}
function $8535b02e916aea73$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $8535b02e916aea73$var$endId = 0;
function $8535b02e916aea73$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$8535b02e916aea73$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $8535b02e916aea73$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $8535b02e916aea73$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$8535b02e916aea73$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$8535b02e916aea73$var$TRANSITION}Duration`);
    const transitionTimeout = $8535b02e916aea73$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$8535b02e916aea73$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$8535b02e916aea73$var$ANIMATION}Duration`);
    const animationTimeout = $8535b02e916aea73$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $8535b02e916aea73$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $8535b02e916aea73$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $8535b02e916aea73$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $8535b02e916aea73$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $8535b02e916aea73$var$TRANSITION : $8535b02e916aea73$var$ANIMATION : null;
        propCount = type ? type === $8535b02e916aea73$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $8535b02e916aea73$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$8535b02e916aea73$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $8535b02e916aea73$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$8535b02e916aea73$var$toMs(d) + $8535b02e916aea73$var$toMs(delays[i])));
}
function $8535b02e916aea73$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $8535b02e916aea73$var$forceReflow() {
    return document.body.offsetHeight;
}
const $8535b02e916aea73$var$positionMap = /* @__PURE__ */ new WeakMap();
const $8535b02e916aea73$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $8535b02e916aea73$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $lfOsO.extend)({}, $8535b02e916aea73$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $aoXob.getCurrentInstance)();
        const state = (0, $aoXob.useTransitionState)();
        let prevChildren;
        let children;
        (0, $aoXob.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$8535b02e916aea73$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($8535b02e916aea73$var$callPendingCbs);
            prevChildren.forEach($8535b02e916aea73$var$recordPosition);
            const movedChildren = prevChildren.filter($8535b02e916aea73$var$applyTranslation);
            $8535b02e916aea73$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $8535b02e916aea73$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $8535b02e916aea73$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $94VKa.toRaw)(props);
            const cssTransitionProps = $8535b02e916aea73$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $aoXob.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $aoXob.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $aoXob.setTransitionHooks)(child, (0, $aoXob.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $aoXob.setTransitionHooks)(child, (0, $aoXob.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $8535b02e916aea73$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $aoXob.createVNode)(tag, null, children);
        };
    }
};
const $8535b02e916aea73$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $8535b02e916aea73$var$removeMode($8535b02e916aea73$var$TransitionGroupImpl.props);
const $8535b02e916aea73$export$19ffa8f511f7bc2e = $8535b02e916aea73$var$TransitionGroupImpl;
function $8535b02e916aea73$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $8535b02e916aea73$var$recordPosition(c) {
    $8535b02e916aea73$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $8535b02e916aea73$var$applyTranslation(c) {
    const oldPos = $8535b02e916aea73$var$positionMap.get(c);
    const newPos = $8535b02e916aea73$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $8535b02e916aea73$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $8535b02e916aea73$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $8535b02e916aea73$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $lfOsO.isArray)(fn) ? (value)=>(0, $lfOsO.invokeArrayFns)(fn, value) : fn;
};
function $8535b02e916aea73$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $8535b02e916aea73$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $8535b02e916aea73$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $8535b02e916aea73$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $lfOsO.looseToNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $8535b02e916aea73$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $8535b02e916aea73$var$addEventListener(el, "compositionstart", $8535b02e916aea73$var$onCompositionStart);
            $8535b02e916aea73$var$addEventListener(el, "compositionend", $8535b02e916aea73$var$onCompositionEnd);
            $8535b02e916aea73$var$addEventListener(el, "change", $8535b02e916aea73$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $lfOsO.looseToNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $8535b02e916aea73$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
        $8535b02e916aea73$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $8535b02e916aea73$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $lfOsO.isArray)(modelValue)) {
                const index = (0, $lfOsO.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $lfOsO.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($8535b02e916aea73$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $8535b02e916aea73$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
        $8535b02e916aea73$var$setChecked(el, binding, vnode);
    }
};
function $8535b02e916aea73$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $lfOsO.isArray)(value)) el.checked = (0, $lfOsO.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $lfOsO.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $lfOsO.looseEqual)(value, $8535b02e916aea73$var$getCheckboxValue(el, true));
}
const $8535b02e916aea73$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $lfOsO.looseEqual)(value, vnode.props.value);
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
        $8535b02e916aea73$var$addEventListener(el, "change", ()=>{
            el._assign($8535b02e916aea73$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $lfOsO.looseEqual)(value, vnode.props.value);
    }
};
const $8535b02e916aea73$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $lfOsO.isSet)(value);
        $8535b02e916aea73$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $lfOsO.looseToNumber)($8535b02e916aea73$var$getValue(o)) : $8535b02e916aea73$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $8535b02e916aea73$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $8535b02e916aea73$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $8535b02e916aea73$var$setSelected(el, value);
    }
};
function $8535b02e916aea73$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $lfOsO.isArray)(value) && !(0, $lfOsO.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $8535b02e916aea73$var$getValue(option);
        if (isMultiple) {
            if ((0, $lfOsO.isArray)(value)) option.selected = (0, $lfOsO.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $lfOsO.looseEqual)($8535b02e916aea73$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $8535b02e916aea73$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $8535b02e916aea73$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $8535b02e916aea73$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $8535b02e916aea73$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $8535b02e916aea73$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $8535b02e916aea73$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $8535b02e916aea73$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $8535b02e916aea73$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $8535b02e916aea73$export$87d227567b51ca39;
        case "TEXTAREA":
            return $8535b02e916aea73$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $8535b02e916aea73$export$8847c2e532b35714;
                case "radio":
                    return $8535b02e916aea73$export$b4356c59b38b7aa9;
                default:
                    return $8535b02e916aea73$export$f1f88689f5728478;
            }
    }
}
function $8535b02e916aea73$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $8535b02e916aea73$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $8535b02e916aea73$var$initVModelForSSR() {
    $8535b02e916aea73$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $8535b02e916aea73$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $lfOsO.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $8535b02e916aea73$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $lfOsO.isArray)(value)) {
            if (vnode.props && (0, $lfOsO.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $lfOsO.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $8535b02e916aea73$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $8535b02e916aea73$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $8535b02e916aea73$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $8535b02e916aea73$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$8535b02e916aea73$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $8535b02e916aea73$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $8535b02e916aea73$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
const $8535b02e916aea73$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $8535b02e916aea73$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $lfOsO.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $8535b02e916aea73$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $8535b02e916aea73$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $8535b02e916aea73$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $8535b02e916aea73$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $8535b02e916aea73$var$setDisplay(el, false);
            });
        } else $8535b02e916aea73$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $8535b02e916aea73$var$setDisplay(el, value);
    }
};
function $8535b02e916aea73$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
function $8535b02e916aea73$var$initVShowForSSR() {
    $8535b02e916aea73$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $8535b02e916aea73$var$rendererOptions = /* @__PURE__ */ (0, $lfOsO.extend)({
    patchProp: $8535b02e916aea73$var$patchProp
}, $8535b02e916aea73$var$nodeOps);
let $8535b02e916aea73$var$renderer;
let $8535b02e916aea73$var$enabledHydration = false;
function $8535b02e916aea73$var$ensureRenderer() {
    return $8535b02e916aea73$var$renderer || ($8535b02e916aea73$var$renderer = (0, $aoXob.createRenderer)($8535b02e916aea73$var$rendererOptions));
}
function $8535b02e916aea73$var$ensureHydrationRenderer() {
    $8535b02e916aea73$var$renderer = $8535b02e916aea73$var$enabledHydration ? $8535b02e916aea73$var$renderer : (0, $aoXob.createHydrationRenderer)($8535b02e916aea73$var$rendererOptions);
    $8535b02e916aea73$var$enabledHydration = true;
    return $8535b02e916aea73$var$renderer;
}
const $8535b02e916aea73$export$b3890eb0ae9dca99 = (...args)=>{
    $8535b02e916aea73$var$ensureRenderer().render(...args);
};
const $8535b02e916aea73$export$fa8d919ba61d84db = (...args)=>{
    $8535b02e916aea73$var$ensureHydrationRenderer().hydrate(...args);
};
const $8535b02e916aea73$export$4e373c34abfa8c68 = (...args)=>{
    const app = $8535b02e916aea73$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $8535b02e916aea73$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $lfOsO.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $8535b02e916aea73$export$35800275c0037383 = (...args)=>{
    const app = $8535b02e916aea73$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $8535b02e916aea73$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $8535b02e916aea73$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $lfOsO.isHTMLTag)(tag) || (0, $lfOsO.isSVGTag)(tag),
        writable: false
    });
}
function $8535b02e916aea73$var$injectCompilerOptionsCheck(app) {
    if ((0, $aoXob.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $aoXob.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $aoXob.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $aoXob.warn)(msg);
            }
        });
    }
}
function $8535b02e916aea73$var$normalizeContainer(container) {
    if ((0, $lfOsO.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $8535b02e916aea73$var$ssrDirectiveInitialized = false;
const $8535b02e916aea73$export$800b28255aa678d9 = ()=>{
    if (!$8535b02e916aea73$var$ssrDirectiveInitialized) {
        $8535b02e916aea73$var$ssrDirectiveInitialized = true;
        $8535b02e916aea73$var$initVModelForSSR();
        $8535b02e916aea73$var$initVShowForSSR();
    }
};

});
parcelRequire.register("lfOsO", function(module, exports) {

$parcel$export(module.exports, "EMPTY_OBJ", function () { return $f79224bef4b37cc1$export$cf583d23ab39677c; });
$parcel$export(module.exports, "isOn", function () { return $f79224bef4b37cc1$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $f79224bef4b37cc1$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $f79224bef4b37cc1$export$8b58be045bf06082; });
$parcel$export(module.exports, "isArray", function () { return $f79224bef4b37cc1$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isSet", function () { return $f79224bef4b37cc1$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isFunction", function () { return $f79224bef4b37cc1$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $f79224bef4b37cc1$export$844ec244b1367d54; });
$parcel$export(module.exports, "isObject", function () { return $f79224bef4b37cc1$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "camelize", function () { return $f79224bef4b37cc1$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $f79224bef4b37cc1$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $f79224bef4b37cc1$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $f79224bef4b37cc1$export$39951422d618a9d3; });
$parcel$export(module.exports, "looseToNumber", function () { return $f79224bef4b37cc1$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $f79224bef4b37cc1$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "isHTMLTag", function () { return $f79224bef4b37cc1$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $f79224bef4b37cc1$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $f79224bef4b37cc1$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $f79224bef4b37cc1$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "looseEqual", function () { return $f79224bef4b37cc1$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $f79224bef4b37cc1$export$42912a80cedb8bd4; });
function $f79224bef4b37cc1$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $f79224bef4b37cc1$export$cf583d23ab39677c = {};
const $f79224bef4b37cc1$export$6bd8558f433f1cc1 = [];
const $f79224bef4b37cc1$export$5702a91a6f42969f = ()=>{};
const $f79224bef4b37cc1$export$c01351c0af048e39 = ()=>false;
const $f79224bef4b37cc1$var$onRE = /^on[^a-z]/;
const $f79224bef4b37cc1$export$1a2d97de39ecbb75 = (key)=>$f79224bef4b37cc1$var$onRE.test(key);
const $f79224bef4b37cc1$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $f79224bef4b37cc1$export$8b58be045bf06082 = Object.assign;
const $f79224bef4b37cc1$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $f79224bef4b37cc1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $f79224bef4b37cc1$export$b5a638e9b3fff9f3 = (val, key)=>$f79224bef4b37cc1$var$hasOwnProperty.call(val, key);
const $f79224bef4b37cc1$export$43bee75e5e14138e = Array.isArray;
const $f79224bef4b37cc1$export$5c90113a285f2241 = (val)=>$f79224bef4b37cc1$export$1dccc787cc36538b(val) === "[object Map]";
const $f79224bef4b37cc1$export$6750766a7c7ec627 = (val)=>$f79224bef4b37cc1$export$1dccc787cc36538b(val) === "[object Set]";
const $f79224bef4b37cc1$export$871608497c498473 = (val)=>$f79224bef4b37cc1$export$1dccc787cc36538b(val) === "[object Date]";
const $f79224bef4b37cc1$export$49841c62b9eff15 = (val)=>$f79224bef4b37cc1$export$1dccc787cc36538b(val) === "[object RegExp]";
const $f79224bef4b37cc1$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $f79224bef4b37cc1$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $f79224bef4b37cc1$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $f79224bef4b37cc1$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $f79224bef4b37cc1$export$4369c812aac99591 = (val)=>{
    return $f79224bef4b37cc1$export$a6cdc56e425d0d0a(val) && $f79224bef4b37cc1$export$f6e2535fb5126e54(val.then) && $f79224bef4b37cc1$export$f6e2535fb5126e54(val.catch);
};
const $f79224bef4b37cc1$export$830c053460e5ddf6 = Object.prototype.toString;
const $f79224bef4b37cc1$export$1dccc787cc36538b = (value)=>$f79224bef4b37cc1$export$830c053460e5ddf6.call(value);
const $f79224bef4b37cc1$export$5ad0a3c360b8fbb5 = (value)=>{
    return $f79224bef4b37cc1$export$1dccc787cc36538b(value).slice(8, -1);
};
const $f79224bef4b37cc1$export$53b83ca8eaab0383 = (val)=>$f79224bef4b37cc1$export$1dccc787cc36538b(val) === "[object Object]";
const $f79224bef4b37cc1$export$e2a2b93446ec9fe = (key)=>$f79224bef4b37cc1$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $f79224bef4b37cc1$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $f79224bef4b37cc1$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $f79224bef4b37cc1$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $f79224bef4b37cc1$var$camelizeRE = /-(\w)/g;
const $f79224bef4b37cc1$export$161d051f5dd25de7 = $f79224bef4b37cc1$var$cacheStringFunction((str)=>{
    return str.replace($f79224bef4b37cc1$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $f79224bef4b37cc1$var$hyphenateRE = /\B([A-Z])/g;
const $f79224bef4b37cc1$export$6e6a0a3676c4b8bb = $f79224bef4b37cc1$var$cacheStringFunction((str)=>str.replace($f79224bef4b37cc1$var$hyphenateRE, "-$1").toLowerCase());
const $f79224bef4b37cc1$export$9a00dee1beb8f576 = $f79224bef4b37cc1$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
const $f79224bef4b37cc1$export$8c022799eeaaefcd = $f79224bef4b37cc1$var$cacheStringFunction((str)=>str ? `on${$f79224bef4b37cc1$export$9a00dee1beb8f576(str)}` : ``);
const $f79224bef4b37cc1$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $f79224bef4b37cc1$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $f79224bef4b37cc1$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $f79224bef4b37cc1$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $f79224bef4b37cc1$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $f79224bef4b37cc1$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $f79224bef4b37cc1$var$_globalThis;
const $f79224bef4b37cc1$export$ff5f2eeb11fc7e14 = ()=>{
    return $f79224bef4b37cc1$var$_globalThis || ($f79224bef4b37cc1$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $f79224bef4b37cc1$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $f79224bef4b37cc1$export$53d5e12f9a1d3cde(name) {
    return $f79224bef4b37cc1$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $f79224bef4b37cc1$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $f79224bef4b37cc1$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $f79224bef4b37cc1$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $f79224bef4b37cc1$export$d6571a1911e4f27e = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8($f79224bef4b37cc1$var$GLOBALS_WHITE_LISTED);
const $f79224bef4b37cc1$var$range = 2;
function $f79224bef4b37cc1$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $f79224bef4b37cc1$var$range; j <= i + $f79224bef4b37cc1$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $f79224bef4b37cc1$export$8756898546458274(value) {
    if ($f79224bef4b37cc1$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $f79224bef4b37cc1$export$844ec244b1367d54(item) ? $f79224bef4b37cc1$export$76a205ce979d066a(item) : $f79224bef4b37cc1$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($f79224bef4b37cc1$export$844ec244b1367d54(value)) return value;
    else if ($f79224bef4b37cc1$export$a6cdc56e425d0d0a(value)) return value;
}
const $f79224bef4b37cc1$var$listDelimiterRE = /;(?![^(]*\))/g;
const $f79224bef4b37cc1$var$propertyDelimiterRE = /:([^]+)/;
const $f79224bef4b37cc1$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $f79224bef4b37cc1$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($f79224bef4b37cc1$var$styleCommentRE, "").split($f79224bef4b37cc1$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($f79224bef4b37cc1$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $f79224bef4b37cc1$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $f79224bef4b37cc1$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $f79224bef4b37cc1$export$6e6a0a3676c4b8bb(key);
        if ($f79224bef4b37cc1$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $f79224bef4b37cc1$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($f79224bef4b37cc1$export$844ec244b1367d54(value)) res = value;
    else if ($f79224bef4b37cc1$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $f79224bef4b37cc1$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($f79224bef4b37cc1$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $f79224bef4b37cc1$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$f79224bef4b37cc1$export$844ec244b1367d54(klass)) props.class = $f79224bef4b37cc1$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $f79224bef4b37cc1$export$8756898546458274(style);
    return props;
}
const $f79224bef4b37cc1$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $f79224bef4b37cc1$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $f79224bef4b37cc1$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $f79224bef4b37cc1$export$1ccf854a0984f890 = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8($f79224bef4b37cc1$var$HTML_TAGS);
const $f79224bef4b37cc1$export$6328ce7565ea1049 = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8($f79224bef4b37cc1$var$SVG_TAGS);
const $f79224bef4b37cc1$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8($f79224bef4b37cc1$var$VOID_TAGS);
const $f79224bef4b37cc1$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $f79224bef4b37cc1$export$d186f5eb2e810715 = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8($f79224bef4b37cc1$var$specialBooleanAttrs);
const $f79224bef4b37cc1$export$f763ba3b84e9cd8c = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8($f79224bef4b37cc1$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $f79224bef4b37cc1$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $f79224bef4b37cc1$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $f79224bef4b37cc1$var$attrValidationCache = {};
function $f79224bef4b37cc1$export$d55ef77660f30d12(name) {
    if ($f79224bef4b37cc1$var$attrValidationCache.hasOwnProperty(name)) return $f79224bef4b37cc1$var$attrValidationCache[name];
    const isUnsafe = $f79224bef4b37cc1$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $f79224bef4b37cc1$var$attrValidationCache[name] = !isUnsafe;
}
const $f79224bef4b37cc1$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $f79224bef4b37cc1$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $f79224bef4b37cc1$export$80da416f43933831 = /* @__PURE__ */ $f79224bef4b37cc1$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $f79224bef4b37cc1$var$escapeRE = /["'&<>]/;
function $f79224bef4b37cc1$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $f79224bef4b37cc1$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $f79224bef4b37cc1$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $f79224bef4b37cc1$export$7b105034a53bde5f(src) {
    return src.replace($f79224bef4b37cc1$var$commentStripRE, "");
}
function $f79224bef4b37cc1$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $f79224bef4b37cc1$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $f79224bef4b37cc1$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $f79224bef4b37cc1$export$871608497c498473(a);
    let bValidType = $f79224bef4b37cc1$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $f79224bef4b37cc1$export$a244864fd9645c7f(a);
    bValidType = $f79224bef4b37cc1$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $f79224bef4b37cc1$export$43bee75e5e14138e(a);
    bValidType = $f79224bef4b37cc1$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $f79224bef4b37cc1$var$looseCompareArrays(a, b) : false;
    aValidType = $f79224bef4b37cc1$export$a6cdc56e425d0d0a(a);
    bValidType = $f79224bef4b37cc1$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$f79224bef4b37cc1$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $f79224bef4b37cc1$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$f79224bef4b37cc1$export$ae8015769846262c(item, val));
}
const $f79224bef4b37cc1$export$b5b1545233b45293 = (val)=>{
    return $f79224bef4b37cc1$export$844ec244b1367d54(val) ? val : val == null ? "" : $f79224bef4b37cc1$export$43bee75e5e14138e(val) || $f79224bef4b37cc1$export$a6cdc56e425d0d0a(val) && (val.toString === $f79224bef4b37cc1$export$830c053460e5ddf6 || !$f79224bef4b37cc1$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $f79224bef4b37cc1$var$replacer, 2) : String(val);
};
const $f79224bef4b37cc1$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $f79224bef4b37cc1$var$replacer(_key, val.value);
    else if ($f79224bef4b37cc1$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($f79224bef4b37cc1$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($f79224bef4b37cc1$export$a6cdc56e425d0d0a(val) && !$f79224bef4b37cc1$export$43bee75e5e14138e(val) && !$f79224bef4b37cc1$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});



parcelRequire.register("1Q2lG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $156c78297501c4fa$export$2e2bcd8739ae039; });
let $156c78297501c4fa$var$script;




let $156c78297501c4fa$var$initialize = ()=>{
    $156c78297501c4fa$var$script = (parcelRequire("ceuLf"));
    if ($156c78297501c4fa$var$script.__esModule) $156c78297501c4fa$var$script = $156c78297501c4fa$var$script.default;
    $156c78297501c4fa$var$script.render = (parcelRequire("a2T1Q")).render;
    $156c78297501c4fa$var$script.__cssModules = {};
    (parcelRequire("8kSFh")).default($156c78297501c4fa$var$script);
    $156c78297501c4fa$var$script.__scopeId = "data-v-c67cb8";
    $156c78297501c4fa$var$script.__file = "ColorMixer.vue";
};
$156c78297501c4fa$var$initialize();
var $156c78297501c4fa$export$2e2bcd8739ae039 = $156c78297501c4fa$var$script;

});
parcelRequire.register("ceuLf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8e7ea75a90642148$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $94VKa = parcelRequire("94VKa");
var $aoXob = parcelRequire("aoXob");

var $iNaqQ = parcelRequire("iNaqQ");
var $8e7ea75a90642148$export$2e2bcd8739ae039 = {
    __name: "ColorMixer",
    props: {
        colorData: {
            type: Array,
            required: true
        },
        scrollToMixer: {
            type: Number,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const nodeMixCompContainer = (0, $94VKa.ref)(null);
        const nodeMixCompCanvas = (0, $94VKa.ref)(null);
        let colorMixAsString = "";
        let remixTimeout = null;
        // eslint-disable-next-line arrow-body-style
        const colorsForMixComp = (0, $aoXob.computed)(()=>{
            return props.colorData.filter((color)=>0 < color.percentage).map(({ id: id, pebbles: pebbles, percentage: percentage })=>({
                    id: id,
                    percentage: percentage,
                    images: pebbles
                }));
        });
        // value will change when user clicks button to scroll to mixer
        // eslint-disable-next-line consistent-return
        (0, $aoXob.watch)(()=>props.scrollToMixer, ()=>{
            // zero will be on page load (don't scroll in this case)
            if (0 === props.scrollToMixer) return null;
            let offsetY = nodeMixCompContainer.value.getBoundingClientRect().top + window.scrollY;
            const nodeHeader = document.getElementById("page-header");
            if (nodeHeader) offsetY -= nodeHeader.getBoundingClientRect().height;
            window.scrollTo({
                top: offsetY,
                behavior: "smooth"
            });
        });
        /**
 * Trigger mix comp to render pebbles
 *
 * @return {void}
 */ const renderMixComp = ()=>{
            const mixComp = window?.webfx?.colorMixer?.mixComp;
            // was mix comp object initiated?
            if (!mixComp) return;
            // do we have a total of 100% (or 99% in case of three colors)?
            const totalColors = colorsForMixComp.value.length;
            const totalPercentage = colorsForMixComp.value.reduce((total, color)=>total + color.percentage, 0);
            // are we clearing mix comp render?
            if (0 === totalColors) {
                mixComp.clearPebbles();
                return;
            }
            if (3 === totalColors) {
                if (99 !== totalPercentage && 100 !== totalPercentage) return;
            } else {
                // eslint-disable-next-line no-lonely-if
                if (100 !== totalPercentage) return;
            }
            mixComp.setColorData(colorsForMixComp.value);
            mixComp.mixColors();
        };
        (0, $aoXob.onMounted)(()=>{
            const diameter = window.innerHeight - document.getElementById("page-header").getBoundingClientRect().height - 50;
            // entire mix comp should always be visible (e.g. if top of comp is at top of browser, shouldn't extend past view)
            nodeMixCompContainer.value.style.setProperty("--diameter", `${diameter}px`);
            window.webfx = window.webfx || {};
            window.webfx.colorMixer = window.webfx.colorMixer || {};
            // for performance purposes, keeping MixComp/MatterJS outside of Vue's reactivity
            window.webfx.colorMixer.mixComp = new (0, $iNaqQ.MixComp)(nodeMixCompCanvas.value, nodeMixCompContainer.value);
            colorMixAsString = JSON.stringify(colorsForMixComp.value);
            renderMixComp();
        });
        (0, $aoXob.onUpdated)(()=>{
            // avoid unnecessary re-rendering
            const colorMixAsStringNew = JSON.stringify(colorsForMixComp.value);
            if (colorMixAsString === colorMixAsStringNew) return;
            colorMixAsString = colorMixAsStringNew;
            // debounce
            clearTimeout(remixTimeout);
            remixTimeout = setTimeout(renderMixComp, 500);
        });
        const __returned__ = {
            props: props,
            nodeMixCompContainer: nodeMixCompContainer,
            nodeMixCompCanvas: nodeMixCompCanvas,
            get colorMixAsString () {
                return colorMixAsString;
            },
            set colorMixAsString (v){
                colorMixAsString = v;
            },
            get remixTimeout () {
                return remixTimeout;
            },
            set remixTimeout (v){
                remixTimeout = v;
            },
            colorsForMixComp: colorsForMixComp,
            renderMixComp: renderMixComp,
            computed: $aoXob.computed,
            onMounted: $aoXob.onMounted,
            onUpdated: $aoXob.onUpdated,
            ref: $94VKa.ref,
            watch: $aoXob.watch,
            get MixComp () {
                return 0, $iNaqQ.MixComp;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRequire.register("iNaqQ", function(module, exports) {

$parcel$export(module.exports, "MixComp", function () { return $dae4e530dea034b1$export$ee8477f669488171; });

var $3637R = parcelRequire("3637R");

var $68TBk = parcelRequire("68TBk");
class $dae4e530dea034b1$export$ee8477f669488171 {
    /**
	 * Creates class instance
	 *
	 * @param {HTMLElement} canvas <canvas> element
	 * @param {HTMLElement} container Container element for <canvas>
	 * @param {int} pebbleWidth Width in pixels of pebble image
	 * @param {int} pebbleCount Number of pebbles to show in canvas element
	 */ constructor(canvas, container, pebbleWidth = 12, pebbleCount = 512){
        this.canvas = canvas;
        this.container = container;
        // don't let <canvas> get too big
        this.containerDiameter = 500;
        this.pebbles = [];
        this.pebbleWidth = pebbleWidth;
        this.pebbleCount = pebbleCount;
        this.engine = null;
        this.render = null;
        this.runner = null;
        // to be populated when user clicks "Mix Colors"
        this.colorData = null;
    }
    /**
	 * Set up MatterJS elements
	 *
	 * @return {self}
	 */ prepWorld() {
        if (null !== this.engine) return this;
        this.engine = (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Engine.create();
        // Earth is flat; avoid pebbles falling off the edge of world
        this.engine.gravity.x = 0;
        this.engine.gravity.y = 0;
        this.render = (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Render.create({
            canvas: this.canvas,
            element: this.container,
            engine: this.engine,
            options: {
                showSleeping: true,
                background: "#000",
                hasBounds: true,
                height: 500,
                width: 500,
                wireframes: false
            }
        });
        this.runner = (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Runner.create();
        return this;
    }
    /**
	 * Add color data to use for mixing pebbles
	 *
	 * @param {array} data Color data
	 * @return {void}
	 */ setColorData(data) {
        this.colorData = data;
    }
    /**
	 * Add pebble images to canvas
	 *
	 * @return {self}
	 */ mixColors() {
        this.prepWorld().generatePebbles().renderWorld();
        return this;
    }
    /**
	 * Generate pebbles to add to world
	 *
	 * @param {bool} keep If true, keep preexisting pebbles; otherwise, clear slate
	 * @return {self}
	 */ generatePebbles(keep = false) {
        if (!keep) this.clearPebbles();
        this.colorData.forEach((color)=>{
            const { images: images, percentage: percentage } = color;
            const count = Math.ceil(this.pebbleCount / (100 / percentage));
            for(let i = 0; i <= count; ++i){
                const imgIndex = (0, $68TBk.Utils).generateRandomInt(0, images.length - 1);
                const imgUrl = images[imgIndex];
                this.pebbles.push(this.createPebble(imgUrl));
                this.pebbles = (0, $68TBk.Utils).shuffleArray(this.pebbles);
            }
        });
        return this;
    }
    /**
	 * Create single pebble to add to world
	 *
	 * @param {string} url URL for pebble image
	 * @return {obj}
	 */ createPebble(url) {
        const posX = (0, $68TBk.Utils).generateRandomInt(50, this.containerDiameter - 50);
        const posY = (0, $68TBk.Utils).generateRandomInt(50, this.containerDiameter - 50);
        const angle = (0, $68TBk.Utils).generateRandomInt(0, 360);
        const pebble = (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Bodies.circle(posX, posY, this.pebbleWidth, {
            angle: angle,
            density: 5e-6,
            frictionAir: 0,
            restitution: 1,
            friction: 0.01,
            mass: 0,
            render: {
                sprite: {
                    texture: url,
                    xScale: 1.5,
                    yScale: 1.5
                }
            }
        });
        return pebble;
    }
    /**
	 * Delete preexisting pebble images from canvas
	 *
	 * @return {self}
	 */ clearPebbles() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Composite.allBodies(this.engine.world).forEach((body)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Composite.remove(this.engine.world, body);
        });
        this.pebbles = [];
        return this;
    }
    /**
	 * Add pebbles to world
	 *
	 * @return {self}
	 */ renderWorld() {
        this.container.classList.add("is-loading");
        this.canvas.classList.add("is-loading");
        (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Composite.add(this.engine.world, this.pebbles);
        (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Render.run(this.render);
        (0, (/*@__PURE__*/$parcel$interopDefault($3637R))).Runner.run(this.runner, this.engine);
        this.canvas.classList.remove("is-loading");
        this.container.classList.remove("is-loading");
        return this;
    }
    /**
	 * Get data URL for canvas
	 *
	 * @return {string}
	 */ getCanvasDataUrl() {
        return this.canvas.toDataURL();
    }
}

});
parcelRequire.register("3637R", function(module, exports) {
/*!
 * matter-js 0.18.0 by @liabru
 * http://brm.io/matter-js/
 * License MIT
 * 
 * The MIT License (MIT)
 * 
 * Copyright (c) Liam Brummitt and contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 21);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            /**
* The `Matter.Common` module contains utility functions that are common to all modules.
*
* @class Common
*/ var Common = {};
            module1.exports = Common;
            (function() {
                Common._nextId = 0;
                Common._seed = 0;
                Common._nowStartTime = +new Date();
                Common._warnedOnce = {};
                Common._decomp = null;
                /**
     * Extends the object in the first argument using the object in the second argument.
     * @method extend
     * @param {} obj
     * @param {boolean} deep
     * @return {} obj extended
     */ Common.extend = function(obj, deep) {
                    var argsStart, args, deepClone;
                    if (typeof deep === "boolean") {
                        argsStart = 2;
                        deepClone = deep;
                    } else {
                        argsStart = 1;
                        deepClone = true;
                    }
                    for(var i = argsStart; i < arguments.length; i++){
                        var source = arguments[i];
                        if (source) {
                            for(var prop in source)if (deepClone && source[prop] && source[prop].constructor === Object) {
                                if (!obj[prop] || obj[prop].constructor === Object) {
                                    obj[prop] = obj[prop] || {};
                                    Common.extend(obj[prop], deepClone, source[prop]);
                                } else obj[prop] = source[prop];
                            } else obj[prop] = source[prop];
                        }
                    }
                    return obj;
                };
                /**
     * Creates a new clone of the object, if deep is true references will also be cloned.
     * @method clone
     * @param {} obj
     * @param {bool} deep
     * @return {} obj cloned
     */ Common.clone = function(obj, deep) {
                    return Common.extend({}, deep, obj);
                };
                /**
     * Returns the list of keys for the given object.
     * @method keys
     * @param {} obj
     * @return {string[]} keys
     */ Common.keys = function(obj) {
                    if (Object.keys) return Object.keys(obj);
                    // avoid hasOwnProperty for performance
                    var keys = [];
                    for(var key in obj)keys.push(key);
                    return keys;
                };
                /**
     * Returns the list of values for the given object.
     * @method values
     * @param {} obj
     * @return {array} Array of the objects property values
     */ Common.values = function(obj) {
                    var values = [];
                    if (Object.keys) {
                        var keys = Object.keys(obj);
                        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                        return values;
                    }
                    // avoid hasOwnProperty for performance
                    for(var key in obj)values.push(obj[key]);
                    return values;
                };
                /**
     * Gets a value from `base` relative to the `path` string.
     * @method get
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} The object at the given path
     */ Common.get = function(obj, path, begin, end) {
                    path = path.split(".").slice(begin, end);
                    for(var i = 0; i < path.length; i += 1)obj = obj[path[i]];
                    return obj;
                };
                /**
     * Sets a value on `base` relative to the given `path` string.
     * @method set
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {} val The value to set
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} Pass through `val` for chaining
     */ Common.set = function(obj, path, val, begin, end) {
                    var parts = path.split(".").slice(begin, end);
                    Common.get(obj, path, 0, -1)[parts[parts.length - 1]] = val;
                    return val;
                };
                /**
     * Shuffles the given array in-place.
     * The function uses a seeded random generator.
     * @method shuffle
     * @param {array} array
     * @return {array} array shuffled randomly
     */ Common.shuffle = function(array) {
                    for(var i = array.length - 1; i > 0; i--){
                        var j = Math.floor(Common.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                };
                /**
     * Randomly chooses a value from a list with equal probability.
     * The function uses a seeded random generator.
     * @method choose
     * @param {array} choices
     * @return {object} A random choice object from the array
     */ Common.choose = function(choices) {
                    return choices[Math.floor(Common.random() * choices.length)];
                };
                /**
     * Returns true if the object is a HTMLElement, otherwise false.
     * @method isElement
     * @param {object} obj
     * @return {boolean} True if the object is a HTMLElement, otherwise false
     */ Common.isElement = function(obj) {
                    if (typeof HTMLElement !== "undefined") return obj instanceof HTMLElement;
                    return !!(obj && obj.nodeType && obj.nodeName);
                };
                /**
     * Returns true if the object is an array.
     * @method isArray
     * @param {object} obj
     * @return {boolean} True if the object is an array, otherwise false
     */ Common.isArray = function(obj) {
                    return Object.prototype.toString.call(obj) === "[object Array]";
                };
                /**
     * Returns true if the object is a function.
     * @method isFunction
     * @param {object} obj
     * @return {boolean} True if the object is a function, otherwise false
     */ Common.isFunction = function(obj) {
                    return typeof obj === "function";
                };
                /**
     * Returns true if the object is a plain object.
     * @method isPlainObject
     * @param {object} obj
     * @return {boolean} True if the object is a plain object, otherwise false
     */ Common.isPlainObject = function(obj) {
                    return typeof obj === "object" && obj.constructor === Object;
                };
                /**
     * Returns true if the object is a string.
     * @method isString
     * @param {object} obj
     * @return {boolean} True if the object is a string, otherwise false
     */ Common.isString = function(obj) {
                    return toString.call(obj) === "[object String]";
                };
                /**
     * Returns the given value clamped between a minimum and maximum value.
     * @method clamp
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @return {number} The value clamped between min and max inclusive
     */ Common.clamp = function(value, min, max) {
                    if (value < min) return min;
                    if (value > max) return max;
                    return value;
                };
                /**
     * Returns the sign of the given value.
     * @method sign
     * @param {number} value
     * @return {number} -1 if negative, +1 if 0 or positive
     */ Common.sign = function(value) {
                    return value < 0 ? -1 : 1;
                };
                /**
     * Returns the current timestamp since the time origin (e.g. from page load).
     * The result is in milliseconds and will use high-resolution timing if available.
     * @method now
     * @return {number} the current timestamp in milliseconds
     */ Common.now = function() {
                    if (typeof window !== "undefined" && window.performance) {
                        if (window.performance.now) return window.performance.now();
                        else if (window.performance.webkitNow) return window.performance.webkitNow();
                    }
                    if (Date.now) return Date.now();
                    return new Date() - Common._nowStartTime;
                };
                /**
     * Returns a random value between a minimum and a maximum value inclusive.
     * The function uses a seeded random generator.
     * @method random
     * @param {number} min
     * @param {number} max
     * @return {number} A random number between min and max inclusive
     */ Common.random = function(min, max) {
                    min = typeof min !== "undefined" ? min : 0;
                    max = typeof max !== "undefined" ? max : 1;
                    return min + _seededRandom() * (max - min);
                };
                var _seededRandom = function() {
                    // https://en.wikipedia.org/wiki/Linear_congruential_generator
                    Common._seed = (Common._seed * 9301 + 49297) % 233280;
                    return Common._seed / 233280;
                };
                /**
     * Converts a CSS hex colour string into an integer.
     * @method colorToNumber
     * @param {string} colorString
     * @return {number} An integer representing the CSS hex string
     */ Common.colorToNumber = function(colorString) {
                    colorString = colorString.replace("#", "");
                    if (colorString.length == 3) colorString = colorString.charAt(0) + colorString.charAt(0) + colorString.charAt(1) + colorString.charAt(1) + colorString.charAt(2) + colorString.charAt(2);
                    return parseInt(colorString, 16);
                };
                /**
     * The console logging level to use, where each level includes all levels above and excludes the levels below.
     * The default level is 'debug' which shows all console messages.  
     *
     * Possible level values are:
     * - 0 = None
     * - 1 = Debug
     * - 2 = Info
     * - 3 = Warn
     * - 4 = Error
     * @property Common.logLevel
     * @type {Number}
     * @default 1
     */ Common.logLevel = 1;
                /**
     * Shows a `console.log` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method log
     * @param ...objs {} The objects to log.
     */ Common.log = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.log.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.info` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method info
     * @param ...objs {} The objects to log.
     */ Common.info = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 2) console.info.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.warn` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method warn
     * @param ...objs {} The objects to log.
     */ Common.warn = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.warn.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Uses `Common.warn` to log the given message one time only.
     * @method warnOnce
     * @param ...objs {} The objects to log.
     */ Common.warnOnce = function() {
                    var message = Array.prototype.slice.call(arguments).join(" ");
                    if (!Common._warnedOnce[message]) {
                        Common.warn(message);
                        Common._warnedOnce[message] = true;
                    }
                };
                /**
     * Shows a deprecated console warning when the function on the given object is called.
     * The target function will be replaced with a new function that first shows the warning
     * and then calls the original function.
     * @method deprecated
     * @param {object} obj The object or module
     * @param {string} name The property name of the function on obj
     * @param {string} warning The one-time message to show if the function is called
     */ Common.deprecated = function(obj, prop, warning) {
                    obj[prop] = Common.chain(function() {
                        Common.warnOnce("\uD83D\uDD05 deprecated \uD83D\uDD05", warning);
                    }, obj[prop]);
                };
                /**
     * Returns the next unique sequential ID.
     * @method nextId
     * @return {Number} Unique sequential ID
     */ Common.nextId = function() {
                    return Common._nextId++;
                };
                /**
     * A cross browser compatible indexOf implementation.
     * @method indexOf
     * @param {array} haystack
     * @param {object} needle
     * @return {number} The position of needle in haystack, otherwise -1.
     */ Common.indexOf = function(haystack, needle) {
                    if (haystack.indexOf) return haystack.indexOf(needle);
                    for(var i = 0; i < haystack.length; i++){
                        if (haystack[i] === needle) return i;
                    }
                    return -1;
                };
                /**
     * A cross browser compatible array map implementation.
     * @method map
     * @param {array} list
     * @param {function} func
     * @return {array} Values from list transformed by func.
     */ Common.map = function(list, func) {
                    if (list.map) return list.map(func);
                    var mapped = [];
                    for(var i = 0; i < list.length; i += 1)mapped.push(func(list[i]));
                    return mapped;
                };
                /**
     * Takes a directed graph and returns the partially ordered set of vertices in topological order.
     * Circular dependencies are allowed.
     * @method topologicalSort
     * @param {object} graph
     * @return {array} Partially ordered set of vertices in topological order.
     */ Common.topologicalSort = function(graph) {
                    // https://github.com/mgechev/javascript-algorithms
                    // Copyright (c) Minko Gechev (MIT license)
                    // Modifications: tidy formatting and naming
                    var result = [], visited = [], temp = [];
                    for(var node in graph)if (!visited[node] && !temp[node]) Common._topologicalSort(node, visited, temp, graph, result);
                    return result;
                };
                Common._topologicalSort = function(node, visited, temp, graph, result) {
                    var neighbors = graph[node] || [];
                    temp[node] = true;
                    for(var i = 0; i < neighbors.length; i += 1){
                        var neighbor = neighbors[i];
                        if (temp[neighbor]) continue;
                        if (!visited[neighbor]) Common._topologicalSort(neighbor, visited, temp, graph, result);
                    }
                    temp[node] = false;
                    visited[node] = true;
                    result.push(node);
                };
                /**
     * Takes _n_ functions as arguments and returns a new function that calls them in order.
     * The arguments applied when calling the new function will also be applied to every function passed.
     * The value of `this` refers to the last value returned in the chain that was not `undefined`.
     * Therefore if a passed function does not return a value, the previously returned value is maintained.
     * After all passed functions have been called the new function returns the last returned value (if any).
     * If any of the passed functions are a chain, then the chain will be flattened.
     * @method chain
     * @param ...funcs {function} The functions to chain.
     * @return {function} A new function that calls the passed functions in order.
     */ Common.chain = function() {
                    var funcs = [];
                    for(var i = 0; i < arguments.length; i += 1){
                        var func = arguments[i];
                        if (func._chained) // flatten already chained functions
                        funcs.push.apply(funcs, func._chained);
                        else funcs.push(func);
                    }
                    var chain = function() {
                        // https://github.com/GoogleChrome/devtools-docs/issues/53#issuecomment-51941358
                        var lastResult, args = new Array(arguments.length);
                        for(var i = 0, l = arguments.length; i < l; i++)args[i] = arguments[i];
                        for(i = 0; i < funcs.length; i += 1){
                            var result = funcs[i].apply(lastResult, args);
                            if (typeof result !== "undefined") lastResult = result;
                        }
                        return lastResult;
                    };
                    chain._chained = funcs;
                    return chain;
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathBefore
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathBefore = function(base, path, func) {
                    return Common.set(base, path, Common.chain(func, Common.get(base, path)));
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathAfter
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathAfter = function(base, path, func) {
                    return Common.set(base, path, Common.chain(Common.get(base, path), func));
                };
                /**
     * Provide the [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module to enable
     * concave vertex decomposition support when using `Bodies.fromVertices` e.g. `Common.setDecomp(require('poly-decomp'))`.
     * @method setDecomp
     * @param {} decomp The [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module.
     */ Common.setDecomp = function(decomp) {
                    Common._decomp = decomp;
                };
                /**
     * Returns the [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module provided through `Common.setDecomp`,
     * otherwise returns the global `decomp` if set.
     * @method getDecomp
     * @return {} The [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module if provided.
     */ Common.getDecomp = function() {
                    // get user provided decomp if set
                    var decomp = Common._decomp;
                    try {
                        // otherwise from window global
                        if (!decomp && typeof window !== "undefined") decomp = window.decomp;
                        // otherwise from node global
                        if (!decomp && typeof $parcel$global !== "undefined") decomp = $parcel$global.decomp;
                    } catch (e) {
                        // decomp not available
                        decomp = null;
                    }
                    return decomp;
                };
            })();
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /**
* The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
*
* @class Bounds
*/ var Bounds = {};
            module1.exports = Bounds;
            (function() {
                /**
     * Creates a new axis-aligned bounding box (AABB) for the given vertices.
     * @method create
     * @param {vertices} vertices
     * @return {bounds} A new bounds object
     */ Bounds.create = function(vertices) {
                    var bounds = {
                        min: {
                            x: 0,
                            y: 0
                        },
                        max: {
                            x: 0,
                            y: 0
                        }
                    };
                    if (vertices) Bounds.update(bounds, vertices);
                    return bounds;
                };
                /**
     * Updates bounds using the given vertices and extends the bounds given a velocity.
     * @method update
     * @param {bounds} bounds
     * @param {vertices} vertices
     * @param {vector} velocity
     */ Bounds.update = function(bounds, vertices, velocity) {
                    bounds.min.x = Infinity;
                    bounds.max.x = -Infinity;
                    bounds.min.y = Infinity;
                    bounds.max.y = -Infinity;
                    for(var i = 0; i < vertices.length; i++){
                        var vertex = vertices[i];
                        if (vertex.x > bounds.max.x) bounds.max.x = vertex.x;
                        if (vertex.x < bounds.min.x) bounds.min.x = vertex.x;
                        if (vertex.y > bounds.max.y) bounds.max.y = vertex.y;
                        if (vertex.y < bounds.min.y) bounds.min.y = vertex.y;
                    }
                    if (velocity) {
                        if (velocity.x > 0) bounds.max.x += velocity.x;
                        else bounds.min.x += velocity.x;
                        if (velocity.y > 0) bounds.max.y += velocity.y;
                        else bounds.min.y += velocity.y;
                    }
                };
                /**
     * Returns true if the bounds contains the given point.
     * @method contains
     * @param {bounds} bounds
     * @param {vector} point
     * @return {boolean} True if the bounds contain the point, otherwise false
     */ Bounds.contains = function(bounds, point) {
                    return point.x >= bounds.min.x && point.x <= bounds.max.x && point.y >= bounds.min.y && point.y <= bounds.max.y;
                };
                /**
     * Returns true if the two bounds intersect.
     * @method overlaps
     * @param {bounds} boundsA
     * @param {bounds} boundsB
     * @return {boolean} True if the bounds overlap, otherwise false
     */ Bounds.overlaps = function(boundsA, boundsB) {
                    return boundsA.min.x <= boundsB.max.x && boundsA.max.x >= boundsB.min.x && boundsA.max.y >= boundsB.min.y && boundsA.min.y <= boundsB.max.y;
                };
                /**
     * Translates the bounds by the given vector.
     * @method translate
     * @param {bounds} bounds
     * @param {vector} vector
     */ Bounds.translate = function(bounds, vector) {
                    bounds.min.x += vector.x;
                    bounds.max.x += vector.x;
                    bounds.min.y += vector.y;
                    bounds.max.y += vector.y;
                };
                /**
     * Shifts the bounds to the given position.
     * @method shift
     * @param {bounds} bounds
     * @param {vector} position
     */ Bounds.shift = function(bounds, position) {
                    var deltaX = bounds.max.x - bounds.min.x, deltaY = bounds.max.y - bounds.min.y;
                    bounds.min.x = position.x;
                    bounds.max.x = position.x + deltaX;
                    bounds.min.y = position.y;
                    bounds.max.y = position.y + deltaY;
                };
            })();
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            /**
* The `Matter.Vector` module contains methods for creating and manipulating vectors.
* Vectors are the basis of all the geometry related operations in the engine.
* A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vector
*/ // TODO: consider params for reusing vector objects
            var Vector = {};
            module1.exports = Vector;
            (function() {
                /**
     * Creates a new vector.
     * @method create
     * @param {number} x
     * @param {number} y
     * @return {vector} A new vector
     */ Vector.create = function(x, y) {
                    return {
                        x: x || 0,
                        y: y || 0
                    };
                };
                /**
     * Returns a new vector with `x` and `y` copied from the given `vector`.
     * @method clone
     * @param {vector} vector
     * @return {vector} A new cloned vector
     */ Vector.clone = function(vector) {
                    return {
                        x: vector.x,
                        y: vector.y
                    };
                };
                /**
     * Returns the magnitude (length) of a vector.
     * @method magnitude
     * @param {vector} vector
     * @return {number} The magnitude of the vector
     */ Vector.magnitude = function(vector) {
                    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
                };
                /**
     * Returns the magnitude (length) of a vector (therefore saving a `sqrt` operation).
     * @method magnitudeSquared
     * @param {vector} vector
     * @return {number} The squared magnitude of the vector
     */ Vector.magnitudeSquared = function(vector) {
                    return vector.x * vector.x + vector.y * vector.y;
                };
                /**
     * Rotates the vector about (0, 0) by specified angle.
     * @method rotate
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} [output]
     * @return {vector} The vector rotated about (0, 0)
     */ Vector.rotate = function(vector, angle, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = vector.x * cos - vector.y * sin;
                    output.y = vector.x * sin + vector.y * cos;
                    output.x = x;
                    return output;
                };
                /**
     * Rotates the vector about a specified point by specified angle.
     * @method rotateAbout
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} point
     * @param {vector} [output]
     * @return {vector} A new vector rotated about the point
     */ Vector.rotateAbout = function(vector, angle, point, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = point.x + ((vector.x - point.x) * cos - (vector.y - point.y) * sin);
                    output.y = point.y + ((vector.x - point.x) * sin + (vector.y - point.y) * cos);
                    output.x = x;
                    return output;
                };
                /**
     * Normalises a vector (such that its magnitude is `1`).
     * @method normalise
     * @param {vector} vector
     * @return {vector} A new vector normalised
     */ Vector.normalise = function(vector) {
                    var magnitude = Vector.magnitude(vector);
                    if (magnitude === 0) return {
                        x: 0,
                        y: 0
                    };
                    return {
                        x: vector.x / magnitude,
                        y: vector.y / magnitude
                    };
                };
                /**
     * Returns the dot-product of two vectors.
     * @method dot
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The dot product of the two vectors
     */ Vector.dot = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.x + vectorA.y * vectorB.y;
                };
                /**
     * Returns the cross-product of two vectors.
     * @method cross
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The cross product of the two vectors
     */ Vector.cross = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.y - vectorA.y * vectorB.x;
                };
                /**
     * Returns the cross-product of three vectors.
     * @method cross3
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} vectorC
     * @return {number} The cross product of the three vectors
     */ Vector.cross3 = function(vectorA, vectorB, vectorC) {
                    return (vectorB.x - vectorA.x) * (vectorC.y - vectorA.y) - (vectorB.y - vectorA.y) * (vectorC.x - vectorA.x);
                };
                /**
     * Adds the two vectors.
     * @method add
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB added
     */ Vector.add = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x + vectorB.x;
                    output.y = vectorA.y + vectorB.y;
                    return output;
                };
                /**
     * Subtracts the two vectors.
     * @method sub
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB subtracted
     */ Vector.sub = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x - vectorB.x;
                    output.y = vectorA.y - vectorB.y;
                    return output;
                };
                /**
     * Multiplies a vector and a scalar.
     * @method mult
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector multiplied by scalar
     */ Vector.mult = function(vector, scalar) {
                    return {
                        x: vector.x * scalar,
                        y: vector.y * scalar
                    };
                };
                /**
     * Divides a vector and a scalar.
     * @method div
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector divided by scalar
     */ Vector.div = function(vector, scalar) {
                    return {
                        x: vector.x / scalar,
                        y: vector.y / scalar
                    };
                };
                /**
     * Returns the perpendicular vector. Set `negate` to true for the perpendicular in the opposite direction.
     * @method perp
     * @param {vector} vector
     * @param {bool} [negate=false]
     * @return {vector} The perpendicular vector
     */ Vector.perp = function(vector, negate) {
                    negate = negate === true ? -1 : 1;
                    return {
                        x: negate * -vector.y,
                        y: negate * vector.x
                    };
                };
                /**
     * Negates both components of a vector such that it points in the opposite direction.
     * @method neg
     * @param {vector} vector
     * @return {vector} The negated vector
     */ Vector.neg = function(vector) {
                    return {
                        x: -vector.x,
                        y: -vector.y
                    };
                };
                /**
     * Returns the angle between the vector `vectorB - vectorA` and the x-axis in radians.
     * @method angle
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The angle in radians
     */ Vector.angle = function(vectorA, vectorB) {
                    return Math.atan2(vectorB.y - vectorA.y, vectorB.x - vectorA.x);
                };
                /**
     * Temporary vector pool (not thread-safe).
     * @property _temp
     * @type {vector[]}
     * @private
     */ Vector._temp = [
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create()
                ];
            })();
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
* A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
* A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vertices
*/ var Vertices = {};
            module1.exports = Vertices;
            var Vector = __webpack_require__(2);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a new set of `Matter.Body` compatible vertices.
     * The `points` argument accepts an array of `Matter.Vector` points orientated around the origin `(0, 0)`, for example:
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * The `Vertices.create` method returns a new array of vertices, which are similar to Matter.Vector objects,
     * but with some additional references required for efficient collision detection routines.
     *
     * Vertices must be specified in clockwise order.
     *
     * Note that the `body` argument is not optional, a `Matter.Body` reference must be provided.
     *
     * @method create
     * @param {vector[]} points
     * @param {body} body
     */ Vertices.create = function(points, body) {
                    var vertices = [];
                    for(var i = 0; i < points.length; i++){
                        var point = points[i], vertex = {
                            x: point.x,
                            y: point.y,
                            index: i,
                            body: body,
                            isInternal: false
                        };
                        vertices.push(vertex);
                    }
                    return vertices;
                };
                /**
     * Parses a string containing ordered x y pairs separated by spaces (and optionally commas), 
     * into a `Matter.Vertices` object for the given `Matter.Body`.
     * For parsing SVG paths, see `Svg.pathToVertices`.
     * @method fromPath
     * @param {string} path
     * @param {body} body
     * @return {vertices} vertices
     */ Vertices.fromPath = function(path, body) {
                    var pathPattern = /L?\s*([-\d.e]+)[\s,]*([-\d.e]+)*/ig, points = [];
                    path.replace(pathPattern, function(match, x, y) {
                        points.push({
                            x: parseFloat(x),
                            y: parseFloat(y)
                        });
                    });
                    return Vertices.create(points, body);
                };
                /**
     * Returns the centre (centroid) of the set of vertices.
     * @method centre
     * @param {vertices} vertices
     * @return {vector} The centre point
     */ Vertices.centre = function(vertices) {
                    var area = Vertices.area(vertices, true), centre = {
                        x: 0,
                        y: 0
                    }, cross, temp, j;
                    for(var i = 0; i < vertices.length; i++){
                        j = (i + 1) % vertices.length;
                        cross = Vector.cross(vertices[i], vertices[j]);
                        temp = Vector.mult(Vector.add(vertices[i], vertices[j]), cross);
                        centre = Vector.add(centre, temp);
                    }
                    return Vector.div(centre, 6 * area);
                };
                /**
     * Returns the average (mean) of the set of vertices.
     * @method mean
     * @param {vertices} vertices
     * @return {vector} The average point
     */ Vertices.mean = function(vertices) {
                    var average = {
                        x: 0,
                        y: 0
                    };
                    for(var i = 0; i < vertices.length; i++){
                        average.x += vertices[i].x;
                        average.y += vertices[i].y;
                    }
                    return Vector.div(average, vertices.length);
                };
                /**
     * Returns the area of the set of vertices.
     * @method area
     * @param {vertices} vertices
     * @param {bool} signed
     * @return {number} The area
     */ Vertices.area = function(vertices, signed) {
                    var area = 0, j = vertices.length - 1;
                    for(var i = 0; i < vertices.length; i++){
                        area += (vertices[j].x - vertices[i].x) * (vertices[j].y + vertices[i].y);
                        j = i;
                    }
                    if (signed) return area / 2;
                    return Math.abs(area) / 2;
                };
                /**
     * Returns the moment of inertia (second moment of area) of the set of vertices given the total mass.
     * @method inertia
     * @param {vertices} vertices
     * @param {number} mass
     * @return {number} The polygon's moment of inertia
     */ Vertices.inertia = function(vertices, mass) {
                    var numerator = 0, denominator = 0, v = vertices, cross, j;
                    // find the polygon's moment of inertia, using second moment of area
                    // from equations at http://www.physicsforums.com/showthread.php?t=25293
                    for(var n = 0; n < v.length; n++){
                        j = (n + 1) % v.length;
                        cross = Math.abs(Vector.cross(v[j], v[n]));
                        numerator += cross * (Vector.dot(v[j], v[j]) + Vector.dot(v[j], v[n]) + Vector.dot(v[n], v[n]));
                        denominator += cross;
                    }
                    return mass / 6 * (numerator / denominator);
                };
                /**
     * Translates the set of vertices in-place.
     * @method translate
     * @param {vertices} vertices
     * @param {vector} vector
     * @param {number} scalar
     */ Vertices.translate = function(vertices, vector, scalar) {
                    scalar = typeof scalar !== "undefined" ? scalar : 1;
                    var verticesLength = vertices.length, translateX = vector.x * scalar, translateY = vector.y * scalar, i;
                    for(i = 0; i < verticesLength; i++){
                        vertices[i].x += translateX;
                        vertices[i].y += translateY;
                    }
                    return vertices;
                };
                /**
     * Rotates the set of vertices in-place.
     * @method rotate
     * @param {vertices} vertices
     * @param {number} angle
     * @param {vector} point
     */ Vertices.rotate = function(vertices, angle, point) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle), pointX = point.x, pointY = point.y, verticesLength = vertices.length, vertex, dx, dy, i;
                    for(i = 0; i < verticesLength; i++){
                        vertex = vertices[i];
                        dx = vertex.x - pointX;
                        dy = vertex.y - pointY;
                        vertex.x = pointX + (dx * cos - dy * sin);
                        vertex.y = pointY + (dx * sin + dy * cos);
                    }
                    return vertices;
                };
                /**
     * Returns `true` if the `point` is inside the set of `vertices`.
     * @method contains
     * @param {vertices} vertices
     * @param {vector} point
     * @return {boolean} True if the vertices contains point, otherwise false
     */ Vertices.contains = function(vertices, point) {
                    var pointX = point.x, pointY = point.y, verticesLength = vertices.length, vertex = vertices[verticesLength - 1], nextVertex;
                    for(var i = 0; i < verticesLength; i++){
                        nextVertex = vertices[i];
                        if ((pointX - vertex.x) * (nextVertex.y - vertex.y) + (pointY - vertex.y) * (vertex.x - nextVertex.x) > 0) return false;
                        vertex = nextVertex;
                    }
                    return true;
                };
                /**
     * Scales the vertices from a point (default is centre) in-place.
     * @method scale
     * @param {vertices} vertices
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     */ Vertices.scale = function(vertices, scaleX, scaleY, point) {
                    if (scaleX === 1 && scaleY === 1) return vertices;
                    point = point || Vertices.centre(vertices);
                    var vertex, delta;
                    for(var i = 0; i < vertices.length; i++){
                        vertex = vertices[i];
                        delta = Vector.sub(vertex, point);
                        vertices[i].x = point.x + delta.x * scaleX;
                        vertices[i].y = point.y + delta.y * scaleY;
                    }
                    return vertices;
                };
                /**
     * Chamfers a set of vertices by giving them rounded corners, returns a new set of vertices.
     * The radius parameter is a single number or an array to specify the radius for each vertex.
     * @method chamfer
     * @param {vertices} vertices
     * @param {number[]} radius
     * @param {number} quality
     * @param {number} qualityMin
     * @param {number} qualityMax
     */ Vertices.chamfer = function(vertices, radius, quality, qualityMin, qualityMax) {
                    if (typeof radius === "number") radius = [
                        radius
                    ];
                    else radius = radius || [
                        8
                    ];
                    // quality defaults to -1, which is auto
                    quality = typeof quality !== "undefined" ? quality : -1;
                    qualityMin = qualityMin || 2;
                    qualityMax = qualityMax || 14;
                    var newVertices = [];
                    for(var i = 0; i < vertices.length; i++){
                        var prevVertex = vertices[i - 1 >= 0 ? i - 1 : vertices.length - 1], vertex = vertices[i], nextVertex = vertices[(i + 1) % vertices.length], currentRadius = radius[i < radius.length ? i : radius.length - 1];
                        if (currentRadius === 0) {
                            newVertices.push(vertex);
                            continue;
                        }
                        var prevNormal = Vector.normalise({
                            x: vertex.y - prevVertex.y,
                            y: prevVertex.x - vertex.x
                        });
                        var nextNormal = Vector.normalise({
                            x: nextVertex.y - vertex.y,
                            y: vertex.x - nextVertex.x
                        });
                        var diagonalRadius = Math.sqrt(2 * Math.pow(currentRadius, 2)), radiusVector = Vector.mult(Common.clone(prevNormal), currentRadius), midNormal = Vector.normalise(Vector.mult(Vector.add(prevNormal, nextNormal), 0.5)), scaledVertex = Vector.sub(vertex, Vector.mult(midNormal, diagonalRadius));
                        var precision = quality;
                        if (quality === -1) // automatically decide precision
                        precision = Math.pow(currentRadius, 0.32) * 1.75;
                        precision = Common.clamp(precision, qualityMin, qualityMax);
                        // use an even value for precision, more likely to reduce axes by using symmetry
                        if (precision % 2 === 1) precision += 1;
                        var alpha = Math.acos(Vector.dot(prevNormal, nextNormal)), theta = alpha / precision;
                        for(var j = 0; j < precision; j++)newVertices.push(Vector.add(Vector.rotate(radiusVector, theta * j), scaledVertex));
                    }
                    return newVertices;
                };
                /**
     * Sorts the input vertices into clockwise order in place.
     * @method clockwiseSort
     * @param {vertices} vertices
     * @return {vertices} vertices
     */ Vertices.clockwiseSort = function(vertices) {
                    var centre = Vertices.mean(vertices);
                    vertices.sort(function(vertexA, vertexB) {
                        return Vector.angle(centre, vertexA) - Vector.angle(centre, vertexB);
                    });
                    return vertices;
                };
                /**
     * Returns true if the vertices form a convex shape (vertices must be in clockwise order).
     * @method isConvex
     * @param {vertices} vertices
     * @return {bool} `true` if the `vertices` are convex, `false` if not (or `null` if not computable).
     */ Vertices.isConvex = function(vertices) {
                    // http://paulbourke.net/geometry/polygonmesh/
                    // Copyright (c) Paul Bourke (use permitted)
                    var flag = 0, n = vertices.length, i, j, k, z;
                    if (n < 3) return null;
                    for(i = 0; i < n; i++){
                        j = (i + 1) % n;
                        k = (i + 2) % n;
                        z = (vertices[j].x - vertices[i].x) * (vertices[k].y - vertices[j].y);
                        z -= (vertices[j].y - vertices[i].y) * (vertices[k].x - vertices[j].x);
                        if (z < 0) flag |= 1;
                        else if (z > 0) flag |= 2;
                        if (flag === 3) return false;
                    }
                    if (flag !== 0) return true;
                    else return null;
                };
                /**
     * Returns the convex hull of the input vertices as a new array of points.
     * @method hull
     * @param {vertices} vertices
     * @return [vertex] vertices
     */ Vertices.hull = function(vertices) {
                    // http://geomalgorithms.com/a10-_hull-1.html
                    var upper = [], lower = [], vertex, i;
                    // sort vertices on x-axis (y-axis for ties)
                    vertices = vertices.slice(0);
                    vertices.sort(function(vertexA, vertexB) {
                        var dx = vertexA.x - vertexB.x;
                        return dx !== 0 ? dx : vertexA.y - vertexB.y;
                    });
                    // build lower hull
                    for(i = 0; i < vertices.length; i += 1){
                        vertex = vertices[i];
                        while(lower.length >= 2 && Vector.cross3(lower[lower.length - 2], lower[lower.length - 1], vertex) <= 0)lower.pop();
                        lower.push(vertex);
                    }
                    // build upper hull
                    for(i = vertices.length - 1; i >= 0; i -= 1){
                        vertex = vertices[i];
                        while(upper.length >= 2 && Vector.cross3(upper[upper.length - 2], upper[upper.length - 1], vertex) <= 0)upper.pop();
                        upper.push(vertex);
                    }
                    // concatenation of the lower and upper hulls gives the convex hull
                    // omit last points because they are repeated at the beginning of the other list
                    upper.pop();
                    lower.pop();
                    return upper.concat(lower);
                };
            })();
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Events` module contains methods to fire and listen to events on other objects.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Events
*/ var Events = {};
            module1.exports = Events;
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Subscribes a callback function to the given object's `eventName`.
     * @method on
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.on = function(object, eventNames, callback) {
                    var names = eventNames.split(" "), name;
                    for(var i = 0; i < names.length; i++){
                        name = names[i];
                        object.events = object.events || {};
                        object.events[name] = object.events[name] || [];
                        object.events[name].push(callback);
                    }
                    return callback;
                };
                /**
     * Removes the given event callback. If no callback, clears all callbacks in `eventNames`. If no `eventNames`, clears all events.
     * @method off
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.off = function(object, eventNames, callback) {
                    if (!eventNames) {
                        object.events = {};
                        return;
                    }
                    // handle Events.off(object, callback)
                    if (typeof eventNames === "function") {
                        callback = eventNames;
                        eventNames = Common.keys(object.events).join(" ");
                    }
                    var names = eventNames.split(" ");
                    for(var i = 0; i < names.length; i++){
                        var callbacks = object.events[names[i]], newCallbacks = [];
                        if (callback && callbacks) {
                            for(var j = 0; j < callbacks.length; j++)if (callbacks[j] !== callback) newCallbacks.push(callbacks[j]);
                        }
                        object.events[names[i]] = newCallbacks;
                    }
                };
                /**
     * Fires all the callbacks subscribed to the given object's `eventName`, in the order they subscribed, if any.
     * @method trigger
     * @param {} object
     * @param {string} eventNames
     * @param {} event
     */ Events.trigger = function(object, eventNames, event) {
                    var names, name, callbacks, eventClone;
                    var events = object.events;
                    if (events && Common.keys(events).length > 0) {
                        if (!event) event = {};
                        names = eventNames.split(" ");
                        for(var i = 0; i < names.length; i++){
                            name = names[i];
                            callbacks = events[name];
                            if (callbacks) {
                                eventClone = Common.clone(event, false);
                                eventClone.name = name;
                                eventClone.source = object;
                                for(var j = 0; j < callbacks.length; j++)callbacks[j].apply(object, [
                                    eventClone
                                ]);
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* A composite is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite` objects.
*
* They are a container that can represent complex objects made of multiple parts, even if they are not physically connected.
* A composite could contain anything from a single body all the way up to a whole world.
* 
* When making any changes to composites, use the included functions rather than changing their properties directly.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composite
*/ var Composite = {};
            module1.exports = Composite;
            var Events = __webpack_require__(4);
            var Common = __webpack_require__(0);
            var Bounds = __webpack_require__(1);
            var Body = __webpack_require__(6);
            (function() {
                /**
     * Creates a new composite. The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properites section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} [options]
     * @return {composite} A new composite
     */ Composite.create = function(options) {
                    return Common.extend({
                        id: Common.nextId(),
                        type: "composite",
                        parent: null,
                        isModified: false,
                        bodies: [],
                        constraints: [],
                        composites: [],
                        label: "Composite",
                        plugin: {},
                        cache: {
                            allBodies: null,
                            allConstraints: null,
                            allComposites: null
                        }
                    }, options);
                };
                /**
     * Sets the composite's `isModified` flag. 
     * If `updateParents` is true, all parents will be set (default: false).
     * If `updateChildren` is true, all children will be set (default: false).
     * @private
     * @method setModified
     * @param {composite} composite
     * @param {boolean} isModified
     * @param {boolean} [updateParents=false]
     * @param {boolean} [updateChildren=false]
     */ Composite.setModified = function(composite, isModified, updateParents, updateChildren) {
                    composite.isModified = isModified;
                    if (isModified && composite.cache) {
                        composite.cache.allBodies = null;
                        composite.cache.allConstraints = null;
                        composite.cache.allComposites = null;
                    }
                    if (updateParents && composite.parent) Composite.setModified(composite.parent, isModified, updateParents, updateChildren);
                    if (updateChildren) for(var i = 0; i < composite.composites.length; i++){
                        var childComposite = composite.composites[i];
                        Composite.setModified(childComposite, isModified, updateParents, updateChildren);
                    }
                };
                /**
     * Generic single or multi-add function. Adds a single or an array of body(s), constraint(s) or composite(s) to the given composite.
     * Triggers `beforeAdd` and `afterAdd` events on the `composite`.
     * @method add
     * @param {composite} composite
     * @param {object|array} object A single or an array of body(s), constraint(s) or composite(s)
     * @return {composite} The original composite with the objects added
     */ Composite.add = function(composite, object) {
                    var objects = [].concat(object);
                    Events.trigger(composite, "beforeAdd", {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case "body":
                                // skip adding compound parts
                                if (obj.parent !== obj) {
                                    Common.warn("Composite.add: skipped adding a compound body part (you must add its parent instead)");
                                    break;
                                }
                                Composite.addBody(composite, obj);
                                break;
                            case "constraint":
                                Composite.addConstraint(composite, obj);
                                break;
                            case "composite":
                                Composite.addComposite(composite, obj);
                                break;
                            case "mouseConstraint":
                                Composite.addConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, "afterAdd", {
                        object: object
                    });
                    return composite;
                };
                /**
     * Generic remove function. Removes one or many body(s), constraint(s) or a composite(s) to the given composite.
     * Optionally searching its children recursively.
     * Triggers `beforeRemove` and `afterRemove` events on the `composite`.
     * @method remove
     * @param {composite} composite
     * @param {object|array} object
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the objects removed
     */ Composite.remove = function(composite, object, deep) {
                    var objects = [].concat(object);
                    Events.trigger(composite, "beforeRemove", {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case "body":
                                Composite.removeBody(composite, obj, deep);
                                break;
                            case "constraint":
                                Composite.removeConstraint(composite, obj, deep);
                                break;
                            case "composite":
                                Composite.removeComposite(composite, obj, deep);
                                break;
                            case "mouseConstraint":
                                Composite.removeConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, "afterRemove", {
                        object: object
                    });
                    return composite;
                };
                /**
     * Adds a composite to the given composite.
     * @private
     * @method addComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @return {composite} The original compositeA with the objects from compositeB added
     */ Composite.addComposite = function(compositeA, compositeB) {
                    compositeA.composites.push(compositeB);
                    compositeB.parent = compositeA;
                    Composite.setModified(compositeA, true, true, false);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @param {boolean} [deep=false]
     * @return {composite} The original compositeA with the composite removed
     */ Composite.removeComposite = function(compositeA, compositeB, deep) {
                    var position = Common.indexOf(compositeA.composites, compositeB);
                    if (position !== -1) Composite.removeCompositeAt(compositeA, position);
                    if (deep) for(var i = 0; i < compositeA.composites.length; i++)Composite.removeComposite(compositeA.composites[i], compositeB, true);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite.
     * @private
     * @method removeCompositeAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the composite removed
     */ Composite.removeCompositeAt = function(composite, position) {
                    composite.composites.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a body to the given composite.
     * @private
     * @method addBody
     * @param {composite} composite
     * @param {body} body
     * @return {composite} The original composite with the body added
     */ Composite.addBody = function(composite, body) {
                    composite.bodies.push(body);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a body from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeBody
     * @param {composite} composite
     * @param {body} body
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the body removed
     */ Composite.removeBody = function(composite, body, deep) {
                    var position = Common.indexOf(composite.bodies, body);
                    if (position !== -1) Composite.removeBodyAt(composite, position);
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeBody(composite.composites[i], body, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeBodyAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the body removed
     */ Composite.removeBodyAt = function(composite, position) {
                    composite.bodies.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a constraint to the given composite.
     * @private
     * @method addConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @return {composite} The original composite with the constraint added
     */ Composite.addConstraint = function(composite, constraint) {
                    composite.constraints.push(constraint);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a constraint from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraint = function(composite, constraint, deep) {
                    var position = Common.indexOf(composite.constraints, constraint);
                    if (position !== -1) Composite.removeConstraintAt(composite, position);
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeConstraint(composite.composites[i], constraint, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeConstraintAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraintAt = function(composite, position) {
                    composite.constraints.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes all bodies, constraints and composites from the given composite.
     * Optionally clearing its children recursively.
     * @method clear
     * @param {composite} composite
     * @param {boolean} keepStatic
     * @param {boolean} [deep=false]
     */ Composite.clear = function(composite, keepStatic, deep) {
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.clear(composite.composites[i], keepStatic, true);
                    if (keepStatic) composite.bodies = composite.bodies.filter(function(body) {
                        return body.isStatic;
                    });
                    else composite.bodies.length = 0;
                    composite.constraints.length = 0;
                    composite.composites.length = 0;
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Returns all bodies in the given composite, including all bodies in its children, recursively.
     * @method allBodies
     * @param {composite} composite
     * @return {body[]} All the bodies
     */ Composite.allBodies = function(composite) {
                    if (composite.cache && composite.cache.allBodies) return composite.cache.allBodies;
                    var bodies = [].concat(composite.bodies);
                    for(var i = 0; i < composite.composites.length; i++)bodies = bodies.concat(Composite.allBodies(composite.composites[i]));
                    if (composite.cache) composite.cache.allBodies = bodies;
                    return bodies;
                };
                /**
     * Returns all constraints in the given composite, including all constraints in its children, recursively.
     * @method allConstraints
     * @param {composite} composite
     * @return {constraint[]} All the constraints
     */ Composite.allConstraints = function(composite) {
                    if (composite.cache && composite.cache.allConstraints) return composite.cache.allConstraints;
                    var constraints = [].concat(composite.constraints);
                    for(var i = 0; i < composite.composites.length; i++)constraints = constraints.concat(Composite.allConstraints(composite.composites[i]));
                    if (composite.cache) composite.cache.allConstraints = constraints;
                    return constraints;
                };
                /**
     * Returns all composites in the given composite, including all composites in its children, recursively.
     * @method allComposites
     * @param {composite} composite
     * @return {composite[]} All the composites
     */ Composite.allComposites = function(composite) {
                    if (composite.cache && composite.cache.allComposites) return composite.cache.allComposites;
                    var composites = [].concat(composite.composites);
                    for(var i = 0; i < composite.composites.length; i++)composites = composites.concat(Composite.allComposites(composite.composites[i]));
                    if (composite.cache) composite.cache.allComposites = composites;
                    return composites;
                };
                /**
     * Searches the composite recursively for an object matching the type and id supplied, null if not found.
     * @method get
     * @param {composite} composite
     * @param {number} id
     * @param {string} type
     * @return {object} The requested object, if found
     */ Composite.get = function(composite, id, type) {
                    var objects, object;
                    switch(type){
                        case "body":
                            objects = Composite.allBodies(composite);
                            break;
                        case "constraint":
                            objects = Composite.allConstraints(composite);
                            break;
                        case "composite":
                            objects = Composite.allComposites(composite).concat(composite);
                            break;
                    }
                    if (!objects) return null;
                    object = objects.filter(function(object) {
                        return object.id.toString() === id.toString();
                    });
                    return object.length === 0 ? null : object[0];
                };
                /**
     * Moves the given object(s) from compositeA to compositeB (equal to a remove followed by an add).
     * @method move
     * @param {compositeA} compositeA
     * @param {object[]} objects
     * @param {compositeB} compositeB
     * @return {composite} Returns compositeA
     */ Composite.move = function(compositeA, objects, compositeB) {
                    Composite.remove(compositeA, objects);
                    Composite.add(compositeB, objects);
                    return compositeA;
                };
                /**
     * Assigns new ids for all objects in the composite, recursively.
     * @method rebase
     * @param {composite} composite
     * @return {composite} Returns composite
     */ Composite.rebase = function(composite) {
                    var objects = Composite.allBodies(composite).concat(Composite.allConstraints(composite)).concat(Composite.allComposites(composite));
                    for(var i = 0; i < objects.length; i++)objects[i].id = Common.nextId();
                    return composite;
                };
                /**
     * Translates all children in the composite by a given vector relative to their current positions, 
     * without imparting any velocity.
     * @method translate
     * @param {composite} composite
     * @param {vector} translation
     * @param {bool} [recursive=true]
     */ Composite.translate = function(composite, translation, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++)Body.translate(bodies[i], translation);
                    return composite;
                };
                /**
     * Rotates all children in the composite by a given angle about the given point, without imparting any angular velocity.
     * @method rotate
     * @param {composite} composite
     * @param {number} rotation
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.rotate = function(composite, rotation, point, recursive) {
                    var cos = Math.cos(rotation), sin = Math.sin(rotation), bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        });
                        Body.rotate(body, rotation);
                    }
                    return composite;
                };
                /**
     * Scales all children in the composite, including updating physical properties (mass, area, axes, inertia), from a world-space point.
     * @method scale
     * @param {composite} composite
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.scale = function(composite, scaleX, scaleY, point, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + dx * scaleX,
                            y: point.y + dy * scaleY
                        });
                        Body.scale(body, scaleX, scaleY);
                    }
                    return composite;
                };
                /**
     * Returns the union of the bounds of all of the composite's bodies.
     * @method bounds
     * @param {composite} composite The composite.
     * @returns {bounds} The composite bounds.
     */ Composite.bounds = function(composite) {
                    var bodies = Composite.allBodies(composite), vertices = [];
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i];
                        vertices.push(body.bounds.min, body.bounds.max);
                    }
                    return Bounds.create(vertices);
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a call to `Composite.add` is made, before objects have been added.
    *
    * @event beforeAdd
    * @param {} event An event object
    * @param {} event.object The object(s) to be added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.add` is made, after objects have been added.
    *
    * @event afterAdd
    * @param {} event An event object
    * @param {} event.object The object(s) that have been added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, before objects have been removed.
    *
    * @event beforeRemove
    * @param {} event An event object
    * @param {} event.object The object(s) to be removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, after objects have been removed.
    *
    * @event afterRemove
    * @param {} event An event object
    * @param {} event.object The object(s) that have been removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "composite"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage composites.
     *
     * @property label
     * @type string
     * @default "Composite"
     */ /**
     * A flag that specifies whether the composite has been modified during the current step.
     * This is automatically managed when bodies, constraints or composites are added or removed.
     *
     * @property isModified
     * @type boolean
     * @default false
     */ /**
     * The `Composite` that is the parent of this composite. It is automatically managed by the `Matter.Composite` methods.
     *
     * @property parent
     * @type composite
     * @default null
     */ /**
     * An array of `Body` that are _direct_ children of this composite.
     * To add or remove bodies you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allBodies` method.
     *
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * An array of `Constraint` that are _direct_ children of this composite.
     * To add or remove constraints you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allConstraints` method.
     *
     * @property constraints
     * @type constraint[]
     * @default []
     */ /**
     * An array of `Composite` that are _direct_ children of this composite.
     * To add or remove composites you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allComposites` method.
     *
     * @property composites
     * @type composite[]
     * @default []
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * An object used for storing cached results for performance reasons.
     * This is used internally only and is automatically managed.
     *
     * @private
     * @property cache
     * @type {}
     */ })();
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Body` module contains methods for creating and manipulating body models.
* A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
* Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the module `Matter.Bodies`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).

* @class Body
*/ var Body = {};
            module1.exports = Body;
            var Vertices = __webpack_require__(3);
            var Vector = __webpack_require__(2);
            var Sleeping = __webpack_require__(7);
            var Render = __webpack_require__(16);
            var Common = __webpack_require__(0);
            var Bounds = __webpack_require__(1);
            var Axes = __webpack_require__(11);
            (function() {
                Body._inertiaScale = 4;
                Body._nextCollidingGroupId = 1;
                Body._nextNonCollidingGroupId = -1;
                Body._nextCategory = 0x0001;
                /**
     * Creates a new rigid body model. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * Vertices must be specified in clockwise order.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {body} body
     */ Body.create = function(options) {
                    var defaults = {
                        id: Common.nextId(),
                        type: "body",
                        label: "Body",
                        parts: [],
                        plugin: {},
                        angle: 0,
                        vertices: Vertices.fromPath("L 0 0 L 40 0 L 40 40 L 0 40"),
                        position: {
                            x: 0,
                            y: 0
                        },
                        force: {
                            x: 0,
                            y: 0
                        },
                        torque: 0,
                        positionImpulse: {
                            x: 0,
                            y: 0
                        },
                        constraintImpulse: {
                            x: 0,
                            y: 0,
                            angle: 0
                        },
                        totalContacts: 0,
                        speed: 0,
                        angularSpeed: 0,
                        velocity: {
                            x: 0,
                            y: 0
                        },
                        angularVelocity: 0,
                        isSensor: false,
                        isStatic: false,
                        isSleeping: false,
                        motion: 0,
                        sleepThreshold: 60,
                        density: 0.001,
                        restitution: 0,
                        friction: 0.1,
                        frictionStatic: 0.5,
                        frictionAir: 0.01,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        },
                        slop: 0.05,
                        timeScale: 1,
                        render: {
                            visible: true,
                            opacity: 1,
                            strokeStyle: null,
                            fillStyle: null,
                            lineWidth: null,
                            sprite: {
                                xScale: 1,
                                yScale: 1,
                                xOffset: 0,
                                yOffset: 0
                            }
                        },
                        events: null,
                        bounds: null,
                        chamfer: null,
                        circleRadius: 0,
                        positionPrev: null,
                        anglePrev: 0,
                        parent: null,
                        axes: null,
                        area: 0,
                        mass: 0,
                        inertia: 0,
                        _original: null
                    };
                    var body = Common.extend(defaults, options);
                    _initProperties(body, options);
                    return body;
                };
                /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will _not_ collide.
     * See `body.collisionFilter` for more information.
     * @method nextGroup
     * @param {bool} [isNonColliding=false]
     * @return {Number} Unique group index
     */ Body.nextGroup = function(isNonColliding) {
                    if (isNonColliding) return Body._nextNonCollidingGroupId--;
                    return Body._nextCollidingGroupId++;
                };
                /**
     * Returns the next unique category bitfield (starting after the initial default category `0x0001`).
     * There are 32 available. See `body.collisionFilter` for more information.
     * @method nextCategory
     * @return {Number} Unique category bitfield
     */ Body.nextCategory = function() {
                    Body._nextCategory = Body._nextCategory << 1;
                    return Body._nextCategory;
                };
                /**
     * Initialises body properties.
     * @method _initProperties
     * @private
     * @param {body} body
     * @param {} [options]
     */ var _initProperties = function(body, options) {
                    options = options || {};
                    // init required properties (order is important)
                    Body.set(body, {
                        bounds: body.bounds || Bounds.create(body.vertices),
                        positionPrev: body.positionPrev || Vector.clone(body.position),
                        anglePrev: body.anglePrev || body.angle,
                        vertices: body.vertices,
                        parts: body.parts || [
                            body
                        ],
                        isStatic: body.isStatic,
                        isSleeping: body.isSleeping,
                        parent: body.parent || body
                    });
                    Vertices.rotate(body.vertices, body.angle, body.position);
                    Axes.rotate(body.axes, body.angle);
                    Bounds.update(body.bounds, body.vertices, body.velocity);
                    // allow options to override the automatically calculated properties
                    Body.set(body, {
                        axes: options.axes || body.axes,
                        area: options.area || body.area,
                        mass: options.mass || body.mass,
                        inertia: options.inertia || body.inertia
                    });
                    // render properties
                    var defaultFillStyle = body.isStatic ? "#14151f" : Common.choose([
                        "#f19648",
                        "#f5d259",
                        "#f55a3c",
                        "#063e7b",
                        "#ececd1"
                    ]), defaultStrokeStyle = body.isStatic ? "#555" : "#ccc", defaultLineWidth = body.isStatic && body.render.fillStyle === null ? 1 : 0;
                    body.render.fillStyle = body.render.fillStyle || defaultFillStyle;
                    body.render.strokeStyle = body.render.strokeStyle || defaultStrokeStyle;
                    body.render.lineWidth = body.render.lineWidth || defaultLineWidth;
                    body.render.sprite.xOffset += -(body.bounds.min.x - body.position.x) / (body.bounds.max.x - body.bounds.min.x);
                    body.render.sprite.yOffset += -(body.bounds.min.y - body.position.y) / (body.bounds.max.y - body.bounds.min.y);
                };
                /**
     * Given a property and a value (or map of), sets the property(s) on the body, using the appropriate setter functions if they exist.
     * Prefer to use the actual setter functions in performance critical situations.
     * @method set
     * @param {body} body
     * @param {} settings A property name (or map of properties and values) to set on the body.
     * @param {} value The value to set if `settings` is a single property name.
     */ Body.set = function(body, settings, value) {
                    var property;
                    if (typeof settings === "string") {
                        property = settings;
                        settings = {};
                        settings[property] = value;
                    }
                    for(property in settings){
                        if (!Object.prototype.hasOwnProperty.call(settings, property)) continue;
                        value = settings[property];
                        switch(property){
                            case "isStatic":
                                Body.setStatic(body, value);
                                break;
                            case "isSleeping":
                                Sleeping.set(body, value);
                                break;
                            case "mass":
                                Body.setMass(body, value);
                                break;
                            case "density":
                                Body.setDensity(body, value);
                                break;
                            case "inertia":
                                Body.setInertia(body, value);
                                break;
                            case "vertices":
                                Body.setVertices(body, value);
                                break;
                            case "position":
                                Body.setPosition(body, value);
                                break;
                            case "angle":
                                Body.setAngle(body, value);
                                break;
                            case "velocity":
                                Body.setVelocity(body, value);
                                break;
                            case "angularVelocity":
                                Body.setAngularVelocity(body, value);
                                break;
                            case "parts":
                                Body.setParts(body, value);
                                break;
                            case "centre":
                                Body.setCentre(body, value);
                                break;
                            default:
                                body[property] = value;
                        }
                    }
                };
                /**
     * Sets the body as static, including isStatic flag and setting mass and inertia to Infinity.
     * @method setStatic
     * @param {body} body
     * @param {bool} isStatic
     */ Body.setStatic = function(body, isStatic) {
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.isStatic = isStatic;
                        if (isStatic) {
                            part._original = {
                                restitution: part.restitution,
                                friction: part.friction,
                                mass: part.mass,
                                inertia: part.inertia,
                                density: part.density,
                                inverseMass: part.inverseMass,
                                inverseInertia: part.inverseInertia
                            };
                            part.restitution = 0;
                            part.friction = 1;
                            part.mass = part.inertia = part.density = Infinity;
                            part.inverseMass = part.inverseInertia = 0;
                            part.positionPrev.x = part.position.x;
                            part.positionPrev.y = part.position.y;
                            part.anglePrev = part.angle;
                            part.angularVelocity = 0;
                            part.speed = 0;
                            part.angularSpeed = 0;
                            part.motion = 0;
                        } else if (part._original) {
                            part.restitution = part._original.restitution;
                            part.friction = part._original.friction;
                            part.mass = part._original.mass;
                            part.inertia = part._original.inertia;
                            part.density = part._original.density;
                            part.inverseMass = part._original.inverseMass;
                            part.inverseInertia = part._original.inverseInertia;
                            part._original = null;
                        }
                    }
                };
                /**
     * Sets the mass of the body. Inverse mass, density and inertia are automatically updated to reflect the change.
     * @method setMass
     * @param {body} body
     * @param {number} mass
     */ Body.setMass = function(body, mass) {
                    var moment = body.inertia / (body.mass / 6);
                    body.inertia = moment * (mass / 6);
                    body.inverseInertia = 1 / body.inertia;
                    body.mass = mass;
                    body.inverseMass = 1 / body.mass;
                    body.density = body.mass / body.area;
                };
                /**
     * Sets the density of the body. Mass and inertia are automatically updated to reflect the change.
     * @method setDensity
     * @param {body} body
     * @param {number} density
     */ Body.setDensity = function(body, density) {
                    Body.setMass(body, density * body.area);
                    body.density = density;
                };
                /**
     * Sets the moment of inertia (i.e. second moment of area) of the body. 
     * Inverse inertia is automatically updated to reflect the change. Mass is not changed.
     * @method setInertia
     * @param {body} body
     * @param {number} inertia
     */ Body.setInertia = function(body, inertia) {
                    body.inertia = inertia;
                    body.inverseInertia = 1 / body.inertia;
                };
                /**
     * Sets the body's vertices and updates body properties accordingly, including inertia, area and mass (with respect to `body.density`).
     * Vertices will be automatically transformed to be orientated around their centre of mass as the origin.
     * They are then automatically translated to world space based on `body.position`.
     *
     * The `vertices` argument should be passed as an array of `Matter.Vector` points (or a `Matter.Vertices` array).
     * Vertices must form a convex hull, concave hulls are not supported.
     *
     * @method setVertices
     * @param {body} body
     * @param {vector[]} vertices
     */ Body.setVertices = function(body, vertices) {
                    // change vertices
                    if (vertices[0].body === body) body.vertices = vertices;
                    else body.vertices = Vertices.create(vertices, body);
                    // update properties
                    body.axes = Axes.fromVertices(body.vertices);
                    body.area = Vertices.area(body.vertices);
                    Body.setMass(body, body.density * body.area);
                    // orient vertices around the centre of mass at origin (0, 0)
                    var centre = Vertices.centre(body.vertices);
                    Vertices.translate(body.vertices, centre, -1);
                    // update inertia while vertices are at origin (0, 0)
                    Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass));
                    // update geometry
                    Vertices.translate(body.vertices, body.position);
                    Bounds.update(body.bounds, body.vertices, body.velocity);
                };
                /**
     * Sets the parts of the `body` and updates mass, inertia and centroid.
     * Each part will have its parent set to `body`.
     * By default the convex hull will be automatically computed and set on `body`, unless `autoHull` is set to `false.`
     * Note that this method will ensure that the first part in `body.parts` will always be the `body`.
     * @method setParts
     * @param {body} body
     * @param [body] parts
     * @param {bool} [autoHull=true]
     */ Body.setParts = function(body, parts, autoHull) {
                    var i;
                    // add all the parts, ensuring that the first part is always the parent body
                    parts = parts.slice(0);
                    body.parts.length = 0;
                    body.parts.push(body);
                    body.parent = body;
                    for(i = 0; i < parts.length; i++){
                        var part = parts[i];
                        if (part !== body) {
                            part.parent = body;
                            body.parts.push(part);
                        }
                    }
                    if (body.parts.length === 1) return;
                    autoHull = typeof autoHull !== "undefined" ? autoHull : true;
                    // find the convex hull of all parts to set on the parent body
                    if (autoHull) {
                        var vertices = [];
                        for(i = 0; i < parts.length; i++)vertices = vertices.concat(parts[i].vertices);
                        Vertices.clockwiseSort(vertices);
                        var hull = Vertices.hull(vertices), hullCentre = Vertices.centre(hull);
                        Body.setVertices(body, hull);
                        Vertices.translate(body.vertices, hullCentre);
                    }
                    // sum the properties of all compound parts of the parent body
                    var total = Body._totalProperties(body);
                    body.area = total.area;
                    body.parent = body;
                    body.position.x = total.centre.x;
                    body.position.y = total.centre.y;
                    body.positionPrev.x = total.centre.x;
                    body.positionPrev.y = total.centre.y;
                    Body.setMass(body, total.mass);
                    Body.setInertia(body, total.inertia);
                    Body.setPosition(body, total.centre);
                };
                /**
     * Set the centre of mass of the body. 
     * The `centre` is a vector in world-space unless `relative` is set, in which case it is a translation.
     * The centre of mass is the point the body rotates about and can be used to simulate non-uniform density.
     * This is equal to moving `body.position` but not the `body.vertices`.
     * Invalid if the `centre` falls outside the body's convex hull.
     * @method setCentre
     * @param {body} body
     * @param {vector} centre
     * @param {bool} relative
     */ Body.setCentre = function(body, centre, relative) {
                    if (!relative) {
                        body.positionPrev.x = centre.x - (body.position.x - body.positionPrev.x);
                        body.positionPrev.y = centre.y - (body.position.y - body.positionPrev.y);
                        body.position.x = centre.x;
                        body.position.y = centre.y;
                    } else {
                        body.positionPrev.x += centre.x;
                        body.positionPrev.y += centre.y;
                        body.position.x += centre.x;
                        body.position.y += centre.y;
                    }
                };
                /**
     * Sets the position of the body instantly. Velocity, angle, force etc. are unchanged.
     * @method setPosition
     * @param {body} body
     * @param {vector} position
     */ Body.setPosition = function(body, position) {
                    var delta = Vector.sub(position, body.position);
                    body.positionPrev.x += delta.x;
                    body.positionPrev.y += delta.y;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.position.x += delta.x;
                        part.position.y += delta.y;
                        Vertices.translate(part.vertices, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Sets the angle of the body instantly. Angular velocity, position, force etc. are unchanged.
     * @method setAngle
     * @param {body} body
     * @param {number} angle
     */ Body.setAngle = function(body, angle) {
                    var delta = angle - body.angle;
                    body.anglePrev += delta;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.angle += delta;
                        Vertices.rotate(part.vertices, delta, body.position);
                        Axes.rotate(part.axes, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                        if (i > 0) Vector.rotateAbout(part.position, delta, body.position, part.position);
                    }
                };
                /**
     * Sets the linear velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setVelocity
     * @param {body} body
     * @param {vector} velocity
     */ Body.setVelocity = function(body, velocity) {
                    body.positionPrev.x = body.position.x - velocity.x;
                    body.positionPrev.y = body.position.y - velocity.y;
                    body.velocity.x = velocity.x;
                    body.velocity.y = velocity.y;
                    body.speed = Vector.magnitude(body.velocity);
                };
                /**
     * Sets the angular velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setAngularVelocity
     * @param {body} body
     * @param {number} velocity
     */ Body.setAngularVelocity = function(body, velocity) {
                    body.anglePrev = body.angle - velocity;
                    body.angularVelocity = velocity;
                    body.angularSpeed = Math.abs(body.angularVelocity);
                };
                /**
     * Moves a body by a given vector relative to its current position, without imparting any velocity.
     * @method translate
     * @param {body} body
     * @param {vector} translation
     */ Body.translate = function(body, translation) {
                    Body.setPosition(body, Vector.add(body.position, translation));
                };
                /**
     * Rotates a body by a given angle relative to its current angle, without imparting any angular velocity.
     * @method rotate
     * @param {body} body
     * @param {number} rotation
     * @param {vector} [point]
     */ Body.rotate = function(body, rotation, point) {
                    if (!point) Body.setAngle(body, body.angle + rotation);
                    else {
                        var cos = Math.cos(rotation), sin = Math.sin(rotation), dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        });
                        Body.setAngle(body, body.angle + rotation);
                    }
                };
                /**
     * Scales the body, including updating physical properties (mass, area, axes, inertia), from a world-space point (default is body centre).
     * @method scale
     * @param {body} body
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} [point]
     */ Body.scale = function(body, scaleX, scaleY, point) {
                    var totalArea = 0, totalInertia = 0;
                    point = point || body.position;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        // scale vertices
                        Vertices.scale(part.vertices, scaleX, scaleY, point);
                        // update properties
                        part.axes = Axes.fromVertices(part.vertices);
                        part.area = Vertices.area(part.vertices);
                        Body.setMass(part, body.density * part.area);
                        // update inertia (requires vertices to be at origin)
                        Vertices.translate(part.vertices, {
                            x: -part.position.x,
                            y: -part.position.y
                        });
                        Body.setInertia(part, Body._inertiaScale * Vertices.inertia(part.vertices, part.mass));
                        Vertices.translate(part.vertices, {
                            x: part.position.x,
                            y: part.position.y
                        });
                        if (i > 0) {
                            totalArea += part.area;
                            totalInertia += part.inertia;
                        }
                        // scale position
                        part.position.x = point.x + (part.position.x - point.x) * scaleX;
                        part.position.y = point.y + (part.position.y - point.y) * scaleY;
                        // update bounds
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                    // handle parent body
                    if (body.parts.length > 1) {
                        body.area = totalArea;
                        if (!body.isStatic) {
                            Body.setMass(body, body.density * totalArea);
                            Body.setInertia(body, totalInertia);
                        }
                    }
                    // handle circles
                    if (body.circleRadius) {
                        if (scaleX === scaleY) body.circleRadius *= scaleX;
                        else // body is no longer a circle
                        body.circleRadius = null;
                    }
                };
                /**
     * Performs a simulation step for the given `body`, including updating position and angle using Verlet integration.
     * @method update
     * @param {body} body
     * @param {number} deltaTime
     * @param {number} timeScale
     * @param {number} correction
     */ Body.update = function(body, deltaTime, timeScale, correction) {
                    var deltaTimeSquared = Math.pow(deltaTime * timeScale * body.timeScale, 2);
                    // from the previous step
                    var frictionAir = 1 - body.frictionAir * timeScale * body.timeScale, velocityPrevX = body.position.x - body.positionPrev.x, velocityPrevY = body.position.y - body.positionPrev.y;
                    // update velocity with Verlet integration
                    body.velocity.x = velocityPrevX * frictionAir * correction + body.force.x / body.mass * deltaTimeSquared;
                    body.velocity.y = velocityPrevY * frictionAir * correction + body.force.y / body.mass * deltaTimeSquared;
                    body.positionPrev.x = body.position.x;
                    body.positionPrev.y = body.position.y;
                    body.position.x += body.velocity.x;
                    body.position.y += body.velocity.y;
                    // update angular velocity with Verlet integration
                    body.angularVelocity = (body.angle - body.anglePrev) * frictionAir * correction + body.torque / body.inertia * deltaTimeSquared;
                    body.anglePrev = body.angle;
                    body.angle += body.angularVelocity;
                    // track speed and acceleration
                    body.speed = Vector.magnitude(body.velocity);
                    body.angularSpeed = Math.abs(body.angularVelocity);
                    // transform the body geometry
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        Vertices.translate(part.vertices, body.velocity);
                        if (i > 0) {
                            part.position.x += body.velocity.x;
                            part.position.y += body.velocity.y;
                        }
                        if (body.angularVelocity !== 0) {
                            Vertices.rotate(part.vertices, body.angularVelocity, body.position);
                            Axes.rotate(part.axes, body.angularVelocity);
                            if (i > 0) Vector.rotateAbout(part.position, body.angularVelocity, body.position, part.position);
                        }
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Applies a force to a body from a given world-space position, including resulting torque.
     * @method applyForce
     * @param {body} body
     * @param {vector} position
     * @param {vector} force
     */ Body.applyForce = function(body, position, force) {
                    body.force.x += force.x;
                    body.force.y += force.y;
                    var offset = {
                        x: position.x - body.position.x,
                        y: position.y - body.position.y
                    };
                    body.torque += offset.x * force.y - offset.y * force.x;
                };
                /**
     * Returns the sums of the properties of all compound parts of the parent body.
     * @method _totalProperties
     * @private
     * @param {body} body
     * @return {}
     */ Body._totalProperties = function(body) {
                    // from equations at:
                    // https://ecourses.ou.edu/cgi-bin/ebook.cgi?doc=&topic=st&chap_sec=07.2&page=theory
                    // http://output.to/sideway/default.asp?qno=121100087
                    var properties = {
                        mass: 0,
                        area: 0,
                        inertia: 0,
                        centre: {
                            x: 0,
                            y: 0
                        }
                    };
                    // sum the properties of all compound parts of the parent body
                    for(var i = body.parts.length === 1 ? 0 : 1; i < body.parts.length; i++){
                        var part = body.parts[i], mass = part.mass !== Infinity ? part.mass : 1;
                        properties.mass += mass;
                        properties.area += part.area;
                        properties.inertia += part.inertia;
                        properties.centre = Vector.add(properties.centre, Vector.mult(part.position, mass));
                    }
                    properties.centre = Vector.div(properties.centre, properties.mass);
                    return properties;
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a body starts sleeping (where `this` is the body).
    *
    * @event sleepStart
    * @this {body} The body that has started sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a body ends sleeping (where `this` is the body).
    *
    * @event sleepEnd
    * @this {body} The body that has ended sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Body.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "body"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Body"
     */ /**
     * An array of bodies that make up this body. 
     * The first body in the array must always be a self reference to the current body instance.
     * All bodies in the `parts` array together form a single rigid compound body.
     * Parts are allowed to overlap, have gaps or holes or even form concave bodies.
     * Parts themselves should never be added to a `World`, only the parent body should be.
     * Use `Body.setParts` when setting parts to ensure correct updates of all properties.
     *
     * @property parts
     * @type body[]
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * A self reference if the body is _not_ a part of another body.
     * Otherwise this is a reference to the body that this is a part of.
     * See `body.parts`.
     *
     * @property parent
     * @type body
     */ /**
     * A `Number` specifying the angle of the body, in radians.
     *
     * @property angle
     * @type number
     * @default 0
     */ /**
     * An array of `Vector` objects that specify the convex hull of the rigid body.
     * These should be provided about the origin `(0, 0)`. E.g.
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * When passed via `Body.create`, the vertices are translated relative to `body.position` (i.e. world-space, and constantly updated by `Body.update` during simulation).
     * The `Vector` objects are also augmented with additional properties required for efficient collision detection. 
     *
     * Other properties such as `inertia` and `bounds` are automatically calculated from the passed vertices (unless provided via `options`).
     * Concave hulls are not currently supported. The module `Matter.Vertices` contains useful methods for working with vertices.
     *
     * @property vertices
     * @type vector[]
     */ /**
     * A `Vector` that specifies the current world-space position of the body.
     *
     * @property position
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that specifies the force to apply in the current step. It is zeroed after every `Body.update`. See also `Body.applyForce`.
     *
     * @property force
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the torque (turning force) to apply in the current step. It is zeroed after every `Body.update`.
     *
     * @property torque
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.velocity`).
     *
     * @readOnly
     * @property speed
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current angular speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.angularVelocity`).
     *
     * @readOnly
     * @property angularSpeed
     * @type number
     * @default 0
     */ /**
     * A `Vector` that _measures_ the current velocity of the body after the last `Body.update`. It is read-only. 
     * If you need to modify a body's velocity directly, you should either apply a force or simply change the body's `position` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property velocity
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that _measures_ the current angular velocity of the body after the last `Body.update`. It is read-only. 
     * If you need to modify a body's angular velocity directly, you should apply a torque or simply change the body's `angle` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property angularVelocity
     * @type number
     * @default 0
     */ /**
     * A flag that indicates whether a body is considered static. A static body can never change position or angle and is completely fixed.
     * If you need to set a body as static after its creation, you should use `Body.setStatic` as this requires more than just setting this flag.
     *
     * @property isStatic
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether a body is a sensor. Sensor triggers collision events, but doesn't react with colliding body physically.
     *
     * @property isSensor
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether the body is considered sleeping. A sleeping body acts similar to a static body, except it is only temporary and can be awoken.
     * If you need to set a body as sleeping, you should use `Sleeping.set` as this requires more than just setting this flag.
     *
     * @property isSleeping
     * @type boolean
     * @default false
     */ /**
     * A `Number` that _measures_ the amount of movement a body currently has (a combination of `speed` and `angularSpeed`). It is read-only and always positive.
     * It is used and updated by the `Matter.Sleeping` module during simulation to decide if a body has come to rest.
     *
     * @readOnly
     * @property motion
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping by the `Matter.Sleeping` module (if sleeping is enabled by the engine).
     *
     * @property sleepThreshold
     * @type number
     * @default 60
     */ /**
     * A `Number` that defines the density of the body, that is its mass per unit area.
     * If you pass the density via `Body.create` the `mass` property is automatically calculated for you based on the size (area) of the object.
     * This is generally preferable to simply setting mass and allows for more intuitive definition of materials (e.g. rock has a higher density than wood).
     *
     * @property density
     * @type number
     * @default 0.001
     */ /**
     * A `Number` that defines the mass of the body, although it may be more appropriate to specify the `density` property instead.
     * If you modify this value, you must also modify the `body.inverseMass` property (`1 / mass`).
     *
     * @property mass
     * @type number
     */ /**
     * A `Number` that defines the inverse mass of the body (`1 / mass`).
     * If you modify this value, you must also modify the `body.mass` property.
     *
     * @property inverseMass
     * @type number
     */ /**
     * A `Number` that defines the moment of inertia (i.e. second moment of area) of the body.
     * It is automatically calculated from the given convex hull (`vertices` array) and density in `Body.create`.
     * If you modify this value, you must also modify the `body.inverseInertia` property (`1 / inertia`).
     *
     * @property inertia
     * @type number
     */ /**
     * A `Number` that defines the inverse moment of inertia of the body (`1 / inertia`).
     * If you modify this value, you must also modify the `body.inertia` property.
     *
     * @property inverseInertia
     * @type number
     */ /**
     * A `Number` that defines the restitution (elasticity) of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means collisions may be perfectly inelastic and no bouncing may occur. 
     * A value of `0.8` means the body may bounce back with approximately 80% of its kinetic energy.
     * Note that collision response is based on _pairs_ of bodies, and that `restitution` values are _combined_ with the following formula:
     *
     *     Math.max(bodyA.restitution, bodyB.restitution)
     *
     * @property restitution
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the friction of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means that the body may slide indefinitely.
     * A value of `1` means the body may come to a stop almost instantly after a force is applied.
     *
     * The effects of the value may be non-linear. 
     * High values may be unstable depending on the body.
     * The engine uses a Coulomb friction model including static and kinetic friction.
     * Note that collision response is based on _pairs_ of bodies, and that `friction` values are _combined_ with the following formula:
     *
     *     Math.min(bodyA.friction, bodyB.friction)
     *
     * @property friction
     * @type number
     * @default 0.1
     */ /**
     * A `Number` that defines the static friction of the body (in the Coulomb friction model). 
     * A value of `0` means the body will never 'stick' when it is nearly stationary and only dynamic `friction` is used.
     * The higher the value (e.g. `10`), the more force it will take to initially get the body moving when nearly stationary.
     * This value is multiplied with the `friction` property to make it easier to change `friction` and maintain an appropriate amount of static friction.
     *
     * @property frictionStatic
     * @type number
     * @default 0.5
     */ /**
     * A `Number` that defines the air friction of the body (air resistance). 
     * A value of `0` means the body will never slow as it moves through space.
     * The higher the value, the faster a body slows when moving through space.
     * The effects of the value are non-linear. 
     *
     * @property frictionAir
     * @type number
     * @default 0.01
     */ /**
     * An `Object` that specifies the collision filtering properties of this body.
     *
     * Collisions between two bodies will obey the following rules:
     * - If the two bodies have the same non-zero value of `collisionFilter.group`,
     *   they will always collide if the value is positive, and they will never collide
     *   if the value is negative.
     * - If the two bodies have different values of `collisionFilter.group` or if one
     *   (or both) of the bodies has a value of 0, then the category/mask rules apply as follows:
     *
     * Each body belongs to a collision category, given by `collisionFilter.category`. This
     * value is used as a bit field and the category should have only one bit set, meaning that
     * the value of this property is a power of two in the range [1, 2^31]. Thus, there are 32
     * different collision categories available.
     *
     * Each body also defines a collision bitmask, given by `collisionFilter.mask` which specifies
     * the categories it collides with (the value is the bitwise AND value of all these categories).
     *
     * Using the category/mask rules, two bodies `A` and `B` collide if each includes the other's
     * category in its mask, i.e. `(categoryA & maskB) !== 0` and `(categoryB & maskA) !== 0`
     * are both true.
     *
     * @property collisionFilter
     * @type object
     */ /**
     * An Integer `Number`, that specifies the collision group this body belongs to.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.group
     * @type object
     * @default 0
     */ /**
     * A bit field that specifies the collision category this body belongs to.
     * The category value should have only one bit set, for example `0x0001`.
     * This means there are up to 32 unique collision categories available.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.category
     * @type object
     * @default 1
     */ /**
     * A bit mask that specifies the collision categories this body may collide with.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.mask
     * @type object
     * @default -1
     */ /**
     * A `Number` that specifies a tolerance on how far a body is allowed to 'sink' or rotate into other bodies.
     * Avoid changing this value unless you understand the purpose of `slop` in physics engines.
     * The default should generally suffice, although very large bodies may require larger values for stable stacking.
     *
     * @property slop
     * @type number
     * @default 0.05
     */ /**
     * A `Number` that allows per-body time scaling, e.g. a force-field where bodies inside are in slow-motion, while others are at full speed.
     *
     * @property timeScale
     * @type number
     * @default 1
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the body should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * Sets the opacity to use when rendering.
     *
     * @property render.opacity
     * @type number
     * @default 1
    */ /**
     * An `Object` that defines the sprite properties to use when rendering, if any.
     *
     * @property render.sprite
     * @type object
     */ /**
     * An `String` that defines the path to the image to use as the sprite texture, if any.
     *
     * @property render.sprite.texture
     * @type string
     */ /**
     * A `Number` that defines the scaling in the x-axis for the sprite, if any.
     *
     * @property render.sprite.xScale
     * @type number
     * @default 1
     */ /**
     * A `Number` that defines the scaling in the y-axis for the sprite, if any.
     *
     * @property render.sprite.yScale
     * @type number
     * @default 1
     */ /**
      * A `Number` that defines the offset in the x-axis for the sprite (normalised by texture width).
      *
      * @property render.sprite.xOffset
      * @type number
      * @default 0
      */ /**
      * A `Number` that defines the offset in the y-axis for the sprite (normalised by texture height).
      *
      * @property render.sprite.yOffset
      * @type number
      * @default 0
      */ /**
     * A `Number` that defines the line width to use when rendering the body outline (if a sprite is not defined).
     * A value of `0` means no outline will be rendered.
     *
     * @property render.lineWidth
     * @type number
     * @default 0
     */ /**
     * A `String` that defines the fill style to use when rendering the body (if a sprite is not defined).
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.fillStyle
     * @type string
     * @default a random colour
     */ /**
     * A `String` that defines the stroke style to use when rendering the body outline (if a sprite is not defined).
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.strokeStyle
     * @type string
     * @default a random colour
     */ /**
     * An array of unique axis vectors (edge normals) used for collision detection.
     * These are automatically calculated from the given convex hull (`vertices` array) in `Body.create`.
     * They are constantly updated by `Body.update` during the simulation.
     *
     * @property axes
     * @type vector[]
     */ /**
     * A `Number` that _measures_ the area of the body's convex hull, calculated at creation by `Body.create`.
     *
     * @property area
     * @type string
     * @default 
     */ /**
     * A `Bounds` object that defines the AABB region for the body.
     * It is automatically calculated from the given convex hull (`vertices` array) in `Body.create` and constantly updated by `Body.update` during simulation.
     *
     * @property bounds
     * @type bounds
     */ })();
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Sleeping` module contains methods to manage the sleeping state of bodies.
*
* @class Sleeping
*/ var Sleeping = {};
            module1.exports = Sleeping;
            var Events = __webpack_require__(4);
            (function() {
                Sleeping._motionWakeThreshold = 0.18;
                Sleeping._motionSleepThreshold = 0.08;
                Sleeping._minBias = 0.9;
                /**
     * Puts bodies to sleep or wakes them up depending on their motion.
     * @method update
     * @param {body[]} bodies
     * @param {number} timeScale
     */ Sleeping.update = function(bodies, timeScale) {
                    var timeFactor = timeScale * timeScale * timeScale;
                    // update bodies sleeping status
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], motion = body.speed * body.speed + body.angularSpeed * body.angularSpeed;
                        // wake up bodies if they have a force applied
                        if (body.force.x !== 0 || body.force.y !== 0) {
                            Sleeping.set(body, false);
                            continue;
                        }
                        var minMotion = Math.min(body.motion, motion), maxMotion = Math.max(body.motion, motion);
                        // biased average motion estimation between frames
                        body.motion = Sleeping._minBias * minMotion + (1 - Sleeping._minBias) * maxMotion;
                        if (body.sleepThreshold > 0 && body.motion < Sleeping._motionSleepThreshold * timeFactor) {
                            body.sleepCounter += 1;
                            if (body.sleepCounter >= body.sleepThreshold) Sleeping.set(body, true);
                        } else if (body.sleepCounter > 0) body.sleepCounter -= 1;
                    }
                };
                /**
     * Given a set of colliding pairs, wakes the sleeping bodies involved.
     * @method afterCollisions
     * @param {pair[]} pairs
     * @param {number} timeScale
     */ Sleeping.afterCollisions = function(pairs, timeScale) {
                    var timeFactor = timeScale * timeScale * timeScale;
                    // wake up bodies involved in collisions
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        // don't wake inactive pairs
                        if (!pair.isActive) continue;
                        var collision = pair.collision, bodyA = collision.bodyA.parent, bodyB = collision.bodyB.parent;
                        // don't wake if at least one body is static
                        if (bodyA.isSleeping && bodyB.isSleeping || bodyA.isStatic || bodyB.isStatic) continue;
                        if (bodyA.isSleeping || bodyB.isSleeping) {
                            var sleepingBody = bodyA.isSleeping && !bodyA.isStatic ? bodyA : bodyB, movingBody = sleepingBody === bodyA ? bodyB : bodyA;
                            if (!sleepingBody.isStatic && movingBody.motion > Sleeping._motionWakeThreshold * timeFactor) Sleeping.set(sleepingBody, false);
                        }
                    }
                };
                /**
     * Set a body as sleeping or awake.
     * @method set
     * @param {body} body
     * @param {boolean} isSleeping
     */ Sleeping.set = function(body, isSleeping) {
                    var wasSleeping = body.isSleeping;
                    if (isSleeping) {
                        body.isSleeping = true;
                        body.sleepCounter = body.sleepThreshold;
                        body.positionImpulse.x = 0;
                        body.positionImpulse.y = 0;
                        body.positionPrev.x = body.position.x;
                        body.positionPrev.y = body.position.y;
                        body.anglePrev = body.angle;
                        body.speed = 0;
                        body.angularSpeed = 0;
                        body.motion = 0;
                        if (!wasSleeping) Events.trigger(body, "sleepStart");
                    } else {
                        body.isSleeping = false;
                        body.sleepCounter = 0;
                        if (wasSleeping) Events.trigger(body, "sleepEnd");
                    }
                };
            })();
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Collision` module contains methods for detecting collisions between a given pair of bodies.
*
* For efficient detection between a list of bodies, see `Matter.Detector` and `Matter.Query`.
*
* See `Matter.Engine` for collision events.
*
* @class Collision
*/ var Collision = {};
            module1.exports = Collision;
            var Vertices = __webpack_require__(3);
            var Pair = __webpack_require__(9);
            (function() {
                var _supports = [];
                var _overlapAB = {
                    overlap: 0,
                    axis: null
                };
                var _overlapBA = {
                    overlap: 0,
                    axis: null
                };
                /**
     * Creates a new collision record.
     * @method create
     * @param {body} bodyA The first body part represented by the collision record
     * @param {body} bodyB The second body part represented by the collision record
     * @return {collision} A new collision record
     */ Collision.create = function(bodyA, bodyB) {
                    return {
                        pair: null,
                        collided: false,
                        bodyA: bodyA,
                        bodyB: bodyB,
                        parentA: bodyA.parent,
                        parentB: bodyB.parent,
                        depth: 0,
                        normal: {
                            x: 0,
                            y: 0
                        },
                        tangent: {
                            x: 0,
                            y: 0
                        },
                        penetration: {
                            x: 0,
                            y: 0
                        },
                        supports: []
                    };
                };
                /**
     * Detect collision between two bodies.
     * @method collides
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {pairs} [pairs] Optionally reuse collision records from existing pairs.
     * @return {collision|null} A collision record if detected, otherwise null
     */ Collision.collides = function(bodyA, bodyB, pairs) {
                    Collision._overlapAxes(_overlapAB, bodyA.vertices, bodyB.vertices, bodyA.axes);
                    if (_overlapAB.overlap <= 0) return null;
                    Collision._overlapAxes(_overlapBA, bodyB.vertices, bodyA.vertices, bodyB.axes);
                    if (_overlapBA.overlap <= 0) return null;
                    // reuse collision records for gc efficiency
                    var pair = pairs && pairs.table[Pair.id(bodyA, bodyB)], collision;
                    if (!pair) {
                        collision = Collision.create(bodyA, bodyB);
                        collision.collided = true;
                        collision.bodyA = bodyA.id < bodyB.id ? bodyA : bodyB;
                        collision.bodyB = bodyA.id < bodyB.id ? bodyB : bodyA;
                        collision.parentA = collision.bodyA.parent;
                        collision.parentB = collision.bodyB.parent;
                    } else collision = pair.collision;
                    bodyA = collision.bodyA;
                    bodyB = collision.bodyB;
                    var minOverlap;
                    if (_overlapAB.overlap < _overlapBA.overlap) minOverlap = _overlapAB;
                    else minOverlap = _overlapBA;
                    var normal = collision.normal, supports = collision.supports, minAxis = minOverlap.axis, minAxisX = minAxis.x, minAxisY = minAxis.y;
                    // ensure normal is facing away from bodyA
                    if (minAxisX * (bodyB.position.x - bodyA.position.x) + minAxisY * (bodyB.position.y - bodyA.position.y) < 0) {
                        normal.x = minAxisX;
                        normal.y = minAxisY;
                    } else {
                        normal.x = -minAxisX;
                        normal.y = -minAxisY;
                    }
                    collision.tangent.x = -normal.y;
                    collision.tangent.y = normal.x;
                    collision.depth = minOverlap.overlap;
                    collision.penetration.x = normal.x * collision.depth;
                    collision.penetration.y = normal.y * collision.depth;
                    // find support points, there is always either exactly one or two
                    var supportsB = Collision._findSupports(bodyA, bodyB, normal, 1), supportCount = 0;
                    // find the supports from bodyB that are inside bodyA
                    if (Vertices.contains(bodyA.vertices, supportsB[0])) supports[supportCount++] = supportsB[0];
                    if (Vertices.contains(bodyA.vertices, supportsB[1])) supports[supportCount++] = supportsB[1];
                    // find the supports from bodyA that are inside bodyB
                    if (supportCount < 2) {
                        var supportsA = Collision._findSupports(bodyB, bodyA, normal, -1);
                        if (Vertices.contains(bodyB.vertices, supportsA[0])) supports[supportCount++] = supportsA[0];
                        if (supportCount < 2 && Vertices.contains(bodyB.vertices, supportsA[1])) supports[supportCount++] = supportsA[1];
                    }
                    // account for the edge case of overlapping but no vertex containment
                    if (supportCount === 0) supports[supportCount++] = supportsB[0];
                    // update supports array size
                    supports.length = supportCount;
                    return collision;
                };
                /**
     * Find the overlap between two sets of vertices.
     * @method _overlapAxes
     * @private
     * @param {object} result
     * @param {vertices} verticesA
     * @param {vertices} verticesB
     * @param {axes} axes
     */ Collision._overlapAxes = function(result, verticesA, verticesB, axes) {
                    var verticesALength = verticesA.length, verticesBLength = verticesB.length, verticesAX = verticesA[0].x, verticesAY = verticesA[0].y, verticesBX = verticesB[0].x, verticesBY = verticesB[0].y, axesLength = axes.length, overlapMin = Number.MAX_VALUE, overlapAxisNumber = 0, overlap, overlapAB, overlapBA, dot, i, j;
                    for(i = 0; i < axesLength; i++){
                        var axis = axes[i], axisX = axis.x, axisY = axis.y, minA = verticesAX * axisX + verticesAY * axisY, minB = verticesBX * axisX + verticesBY * axisY, maxA = minA, maxB = minB;
                        for(j = 1; j < verticesALength; j += 1){
                            dot = verticesA[j].x * axisX + verticesA[j].y * axisY;
                            if (dot > maxA) maxA = dot;
                            else if (dot < minA) minA = dot;
                        }
                        for(j = 1; j < verticesBLength; j += 1){
                            dot = verticesB[j].x * axisX + verticesB[j].y * axisY;
                            if (dot > maxB) maxB = dot;
                            else if (dot < minB) minB = dot;
                        }
                        overlapAB = maxA - minB;
                        overlapBA = maxB - minA;
                        overlap = overlapAB < overlapBA ? overlapAB : overlapBA;
                        if (overlap < overlapMin) {
                            overlapMin = overlap;
                            overlapAxisNumber = i;
                            if (overlap <= 0) break;
                        }
                    }
                    result.axis = axes[overlapAxisNumber];
                    result.overlap = overlapMin;
                };
                /**
     * Projects vertices on an axis and returns an interval.
     * @method _projectToAxis
     * @private
     * @param {} projection
     * @param {} vertices
     * @param {} axis
     */ Collision._projectToAxis = function(projection, vertices, axis) {
                    var min = vertices[0].x * axis.x + vertices[0].y * axis.y, max = min;
                    for(var i = 1; i < vertices.length; i += 1){
                        var dot = vertices[i].x * axis.x + vertices[i].y * axis.y;
                        if (dot > max) max = dot;
                        else if (dot < min) min = dot;
                    }
                    projection.min = min;
                    projection.max = max;
                };
                /**
     * Finds supporting vertices given two bodies along a given direction using hill-climbing.
     * @method _findSupports
     * @private
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {vector} normal
     * @param {number} direction
     * @return [vector]
     */ Collision._findSupports = function(bodyA, bodyB, normal, direction) {
                    var vertices = bodyB.vertices, verticesLength = vertices.length, bodyAPositionX = bodyA.position.x, bodyAPositionY = bodyA.position.y, normalX = normal.x * direction, normalY = normal.y * direction, nearestDistance = Number.MAX_VALUE, vertexA, vertexB, vertexC, distance, j;
                    // find deepest vertex relative to the axis
                    for(j = 0; j < verticesLength; j += 1){
                        vertexB = vertices[j];
                        distance = normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y);
                        // convex hill-climbing
                        if (distance < nearestDistance) {
                            nearestDistance = distance;
                            vertexA = vertexB;
                        }
                    }
                    // measure next vertex
                    vertexC = vertices[(verticesLength + vertexA.index - 1) % verticesLength];
                    nearestDistance = normalX * (bodyAPositionX - vertexC.x) + normalY * (bodyAPositionY - vertexC.y);
                    // compare with previous vertex
                    vertexB = vertices[(vertexA.index + 1) % verticesLength];
                    if (normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y) < nearestDistance) {
                        _supports[0] = vertexA;
                        _supports[1] = vertexB;
                        return _supports;
                    }
                    _supports[0] = vertexA;
                    _supports[1] = vertexC;
                    return _supports;
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * A reference to the pair using this collision record, if there is one.
     *
     * @property pair
     * @type {pair|null}
     * @default null
     */ /**
     * A flag that indicates if the bodies were colliding when the collision was last updated.
     * 
     * @property collided
     * @type boolean
     * @default false
     */ /**
     * The first body part represented by the collision (see also `collision.parentA`).
     * 
     * @property bodyA
     * @type body
     */ /**
     * The second body part represented by the collision (see also `collision.parentB`).
     * 
     * @property bodyB
     * @type body
     */ /**
     * The first body represented by the collision (i.e. `collision.bodyA.parent`).
     * 
     * @property parentA
     * @type body
     */ /**
     * The second body represented by the collision (i.e. `collision.bodyB.parent`).
     * 
     * @property parentB
     * @type body
     */ /**
     * A `Number` that represents the minimum separating distance between the bodies along the collision normal.
     *
     * @readOnly
     * @property depth
     * @type number
     * @default 0
     */ /**
     * A normalised `Vector` that represents the direction between the bodies that provides the minimum separating distance.
     *
     * @property normal
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A normalised `Vector` that is the tangent direction to the collision normal.
     *
     * @property tangent
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that represents the direction and depth of the collision.
     *
     * @property penetration
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * An array of body vertices that represent the support points in the collision.
     * These are the deepest vertices (along the collision normal) of each body that are contained by the other body's vertices.
     *
     * @property supports
     * @type vector[]
     * @default []
     */ })();
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
*
* @class Pair
*/ var Pair = {};
            module1.exports = Pair;
            var Contact = __webpack_require__(17);
            (function() {
                /**
     * Creates a pair.
     * @method create
     * @param {collision} collision
     * @param {number} timestamp
     * @return {pair} A new pair
     */ Pair.create = function(collision, timestamp) {
                    var bodyA = collision.bodyA, bodyB = collision.bodyB;
                    var pair = {
                        id: Pair.id(bodyA, bodyB),
                        bodyA: bodyA,
                        bodyB: bodyB,
                        collision: collision,
                        contacts: [],
                        activeContacts: [],
                        separation: 0,
                        isActive: true,
                        confirmedActive: true,
                        isSensor: bodyA.isSensor || bodyB.isSensor,
                        timeCreated: timestamp,
                        timeUpdated: timestamp,
                        inverseMass: 0,
                        friction: 0,
                        frictionStatic: 0,
                        restitution: 0,
                        slop: 0
                    };
                    Pair.update(pair, collision, timestamp);
                    return pair;
                };
                /**
     * Updates a pair given a collision.
     * @method update
     * @param {pair} pair
     * @param {collision} collision
     * @param {number} timestamp
     */ Pair.update = function(pair, collision, timestamp) {
                    var contacts = pair.contacts, supports = collision.supports, activeContacts = pair.activeContacts, parentA = collision.parentA, parentB = collision.parentB, parentAVerticesLength = parentA.vertices.length;
                    pair.isActive = true;
                    pair.timeUpdated = timestamp;
                    pair.collision = collision;
                    pair.separation = collision.depth;
                    pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
                    pair.friction = parentA.friction < parentB.friction ? parentA.friction : parentB.friction;
                    pair.frictionStatic = parentA.frictionStatic > parentB.frictionStatic ? parentA.frictionStatic : parentB.frictionStatic;
                    pair.restitution = parentA.restitution > parentB.restitution ? parentA.restitution : parentB.restitution;
                    pair.slop = parentA.slop > parentB.slop ? parentA.slop : parentB.slop;
                    collision.pair = pair;
                    activeContacts.length = 0;
                    for(var i = 0; i < supports.length; i++){
                        var support = supports[i], contactId = support.body === parentA ? support.index : parentAVerticesLength + support.index, contact = contacts[contactId];
                        if (contact) activeContacts.push(contact);
                        else activeContacts.push(contacts[contactId] = Contact.create(support));
                    }
                };
                /**
     * Set a pair as active or inactive.
     * @method setActive
     * @param {pair} pair
     * @param {bool} isActive
     * @param {number} timestamp
     */ Pair.setActive = function(pair, isActive, timestamp) {
                    if (isActive) {
                        pair.isActive = true;
                        pair.timeUpdated = timestamp;
                    } else {
                        pair.isActive = false;
                        pair.activeContacts.length = 0;
                    }
                };
                /**
     * Get the id for the given pair.
     * @method id
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {string} Unique pairId
     */ Pair.id = function(bodyA, bodyB) {
                    if (bodyA.id < bodyB.id) return "A" + bodyA.id + "B" + bodyB.id;
                    else return "A" + bodyB.id + "B" + bodyA.id;
                };
            })();
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Constraint` module contains methods for creating and manipulating constraints.
* Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
* The stiffness of constraints can be modified to create springs or elastic.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Constraint
*/ var Constraint = {};
            module1.exports = Constraint;
            var Vertices = __webpack_require__(3);
            var Vector = __webpack_require__(2);
            var Sleeping = __webpack_require__(7);
            var Bounds = __webpack_require__(1);
            var Axes = __webpack_require__(11);
            var Common = __webpack_require__(0);
            (function() {
                Constraint._warming = 0.4;
                Constraint._torqueDampen = 1;
                Constraint._minLength = 0.000001;
                /**
     * Creates a new constraint.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness` value (e.g. `0.7` or above).
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing `engine.constraintIterations`.
     * For compound bodies, constraints must be applied to the parent body (not one of its parts).
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {constraint} constraint
     */ Constraint.create = function(options) {
                    var constraint = options;
                    // if bodies defined but no points, use body centre
                    if (constraint.bodyA && !constraint.pointA) constraint.pointA = {
                        x: 0,
                        y: 0
                    };
                    if (constraint.bodyB && !constraint.pointB) constraint.pointB = {
                        x: 0,
                        y: 0
                    };
                    // calculate static length using initial world space points
                    var initialPointA = constraint.bodyA ? Vector.add(constraint.bodyA.position, constraint.pointA) : constraint.pointA, initialPointB = constraint.bodyB ? Vector.add(constraint.bodyB.position, constraint.pointB) : constraint.pointB, length = Vector.magnitude(Vector.sub(initialPointA, initialPointB));
                    constraint.length = typeof constraint.length !== "undefined" ? constraint.length : length;
                    // option defaults
                    constraint.id = constraint.id || Common.nextId();
                    constraint.label = constraint.label || "Constraint";
                    constraint.type = "constraint";
                    constraint.stiffness = constraint.stiffness || (constraint.length > 0 ? 1 : 0.7);
                    constraint.damping = constraint.damping || 0;
                    constraint.angularStiffness = constraint.angularStiffness || 0;
                    constraint.angleA = constraint.bodyA ? constraint.bodyA.angle : constraint.angleA;
                    constraint.angleB = constraint.bodyB ? constraint.bodyB.angle : constraint.angleB;
                    constraint.plugin = {};
                    // render
                    var render = {
                        visible: true,
                        lineWidth: 2,
                        strokeStyle: "#ffffff",
                        type: "line",
                        anchors: true
                    };
                    if (constraint.length === 0 && constraint.stiffness > 0.1) {
                        render.type = "pin";
                        render.anchors = false;
                    } else if (constraint.stiffness < 0.9) render.type = "spring";
                    constraint.render = Common.extend(render, constraint.render);
                    return constraint;
                };
                /**
     * Prepares for solving by constraint warming.
     * @private
     * @method preSolveAll
     * @param {body[]} bodies
     */ Constraint.preSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        body.position.x += impulse.x;
                        body.position.y += impulse.y;
                        body.angle += impulse.angle;
                    }
                };
                /**
     * Solves all constraints in a list of collisions.
     * @private
     * @method solveAll
     * @param {constraint[]} constraints
     * @param {number} timeScale
     */ Constraint.solveAll = function(constraints, timeScale) {
                    // Solve fixed constraints first.
                    for(var i = 0; i < constraints.length; i += 1){
                        var constraint = constraints[i], fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic, fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (fixedA || fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                    // Solve free constraints last.
                    for(i = 0; i < constraints.length; i += 1){
                        constraint = constraints[i];
                        fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic;
                        fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (!fixedA && !fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                };
                /**
     * Solves a distance constraint with Gauss-Siedel method.
     * @private
     * @method solve
     * @param {constraint} constraint
     * @param {number} timeScale
     */ Constraint.solve = function(constraint, timeScale) {
                    var bodyA = constraint.bodyA, bodyB = constraint.bodyB, pointA = constraint.pointA, pointB = constraint.pointB;
                    if (!bodyA && !bodyB) return;
                    // update reference angle
                    if (bodyA && !bodyA.isStatic) {
                        Vector.rotate(pointA, bodyA.angle - constraint.angleA, pointA);
                        constraint.angleA = bodyA.angle;
                    }
                    // update reference angle
                    if (bodyB && !bodyB.isStatic) {
                        Vector.rotate(pointB, bodyB.angle - constraint.angleB, pointB);
                        constraint.angleB = bodyB.angle;
                    }
                    var pointAWorld = pointA, pointBWorld = pointB;
                    if (bodyA) pointAWorld = Vector.add(bodyA.position, pointA);
                    if (bodyB) pointBWorld = Vector.add(bodyB.position, pointB);
                    if (!pointAWorld || !pointBWorld) return;
                    var delta = Vector.sub(pointAWorld, pointBWorld), currentLength = Vector.magnitude(delta);
                    // prevent singularity
                    if (currentLength < Constraint._minLength) currentLength = Constraint._minLength;
                    // solve distance constraint with Gauss-Siedel method
                    var difference = (currentLength - constraint.length) / currentLength, stiffness = constraint.stiffness < 1 ? constraint.stiffness * timeScale : constraint.stiffness, force = Vector.mult(delta, difference * stiffness), massTotal = (bodyA ? bodyA.inverseMass : 0) + (bodyB ? bodyB.inverseMass : 0), inertiaTotal = (bodyA ? bodyA.inverseInertia : 0) + (bodyB ? bodyB.inverseInertia : 0), resistanceTotal = massTotal + inertiaTotal, torque, share, normal, normalVelocity, relativeVelocity;
                    if (constraint.damping) {
                        var zero = Vector.create();
                        normal = Vector.div(delta, currentLength);
                        relativeVelocity = Vector.sub(bodyB && Vector.sub(bodyB.position, bodyB.positionPrev) || zero, bodyA && Vector.sub(bodyA.position, bodyA.positionPrev) || zero);
                        normalVelocity = Vector.dot(normal, relativeVelocity);
                    }
                    if (bodyA && !bodyA.isStatic) {
                        share = bodyA.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyA.constraintImpulse.x -= force.x * share;
                        bodyA.constraintImpulse.y -= force.y * share;
                        // apply forces
                        bodyA.position.x -= force.x * share;
                        bodyA.position.y -= force.y * share;
                        // apply damping
                        if (constraint.damping) {
                            bodyA.positionPrev.x -= constraint.damping * normal.x * normalVelocity * share;
                            bodyA.positionPrev.y -= constraint.damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointA, force) / resistanceTotal * Constraint._torqueDampen * bodyA.inverseInertia * (1 - constraint.angularStiffness);
                        bodyA.constraintImpulse.angle -= torque;
                        bodyA.angle -= torque;
                    }
                    if (bodyB && !bodyB.isStatic) {
                        share = bodyB.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyB.constraintImpulse.x += force.x * share;
                        bodyB.constraintImpulse.y += force.y * share;
                        // apply forces
                        bodyB.position.x += force.x * share;
                        bodyB.position.y += force.y * share;
                        // apply damping
                        if (constraint.damping) {
                            bodyB.positionPrev.x += constraint.damping * normal.x * normalVelocity * share;
                            bodyB.positionPrev.y += constraint.damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointB, force) / resistanceTotal * Constraint._torqueDampen * bodyB.inverseInertia * (1 - constraint.angularStiffness);
                        bodyB.constraintImpulse.angle += torque;
                        bodyB.angle += torque;
                    }
                };
                /**
     * Performs body updates required after solving constraints.
     * @private
     * @method postSolveAll
     * @param {body[]} bodies
     */ Constraint.postSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        Sleeping.set(body, false);
                        // update geometry and reset
                        for(var j = 0; j < body.parts.length; j++){
                            var part = body.parts[j];
                            Vertices.translate(part.vertices, impulse);
                            if (j > 0) {
                                part.position.x += impulse.x;
                                part.position.y += impulse.y;
                            }
                            if (impulse.angle !== 0) {
                                Vertices.rotate(part.vertices, impulse.angle, body.position);
                                Axes.rotate(part.axes, impulse.angle);
                                if (j > 0) Vector.rotateAbout(part.position, impulse.angle, body.position, part.position);
                            }
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                        }
                        // dampen the cached impulse for warming next step
                        impulse.angle *= Constraint._warming;
                        impulse.x *= Constraint._warming;
                        impulse.y *= Constraint._warming;
                    }
                };
                /**
     * Returns the world-space position of `constraint.pointA`, accounting for `constraint.bodyA`.
     * @method pointAWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointAWorld = function(constraint) {
                    return {
                        x: (constraint.bodyA ? constraint.bodyA.position.x : 0) + constraint.pointA.x,
                        y: (constraint.bodyA ? constraint.bodyA.position.y : 0) + constraint.pointA.y
                    };
                };
                /**
     * Returns the world-space position of `constraint.pointB`, accounting for `constraint.bodyB`.
     * @method pointBWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointBWorld = function(constraint) {
                    return {
                        x: (constraint.bodyB ? constraint.bodyB.position.x : 0) + constraint.pointB.x,
                        y: (constraint.bodyB ? constraint.bodyB.position.y : 0) + constraint.pointB.y
                    };
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "constraint"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Constraint"
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the constraint should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * A `Number` that defines the line width to use when rendering the constraint outline.
     * A value of `0` means no outline will be rendered.
     *
     * @property render.lineWidth
     * @type number
     * @default 2
     */ /**
     * A `String` that defines the stroke style to use when rendering the constraint outline.
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.strokeStyle
     * @type string
     * @default a random colour
     */ /**
     * A `String` that defines the constraint rendering type. 
     * The possible values are 'line', 'pin', 'spring'.
     * An appropriate render type will be automatically chosen unless one is given in options.
     *
     * @property render.type
     * @type string
     * @default 'line'
     */ /**
     * A `Boolean` that defines if the constraint's anchor points should be rendered.
     *
     * @property render.anchors
     * @type boolean
     * @default true
     */ /**
     * The first possible `Body` that this constraint is attached to.
     *
     * @property bodyA
     * @type body
     * @default null
     */ /**
     * The second possible `Body` that this constraint is attached to.
     *
     * @property bodyB
     * @type body
     * @default null
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
     *
     * @property pointA
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyB` if defined, otherwise a world-space position.
     *
     * @property pointB
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`.
     * A value of `1` means the constraint should be very stiff.
     * A value of `0.2` means the constraint acts like a soft spring.
     *
     * @property stiffness
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the damping of the constraint, 
     * i.e. the amount of resistance applied to each body based on their velocities to limit the amount of oscillation.
     * Damping will only be apparent when the constraint also has a very low `stiffness`.
     * A value of `0.1` means the constraint will apply heavy damping, resulting in little to no oscillation.
     * A value of `0` means the constraint will apply no damping.
     *
     * @property damping
     * @type number
     * @default 0
     */ /**
     * A `Number` that specifies the target resting length of the constraint. 
     * It is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     *
     * @property length
     * @type number
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
*
* @class Axes
*/ var Axes = {};
            module1.exports = Axes;
            var Vector = __webpack_require__(2);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a new set of axes from the given vertices.
     * @method fromVertices
     * @param {vertices} vertices
     * @return {axes} A new axes from the given vertices
     */ Axes.fromVertices = function(vertices) {
                    var axes = {};
                    // find the unique axes, using edge normal gradients
                    for(var i = 0; i < vertices.length; i++){
                        var j = (i + 1) % vertices.length, normal = Vector.normalise({
                            x: vertices[j].y - vertices[i].y,
                            y: vertices[i].x - vertices[j].x
                        }), gradient = normal.y === 0 ? Infinity : normal.x / normal.y;
                        // limit precision
                        gradient = gradient.toFixed(3).toString();
                        axes[gradient] = normal;
                    }
                    return Common.values(axes);
                };
                /**
     * Rotates a set of axes by the given angle.
     * @method rotate
     * @param {axes} axes
     * @param {number} angle
     */ Axes.rotate = function(axes, angle) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    for(var i = 0; i < axes.length; i++){
                        var axis = axes[i], xx;
                        xx = axis.x * cos - axis.y * sin;
                        axis.y = axis.x * sin + axis.y * cos;
                        axis.x = xx;
                    }
                };
            })();
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Bodies` module contains factory methods for creating rigid body models 
* with commonly used body configurations (such as rectangles, circles and other polygons).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Bodies
*/ // TODO: true circle bodies
            var Bodies = {};
            module1.exports = Bodies;
            var Vertices = __webpack_require__(3);
            var Common = __webpack_require__(0);
            var Body = __webpack_require__(6);
            var Bounds = __webpack_require__(1);
            var Vector = __webpack_require__(2);
            (function() {
                /**
     * Creates a new rigid body model with a rectangle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method rectangle
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {object} [options]
     * @return {body} A new rectangle body
     */ Bodies.rectangle = function(x, y, width, height, options) {
                    options = options || {};
                    var rectangle = {
                        label: "Rectangle Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath("L 0 0 L " + width + " 0 L " + width + " " + height + " L 0 " + height)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        rectangle.vertices = Vertices.chamfer(rectangle.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, rectangle, options));
                };
                /**
     * Creates a new rigid body model with a trapezoid hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method trapezoid
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {number} slope
     * @param {object} [options]
     * @return {body} A new trapezoid body
     */ Bodies.trapezoid = function(x, y, width, height, slope, options) {
                    options = options || {};
                    slope *= 0.5;
                    var roof = (1 - slope * 2) * width;
                    var x1 = width * slope, x2 = x1 + roof, x3 = x2 + x1, verticesPath;
                    if (slope < 0.5) verticesPath = "L 0 0 L " + x1 + " " + -height + " L " + x2 + " " + -height + " L " + x3 + " 0";
                    else verticesPath = "L 0 0 L " + x2 + " " + -height + " L " + x3 + " 0";
                    var trapezoid = {
                        label: "Trapezoid Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(verticesPath)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        trapezoid.vertices = Vertices.chamfer(trapezoid.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, trapezoid, options));
                };
                /**
     * Creates a new rigid body model with a circle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method circle
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @param {object} [options]
     * @param {number} [maxSides]
     * @return {body} A new circle body
     */ Bodies.circle = function(x, y, radius, options, maxSides) {
                    options = options || {};
                    var circle = {
                        label: "Circle Body",
                        circleRadius: radius
                    };
                    // approximate circles with polygons until true circles implemented in SAT
                    maxSides = maxSides || 25;
                    var sides = Math.ceil(Math.max(10, Math.min(maxSides, radius)));
                    // optimisation: always use even number of sides (half the number of unique axes)
                    if (sides % 2 === 1) sides += 1;
                    return Bodies.polygon(x, y, sides, radius, Common.extend({}, circle, options));
                };
                /**
     * Creates a new rigid body model with a regular polygon hull with the given number of sides. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method polygon
     * @param {number} x
     * @param {number} y
     * @param {number} sides
     * @param {number} radius
     * @param {object} [options]
     * @return {body} A new regular polygon body
     */ Bodies.polygon = function(x, y, sides, radius, options) {
                    options = options || {};
                    if (sides < 3) return Bodies.circle(x, y, radius, options);
                    var theta = 2 * Math.PI / sides, path = "", offset = theta * 0.5;
                    for(var i = 0; i < sides; i += 1){
                        var angle = offset + i * theta, xx = Math.cos(angle) * radius, yy = Math.sin(angle) * radius;
                        path += "L " + xx.toFixed(3) + " " + yy.toFixed(3) + " ";
                    }
                    var polygon = {
                        label: "Polygon Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(path)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        polygon.vertices = Vertices.chamfer(polygon.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, polygon, options));
                };
                /**
     * Utility to create a compound body based on set(s) of vertices.
     * 
     * _Note:_ To optionally enable automatic concave vertices decomposition the [poly-decomp](https://github.com/schteppe/poly-decomp.js) 
     * package must be first installed and provided see `Common.setDecomp`, otherwise the convex hull of each vertex set will be used.
     * 
     * The resulting vertices are reorientated about their centre of mass,
     * and offset such that `body.position` corresponds to this point.
     * 
     * The resulting offset may be found if needed by subtracting `body.bounds` from the original input bounds.
     * To later move the centre of mass see `Body.setCentre`.
     * 
     * Note that automatic conconcave decomposition results are not always optimal. 
     * For best results, simplify the input vertices as much as possible first.
     * By default this function applies some addtional simplification to help.
     * 
     * Some outputs may also require further manual processing afterwards to be robust.
     * In particular some parts may need to be overlapped to avoid collision gaps.
     * Thin parts and sharp points should be avoided or removed where possible.
     *
     * The options parameter object specifies any `Matter.Body` properties you wish to override the defaults.
     * 
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method fromVertices
     * @param {number} x
     * @param {number} y
     * @param {array} vertexSets One or more arrays of vertex points e.g. `[[{ x: 0, y: 0 }...], ...]`.
     * @param {object} [options] The body options.
     * @param {bool} [flagInternal=false] Optionally marks internal edges with `isInternal`.
     * @param {number} [removeCollinear=0.01] Threshold when simplifying vertices along the same edge.
     * @param {number} [minimumArea=10] Threshold when removing small parts.
     * @param {number} [removeDuplicatePoints=0.01] Threshold when simplifying nearby vertices.
     * @return {body}
     */ Bodies.fromVertices = function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea, removeDuplicatePoints) {
                    var decomp = Common.getDecomp(), canDecomp, body, parts, isConvex, isConcave, vertices, i, j, k, v, z;
                    // check decomp is as expected
                    canDecomp = Boolean(decomp && decomp.quickDecomp);
                    options = options || {};
                    parts = [];
                    flagInternal = typeof flagInternal !== "undefined" ? flagInternal : false;
                    removeCollinear = typeof removeCollinear !== "undefined" ? removeCollinear : 0.01;
                    minimumArea = typeof minimumArea !== "undefined" ? minimumArea : 10;
                    removeDuplicatePoints = typeof removeDuplicatePoints !== "undefined" ? removeDuplicatePoints : 0.01;
                    // ensure vertexSets is an array of arrays
                    if (!Common.isArray(vertexSets[0])) vertexSets = [
                        vertexSets
                    ];
                    for(v = 0; v < vertexSets.length; v += 1){
                        vertices = vertexSets[v];
                        isConvex = Vertices.isConvex(vertices);
                        isConcave = !isConvex;
                        if (isConcave && !canDecomp) Common.warnOnce("Bodies.fromVertices: Install the 'poly-decomp' library and use Common.setDecomp or provide 'decomp' as a global to decompose concave vertices.");
                        if (isConvex || !canDecomp) {
                            if (isConvex) vertices = Vertices.clockwiseSort(vertices);
                            else // fallback to convex hull when decomposition is not possible
                            vertices = Vertices.hull(vertices);
                            parts.push({
                                position: {
                                    x: x,
                                    y: y
                                },
                                vertices: vertices
                            });
                        } else {
                            // initialise a decomposition
                            var concave = vertices.map(function(vertex) {
                                return [
                                    vertex.x,
                                    vertex.y
                                ];
                            });
                            // vertices are concave and simple, we can decompose into parts
                            decomp.makeCCW(concave);
                            if (removeCollinear !== false) decomp.removeCollinearPoints(concave, removeCollinear);
                            if (removeDuplicatePoints !== false && decomp.removeDuplicatePoints) decomp.removeDuplicatePoints(concave, removeDuplicatePoints);
                            // use the quick decomposition algorithm (Bayazit)
                            var decomposed = decomp.quickDecomp(concave);
                            // for each decomposed chunk
                            for(i = 0; i < decomposed.length; i++){
                                var chunk = decomposed[i];
                                // convert vertices into the correct structure
                                var chunkVertices = chunk.map(function(vertices) {
                                    return {
                                        x: vertices[0],
                                        y: vertices[1]
                                    };
                                });
                                // skip small chunks
                                if (minimumArea > 0 && Vertices.area(chunkVertices) < minimumArea) continue;
                                // create a compound part
                                parts.push({
                                    position: Vertices.centre(chunkVertices),
                                    vertices: chunkVertices
                                });
                            }
                        }
                    }
                    // create body parts
                    for(i = 0; i < parts.length; i++)parts[i] = Body.create(Common.extend(parts[i], options));
                    // flag internal edges (coincident part edges)
                    if (flagInternal) {
                        var coincident_max_dist = 5;
                        for(i = 0; i < parts.length; i++){
                            var partA = parts[i];
                            for(j = i + 1; j < parts.length; j++){
                                var partB = parts[j];
                                if (Bounds.overlaps(partA.bounds, partB.bounds)) {
                                    var pav = partA.vertices, pbv = partB.vertices;
                                    // iterate vertices of both parts
                                    for(k = 0; k < partA.vertices.length; k++)for(z = 0; z < partB.vertices.length; z++){
                                        // find distances between the vertices
                                        var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z])), db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
                                        // if both vertices are very close, consider the edge concident (internal)
                                        if (da < coincident_max_dist && db < coincident_max_dist) {
                                            pav[k].isInternal = true;
                                            pbv[z].isInternal = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (parts.length > 1) {
                        // create the parent body to be returned, that contains generated compound parts
                        body = Body.create(Common.extend({
                            parts: parts.slice(0)
                        }, options));
                        // offset such that body.position is at the centre off mass
                        Body.setPosition(body, {
                            x: x,
                            y: y
                        });
                        return body;
                    } else return parts[0];
                };
            })();
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Mouse` module contains methods for creating and manipulating mouse inputs.
*
* @class Mouse
*/ var Mouse = {};
            module1.exports = Mouse;
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a mouse input.
     * @method create
     * @param {HTMLElement} element
     * @return {mouse} A new mouse
     */ Mouse.create = function(element) {
                    var mouse = {};
                    if (!element) Common.log("Mouse.create: element was undefined, defaulting to document.body", "warn");
                    mouse.element = element || document.body;
                    mouse.absolute = {
                        x: 0,
                        y: 0
                    };
                    mouse.position = {
                        x: 0,
                        y: 0
                    };
                    mouse.mousedownPosition = {
                        x: 0,
                        y: 0
                    };
                    mouse.mouseupPosition = {
                        x: 0,
                        y: 0
                    };
                    mouse.offset = {
                        x: 0,
                        y: 0
                    };
                    mouse.scale = {
                        x: 1,
                        y: 1
                    };
                    mouse.wheelDelta = 0;
                    mouse.button = -1;
                    mouse.pixelRatio = parseInt(mouse.element.getAttribute("data-pixel-ratio"), 10) || 1;
                    mouse.sourceEvents = {
                        mousemove: null,
                        mousedown: null,
                        mouseup: null,
                        mousewheel: null
                    };
                    mouse.mousemove = function(event) {
                        var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio), touches = event.changedTouches;
                        if (touches) {
                            mouse.button = 0;
                            event.preventDefault();
                        }
                        mouse.absolute.x = position.x;
                        mouse.absolute.y = position.y;
                        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                        mouse.sourceEvents.mousemove = event;
                    };
                    mouse.mousedown = function(event) {
                        var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio), touches = event.changedTouches;
                        if (touches) {
                            mouse.button = 0;
                            event.preventDefault();
                        } else mouse.button = event.button;
                        mouse.absolute.x = position.x;
                        mouse.absolute.y = position.y;
                        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                        mouse.mousedownPosition.x = mouse.position.x;
                        mouse.mousedownPosition.y = mouse.position.y;
                        mouse.sourceEvents.mousedown = event;
                    };
                    mouse.mouseup = function(event) {
                        var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio), touches = event.changedTouches;
                        if (touches) event.preventDefault();
                        mouse.button = -1;
                        mouse.absolute.x = position.x;
                        mouse.absolute.y = position.y;
                        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                        mouse.mouseupPosition.x = mouse.position.x;
                        mouse.mouseupPosition.y = mouse.position.y;
                        mouse.sourceEvents.mouseup = event;
                    };
                    mouse.mousewheel = function(event) {
                        mouse.wheelDelta = Math.max(-1, Math.min(1, event.wheelDelta || -event.detail));
                        event.preventDefault();
                    };
                    Mouse.setElement(mouse, mouse.element);
                    return mouse;
                };
                /**
     * Sets the element the mouse is bound to (and relative to).
     * @method setElement
     * @param {mouse} mouse
     * @param {HTMLElement} element
     */ Mouse.setElement = function(mouse, element) {
                    mouse.element = element;
                    element.addEventListener("mousemove", mouse.mousemove);
                    element.addEventListener("mousedown", mouse.mousedown);
                    element.addEventListener("mouseup", mouse.mouseup);
                    element.addEventListener("mousewheel", mouse.mousewheel);
                    element.addEventListener("DOMMouseScroll", mouse.mousewheel);
                    element.addEventListener("touchmove", mouse.mousemove);
                    element.addEventListener("touchstart", mouse.mousedown);
                    element.addEventListener("touchend", mouse.mouseup);
                };
                /**
     * Clears all captured source events.
     * @method clearSourceEvents
     * @param {mouse} mouse
     */ Mouse.clearSourceEvents = function(mouse) {
                    mouse.sourceEvents.mousemove = null;
                    mouse.sourceEvents.mousedown = null;
                    mouse.sourceEvents.mouseup = null;
                    mouse.sourceEvents.mousewheel = null;
                    mouse.wheelDelta = 0;
                };
                /**
     * Sets the mouse position offset.
     * @method setOffset
     * @param {mouse} mouse
     * @param {vector} offset
     */ Mouse.setOffset = function(mouse, offset) {
                    mouse.offset.x = offset.x;
                    mouse.offset.y = offset.y;
                    mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                    mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                };
                /**
     * Sets the mouse position scale.
     * @method setScale
     * @param {mouse} mouse
     * @param {vector} scale
     */ Mouse.setScale = function(mouse, scale) {
                    mouse.scale.x = scale.x;
                    mouse.scale.y = scale.y;
                    mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                    mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                };
                /**
     * Gets the mouse position relative to an element given a screen pixel ratio.
     * @method _getRelativeMousePosition
     * @private
     * @param {} event
     * @param {} element
     * @param {number} pixelRatio
     * @return {}
     */ Mouse._getRelativeMousePosition = function(event, element, pixelRatio) {
                    var elementBounds = element.getBoundingClientRect(), rootNode = document.documentElement || document.body.parentNode || document.body, scrollX = window.pageXOffset !== undefined ? window.pageXOffset : rootNode.scrollLeft, scrollY = window.pageYOffset !== undefined ? window.pageYOffset : rootNode.scrollTop, touches = event.changedTouches, x, y;
                    if (touches) {
                        x = touches[0].pageX - elementBounds.left - scrollX;
                        y = touches[0].pageY - elementBounds.top - scrollY;
                    } else {
                        x = event.pageX - elementBounds.left - scrollX;
                        y = event.pageY - elementBounds.top - scrollY;
                    }
                    return {
                        x: x / (element.clientWidth / (element.width || element.clientWidth) * pixelRatio),
                        y: y / (element.clientHeight / (element.height || element.clientHeight) * pixelRatio)
                    };
                };
            })();
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Detector` module contains methods for efficiently detecting collisions between a list of bodies using a broadphase algorithm.
*
* @class Detector
*/ var Detector = {};
            module1.exports = Detector;
            var Common = __webpack_require__(0);
            var Collision = __webpack_require__(8);
            (function() {
                /**
     * Creates a new collision detector.
     * @method create
     * @param {} options
     * @return {detector} A new collision detector
     */ Detector.create = function(options) {
                    var defaults = {
                        bodies: [],
                        pairs: null
                    };
                    return Common.extend(defaults, options);
                };
                /**
     * Sets the list of bodies in the detector.
     * @method setBodies
     * @param {detector} detector
     * @param {body[]} bodies
     */ Detector.setBodies = function(detector, bodies) {
                    detector.bodies = bodies.slice(0);
                };
                /**
     * Clears the detector including its list of bodies.
     * @method clear
     * @param {detector} detector
     */ Detector.clear = function(detector) {
                    detector.bodies = [];
                };
                /**
     * Efficiently finds all collisions among all the bodies in `detector.bodies` using a broadphase algorithm.
     * 
     * _Note:_ The specific ordering of collisions returned is not guaranteed between releases and may change for performance reasons.
     * If a specific ordering is required then apply a sort to the resulting array.
     * @method collisions
     * @param {detector} detector
     * @return {collision[]} collisions
     */ Detector.collisions = function(detector) {
                    var collisions = [], pairs = detector.pairs, bodies = detector.bodies, bodiesLength = bodies.length, canCollide = Detector.canCollide, collides = Collision.collides, i, j;
                    bodies.sort(Detector._compareBoundsX);
                    for(i = 0; i < bodiesLength; i++){
                        var bodyA = bodies[i], boundsA = bodyA.bounds, boundXMax = bodyA.bounds.max.x, boundYMax = bodyA.bounds.max.y, boundYMin = bodyA.bounds.min.y, bodyAStatic = bodyA.isStatic || bodyA.isSleeping, partsALength = bodyA.parts.length, partsASingle = partsALength === 1;
                        for(j = i + 1; j < bodiesLength; j++){
                            var bodyB = bodies[j], boundsB = bodyB.bounds;
                            if (boundsB.min.x > boundXMax) break;
                            if (boundYMax < boundsB.min.y || boundYMin > boundsB.max.y) continue;
                            if (bodyAStatic && (bodyB.isStatic || bodyB.isSleeping)) continue;
                            if (!canCollide(bodyA.collisionFilter, bodyB.collisionFilter)) continue;
                            var partsBLength = bodyB.parts.length;
                            if (partsASingle && partsBLength === 1) {
                                var collision = collides(bodyA, bodyB, pairs);
                                if (collision) collisions.push(collision);
                            } else {
                                var partsAStart = partsALength > 1 ? 1 : 0, partsBStart = partsBLength > 1 ? 1 : 0;
                                for(var k = partsAStart; k < partsALength; k++){
                                    var partA = bodyA.parts[k], boundsA = partA.bounds;
                                    for(var z = partsBStart; z < partsBLength; z++){
                                        var partB = bodyB.parts[z], boundsB = partB.bounds;
                                        if (boundsA.min.x > boundsB.max.x || boundsA.max.x < boundsB.min.x || boundsA.max.y < boundsB.min.y || boundsA.min.y > boundsB.max.y) continue;
                                        var collision = collides(partA, partB, pairs);
                                        if (collision) collisions.push(collision);
                                    }
                                }
                            }
                        }
                    }
                    return collisions;
                };
                /**
     * Returns `true` if both supplied collision filters will allow a collision to occur.
     * See `body.collisionFilter` for more information.
     * @method canCollide
     * @param {} filterA
     * @param {} filterB
     * @return {bool} `true` if collision can occur
     */ Detector.canCollide = function(filterA, filterB) {
                    if (filterA.group === filterB.group && filterA.group !== 0) return filterA.group > 0;
                    return (filterA.mask & filterB.category) !== 0 && (filterB.mask & filterA.category) !== 0;
                };
                /**
     * The comparison function used in the broadphase algorithm.
     * Returns the signed delta of the bodies bounds on the x-axis.
     * @private
     * @method _sortCompare
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {number} The signed delta used for sorting
     */ Detector._compareBoundsX = function(bodyA, bodyB) {
                    return bodyA.bounds.min.x - bodyB.bounds.min.x;
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * The array of `Matter.Body` between which the detector finds collisions.
     * 
     * _Note:_ The order of bodies in this array _is not fixed_ and will be continually managed by the detector.
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * Optional. A `Matter.Pairs` object from which previous collision objects may be reused. Intended for internal `Matter.Engine` usage.
     * @property pairs
     * @type {pairs|null}
     * @default null
     */ })();
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Plugin` module contains functions for registering and installing plugins on modules.
*
* @class Plugin
*/ var Plugin = {};
            module1.exports = Plugin;
            var Common = __webpack_require__(0);
            (function() {
                Plugin._registry = {};
                /**
     * Registers a plugin object so it can be resolved later by name.
     * @method register
     * @param plugin {} The plugin to register.
     * @return {object} The plugin.
     */ Plugin.register = function(plugin) {
                    if (!Plugin.isPlugin(plugin)) Common.warn("Plugin.register:", Plugin.toString(plugin), "does not implement all required fields.");
                    if (plugin.name in Plugin._registry) {
                        var registered = Plugin._registry[plugin.name], pluginVersion = Plugin.versionParse(plugin.version).number, registeredVersion = Plugin.versionParse(registered.version).number;
                        if (pluginVersion > registeredVersion) {
                            Common.warn("Plugin.register:", Plugin.toString(registered), "was upgraded to", Plugin.toString(plugin));
                            Plugin._registry[plugin.name] = plugin;
                        } else if (pluginVersion < registeredVersion) Common.warn("Plugin.register:", Plugin.toString(registered), "can not be downgraded to", Plugin.toString(plugin));
                        else if (plugin !== registered) Common.warn("Plugin.register:", Plugin.toString(plugin), "is already registered to different plugin object");
                    } else Plugin._registry[plugin.name] = plugin;
                    return plugin;
                };
                /**
     * Resolves a dependency to a plugin object from the registry if it exists. 
     * The `dependency` may contain a version, but only the name matters when resolving.
     * @method resolve
     * @param dependency {string} The dependency.
     * @return {object} The plugin if resolved, otherwise `undefined`.
     */ Plugin.resolve = function(dependency) {
                    return Plugin._registry[Plugin.dependencyParse(dependency).name];
                };
                /**
     * Returns a pretty printed plugin name and version.
     * @method toString
     * @param plugin {} The plugin.
     * @return {string} Pretty printed plugin name and version.
     */ Plugin.toString = function(plugin) {
                    return typeof plugin === "string" ? plugin : (plugin.name || "anonymous") + "@" + (plugin.version || plugin.range || "0.0.0");
                };
                /**
     * Returns `true` if the object meets the minimum standard to be considered a plugin.
     * This means it must define the following properties:
     * - `name`
     * - `version`
     * - `install`
     * @method isPlugin
     * @param obj {} The obj to test.
     * @return {boolean} `true` if the object can be considered a plugin otherwise `false`.
     */ Plugin.isPlugin = function(obj) {
                    return obj && obj.name && obj.version && obj.install;
                };
                /**
     * Returns `true` if a plugin with the given `name` been installed on `module`.
     * @method isUsed
     * @param module {} The module.
     * @param name {string} The plugin name.
     * @return {boolean} `true` if a plugin with the given `name` been installed on `module`, otherwise `false`.
     */ Plugin.isUsed = function(module1, name) {
                    return module1.used.indexOf(name) > -1;
                };
                /**
     * Returns `true` if `plugin.for` is applicable to `module` by comparing against `module.name` and `module.version`.
     * If `plugin.for` is not specified then it is assumed to be applicable.
     * The value of `plugin.for` is a string of the format `'module-name'` or `'module-name@version'`.
     * @method isFor
     * @param plugin {} The plugin.
     * @param module {} The module.
     * @return {boolean} `true` if `plugin.for` is applicable to `module`, otherwise `false`.
     */ Plugin.isFor = function(plugin, module1) {
                    var parsed = plugin.for && Plugin.dependencyParse(plugin.for);
                    return !plugin.for || module1.name === parsed.name && Plugin.versionSatisfies(module1.version, parsed.range);
                };
                /**
     * Installs the plugins by calling `plugin.install` on each plugin specified in `plugins` if passed, otherwise `module.uses`.
     * For installing plugins on `Matter` see the convenience function `Matter.use`.
     * Plugins may be specified either by their name or a reference to the plugin object.
     * Plugins themselves may specify further dependencies, but each plugin is installed only once.
     * Order is important, a topological sort is performed to find the best resulting order of installation.
     * This sorting attempts to satisfy every dependency's requested ordering, but may not be exact in all cases.
     * This function logs the resulting status of each dependency in the console, along with any warnings.
     * - A green tick ✅ indicates a dependency was resolved and installed.
     * - An orange diamond 🔶 indicates a dependency was resolved but a warning was thrown for it or one if its dependencies.
     * - A red cross ❌ indicates a dependency could not be resolved.
     * Avoid calling this function multiple times on the same module unless you intend to manually control installation order.
     * @method use
     * @param module {} The module install plugins on.
     * @param [plugins=module.uses] {} The plugins to install on module (optional, defaults to `module.uses`).
     */ Plugin.use = function(module1, plugins) {
                    module1.uses = (module1.uses || []).concat(plugins || []);
                    if (module1.uses.length === 0) {
                        Common.warn("Plugin.use:", Plugin.toString(module1), "does not specify any dependencies to install.");
                        return;
                    }
                    var dependencies = Plugin.dependencies(module1), sortedDependencies = Common.topologicalSort(dependencies), status = [];
                    for(var i = 0; i < sortedDependencies.length; i += 1){
                        if (sortedDependencies[i] === module1.name) continue;
                        var plugin = Plugin.resolve(sortedDependencies[i]);
                        if (!plugin) {
                            status.push("❌ " + sortedDependencies[i]);
                            continue;
                        }
                        if (Plugin.isUsed(module1, plugin.name)) continue;
                        if (!Plugin.isFor(plugin, module1)) {
                            Common.warn("Plugin.use:", Plugin.toString(plugin), "is for", plugin.for, "but installed on", Plugin.toString(module1) + ".");
                            plugin._warned = true;
                        }
                        if (plugin.install) plugin.install(module1);
                        else {
                            Common.warn("Plugin.use:", Plugin.toString(plugin), "does not specify an install function.");
                            plugin._warned = true;
                        }
                        if (plugin._warned) {
                            status.push("\uD83D\uDD36 " + Plugin.toString(plugin));
                            delete plugin._warned;
                        } else status.push("✅ " + Plugin.toString(plugin));
                        module1.used.push(plugin.name);
                    }
                    if (status.length > 0) Common.info(status.join("  "));
                };
                /**
     * Recursively finds all of a module's dependencies and returns a flat dependency graph.
     * @method dependencies
     * @param module {} The module.
     * @return {object} A dependency graph.
     */ Plugin.dependencies = function(module1, tracked) {
                    var parsedBase = Plugin.dependencyParse(module1), name = parsedBase.name;
                    tracked = tracked || {};
                    if (name in tracked) return;
                    module1 = Plugin.resolve(module1) || module1;
                    tracked[name] = Common.map(module1.uses || [], function(dependency) {
                        if (Plugin.isPlugin(dependency)) Plugin.register(dependency);
                        var parsed = Plugin.dependencyParse(dependency), resolved = Plugin.resolve(dependency);
                        if (resolved && !Plugin.versionSatisfies(resolved.version, parsed.range)) {
                            Common.warn("Plugin.dependencies:", Plugin.toString(resolved), "does not satisfy", Plugin.toString(parsed), "used by", Plugin.toString(parsedBase) + ".");
                            resolved._warned = true;
                            module1._warned = true;
                        } else if (!resolved) {
                            Common.warn("Plugin.dependencies:", Plugin.toString(dependency), "used by", Plugin.toString(parsedBase), "could not be resolved.");
                            module1._warned = true;
                        }
                        return parsed.name;
                    });
                    for(var i = 0; i < tracked[name].length; i += 1)Plugin.dependencies(tracked[name][i], tracked);
                    return tracked;
                };
                /**
     * Parses a dependency string into its components.
     * The `dependency` is a string of the format `'module-name'` or `'module-name@version'`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * This function can also handle dependencies that are already resolved (e.g. a module object).
     * @method dependencyParse
     * @param dependency {string} The dependency of the format `'module-name'` or `'module-name@version'`.
     * @return {object} The dependency parsed into its components.
     */ Plugin.dependencyParse = function(dependency) {
                    if (Common.isString(dependency)) {
                        var pattern = /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-+]+)?))?$/;
                        if (!pattern.test(dependency)) Common.warn("Plugin.dependencyParse:", dependency, "is not a valid dependency string.");
                        return {
                            name: dependency.split("@")[0],
                            range: dependency.split("@")[1] || "*"
                        };
                    }
                    return {
                        name: dependency.name,
                        range: dependency.range || dependency.version
                    };
                };
                /**
     * Parses a version string into its components.  
     * Versions are strictly of the format `x.y.z` (as in [semver](http://semver.org/)).
     * Versions may optionally have a prerelease tag in the format `x.y.z-alpha`.
     * Ranges are a strict subset of [npm ranges](https://docs.npmjs.com/misc/semver#advanced-range-syntax).
     * Only the following range types are supported:
     * - Tilde ranges e.g. `~1.2.3`
     * - Caret ranges e.g. `^1.2.3`
     * - Greater than ranges e.g. `>1.2.3`
     * - Greater than or equal ranges e.g. `>=1.2.3`
     * - Exact version e.g. `1.2.3`
     * - Any version `*`
     * @method versionParse
     * @param range {string} The version string.
     * @return {object} The version range parsed into its components.
     */ Plugin.versionParse = function(range) {
                    var pattern = /^(\*)|(\^|~|>=|>)?\s*((\d+)\.(\d+)\.(\d+))(-[0-9A-Za-z-+]+)?$/;
                    if (!pattern.test(range)) Common.warn("Plugin.versionParse:", range, "is not a valid version or range.");
                    var parts = pattern.exec(range);
                    var major = Number(parts[4]);
                    var minor = Number(parts[5]);
                    var patch = Number(parts[6]);
                    return {
                        isRange: Boolean(parts[1] || parts[2]),
                        version: parts[3],
                        range: range,
                        operator: parts[1] || parts[2] || "",
                        major: major,
                        minor: minor,
                        patch: patch,
                        parts: [
                            major,
                            minor,
                            patch
                        ],
                        prerelease: parts[7],
                        number: major * 1e8 + minor * 1e4 + patch
                    };
                };
                /**
     * Returns `true` if `version` satisfies the given `range`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * If a version or range is not specified, then any version (`*`) is assumed to satisfy.
     * @method versionSatisfies
     * @param version {string} The version string.
     * @param range {string} The range string.
     * @return {boolean} `true` if `version` satisfies `range`, otherwise `false`.
     */ Plugin.versionSatisfies = function(version, range) {
                    range = range || "*";
                    var r = Plugin.versionParse(range), v = Plugin.versionParse(version);
                    if (r.isRange) {
                        if (r.operator === "*" || version === "*") return true;
                        if (r.operator === ">") return v.number > r.number;
                        if (r.operator === ">=") return v.number >= r.number;
                        if (r.operator === "~") return v.major === r.major && v.minor === r.minor && v.patch >= r.patch;
                        if (r.operator === "^") {
                            if (r.major > 0) return v.major === r.major && v.number >= r.number;
                            if (r.minor > 0) return v.minor === r.minor && v.patch >= r.patch;
                            return v.patch === r.patch;
                        }
                    }
                    return version === range || version === "*";
                };
            })();
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Render` module is a simple canvas based renderer for visualising instances of `Matter.Engine`.
* It is intended for development and debugging purposes, but may also be suitable for simple games.
* It includes a number of drawing options including wireframe, vector with support for sprites and viewports.
*
* @class Render
*/ var Render = {};
            module1.exports = Render;
            var Common = __webpack_require__(0);
            var Composite = __webpack_require__(5);
            var Bounds = __webpack_require__(1);
            var Events = __webpack_require__(4);
            var Vector = __webpack_require__(2);
            var Mouse = __webpack_require__(13);
            (function() {
                var _requestAnimationFrame, _cancelAnimationFrame;
                if (typeof window !== "undefined") {
                    _requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                        window.setTimeout(function() {
                            callback(Common.now());
                        }, 1000 / 60);
                    };
                    _cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame;
                }
                Render._goodFps = 30;
                Render._goodDelta = 1000 / 60;
                /**
     * Creates a new renderer. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {object} [options]
     * @return {render} A new renderer
     */ Render.create = function(options) {
                    var defaults = {
                        controller: Render,
                        engine: null,
                        element: null,
                        canvas: null,
                        mouse: null,
                        frameRequestId: null,
                        timing: {
                            historySize: 60,
                            delta: 0,
                            deltaHistory: [],
                            lastTime: 0,
                            lastTimestamp: 0,
                            lastElapsed: 0,
                            timestampElapsed: 0,
                            timestampElapsedHistory: [],
                            engineDeltaHistory: [],
                            engineElapsedHistory: [],
                            elapsedHistory: []
                        },
                        options: {
                            width: 800,
                            height: 600,
                            pixelRatio: 1,
                            background: "#14151f",
                            wireframeBackground: "#14151f",
                            hasBounds: !!options.bounds,
                            enabled: true,
                            wireframes: true,
                            showSleeping: true,
                            showDebug: false,
                            showStats: false,
                            showPerformance: false,
                            showBounds: false,
                            showVelocity: false,
                            showCollisions: false,
                            showSeparations: false,
                            showAxes: false,
                            showPositions: false,
                            showAngleIndicator: false,
                            showIds: false,
                            showVertexNumbers: false,
                            showConvexHulls: false,
                            showInternalEdges: false,
                            showMousePosition: false
                        }
                    };
                    var render = Common.extend(defaults, options);
                    if (render.canvas) {
                        render.canvas.width = render.options.width || render.canvas.width;
                        render.canvas.height = render.options.height || render.canvas.height;
                    }
                    render.mouse = options.mouse;
                    render.engine = options.engine;
                    render.canvas = render.canvas || _createCanvas(render.options.width, render.options.height);
                    render.context = render.canvas.getContext("2d");
                    render.textures = {};
                    render.bounds = render.bounds || {
                        min: {
                            x: 0,
                            y: 0
                        },
                        max: {
                            x: render.canvas.width,
                            y: render.canvas.height
                        }
                    };
                    // for temporary back compatibility only
                    render.options.showBroadphase = false;
                    if (render.options.pixelRatio !== 1) Render.setPixelRatio(render, render.options.pixelRatio);
                    if (Common.isElement(render.element)) render.element.appendChild(render.canvas);
                    else if (!render.canvas.parentNode) Common.log("Render.create: options.element was undefined, render.canvas was created but not appended", "warn");
                    return render;
                };
                /**
     * Continuously updates the render canvas on the `requestAnimationFrame` event.
     * @method run
     * @param {render} render
     */ Render.run = function(render) {
                    (function loop(time) {
                        render.frameRequestId = _requestAnimationFrame(loop);
                        _updateTiming(render, time);
                        Render.world(render, time);
                        if (render.options.showStats || render.options.showDebug) Render.stats(render, render.context, time);
                        if (render.options.showPerformance || render.options.showDebug) Render.performance(render, render.context, time);
                    })();
                };
                /**
     * Ends execution of `Render.run` on the given `render`, by canceling the animation frame request event loop.
     * @method stop
     * @param {render} render
     */ Render.stop = function(render) {
                    _cancelAnimationFrame(render.frameRequestId);
                };
                /**
     * Sets the pixel ratio of the renderer and updates the canvas.
     * To automatically detect the correct ratio, pass the string `'auto'` for `pixelRatio`.
     * @method setPixelRatio
     * @param {render} render
     * @param {number} pixelRatio
     */ Render.setPixelRatio = function(render, pixelRatio) {
                    var options = render.options, canvas = render.canvas;
                    if (pixelRatio === "auto") pixelRatio = _getPixelRatio(canvas);
                    options.pixelRatio = pixelRatio;
                    canvas.setAttribute("data-pixel-ratio", pixelRatio);
                    canvas.width = options.width * pixelRatio;
                    canvas.height = options.height * pixelRatio;
                    canvas.style.width = options.width + "px";
                    canvas.style.height = options.height + "px";
                };
                /**
     * Positions and sizes the viewport around the given object bounds.
     * Objects must have at least one of the following properties:
     * - `object.bounds`
     * - `object.position`
     * - `object.min` and `object.max`
     * - `object.x` and `object.y`
     * @method lookAt
     * @param {render} render
     * @param {object[]} objects
     * @param {vector} [padding]
     * @param {bool} [center=true]
     */ Render.lookAt = function(render, objects, padding, center) {
                    center = typeof center !== "undefined" ? center : true;
                    objects = Common.isArray(objects) ? objects : [
                        objects
                    ];
                    padding = padding || {
                        x: 0,
                        y: 0
                    };
                    // find bounds of all objects
                    var bounds = {
                        min: {
                            x: Infinity,
                            y: Infinity
                        },
                        max: {
                            x: -Infinity,
                            y: -Infinity
                        }
                    };
                    for(var i = 0; i < objects.length; i += 1){
                        var object = objects[i], min = object.bounds ? object.bounds.min : object.min || object.position || object, max = object.bounds ? object.bounds.max : object.max || object.position || object;
                        if (min && max) {
                            if (min.x < bounds.min.x) bounds.min.x = min.x;
                            if (max.x > bounds.max.x) bounds.max.x = max.x;
                            if (min.y < bounds.min.y) bounds.min.y = min.y;
                            if (max.y > bounds.max.y) bounds.max.y = max.y;
                        }
                    }
                    // find ratios
                    var width = bounds.max.x - bounds.min.x + 2 * padding.x, height = bounds.max.y - bounds.min.y + 2 * padding.y, viewHeight = render.canvas.height, viewWidth = render.canvas.width, outerRatio = viewWidth / viewHeight, innerRatio = width / height, scaleX = 1, scaleY = 1;
                    // find scale factor
                    if (innerRatio > outerRatio) scaleY = innerRatio / outerRatio;
                    else scaleX = outerRatio / innerRatio;
                    // enable bounds
                    render.options.hasBounds = true;
                    // position and size
                    render.bounds.min.x = bounds.min.x;
                    render.bounds.max.x = bounds.min.x + width * scaleX;
                    render.bounds.min.y = bounds.min.y;
                    render.bounds.max.y = bounds.min.y + height * scaleY;
                    // center
                    if (center) {
                        render.bounds.min.x += width * 0.5 - width * scaleX * 0.5;
                        render.bounds.max.x += width * 0.5 - width * scaleX * 0.5;
                        render.bounds.min.y += height * 0.5 - height * scaleY * 0.5;
                        render.bounds.max.y += height * 0.5 - height * scaleY * 0.5;
                    }
                    // padding
                    render.bounds.min.x -= padding.x;
                    render.bounds.max.x -= padding.x;
                    render.bounds.min.y -= padding.y;
                    render.bounds.max.y -= padding.y;
                    // update mouse
                    if (render.mouse) {
                        Mouse.setScale(render.mouse, {
                            x: (render.bounds.max.x - render.bounds.min.x) / render.canvas.width,
                            y: (render.bounds.max.y - render.bounds.min.y) / render.canvas.height
                        });
                        Mouse.setOffset(render.mouse, render.bounds.min);
                    }
                };
                /**
     * Applies viewport transforms based on `render.bounds` to a render context.
     * @method startViewTransform
     * @param {render} render
     */ Render.startViewTransform = function(render) {
                    var boundsWidth = render.bounds.max.x - render.bounds.min.x, boundsHeight = render.bounds.max.y - render.bounds.min.y, boundsScaleX = boundsWidth / render.options.width, boundsScaleY = boundsHeight / render.options.height;
                    render.context.setTransform(render.options.pixelRatio / boundsScaleX, 0, 0, render.options.pixelRatio / boundsScaleY, 0, 0);
                    render.context.translate(-render.bounds.min.x, -render.bounds.min.y);
                };
                /**
     * Resets all transforms on the render context.
     * @method endViewTransform
     * @param {render} render
     */ Render.endViewTransform = function(render) {
                    render.context.setTransform(render.options.pixelRatio, 0, 0, render.options.pixelRatio, 0, 0);
                };
                /**
     * Renders the given `engine`'s `Matter.World` object.
     * This is the entry point for all rendering and should be called every time the scene changes.
     * @method world
     * @param {render} render
     */ Render.world = function(render, time) {
                    var startTime = Common.now(), engine = render.engine, world = engine.world, canvas = render.canvas, context = render.context, options = render.options, timing = render.timing;
                    var allBodies = Composite.allBodies(world), allConstraints = Composite.allConstraints(world), background = options.wireframes ? options.wireframeBackground : options.background, bodies = [], constraints = [], i;
                    var event = {
                        timestamp: engine.timing.timestamp
                    };
                    Events.trigger(render, "beforeRender", event);
                    // apply background if it has changed
                    if (render.currentBackground !== background) _applyBackground(render, background);
                    // clear the canvas with a transparent fill, to allow the canvas background to show
                    context.globalCompositeOperation = "source-in";
                    context.fillStyle = "transparent";
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    context.globalCompositeOperation = "source-over";
                    // handle bounds
                    if (options.hasBounds) {
                        // filter out bodies that are not in view
                        for(i = 0; i < allBodies.length; i++){
                            var body = allBodies[i];
                            if (Bounds.overlaps(body.bounds, render.bounds)) bodies.push(body);
                        }
                        // filter out constraints that are not in view
                        for(i = 0; i < allConstraints.length; i++){
                            var constraint = allConstraints[i], bodyA = constraint.bodyA, bodyB = constraint.bodyB, pointAWorld = constraint.pointA, pointBWorld = constraint.pointB;
                            if (bodyA) pointAWorld = Vector.add(bodyA.position, constraint.pointA);
                            if (bodyB) pointBWorld = Vector.add(bodyB.position, constraint.pointB);
                            if (!pointAWorld || !pointBWorld) continue;
                            if (Bounds.contains(render.bounds, pointAWorld) || Bounds.contains(render.bounds, pointBWorld)) constraints.push(constraint);
                        }
                        // transform the view
                        Render.startViewTransform(render);
                        // update mouse
                        if (render.mouse) {
                            Mouse.setScale(render.mouse, {
                                x: (render.bounds.max.x - render.bounds.min.x) / render.options.width,
                                y: (render.bounds.max.y - render.bounds.min.y) / render.options.height
                            });
                            Mouse.setOffset(render.mouse, render.bounds.min);
                        }
                    } else {
                        constraints = allConstraints;
                        bodies = allBodies;
                        if (render.options.pixelRatio !== 1) render.context.setTransform(render.options.pixelRatio, 0, 0, render.options.pixelRatio, 0, 0);
                    }
                    if (!options.wireframes || engine.enableSleeping && options.showSleeping) // fully featured rendering of bodies
                    Render.bodies(render, bodies, context);
                    else {
                        if (options.showConvexHulls) Render.bodyConvexHulls(render, bodies, context);
                        // optimised method for wireframes only
                        Render.bodyWireframes(render, bodies, context);
                    }
                    if (options.showBounds) Render.bodyBounds(render, bodies, context);
                    if (options.showAxes || options.showAngleIndicator) Render.bodyAxes(render, bodies, context);
                    if (options.showPositions) Render.bodyPositions(render, bodies, context);
                    if (options.showVelocity) Render.bodyVelocity(render, bodies, context);
                    if (options.showIds) Render.bodyIds(render, bodies, context);
                    if (options.showSeparations) Render.separations(render, engine.pairs.list, context);
                    if (options.showCollisions) Render.collisions(render, engine.pairs.list, context);
                    if (options.showVertexNumbers) Render.vertexNumbers(render, bodies, context);
                    if (options.showMousePosition) Render.mousePosition(render, render.mouse, context);
                    Render.constraints(constraints, context);
                    if (options.hasBounds) // revert view transforms
                    Render.endViewTransform(render);
                    Events.trigger(render, "afterRender", event);
                    // log the time elapsed computing this update
                    timing.lastElapsed = Common.now() - startTime;
                };
                /**
     * Renders statistics about the engine and world useful for debugging.
     * @private
     * @method stats
     * @param {render} render
     * @param {RenderingContext} context
     * @param {Number} time
     */ Render.stats = function(render, context, time) {
                    var engine = render.engine, world = engine.world, bodies = Composite.allBodies(world), parts = 0, width = 55, height = 44, x = 0, y = 0;
                    // count parts
                    for(var i = 0; i < bodies.length; i += 1)parts += bodies[i].parts.length;
                    // sections
                    var sections = {
                        "Part": parts,
                        "Body": bodies.length,
                        "Cons": Composite.allConstraints(world).length,
                        "Comp": Composite.allComposites(world).length,
                        "Pair": engine.pairs.list.length
                    };
                    // background
                    context.fillStyle = "#0e0f19";
                    context.fillRect(x, y, width * 5.5, height);
                    context.font = "12px Arial";
                    context.textBaseline = "top";
                    context.textAlign = "right";
                    // sections
                    for(var key in sections){
                        var section = sections[key];
                        // label
                        context.fillStyle = "#aaa";
                        context.fillText(key, x + width, y + 8);
                        // value
                        context.fillStyle = "#eee";
                        context.fillText(section, x + width, y + 26);
                        x += width;
                    }
                };
                /**
     * Renders engine and render performance information.
     * @private
     * @method performance
     * @param {render} render
     * @param {RenderingContext} context
     */ Render.performance = function(render, context) {
                    var engine = render.engine, timing = render.timing, deltaHistory = timing.deltaHistory, elapsedHistory = timing.elapsedHistory, timestampElapsedHistory = timing.timestampElapsedHistory, engineDeltaHistory = timing.engineDeltaHistory, engineElapsedHistory = timing.engineElapsedHistory, lastEngineDelta = engine.timing.lastDelta;
                    var deltaMean = _mean(deltaHistory), elapsedMean = _mean(elapsedHistory), engineDeltaMean = _mean(engineDeltaHistory), engineElapsedMean = _mean(engineElapsedHistory), timestampElapsedMean = _mean(timestampElapsedHistory), rateMean = timestampElapsedMean / deltaMean || 0, fps = 1000 / deltaMean || 0;
                    var graphHeight = 4, gap = 12, width = 60, height = 34, x = 10, y = 69;
                    // background
                    context.fillStyle = "#0e0f19";
                    context.fillRect(0, 50, gap * 4 + width * 5 + 22, height);
                    // show FPS
                    Render.status(context, x, y, width, graphHeight, deltaHistory.length, Math.round(fps) + " fps", fps / Render._goodFps, function(i) {
                        return deltaHistory[i] / deltaMean - 1;
                    });
                    // show engine delta
                    Render.status(context, x + gap + width, y, width, graphHeight, engineDeltaHistory.length, lastEngineDelta.toFixed(2) + " dt", Render._goodDelta / lastEngineDelta, function(i) {
                        return engineDeltaHistory[i] / engineDeltaMean - 1;
                    });
                    // show engine update time
                    Render.status(context, x + (gap + width) * 2, y, width, graphHeight, engineElapsedHistory.length, engineElapsedMean.toFixed(2) + " ut", 1 - engineElapsedMean / Render._goodFps, function(i) {
                        return engineElapsedHistory[i] / engineElapsedMean - 1;
                    });
                    // show render time
                    Render.status(context, x + (gap + width) * 3, y, width, graphHeight, elapsedHistory.length, elapsedMean.toFixed(2) + " rt", 1 - elapsedMean / Render._goodFps, function(i) {
                        return elapsedHistory[i] / elapsedMean - 1;
                    });
                    // show effective speed
                    Render.status(context, x + (gap + width) * 4, y, width, graphHeight, timestampElapsedHistory.length, rateMean.toFixed(2) + " x", rateMean * rateMean * rateMean, function(i) {
                        return (timestampElapsedHistory[i] / deltaHistory[i] / rateMean || 0) - 1;
                    });
                };
                /**
     * Renders a label, indicator and a chart.
     * @private
     * @method status
     * @param {RenderingContext} context
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {number} count
     * @param {string} label
     * @param {string} indicator
     * @param {function} plotY
     */ Render.status = function(context, x, y, width, height, count, label, indicator, plotY) {
                    // background
                    context.strokeStyle = "#888";
                    context.fillStyle = "#444";
                    context.lineWidth = 1;
                    context.fillRect(x, y + 7, width, 1);
                    // chart
                    context.beginPath();
                    context.moveTo(x, y + 7 - height * Common.clamp(0.4 * plotY(0), -2, 2));
                    for(var i = 0; i < width; i += 1)context.lineTo(x + i, y + 7 - (i < count ? height * Common.clamp(0.4 * plotY(i), -2, 2) : 0));
                    context.stroke();
                    // indicator
                    context.fillStyle = "hsl(" + Common.clamp(25 + 95 * indicator, 0, 120) + ",100%,60%)";
                    context.fillRect(x, y - 7, 4, 4);
                    // label
                    context.font = "12px Arial";
                    context.textBaseline = "middle";
                    context.textAlign = "right";
                    context.fillStyle = "#eee";
                    context.fillText(label, x + width, y - 5);
                };
                /**
     * Description
     * @private
     * @method constraints
     * @param {constraint[]} constraints
     * @param {RenderingContext} context
     */ Render.constraints = function(constraints, context) {
                    var c = context;
                    for(var i = 0; i < constraints.length; i++){
                        var constraint = constraints[i];
                        if (!constraint.render.visible || !constraint.pointA || !constraint.pointB) continue;
                        var bodyA = constraint.bodyA, bodyB = constraint.bodyB, start, end;
                        if (bodyA) start = Vector.add(bodyA.position, constraint.pointA);
                        else start = constraint.pointA;
                        if (constraint.render.type === "pin") {
                            c.beginPath();
                            c.arc(start.x, start.y, 3, 0, 2 * Math.PI);
                            c.closePath();
                        } else {
                            if (bodyB) end = Vector.add(bodyB.position, constraint.pointB);
                            else end = constraint.pointB;
                            c.beginPath();
                            c.moveTo(start.x, start.y);
                            if (constraint.render.type === "spring") {
                                var delta = Vector.sub(end, start), normal = Vector.perp(Vector.normalise(delta)), coils = Math.ceil(Common.clamp(constraint.length / 5, 12, 20)), offset;
                                for(var j = 1; j < coils; j += 1){
                                    offset = j % 2 === 0 ? 1 : -1;
                                    c.lineTo(start.x + delta.x * (j / coils) + normal.x * offset * 4, start.y + delta.y * (j / coils) + normal.y * offset * 4);
                                }
                            }
                            c.lineTo(end.x, end.y);
                        }
                        if (constraint.render.lineWidth) {
                            c.lineWidth = constraint.render.lineWidth;
                            c.strokeStyle = constraint.render.strokeStyle;
                            c.stroke();
                        }
                        if (constraint.render.anchors) {
                            c.fillStyle = constraint.render.strokeStyle;
                            c.beginPath();
                            c.arc(start.x, start.y, 3, 0, 2 * Math.PI);
                            c.arc(end.x, end.y, 3, 0, 2 * Math.PI);
                            c.closePath();
                            c.fill();
                        }
                    }
                };
                /**
     * Description
     * @private
     * @method bodies
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodies = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options, showInternalEdges = options.showInternalEdges || !options.wireframes, body, part, i, k;
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible) continue;
                        // handle compound parts
                        for(k = body.parts.length > 1 ? 1 : 0; k < body.parts.length; k++){
                            part = body.parts[k];
                            if (!part.render.visible) continue;
                            if (options.showSleeping && body.isSleeping) c.globalAlpha = 0.5 * part.render.opacity;
                            else if (part.render.opacity !== 1) c.globalAlpha = part.render.opacity;
                            if (part.render.sprite && part.render.sprite.texture && !options.wireframes) {
                                // part sprite
                                var sprite = part.render.sprite, texture = _getTexture(render, sprite.texture);
                                c.translate(part.position.x, part.position.y);
                                c.rotate(part.angle);
                                c.drawImage(texture, texture.width * -sprite.xOffset * sprite.xScale, texture.height * -sprite.yOffset * sprite.yScale, texture.width * sprite.xScale, texture.height * sprite.yScale);
                                // revert translation, hopefully faster than save / restore
                                c.rotate(-part.angle);
                                c.translate(-part.position.x, -part.position.y);
                            } else {
                                // part polygon
                                if (part.circleRadius) {
                                    c.beginPath();
                                    c.arc(part.position.x, part.position.y, part.circleRadius, 0, 2 * Math.PI);
                                } else {
                                    c.beginPath();
                                    c.moveTo(part.vertices[0].x, part.vertices[0].y);
                                    for(var j = 1; j < part.vertices.length; j++){
                                        if (!part.vertices[j - 1].isInternal || showInternalEdges) c.lineTo(part.vertices[j].x, part.vertices[j].y);
                                        else c.moveTo(part.vertices[j].x, part.vertices[j].y);
                                        if (part.vertices[j].isInternal && !showInternalEdges) c.moveTo(part.vertices[(j + 1) % part.vertices.length].x, part.vertices[(j + 1) % part.vertices.length].y);
                                    }
                                    c.lineTo(part.vertices[0].x, part.vertices[0].y);
                                    c.closePath();
                                }
                                if (!options.wireframes) {
                                    c.fillStyle = part.render.fillStyle;
                                    if (part.render.lineWidth) {
                                        c.lineWidth = part.render.lineWidth;
                                        c.strokeStyle = part.render.strokeStyle;
                                        c.stroke();
                                    }
                                    c.fill();
                                } else {
                                    c.lineWidth = 1;
                                    c.strokeStyle = "#bbb";
                                    c.stroke();
                                }
                            }
                            c.globalAlpha = 1;
                        }
                    }
                };
                /**
     * Optimised method for drawing body wireframes in one pass
     * @private
     * @method bodyWireframes
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyWireframes = function(render, bodies, context) {
                    var c = context, showInternalEdges = render.options.showInternalEdges, body, part, i, j, k;
                    c.beginPath();
                    // render all bodies
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible) continue;
                        // handle compound parts
                        for(k = body.parts.length > 1 ? 1 : 0; k < body.parts.length; k++){
                            part = body.parts[k];
                            c.moveTo(part.vertices[0].x, part.vertices[0].y);
                            for(j = 1; j < part.vertices.length; j++){
                                if (!part.vertices[j - 1].isInternal || showInternalEdges) c.lineTo(part.vertices[j].x, part.vertices[j].y);
                                else c.moveTo(part.vertices[j].x, part.vertices[j].y);
                                if (part.vertices[j].isInternal && !showInternalEdges) c.moveTo(part.vertices[(j + 1) % part.vertices.length].x, part.vertices[(j + 1) % part.vertices.length].y);
                            }
                            c.lineTo(part.vertices[0].x, part.vertices[0].y);
                        }
                    }
                    c.lineWidth = 1;
                    c.strokeStyle = "#bbb";
                    c.stroke();
                };
                /**
     * Optimised method for drawing body convex hull wireframes in one pass
     * @private
     * @method bodyConvexHulls
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyConvexHulls = function(render, bodies, context) {
                    var c = context, body, part, i, j, k;
                    c.beginPath();
                    // render convex hulls
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible || body.parts.length === 1) continue;
                        c.moveTo(body.vertices[0].x, body.vertices[0].y);
                        for(j = 1; j < body.vertices.length; j++)c.lineTo(body.vertices[j].x, body.vertices[j].y);
                        c.lineTo(body.vertices[0].x, body.vertices[0].y);
                    }
                    c.lineWidth = 1;
                    c.strokeStyle = "rgba(255,255,255,0.2)";
                    c.stroke();
                };
                /**
     * Renders body vertex numbers.
     * @private
     * @method vertexNumbers
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.vertexNumbers = function(render, bodies, context) {
                    var c = context, i, j, k;
                    for(i = 0; i < bodies.length; i++){
                        var parts = bodies[i].parts;
                        for(k = parts.length > 1 ? 1 : 0; k < parts.length; k++){
                            var part = parts[k];
                            for(j = 0; j < part.vertices.length; j++){
                                c.fillStyle = "rgba(255,255,255,0.2)";
                                c.fillText(i + "_" + j, part.position.x + (part.vertices[j].x - part.position.x) * 0.8, part.position.y + (part.vertices[j].y - part.position.y) * 0.8);
                            }
                        }
                    }
                };
                /**
     * Renders mouse position.
     * @private
     * @method mousePosition
     * @param {render} render
     * @param {mouse} mouse
     * @param {RenderingContext} context
     */ Render.mousePosition = function(render, mouse, context) {
                    var c = context;
                    c.fillStyle = "rgba(255,255,255,0.8)";
                    c.fillText(mouse.position.x + "  " + mouse.position.y, mouse.position.x + 5, mouse.position.y - 5);
                };
                /**
     * Draws body bounds
     * @private
     * @method bodyBounds
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyBounds = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options;
                    c.beginPath();
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.render.visible) {
                            var parts = bodies[i].parts;
                            for(var j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                                var part = parts[j];
                                c.rect(part.bounds.min.x, part.bounds.min.y, part.bounds.max.x - part.bounds.min.x, part.bounds.max.y - part.bounds.min.y);
                            }
                        }
                    }
                    if (options.wireframes) c.strokeStyle = "rgba(255,255,255,0.08)";
                    else c.strokeStyle = "rgba(0,0,0,0.1)";
                    c.lineWidth = 1;
                    c.stroke();
                };
                /**
     * Draws body angle indicators and axes
     * @private
     * @method bodyAxes
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyAxes = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options, part, i, j, k;
                    c.beginPath();
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i], parts = body.parts;
                        if (!body.render.visible) continue;
                        if (options.showAxes) // render all axes
                        for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++){
                                var axis = part.axes[k];
                                c.moveTo(part.position.x, part.position.y);
                                c.lineTo(part.position.x + axis.x * 20, part.position.y + axis.y * 20);
                            }
                        }
                        else for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++){
                                // render a single axis indicator
                                c.moveTo(part.position.x, part.position.y);
                                c.lineTo((part.vertices[0].x + part.vertices[part.vertices.length - 1].x) / 2, (part.vertices[0].y + part.vertices[part.vertices.length - 1].y) / 2);
                            }
                        }
                    }
                    if (options.wireframes) {
                        c.strokeStyle = "indianred";
                        c.lineWidth = 1;
                    } else {
                        c.strokeStyle = "rgba(255, 255, 255, 0.4)";
                        c.globalCompositeOperation = "overlay";
                        c.lineWidth = 2;
                    }
                    c.stroke();
                    c.globalCompositeOperation = "source-over";
                };
                /**
     * Draws body positions
     * @private
     * @method bodyPositions
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyPositions = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options, body, part, i, k;
                    c.beginPath();
                    // render current positions
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible) continue;
                        // handle compound parts
                        for(k = 0; k < body.parts.length; k++){
                            part = body.parts[k];
                            c.arc(part.position.x, part.position.y, 3, 0, 2 * Math.PI, false);
                            c.closePath();
                        }
                    }
                    if (options.wireframes) c.fillStyle = "indianred";
                    else c.fillStyle = "rgba(0,0,0,0.5)";
                    c.fill();
                    c.beginPath();
                    // render previous positions
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (body.render.visible) {
                            c.arc(body.positionPrev.x, body.positionPrev.y, 2, 0, 2 * Math.PI, false);
                            c.closePath();
                        }
                    }
                    c.fillStyle = "rgba(255,165,0,0.8)";
                    c.fill();
                };
                /**
     * Draws body velocity
     * @private
     * @method bodyVelocity
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyVelocity = function(render, bodies, context) {
                    var c = context;
                    c.beginPath();
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (!body.render.visible) continue;
                        c.moveTo(body.position.x, body.position.y);
                        c.lineTo(body.position.x + (body.position.x - body.positionPrev.x) * 2, body.position.y + (body.position.y - body.positionPrev.y) * 2);
                    }
                    c.lineWidth = 3;
                    c.strokeStyle = "cornflowerblue";
                    c.stroke();
                };
                /**
     * Draws body ids
     * @private
     * @method bodyIds
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyIds = function(render, bodies, context) {
                    var c = context, i, j;
                    for(i = 0; i < bodies.length; i++){
                        if (!bodies[i].render.visible) continue;
                        var parts = bodies[i].parts;
                        for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            var part = parts[j];
                            c.font = "12px Arial";
                            c.fillStyle = "rgba(255,255,255,0.5)";
                            c.fillText(part.id, part.position.x + 10, part.position.y - 10);
                        }
                    }
                };
                /**
     * Description
     * @private
     * @method collisions
     * @param {render} render
     * @param {pair[]} pairs
     * @param {RenderingContext} context
     */ Render.collisions = function(render, pairs, context) {
                    var c = context, options = render.options, pair, collision, corrected, bodyA, bodyB, i, j;
                    c.beginPath();
                    // render collision positions
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        collision = pair.collision;
                        for(j = 0; j < pair.activeContacts.length; j++){
                            var contact = pair.activeContacts[j], vertex = contact.vertex;
                            c.rect(vertex.x - 1.5, vertex.y - 1.5, 3.5, 3.5);
                        }
                    }
                    if (options.wireframes) c.fillStyle = "rgba(255,255,255,0.7)";
                    else c.fillStyle = "orange";
                    c.fill();
                    c.beginPath();
                    // render collision normals
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        collision = pair.collision;
                        if (pair.activeContacts.length > 0) {
                            var normalPosX = pair.activeContacts[0].vertex.x, normalPosY = pair.activeContacts[0].vertex.y;
                            if (pair.activeContacts.length === 2) {
                                normalPosX = (pair.activeContacts[0].vertex.x + pair.activeContacts[1].vertex.x) / 2;
                                normalPosY = (pair.activeContacts[0].vertex.y + pair.activeContacts[1].vertex.y) / 2;
                            }
                            if (collision.bodyB === collision.supports[0].body || collision.bodyA.isStatic === true) c.moveTo(normalPosX - collision.normal.x * 8, normalPosY - collision.normal.y * 8);
                            else c.moveTo(normalPosX + collision.normal.x * 8, normalPosY + collision.normal.y * 8);
                            c.lineTo(normalPosX, normalPosY);
                        }
                    }
                    if (options.wireframes) c.strokeStyle = "rgba(255,165,0,0.7)";
                    else c.strokeStyle = "orange";
                    c.lineWidth = 1;
                    c.stroke();
                };
                /**
     * Description
     * @private
     * @method separations
     * @param {render} render
     * @param {pair[]} pairs
     * @param {RenderingContext} context
     */ Render.separations = function(render, pairs, context) {
                    var c = context, options = render.options, pair, collision, corrected, bodyA, bodyB, i, j;
                    c.beginPath();
                    // render separations
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        collision = pair.collision;
                        bodyA = collision.bodyA;
                        bodyB = collision.bodyB;
                        var k = 1;
                        if (!bodyB.isStatic && !bodyA.isStatic) k = 0.5;
                        if (bodyB.isStatic) k = 0;
                        c.moveTo(bodyB.position.x, bodyB.position.y);
                        c.lineTo(bodyB.position.x - collision.penetration.x * k, bodyB.position.y - collision.penetration.y * k);
                        k = 1;
                        if (!bodyB.isStatic && !bodyA.isStatic) k = 0.5;
                        if (bodyA.isStatic) k = 0;
                        c.moveTo(bodyA.position.x, bodyA.position.y);
                        c.lineTo(bodyA.position.x + collision.penetration.x * k, bodyA.position.y + collision.penetration.y * k);
                    }
                    if (options.wireframes) c.strokeStyle = "rgba(255,165,0,0.5)";
                    else c.strokeStyle = "orange";
                    c.stroke();
                };
                /**
     * Description
     * @private
     * @method inspector
     * @param {inspector} inspector
     * @param {RenderingContext} context
     */ Render.inspector = function(inspector, context) {
                    var engine = inspector.engine, selected = inspector.selected, render = inspector.render, options = render.options, bounds;
                    if (options.hasBounds) {
                        var boundsWidth = render.bounds.max.x - render.bounds.min.x, boundsHeight = render.bounds.max.y - render.bounds.min.y, boundsScaleX = boundsWidth / render.options.width, boundsScaleY = boundsHeight / render.options.height;
                        context.scale(1 / boundsScaleX, 1 / boundsScaleY);
                        context.translate(-render.bounds.min.x, -render.bounds.min.y);
                    }
                    for(var i = 0; i < selected.length; i++){
                        var item = selected[i].data;
                        context.translate(0.5, 0.5);
                        context.lineWidth = 1;
                        context.strokeStyle = "rgba(255,165,0,0.9)";
                        context.setLineDash([
                            1,
                            2
                        ]);
                        switch(item.type){
                            case "body":
                                // render body selections
                                bounds = item.bounds;
                                context.beginPath();
                                context.rect(Math.floor(bounds.min.x - 3), Math.floor(bounds.min.y - 3), Math.floor(bounds.max.x - bounds.min.x + 6), Math.floor(bounds.max.y - bounds.min.y + 6));
                                context.closePath();
                                context.stroke();
                                break;
                            case "constraint":
                                // render constraint selections
                                var point = item.pointA;
                                if (item.bodyA) point = item.pointB;
                                context.beginPath();
                                context.arc(point.x, point.y, 10, 0, 2 * Math.PI);
                                context.closePath();
                                context.stroke();
                                break;
                        }
                        context.setLineDash([]);
                        context.translate(-0.5, -0.5);
                    }
                    // render selection region
                    if (inspector.selectStart !== null) {
                        context.translate(0.5, 0.5);
                        context.lineWidth = 1;
                        context.strokeStyle = "rgba(255,165,0,0.6)";
                        context.fillStyle = "rgba(255,165,0,0.1)";
                        bounds = inspector.selectBounds;
                        context.beginPath();
                        context.rect(Math.floor(bounds.min.x), Math.floor(bounds.min.y), Math.floor(bounds.max.x - bounds.min.x), Math.floor(bounds.max.y - bounds.min.y));
                        context.closePath();
                        context.stroke();
                        context.fill();
                        context.translate(-0.5, -0.5);
                    }
                    if (options.hasBounds) context.setTransform(1, 0, 0, 1, 0, 0);
                };
                /**
     * Updates render timing.
     * @method _updateTiming
     * @private
     * @param {render} render
     * @param {number} time
     */ var _updateTiming = function(render, time) {
                    var engine = render.engine, timing = render.timing, historySize = timing.historySize, timestamp = engine.timing.timestamp;
                    timing.delta = time - timing.lastTime || Render._goodDelta;
                    timing.lastTime = time;
                    timing.timestampElapsed = timestamp - timing.lastTimestamp || 0;
                    timing.lastTimestamp = timestamp;
                    timing.deltaHistory.unshift(timing.delta);
                    timing.deltaHistory.length = Math.min(timing.deltaHistory.length, historySize);
                    timing.engineDeltaHistory.unshift(engine.timing.lastDelta);
                    timing.engineDeltaHistory.length = Math.min(timing.engineDeltaHistory.length, historySize);
                    timing.timestampElapsedHistory.unshift(timing.timestampElapsed);
                    timing.timestampElapsedHistory.length = Math.min(timing.timestampElapsedHistory.length, historySize);
                    timing.engineElapsedHistory.unshift(engine.timing.lastElapsed);
                    timing.engineElapsedHistory.length = Math.min(timing.engineElapsedHistory.length, historySize);
                    timing.elapsedHistory.unshift(timing.lastElapsed);
                    timing.elapsedHistory.length = Math.min(timing.elapsedHistory.length, historySize);
                };
                /**
     * Returns the mean value of the given numbers.
     * @method _mean
     * @private
     * @param {Number[]} values
     * @return {Number} the mean of given values
     */ var _mean = function(values) {
                    var result = 0;
                    for(var i = 0; i < values.length; i += 1)result += values[i];
                    return result / values.length || 0;
                };
                /**
     * @method _createCanvas
     * @private
     * @param {} width
     * @param {} height
     * @return canvas
     */ var _createCanvas = function(width, height) {
                    var canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    canvas.oncontextmenu = function() {
                        return false;
                    };
                    canvas.onselectstart = function() {
                        return false;
                    };
                    return canvas;
                };
                /**
     * Gets the pixel ratio of the canvas.
     * @method _getPixelRatio
     * @private
     * @param {HTMLElement} canvas
     * @return {Number} pixel ratio
     */ var _getPixelRatio = function(canvas) {
                    var context = canvas.getContext("2d"), devicePixelRatio = window.devicePixelRatio || 1, backingStorePixelRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
                    return devicePixelRatio / backingStorePixelRatio;
                };
                /**
     * Gets the requested texture (an Image) via its path
     * @method _getTexture
     * @private
     * @param {render} render
     * @param {string} imagePath
     * @return {Image} texture
     */ var _getTexture = function(render, imagePath) {
                    var image = render.textures[imagePath];
                    if (image) return image;
                    image = render.textures[imagePath] = new Image();
                    image.src = imagePath;
                    return image;
                };
                /**
     * Applies the background to the canvas using CSS.
     * @method applyBackground
     * @private
     * @param {render} render
     * @param {string} background
     */ var _applyBackground = function(render, background) {
                    var cssBackground = background;
                    if (/(jpg|gif|png)$/.test(background)) cssBackground = "url(" + background + ")";
                    render.canvas.style.background = cssBackground;
                    render.canvas.style.backgroundSize = "contain";
                    render.currentBackground = background;
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired before rendering
    *
    * @event beforeRender
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after rendering
    *
    * @event afterRender
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * A back-reference to the `Matter.Render` module.
     *
     * @property controller
     * @type render
     */ /**
     * A reference to the `Matter.Engine` instance to be used.
     *
     * @property engine
     * @type engine
     */ /**
     * A reference to the element where the canvas is to be inserted (if `render.canvas` has not been specified)
     *
     * @property element
     * @type HTMLElement
     * @default null
     */ /**
     * The canvas element to render to. If not specified, one will be created if `render.element` has been specified.
     *
     * @property canvas
     * @type HTMLCanvasElement
     * @default null
     */ /**
     * A `Bounds` object that specifies the drawing view region.
     * Rendering will be automatically transformed and scaled to fit within the canvas size (`render.options.width` and `render.options.height`).
     * This allows for creating views that can pan or zoom around the scene.
     * You must also set `render.options.hasBounds` to `true` to enable bounded rendering.
     *
     * @property bounds
     * @type bounds
     */ /**
     * The 2d rendering context from the `render.canvas` element.
     *
     * @property context
     * @type CanvasRenderingContext2D
     */ /**
     * The sprite texture cache.
     *
     * @property textures
     * @type {}
     */ /**
     * The mouse to render if `render.options.showMousePosition` is enabled.
     *
     * @property mouse
     * @type mouse
     * @default null
     */ /**
     * The configuration options of the renderer.
     *
     * @property options
     * @type {}
     */ /**
     * The target width in pixels of the `render.canvas` to be created.
     * See also the `options.pixelRatio` property to change render quality.
     *
     * @property options.width
     * @type number
     * @default 800
     */ /**
     * The target height in pixels of the `render.canvas` to be created.
     * See also the `options.pixelRatio` property to change render quality.
     *
     * @property options.height
     * @type number
     * @default 600
     */ /**
     * The [pixel ratio](https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio) to use when rendering.
     *
     * @property options.pixelRatio
     * @type number
     * @default 1
     */ /**
     * A CSS background color string to use when `render.options.wireframes` is disabled.
     * This may be also set to `'transparent'` or equivalent.
     *
     * @property options.background
     * @type string
     * @default '#14151f'
     */ /**
     * A CSS background color string to use when `render.options.wireframes` is enabled.
     * This may be also set to `'transparent'` or equivalent.
     *
     * @property options.wireframeBackground
     * @type string
     * @default '#14151f'
     */ /**
     * A flag that specifies if `render.bounds` should be used when rendering.
     *
     * @property options.hasBounds
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable all debug information overlays together.  
     * This includes and has priority over the values of:
     *
     * - `render.options.showStats`
     * - `render.options.showPerformance`
     *
     * @property options.showDebug
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the engine stats info overlay.  
     * From left to right, the values shown are:
     *
     * - body parts total
     * - body total
     * - constraints total
     * - composites total
     * - collision pairs total
     *
     * @property options.showStats
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable performance charts.  
     * From left to right, the values shown are:
     *
     * - average render frequency (e.g. 60 fps)
     * - exact engine delta time used for last update (e.g. 16.66ms)
     * - average engine execution duration (e.g. 5.00ms)
     * - average render execution duration (e.g. 0.40ms)
     * - average effective play speed (e.g. '1.00x' is 'real-time')
     *
     * Each value is recorded over a fixed sample of past frames (60 frames).
     *
     * A chart shown below each value indicates the variance from the average over the sample.
     * The more stable or fixed the value is the flatter the chart will appear.
     *
     * @property options.showPerformance
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable rendering entirely.
     *
     * @property options.enabled
     * @type boolean
     * @default false
     */ /**
     * A flag to toggle wireframe rendering otherwise solid fill rendering is used.
     *
     * @property options.wireframes
     * @type boolean
     * @default true
     */ /**
     * A flag to enable or disable sleeping bodies indicators.
     *
     * @property options.showSleeping
     * @type boolean
     * @default true
     */ /**
     * A flag to enable or disable the debug information overlay.
     *
     * @property options.showDebug
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the collision broadphase debug overlay.
     *
     * @deprecated no longer implemented
     * @property options.showBroadphase
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body bounds debug overlay.
     *
     * @property options.showBounds
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body velocity debug overlay.
     *
     * @property options.showVelocity
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body collisions debug overlay.
     *
     * @property options.showCollisions
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the collision resolver separations debug overlay.
     *
     * @property options.showSeparations
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body axes debug overlay.
     *
     * @property options.showAxes
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body positions debug overlay.
     *
     * @property options.showPositions
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body angle debug overlay.
     *
     * @property options.showAngleIndicator
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body and part ids debug overlay.
     *
     * @property options.showIds
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body vertex numbers debug overlay.
     *
     * @property options.showVertexNumbers
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body convex hulls debug overlay.
     *
     * @property options.showConvexHulls
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body internal edges debug overlay.
     *
     * @property options.showInternalEdges
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the mouse position debug overlay.
     *
     * @property options.showMousePosition
     * @type boolean
     * @default false
     */ })();
        /***/ },
        /* 17 */ /***/ function(module1, exports) {
            /**
* The `Matter.Contact` module contains methods for creating and manipulating collision contacts.
*
* @class Contact
*/ var Contact = {};
            module1.exports = Contact;
            (function() {
                /**
     * Creates a new contact.
     * @method create
     * @param {vertex} vertex
     * @return {contact} A new contact
     */ Contact.create = function(vertex) {
                    return {
                        vertex: vertex,
                        normalImpulse: 0,
                        tangentImpulse: 0
                    };
                };
            })();
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Engine` module contains methods for creating and manipulating engines.
* An engine is a controller that manages updating the simulation of the world.
* See `Matter.Runner` for an optional game loop utility.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Engine
*/ var Engine = {};
            module1.exports = Engine;
            var Sleeping = __webpack_require__(7);
            var Resolver = __webpack_require__(19);
            var Detector = __webpack_require__(14);
            var Pairs = __webpack_require__(20);
            var Events = __webpack_require__(4);
            var Composite = __webpack_require__(5);
            var Constraint = __webpack_require__(10);
            var Common = __webpack_require__(0);
            var Body = __webpack_require__(6);
            (function() {
                /**
     * Creates a new engine. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {object} [options]
     * @return {engine} engine
     */ Engine.create = function(options) {
                    options = options || {};
                    var defaults = {
                        positionIterations: 6,
                        velocityIterations: 4,
                        constraintIterations: 2,
                        enableSleeping: false,
                        events: [],
                        plugin: {},
                        gravity: {
                            x: 0,
                            y: 1,
                            scale: 0.001
                        },
                        timing: {
                            timestamp: 0,
                            timeScale: 1,
                            lastDelta: 0,
                            lastElapsed: 0
                        }
                    };
                    var engine = Common.extend(defaults, options);
                    engine.world = options.world || Composite.create({
                        label: "World"
                    });
                    engine.pairs = options.pairs || Pairs.create();
                    engine.detector = options.detector || Detector.create();
                    // for temporary back compatibility only
                    engine.grid = {
                        buckets: []
                    };
                    engine.world.gravity = engine.gravity;
                    engine.broadphase = engine.grid;
                    engine.metrics = {};
                    return engine;
                };
                /**
     * Moves the simulation forward in time by `delta` ms.
     * The `correction` argument is an optional `Number` that specifies the time correction factor to apply to the update.
     * This can help improve the accuracy of the simulation in cases where `delta` is changing between updates.
     * The value of `correction` is defined as `delta / lastDelta`, i.e. the percentage change of `delta` over the last step.
     * Therefore the value is always `1` (no correction) when `delta` constant (or when no correction is desired, which is the default).
     * See the paper on <a href="http://lonesock.net/article/verlet.html">Time Corrected Verlet</a> for more information.
     *
     * Triggers `beforeUpdate` and `afterUpdate` events.
     * Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     * @method update
     * @param {engine} engine
     * @param {number} [delta=16.666]
     * @param {number} [correction=1]
     */ Engine.update = function(engine, delta, correction) {
                    var startTime = Common.now();
                    delta = delta || 1000 / 60;
                    correction = correction || 1;
                    var world = engine.world, detector = engine.detector, pairs = engine.pairs, timing = engine.timing, timestamp = timing.timestamp, i;
                    // increment timestamp
                    timing.timestamp += delta * timing.timeScale;
                    timing.lastDelta = delta * timing.timeScale;
                    // create an event object
                    var event = {
                        timestamp: timing.timestamp
                    };
                    Events.trigger(engine, "beforeUpdate", event);
                    // get all bodies and all constraints in the world
                    var allBodies = Composite.allBodies(world), allConstraints = Composite.allConstraints(world);
                    // update the detector bodies if they have changed
                    if (world.isModified) Detector.setBodies(detector, allBodies);
                    // reset all composite modified flags
                    if (world.isModified) Composite.setModified(world, false, false, true);
                    // update sleeping if enabled
                    if (engine.enableSleeping) Sleeping.update(allBodies, timing.timeScale);
                    // apply gravity to all bodies
                    Engine._bodiesApplyGravity(allBodies, engine.gravity);
                    // update all body position and rotation by integration
                    Engine._bodiesUpdate(allBodies, delta, timing.timeScale, correction, world.bounds);
                    // update all constraints (first pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, timing.timeScale);
                    Constraint.postSolveAll(allBodies);
                    // find all collisions
                    detector.pairs = engine.pairs;
                    var collisions = Detector.collisions(detector);
                    // update collision pairs
                    Pairs.update(pairs, collisions, timestamp);
                    // wake up bodies involved in collisions
                    if (engine.enableSleeping) Sleeping.afterCollisions(pairs.list, timing.timeScale);
                    // trigger collision events
                    if (pairs.collisionStart.length > 0) Events.trigger(engine, "collisionStart", {
                        pairs: pairs.collisionStart
                    });
                    // iteratively resolve position between collisions
                    Resolver.preSolvePosition(pairs.list);
                    for(i = 0; i < engine.positionIterations; i++)Resolver.solvePosition(pairs.list, timing.timeScale);
                    Resolver.postSolvePosition(allBodies);
                    // update all constraints (second pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, timing.timeScale);
                    Constraint.postSolveAll(allBodies);
                    // iteratively resolve velocity between collisions
                    Resolver.preSolveVelocity(pairs.list);
                    for(i = 0; i < engine.velocityIterations; i++)Resolver.solveVelocity(pairs.list, timing.timeScale);
                    // trigger collision events
                    if (pairs.collisionActive.length > 0) Events.trigger(engine, "collisionActive", {
                        pairs: pairs.collisionActive
                    });
                    if (pairs.collisionEnd.length > 0) Events.trigger(engine, "collisionEnd", {
                        pairs: pairs.collisionEnd
                    });
                    // clear force buffers
                    Engine._bodiesClearForces(allBodies);
                    Events.trigger(engine, "afterUpdate", event);
                    // log the time elapsed computing this update
                    engine.timing.lastElapsed = Common.now() - startTime;
                    return engine;
                };
                /**
     * Merges two engines by keeping the configuration of `engineA` but replacing the world with the one from `engineB`.
     * @method merge
     * @param {engine} engineA
     * @param {engine} engineB
     */ Engine.merge = function(engineA, engineB) {
                    Common.extend(engineA, engineB);
                    if (engineB.world) {
                        engineA.world = engineB.world;
                        Engine.clear(engineA);
                        var bodies = Composite.allBodies(engineA.world);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            Sleeping.set(body, false);
                            body.id = Common.nextId();
                        }
                    }
                };
                /**
     * Clears the engine pairs and detector.
     * @method clear
     * @param {engine} engine
     */ Engine.clear = function(engine) {
                    Pairs.clear(engine.pairs);
                    Detector.clear(engine.detector);
                };
                /**
     * Zeroes the `body.force` and `body.torque` force buffers.
     * @method _bodiesClearForces
     * @private
     * @param {body[]} bodies
     */ Engine._bodiesClearForces = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        // reset force buffers
                        body.force.x = 0;
                        body.force.y = 0;
                        body.torque = 0;
                    }
                };
                /**
     * Applys a mass dependant force to all given bodies.
     * @method _bodiesApplyGravity
     * @private
     * @param {body[]} bodies
     * @param {vector} gravity
     */ Engine._bodiesApplyGravity = function(bodies, gravity) {
                    var gravityScale = typeof gravity.scale !== "undefined" ? gravity.scale : 0.001;
                    if (gravity.x === 0 && gravity.y === 0 || gravityScale === 0) return;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isStatic || body.isSleeping) continue;
                        // apply gravity
                        body.force.y += body.mass * gravity.y * gravityScale;
                        body.force.x += body.mass * gravity.x * gravityScale;
                    }
                };
                /**
     * Applys `Body.update` to all given `bodies`.
     * @method _bodiesUpdate
     * @private
     * @param {body[]} bodies
     * @param {number} deltaTime 
     * The amount of time elapsed between updates
     * @param {number} timeScale
     * @param {number} correction 
     * The Verlet correction factor (deltaTime / lastDeltaTime)
     * @param {bounds} worldBounds
     */ Engine._bodiesUpdate = function(bodies, deltaTime, timeScale, correction, worldBounds) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isStatic || body.isSleeping) continue;
                        Body.update(body, deltaTime, timeScale, correction);
                    }
                };
            /**
     * A deprecated alias for `Runner.run`, use `Matter.Runner.run(engine)` instead and see `Matter.Runner` for more information.
     * @deprecated use Matter.Runner.run(engine) instead
     * @method run
     * @param {engine} engine
     */ /**
    * Fired just before an update
    *
    * @event beforeUpdate
    * @param {object} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update and all collision events
    *
    * @event afterUpdate
    * @param {object} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have started to collide in the current tick (if any)
    *
    * @event collisionStart
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that are colliding in the current tick (if any)
    *
    * @event collisionActive
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have ended collision in the current tick (if any)
    *
    * @event collisionEnd
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` that specifies the number of position iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property positionIterations
     * @type number
     * @default 6
     */ /**
     * An integer `Number` that specifies the number of velocity iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property velocityIterations
     * @type number
     * @default 4
     */ /**
     * An integer `Number` that specifies the number of constraint iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     * The default value of `2` is usually very adequate.
     *
     * @property constraintIterations
     * @type number
     * @default 2
     */ /**
     * A flag that specifies whether the engine should allow sleeping via the `Matter.Sleeping` module.
     * Sleeping can improve stability and performance, but often at the expense of accuracy.
     *
     * @property enableSleeping
     * @type boolean
     * @default false
     */ /**
     * An `Object` containing properties regarding the timing systems of the engine. 
     *
     * @property timing
     * @type object
     */ /**
     * A `Number` that specifies the global scaling factor of time for all bodies.
     * A value of `0` freezes the simulation.
     * A value of `0.1` gives a slow-motion effect.
     * A value of `1.2` gives a speed-up effect.
     *
     * @property timing.timeScale
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the current simulation-time in milliseconds starting from `0`. 
     * It is incremented on every `Engine.update` by the given `delta` argument. 
     *
     * @property timing.timestamp
     * @type number
     * @default 0
     */ /**
     * A `Number` that represents the total execution time elapsed during the last `Engine.update` in milliseconds.
     * It is updated by timing from the start of the last `Engine.update` call until it ends.
     *
     * This value will also include the total execution time of all event handlers directly or indirectly triggered by the engine update.
     *
     * @property timing.lastElapsed
     * @type number
     * @default 0
     */ /**
     * A `Number` that represents the `delta` value used in the last engine update.
     *
     * @property timing.lastDelta
     * @type number
     * @default 0
     */ /**
     * A `Matter.Detector` instance.
     *
     * @property detector
     * @type detector
     * @default a Matter.Detector instance
     */ /**
     * A `Matter.Grid` instance.
     *
     * @deprecated replaced by `engine.detector`
     * @property grid
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * Replaced by and now alias for `engine.grid`.
     *
     * @deprecated replaced by `engine.detector`
     * @property broadphase
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * The root `Matter.Composite` instance that will contain all bodies, constraints and other composites to be simulated by this engine.
     *
     * @property world
     * @type composite
     * @default a Matter.Composite instance
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * The gravity to apply on all bodies in `engine.world`.
     *
     * @property gravity
     * @type object
     */ /**
     * The gravity x component.
     *
     * @property gravity.x
     * @type object
     * @default 0
     */ /**
     * The gravity y component.
     *
     * @property gravity.y
     * @type object
     * @default 1
     */ /**
     * The gravity scale factor.
     *
     * @property gravity.scale
     * @type object
     * @default 0.001
     */ })();
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Resolver` module contains methods for resolving collision pairs.
*
* @class Resolver
*/ var Resolver = {};
            module1.exports = Resolver;
            var Vertices = __webpack_require__(3);
            var Bounds = __webpack_require__(1);
            (function() {
                Resolver._restingThresh = 4;
                Resolver._restingThreshTangent = 6;
                Resolver._positionDampen = 0.9;
                Resolver._positionWarming = 0.8;
                Resolver._frictionNormalMultiplier = 5;
                /**
     * Prepare pairs for position solving.
     * @method preSolvePosition
     * @param {pair[]} pairs
     */ Resolver.preSolvePosition = function(pairs) {
                    var i, pair, activeCount, pairsLength = pairs.length;
                    // find total contacts on each body
                    for(i = 0; i < pairsLength; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        activeCount = pair.activeContacts.length;
                        pair.collision.parentA.totalContacts += activeCount;
                        pair.collision.parentB.totalContacts += activeCount;
                    }
                };
                /**
     * Find a solution for pair positions.
     * @method solvePosition
     * @param {pair[]} pairs
     * @param {number} timeScale
     */ Resolver.solvePosition = function(pairs, timeScale) {
                    var i, pair, collision, bodyA, bodyB, normal, contactShare, positionImpulse, positionDampen = Resolver._positionDampen, pairsLength = pairs.length;
                    // find impulses required to resolve penetration
                    for(i = 0; i < pairsLength; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        // get current separation between body edges involved in collision
                        pair.separation = normal.x * (bodyB.positionImpulse.x + collision.penetration.x - bodyA.positionImpulse.x) + normal.y * (bodyB.positionImpulse.y + collision.penetration.y - bodyA.positionImpulse.y);
                    }
                    for(i = 0; i < pairsLength; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        positionImpulse = (pair.separation - pair.slop) * timeScale;
                        if (bodyA.isStatic || bodyB.isStatic) positionImpulse *= 2;
                        if (!(bodyA.isStatic || bodyA.isSleeping)) {
                            contactShare = positionDampen / bodyA.totalContacts;
                            bodyA.positionImpulse.x += normal.x * positionImpulse * contactShare;
                            bodyA.positionImpulse.y += normal.y * positionImpulse * contactShare;
                        }
                        if (!(bodyB.isStatic || bodyB.isSleeping)) {
                            contactShare = positionDampen / bodyB.totalContacts;
                            bodyB.positionImpulse.x -= normal.x * positionImpulse * contactShare;
                            bodyB.positionImpulse.y -= normal.y * positionImpulse * contactShare;
                        }
                    }
                };
                /**
     * Apply position resolution.
     * @method postSolvePosition
     * @param {body[]} bodies
     */ Resolver.postSolvePosition = function(bodies) {
                    var positionWarming = Resolver._positionWarming, bodiesLength = bodies.length, verticesTranslate = Vertices.translate, boundsUpdate = Bounds.update;
                    for(var i = 0; i < bodiesLength; i++){
                        var body = bodies[i], positionImpulse = body.positionImpulse, positionImpulseX = positionImpulse.x, positionImpulseY = positionImpulse.y, velocity = body.velocity;
                        // reset contact count
                        body.totalContacts = 0;
                        if (positionImpulseX !== 0 || positionImpulseY !== 0) {
                            // update body geometry
                            for(var j = 0; j < body.parts.length; j++){
                                var part = body.parts[j];
                                verticesTranslate(part.vertices, positionImpulse);
                                boundsUpdate(part.bounds, part.vertices, velocity);
                                part.position.x += positionImpulseX;
                                part.position.y += positionImpulseY;
                            }
                            // move the body without changing velocity
                            body.positionPrev.x += positionImpulseX;
                            body.positionPrev.y += positionImpulseY;
                            if (positionImpulseX * velocity.x + positionImpulseY * velocity.y < 0) {
                                // reset cached impulse if the body has velocity along it
                                positionImpulse.x = 0;
                                positionImpulse.y = 0;
                            } else {
                                // warm the next iteration
                                positionImpulse.x *= positionWarming;
                                positionImpulse.y *= positionWarming;
                            }
                        }
                    }
                };
                /**
     * Prepare pairs for velocity solving.
     * @method preSolveVelocity
     * @param {pair[]} pairs
     */ Resolver.preSolveVelocity = function(pairs) {
                    var pairsLength = pairs.length, i, j;
                    for(i = 0; i < pairsLength; i++){
                        var pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        var contacts = pair.activeContacts, contactsLength = contacts.length, collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, normal = collision.normal, tangent = collision.tangent;
                        // resolve each contact
                        for(j = 0; j < contactsLength; j++){
                            var contact = contacts[j], contactVertex = contact.vertex, normalImpulse = contact.normalImpulse, tangentImpulse = contact.tangentImpulse;
                            if (normalImpulse !== 0 || tangentImpulse !== 0) {
                                // total impulse from contact
                                var impulseX = normal.x * normalImpulse + tangent.x * tangentImpulse, impulseY = normal.y * normalImpulse + tangent.y * tangentImpulse;
                                // apply impulse from contact
                                if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                    bodyA.positionPrev.x += impulseX * bodyA.inverseMass;
                                    bodyA.positionPrev.y += impulseY * bodyA.inverseMass;
                                    bodyA.anglePrev += bodyA.inverseInertia * ((contactVertex.x - bodyA.position.x) * impulseY - (contactVertex.y - bodyA.position.y) * impulseX);
                                }
                                if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                    bodyB.positionPrev.x -= impulseX * bodyB.inverseMass;
                                    bodyB.positionPrev.y -= impulseY * bodyB.inverseMass;
                                    bodyB.anglePrev -= bodyB.inverseInertia * ((contactVertex.x - bodyB.position.x) * impulseY - (contactVertex.y - bodyB.position.y) * impulseX);
                                }
                            }
                        }
                    }
                };
                /**
     * Find a solution for pair velocities.
     * @method solveVelocity
     * @param {pair[]} pairs
     * @param {number} timeScale
     */ Resolver.solveVelocity = function(pairs, timeScale) {
                    var timeScaleSquared = timeScale * timeScale, restingThresh = Resolver._restingThresh * timeScaleSquared, frictionNormalMultiplier = Resolver._frictionNormalMultiplier, restingThreshTangent = Resolver._restingThreshTangent * timeScaleSquared, NumberMaxValue = Number.MAX_VALUE, pairsLength = pairs.length, tangentImpulse, maxFriction, i, j;
                    for(i = 0; i < pairsLength; i++){
                        var pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        var collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, bodyAVelocity = bodyA.velocity, bodyBVelocity = bodyB.velocity, normalX = collision.normal.x, normalY = collision.normal.y, tangentX = collision.tangent.x, tangentY = collision.tangent.y, contacts = pair.activeContacts, contactsLength = contacts.length, contactShare = 1 / contactsLength, inverseMassTotal = bodyA.inverseMass + bodyB.inverseMass, friction = pair.friction * pair.frictionStatic * frictionNormalMultiplier * timeScaleSquared;
                        // update body velocities
                        bodyAVelocity.x = bodyA.position.x - bodyA.positionPrev.x;
                        bodyAVelocity.y = bodyA.position.y - bodyA.positionPrev.y;
                        bodyBVelocity.x = bodyB.position.x - bodyB.positionPrev.x;
                        bodyBVelocity.y = bodyB.position.y - bodyB.positionPrev.y;
                        bodyA.angularVelocity = bodyA.angle - bodyA.anglePrev;
                        bodyB.angularVelocity = bodyB.angle - bodyB.anglePrev;
                        // resolve each contact
                        for(j = 0; j < contactsLength; j++){
                            var contact = contacts[j], contactVertex = contact.vertex;
                            var offsetAX = contactVertex.x - bodyA.position.x, offsetAY = contactVertex.y - bodyA.position.y, offsetBX = contactVertex.x - bodyB.position.x, offsetBY = contactVertex.y - bodyB.position.y;
                            var velocityPointAX = bodyAVelocity.x - offsetAY * bodyA.angularVelocity, velocityPointAY = bodyAVelocity.y + offsetAX * bodyA.angularVelocity, velocityPointBX = bodyBVelocity.x - offsetBY * bodyB.angularVelocity, velocityPointBY = bodyBVelocity.y + offsetBX * bodyB.angularVelocity;
                            var relativeVelocityX = velocityPointAX - velocityPointBX, relativeVelocityY = velocityPointAY - velocityPointBY;
                            var normalVelocity = normalX * relativeVelocityX + normalY * relativeVelocityY, tangentVelocity = tangentX * relativeVelocityX + tangentY * relativeVelocityY;
                            // coulomb friction
                            var normalOverlap = pair.separation + normalVelocity;
                            var normalForce = Math.min(normalOverlap, 1);
                            normalForce = normalOverlap < 0 ? 0 : normalForce;
                            var frictionLimit = normalForce * friction;
                            if (tangentVelocity > frictionLimit || -tangentVelocity > frictionLimit) {
                                maxFriction = tangentVelocity > 0 ? tangentVelocity : -tangentVelocity;
                                tangentImpulse = pair.friction * (tangentVelocity > 0 ? 1 : -1) * timeScaleSquared;
                                if (tangentImpulse < -maxFriction) tangentImpulse = -maxFriction;
                                else if (tangentImpulse > maxFriction) tangentImpulse = maxFriction;
                            } else {
                                tangentImpulse = tangentVelocity;
                                maxFriction = NumberMaxValue;
                            }
                            // account for mass, inertia and contact offset
                            var oAcN = offsetAX * normalY - offsetAY * normalX, oBcN = offsetBX * normalY - offsetBY * normalX, share = contactShare / (inverseMassTotal + bodyA.inverseInertia * oAcN * oAcN + bodyB.inverseInertia * oBcN * oBcN);
                            // raw impulses
                            var normalImpulse = (1 + pair.restitution) * normalVelocity * share;
                            tangentImpulse *= share;
                            // handle high velocity and resting collisions separately
                            if (normalVelocity * normalVelocity > restingThresh && normalVelocity < 0) // high normal velocity so clear cached contact normal impulse
                            contact.normalImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // impulse constraint tends to 0
                                var contactNormalImpulse = contact.normalImpulse;
                                contact.normalImpulse += normalImpulse;
                                contact.normalImpulse = Math.min(contact.normalImpulse, 0);
                                normalImpulse = contact.normalImpulse - contactNormalImpulse;
                            }
                            // handle high velocity and resting collisions separately
                            if (tangentVelocity * tangentVelocity > restingThreshTangent) // high tangent velocity so clear cached contact tangent impulse
                            contact.tangentImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // tangent impulse tends to -tangentSpeed or +tangentSpeed
                                var contactTangentImpulse = contact.tangentImpulse;
                                contact.tangentImpulse += tangentImpulse;
                                if (contact.tangentImpulse < -maxFriction) contact.tangentImpulse = -maxFriction;
                                if (contact.tangentImpulse > maxFriction) contact.tangentImpulse = maxFriction;
                                tangentImpulse = contact.tangentImpulse - contactTangentImpulse;
                            }
                            // total impulse from contact
                            var impulseX = normalX * normalImpulse + tangentX * tangentImpulse, impulseY = normalY * normalImpulse + tangentY * tangentImpulse;
                            // apply impulse from contact
                            if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                bodyA.positionPrev.x += impulseX * bodyA.inverseMass;
                                bodyA.positionPrev.y += impulseY * bodyA.inverseMass;
                                bodyA.anglePrev += (offsetAX * impulseY - offsetAY * impulseX) * bodyA.inverseInertia;
                            }
                            if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                bodyB.positionPrev.x -= impulseX * bodyB.inverseMass;
                                bodyB.positionPrev.y -= impulseY * bodyB.inverseMass;
                                bodyB.anglePrev -= (offsetBX * impulseY - offsetBY * impulseX) * bodyB.inverseInertia;
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
*
* @class Pairs
*/ var Pairs = {};
            module1.exports = Pairs;
            var Pair = __webpack_require__(9);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a new pairs structure.
     * @method create
     * @param {object} options
     * @return {pairs} A new pairs structure
     */ Pairs.create = function(options) {
                    return Common.extend({
                        table: {},
                        list: [],
                        collisionStart: [],
                        collisionActive: [],
                        collisionEnd: []
                    }, options);
                };
                /**
     * Updates pairs given a list of collisions.
     * @method update
     * @param {object} pairs
     * @param {collision[]} collisions
     * @param {number} timestamp
     */ Pairs.update = function(pairs, collisions, timestamp) {
                    var pairsList = pairs.list, pairsListLength = pairsList.length, pairsTable = pairs.table, collisionsLength = collisions.length, collisionStart = pairs.collisionStart, collisionEnd = pairs.collisionEnd, collisionActive = pairs.collisionActive, collision, pairIndex, pair, i;
                    // clear collision state arrays, but maintain old reference
                    collisionStart.length = 0;
                    collisionEnd.length = 0;
                    collisionActive.length = 0;
                    for(i = 0; i < pairsListLength; i++)pairsList[i].confirmedActive = false;
                    for(i = 0; i < collisionsLength; i++){
                        collision = collisions[i];
                        pair = collision.pair;
                        if (pair) {
                            // pair already exists (but may or may not be active)
                            if (pair.isActive) // pair exists and is active
                            collisionActive.push(pair);
                            else // pair exists but was inactive, so a collision has just started again
                            collisionStart.push(pair);
                            // update the pair
                            Pair.update(pair, collision, timestamp);
                            pair.confirmedActive = true;
                        } else {
                            // pair did not exist, create a new pair
                            pair = Pair.create(collision, timestamp);
                            pairsTable[pair.id] = pair;
                            // push the new pair
                            collisionStart.push(pair);
                            pairsList.push(pair);
                        }
                    }
                    // find pairs that are no longer active
                    var removePairIndex = [];
                    pairsListLength = pairsList.length;
                    for(i = 0; i < pairsListLength; i++){
                        pair = pairsList[i];
                        if (!pair.confirmedActive) {
                            Pair.setActive(pair, false, timestamp);
                            collisionEnd.push(pair);
                            if (!pair.collision.bodyA.isSleeping && !pair.collision.bodyB.isSleeping) removePairIndex.push(i);
                        }
                    }
                    // remove inactive pairs
                    for(i = 0; i < removePairIndex.length; i++){
                        pairIndex = removePairIndex[i] - i;
                        pair = pairsList[pairIndex];
                        pairsList.splice(pairIndex, 1);
                        delete pairsTable[pair.id];
                    }
                };
                /**
     * Clears the given pairs structure.
     * @method clear
     * @param {pairs} pairs
     * @return {pairs} pairs
     */ Pairs.clear = function(pairs) {
                    pairs.table = {};
                    pairs.list.length = 0;
                    pairs.collisionStart.length = 0;
                    pairs.collisionActive.length = 0;
                    pairs.collisionEnd.length = 0;
                    return pairs;
                };
            })();
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            var Matter = module1.exports = __webpack_require__(22);
            Matter.Axes = __webpack_require__(11);
            Matter.Bodies = __webpack_require__(12);
            Matter.Body = __webpack_require__(6);
            Matter.Bounds = __webpack_require__(1);
            Matter.Collision = __webpack_require__(8);
            Matter.Common = __webpack_require__(0);
            Matter.Composite = __webpack_require__(5);
            Matter.Composites = __webpack_require__(23);
            Matter.Constraint = __webpack_require__(10);
            Matter.Contact = __webpack_require__(17);
            Matter.Detector = __webpack_require__(14);
            Matter.Engine = __webpack_require__(18);
            Matter.Events = __webpack_require__(4);
            Matter.Grid = __webpack_require__(24);
            Matter.Mouse = __webpack_require__(13);
            Matter.MouseConstraint = __webpack_require__(25);
            Matter.Pair = __webpack_require__(9);
            Matter.Pairs = __webpack_require__(20);
            Matter.Plugin = __webpack_require__(15);
            Matter.Query = __webpack_require__(26);
            Matter.Render = __webpack_require__(16);
            Matter.Resolver = __webpack_require__(19);
            Matter.Runner = __webpack_require__(27);
            Matter.SAT = __webpack_require__(28);
            Matter.Sleeping = __webpack_require__(7);
            Matter.Svg = __webpack_require__(29);
            Matter.Vector = __webpack_require__(2);
            Matter.Vertices = __webpack_require__(3);
            Matter.World = __webpack_require__(30);
            // temporary back compatibility
            Matter.Engine.run = Matter.Runner.run;
            Matter.Common.deprecated(Matter.Engine, "run", "Engine.run ➤ use Matter.Runner.run(engine) instead");
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter` module is the top level namespace. It also includes a function for installing plugins on top of the library.
*
* @class Matter
*/ var Matter = {};
            module1.exports = Matter;
            var Plugin = __webpack_require__(15);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * The library name.
     * @property name
     * @readOnly
     * @type {String}
     */ Matter.name = "matter-js";
                /**
     * The library version.
     * @property version
     * @readOnly
     * @type {String}
     */ Matter.version = "0.18.0";
                /**
     * A list of plugin dependencies to be installed. These are normally set and installed through `Matter.use`.
     * Alternatively you may set `Matter.uses` manually and install them by calling `Plugin.use(Matter)`.
     * @property uses
     * @type {Array}
     */ Matter.uses = [];
                /**
     * The plugins that have been installed through `Matter.Plugin.install`. Read only.
     * @property used
     * @readOnly
     * @type {Array}
     */ Matter.used = [];
                /**
     * Installs the given plugins on the `Matter` namespace.
     * This is a short-hand for `Plugin.use`, see it for more information.
     * Call this function once at the start of your code, with all of the plugins you wish to install as arguments.
     * Avoid calling this function multiple times unless you intend to manually control installation order.
     * @method use
     * @param ...plugin {Function} The plugin(s) to install on `base` (multi-argument).
     */ Matter.use = function() {
                    Plugin.use(Matter, Array.prototype.slice.call(arguments));
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method before
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Matter.before = function(path, func) {
                    path = path.replace(/^Matter./, "");
                    return Common.chainPathBefore(Matter, path, func);
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method after
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Matter.after = function(path, func) {
                    path = path.replace(/^Matter./, "");
                    return Common.chainPathAfter(Matter, path, func);
                };
            })();
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Composites` module contains factory methods for creating composite bodies
* with commonly used configurations (such as stacks and chains).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composites
*/ var Composites = {};
            module1.exports = Composites;
            var Composite = __webpack_require__(5);
            var Constraint = __webpack_require__(10);
            var Common = __webpack_require__(0);
            var Body = __webpack_require__(6);
            var Bodies = __webpack_require__(12);
            var deprecated = Common.deprecated;
            (function() {
                /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method stack
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.stack = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composite.create({
                        label: "Stack"
                    }), x = xx, y = yy, lastBody, i = 0;
                    for(var row = 0; row < rows; row++){
                        var maxHeight = 0;
                        for(var column = 0; column < columns; column++){
                            var body = callback(x, y, column, row, lastBody, i);
                            if (body) {
                                var bodyHeight = body.bounds.max.y - body.bounds.min.y, bodyWidth = body.bounds.max.x - body.bounds.min.x;
                                if (bodyHeight > maxHeight) maxHeight = bodyHeight;
                                Body.translate(body, {
                                    x: bodyWidth * 0.5,
                                    y: bodyHeight * 0.5
                                });
                                x = body.bounds.max.x + columnGap;
                                Composite.addBody(stack, body);
                                lastBody = body;
                                i += 1;
                            } else x += columnGap;
                        }
                        y += maxHeight + rowGap;
                        x = xx;
                    }
                    return stack;
                };
                /**
     * Chains all bodies in the given composite together using constraints.
     * @method chain
     * @param {composite} composite
     * @param {number} xOffsetA
     * @param {number} yOffsetA
     * @param {number} xOffsetB
     * @param {number} yOffsetB
     * @param {object} options
     * @return {composite} A new composite containing objects chained together with constraints
     */ Composites.chain = function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                    var bodies = composite.bodies;
                    for(var i = 1; i < bodies.length; i++){
                        var bodyA = bodies[i - 1], bodyB = bodies[i], bodyAHeight = bodyA.bounds.max.y - bodyA.bounds.min.y, bodyAWidth = bodyA.bounds.max.x - bodyA.bounds.min.x, bodyBHeight = bodyB.bounds.max.y - bodyB.bounds.min.y, bodyBWidth = bodyB.bounds.max.x - bodyB.bounds.min.x;
                        var defaults = {
                            bodyA: bodyA,
                            pointA: {
                                x: bodyAWidth * xOffsetA,
                                y: bodyAHeight * yOffsetA
                            },
                            bodyB: bodyB,
                            pointB: {
                                x: bodyBWidth * xOffsetB,
                                y: bodyBHeight * yOffsetB
                            }
                        };
                        var constraint = Common.extend(defaults, options);
                        Composite.addConstraint(composite, Constraint.create(constraint));
                    }
                    composite.label += " Chain";
                    return composite;
                };
                /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     * @method mesh
     * @param {composite} composite
     * @param {number} columns
     * @param {number} rows
     * @param {boolean} crossBrace
     * @param {object} options
     * @return {composite} The composite containing objects meshed together with constraints
     */ Composites.mesh = function(composite, columns, rows, crossBrace, options) {
                    var bodies = composite.bodies, row, col, bodyA, bodyB, bodyC;
                    for(row = 0; row < rows; row++){
                        for(col = 1; col < columns; col++){
                            bodyA = bodies[col - 1 + row * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                        }
                        if (row > 0) for(col = 0; col < columns; col++){
                            bodyA = bodies[col + (row - 1) * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                            if (crossBrace && col > 0) {
                                bodyC = bodies[col - 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                            if (crossBrace && col < columns - 1) {
                                bodyC = bodies[col + 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                        }
                    }
                    composite.label += " Mesh";
                    return composite;
                };
                /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method pyramid
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.pyramid = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
                    return Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y, column, row, lastBody, i) {
                        var actualRows = Math.min(rows, Math.ceil(columns / 2)), lastBodyWidth = lastBody ? lastBody.bounds.max.x - lastBody.bounds.min.x : 0;
                        if (row > actualRows) return;
                        // reverse row order
                        row = actualRows - row;
                        var start = row, end = columns - 1 - row;
                        if (column < start || column > end) return;
                        // retroactively fix the first body's position, since width was unknown
                        if (i === 1) Body.translate(lastBody, {
                            x: (column + (columns % 2 === 1 ? 1 : -1)) * lastBodyWidth,
                            y: 0
                        });
                        var xOffset = lastBody ? column * lastBodyWidth : 0;
                        return callback(xx + xOffset + column * columnGap, y, column, row, lastBody, i);
                    });
                };
                /**
     * This has now moved to the [newtonsCradle example](https://github.com/liabru/matter-js/blob/master/examples/newtonsCradle.js), follow that instead as this function is deprecated here.
     * @deprecated moved to newtonsCradle example
     * @method newtonsCradle
     * @param {number} xx
     * @param {number} yy
     * @param {number} number
     * @param {number} size
     * @param {number} length
     * @return {composite} A new composite newtonsCradle body
     */ Composites.newtonsCradle = function(xx, yy, number, size, length) {
                    var newtonsCradle = Composite.create({
                        label: "Newtons Cradle"
                    });
                    for(var i = 0; i < number; i++){
                        var separation = 1.9, circle = Bodies.circle(xx + i * (size * separation), yy + length, size, {
                            inertia: Infinity,
                            restitution: 1,
                            friction: 0,
                            frictionAir: 0.0001,
                            slop: 1
                        }), constraint = Constraint.create({
                            pointA: {
                                x: xx + i * (size * separation),
                                y: yy
                            },
                            bodyB: circle
                        });
                        Composite.addBody(newtonsCradle, circle);
                        Composite.addConstraint(newtonsCradle, constraint);
                    }
                    return newtonsCradle;
                };
                deprecated(Composites, "newtonsCradle", "Composites.newtonsCradle ➤ moved to newtonsCradle example");
                /**
     * This has now moved to the [car example](https://github.com/liabru/matter-js/blob/master/examples/car.js), follow that instead as this function is deprecated here.
     * @deprecated moved to car example
     * @method car
     * @param {number} xx
     * @param {number} yy
     * @param {number} width
     * @param {number} height
     * @param {number} wheelSize
     * @return {composite} A new composite car body
     */ Composites.car = function(xx, yy, width, height, wheelSize) {
                    var group = Body.nextGroup(true), wheelBase = 20, wheelAOffset = -width * 0.5 + wheelBase, wheelBOffset = width * 0.5 - wheelBase, wheelYOffset = 0;
                    var car = Composite.create({
                        label: "Car"
                    }), body = Bodies.rectangle(xx, yy, width, height, {
                        collisionFilter: {
                            group: group
                        },
                        chamfer: {
                            radius: height * 0.5
                        },
                        density: 0.0002
                    });
                    var wheelA = Bodies.circle(xx + wheelAOffset, yy + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var wheelB = Bodies.circle(xx + wheelBOffset, yy + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var axelA = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelAOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelA,
                        stiffness: 1,
                        length: 0
                    });
                    var axelB = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelBOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelB,
                        stiffness: 1,
                        length: 0
                    });
                    Composite.addBody(car, body);
                    Composite.addBody(car, wheelA);
                    Composite.addBody(car, wheelB);
                    Composite.addConstraint(car, axelA);
                    Composite.addConstraint(car, axelB);
                    return car;
                };
                deprecated(Composites, "car", "Composites.car ➤ moved to car example");
                /**
     * This has now moved to the [softBody example](https://github.com/liabru/matter-js/blob/master/examples/softBody.js)
     * and the [cloth example](https://github.com/liabru/matter-js/blob/master/examples/cloth.js), follow those instead as this function is deprecated here.
     * @deprecated moved to softBody and cloth examples
     * @method softBody
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {boolean} crossBrace
     * @param {number} particleRadius
     * @param {} particleOptions
     * @param {} constraintOptions
     * @return {composite} A new composite softBody
     */ Composites.softBody = function(xx, yy, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                    particleOptions = Common.extend({
                        inertia: Infinity
                    }, particleOptions);
                    constraintOptions = Common.extend({
                        stiffness: 0.2,
                        render: {
                            type: "line",
                            anchors: false
                        }
                    }, constraintOptions);
                    var softBody = Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y) {
                        return Bodies.circle(x, y, particleRadius, particleOptions);
                    });
                    Composites.mesh(softBody, columns, rows, crossBrace, constraintOptions);
                    softBody.label = "Soft Body";
                    return softBody;
                };
                deprecated(Composites, "softBody", "Composites.softBody ➤ moved to softBody and cloth examples");
            })();
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* This module has now been replaced by `Matter.Detector`.
*
* All usage should be migrated to `Matter.Detector` or another alternative.
* For back-compatibility purposes this module will remain for a short term and then later removed in a future release.
*
* The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
*
* @class Grid
* @deprecated
*/ var Grid = {};
            module1.exports = Grid;
            var Pair = __webpack_require__(9);
            var Common = __webpack_require__(0);
            var deprecated = Common.deprecated;
            (function() {
                /**
     * Creates a new grid.
     * @deprecated replaced by Matter.Detector
     * @method create
     * @param {} options
     * @return {grid} A new grid
     */ Grid.create = function(options) {
                    var defaults = {
                        buckets: {},
                        pairs: {},
                        pairsList: [],
                        bucketWidth: 48,
                        bucketHeight: 48
                    };
                    return Common.extend(defaults, options);
                };
                /**
     * The width of a single grid bucket.
     *
     * @property bucketWidth
     * @type number
     * @default 48
     */ /**
     * The height of a single grid bucket.
     *
     * @property bucketHeight
     * @type number
     * @default 48
     */ /**
     * Updates the grid.
     * @deprecated replaced by Matter.Detector
     * @method update
     * @param {grid} grid
     * @param {body[]} bodies
     * @param {engine} engine
     * @param {boolean} forceUpdate
     */ Grid.update = function(grid, bodies, engine, forceUpdate) {
                    var i, col, row, world = engine.world, buckets = grid.buckets, bucket, bucketId, gridChanged = false;
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isSleeping && !forceUpdate) continue;
                        // temporary back compatibility bounds check
                        if (world.bounds && (body.bounds.max.x < world.bounds.min.x || body.bounds.min.x > world.bounds.max.x || body.bounds.max.y < world.bounds.min.y || body.bounds.min.y > world.bounds.max.y)) continue;
                        var newRegion = Grid._getRegion(grid, body);
                        // if the body has changed grid region
                        if (!body.region || newRegion.id !== body.region.id || forceUpdate) {
                            if (!body.region || forceUpdate) body.region = newRegion;
                            var union = Grid._regionUnion(newRegion, body.region);
                            // update grid buckets affected by region change
                            // iterate over the union of both regions
                            for(col = union.startCol; col <= union.endCol; col++)for(row = union.startRow; row <= union.endRow; row++){
                                bucketId = Grid._getBucketId(col, row);
                                bucket = buckets[bucketId];
                                var isInsideNewRegion = col >= newRegion.startCol && col <= newRegion.endCol && row >= newRegion.startRow && row <= newRegion.endRow;
                                var isInsideOldRegion = col >= body.region.startCol && col <= body.region.endCol && row >= body.region.startRow && row <= body.region.endRow;
                                // remove from old region buckets
                                if (!isInsideNewRegion && isInsideOldRegion) {
                                    if (isInsideOldRegion) {
                                        if (bucket) Grid._bucketRemoveBody(grid, bucket, body);
                                    }
                                }
                                // add to new region buckets
                                if (body.region === newRegion || isInsideNewRegion && !isInsideOldRegion || forceUpdate) {
                                    if (!bucket) bucket = Grid._createBucket(buckets, bucketId);
                                    Grid._bucketAddBody(grid, bucket, body);
                                }
                            }
                            // set the new region
                            body.region = newRegion;
                            // flag changes so we can update pairs
                            gridChanged = true;
                        }
                    }
                    // update pairs list only if pairs changed (i.e. a body changed region)
                    if (gridChanged) grid.pairsList = Grid._createActivePairsList(grid);
                };
                deprecated(Grid, "update", "Grid.update ➤ replaced by Matter.Detector");
                /**
     * Clears the grid.
     * @deprecated replaced by Matter.Detector
     * @method clear
     * @param {grid} grid
     */ Grid.clear = function(grid) {
                    grid.buckets = {};
                    grid.pairs = {};
                    grid.pairsList = [];
                };
                deprecated(Grid, "clear", "Grid.clear ➤ replaced by Matter.Detector");
                /**
     * Finds the union of two regions.
     * @method _regionUnion
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} regionA
     * @param {} regionB
     * @return {} region
     */ Grid._regionUnion = function(regionA, regionB) {
                    var startCol = Math.min(regionA.startCol, regionB.startCol), endCol = Math.max(regionA.endCol, regionB.endCol), startRow = Math.min(regionA.startRow, regionB.startRow), endRow = Math.max(regionA.endRow, regionB.endRow);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Gets the region a given body falls in for a given grid.
     * @method _getRegion
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @param {} body
     * @return {} region
     */ Grid._getRegion = function(grid, body) {
                    var bounds = body.bounds, startCol = Math.floor(bounds.min.x / grid.bucketWidth), endCol = Math.floor(bounds.max.x / grid.bucketWidth), startRow = Math.floor(bounds.min.y / grid.bucketHeight), endRow = Math.floor(bounds.max.y / grid.bucketHeight);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Creates a region.
     * @method _createRegion
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} startCol
     * @param {} endCol
     * @param {} startRow
     * @param {} endRow
     * @return {} region
     */ Grid._createRegion = function(startCol, endCol, startRow, endRow) {
                    return {
                        id: startCol + "," + endCol + "," + startRow + "," + endRow,
                        startCol: startCol,
                        endCol: endCol,
                        startRow: startRow,
                        endRow: endRow
                    };
                };
                /**
     * Gets the bucket id at the given position.
     * @method _getBucketId
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} column
     * @param {} row
     * @return {string} bucket id
     */ Grid._getBucketId = function(column, row) {
                    return "C" + column + "R" + row;
                };
                /**
     * Creates a bucket.
     * @method _createBucket
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} buckets
     * @param {} bucketId
     * @return {} bucket
     */ Grid._createBucket = function(buckets, bucketId) {
                    var bucket = buckets[bucketId] = [];
                    return bucket;
                };
                /**
     * Adds a body to a bucket.
     * @method _bucketAddBody
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketAddBody = function(grid, bucket, body) {
                    var gridPairs = grid.pairs, pairId = Pair.id, bucketLength = bucket.length, i;
                    // add new pairs
                    for(i = 0; i < bucketLength; i++){
                        var bodyB = bucket[i];
                        if (body.id === bodyB.id || body.isStatic && bodyB.isStatic) continue;
                        // keep track of the number of buckets the pair exists in
                        // important for Grid.update to work
                        var id = pairId(body, bodyB), pair = gridPairs[id];
                        if (pair) pair[2] += 1;
                        else gridPairs[id] = [
                            body,
                            bodyB,
                            1
                        ];
                    }
                    // add to bodies (after pairs, otherwise pairs with self)
                    bucket.push(body);
                };
                /**
     * Removes a body from a bucket.
     * @method _bucketRemoveBody
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketRemoveBody = function(grid, bucket, body) {
                    var gridPairs = grid.pairs, pairId = Pair.id, i;
                    // remove from bucket
                    bucket.splice(Common.indexOf(bucket, body), 1);
                    var bucketLength = bucket.length;
                    // update pair counts
                    for(i = 0; i < bucketLength; i++){
                        // keep track of the number of buckets the pair exists in
                        // important for _createActivePairsList to work
                        var pair = gridPairs[pairId(body, bucket[i])];
                        if (pair) pair[2] -= 1;
                    }
                };
                /**
     * Generates a list of the active pairs in the grid.
     * @method _createActivePairsList
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @return [] pairs
     */ Grid._createActivePairsList = function(grid) {
                    var pair, gridPairs = grid.pairs, pairKeys = Common.keys(gridPairs), pairKeysLength = pairKeys.length, pairs = [], k;
                    // iterate over grid.pairs
                    for(k = 0; k < pairKeysLength; k++){
                        pair = gridPairs[pairKeys[k]];
                        // if pair exists in at least one bucket
                        // it is a pair that needs further collision testing so push it
                        if (pair[2] > 0) pairs.push(pair);
                        else delete gridPairs[pairKeys[k]];
                    }
                    return pairs;
                };
            })();
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.MouseConstraint` module contains methods for creating mouse constraints.
* Mouse constraints are used for allowing user interaction, providing the ability to move bodies via the mouse or touch.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class MouseConstraint
*/ var MouseConstraint = {};
            module1.exports = MouseConstraint;
            var Vertices = __webpack_require__(3);
            var Sleeping = __webpack_require__(7);
            var Mouse = __webpack_require__(13);
            var Events = __webpack_require__(4);
            var Detector = __webpack_require__(14);
            var Constraint = __webpack_require__(10);
            var Composite = __webpack_require__(5);
            var Common = __webpack_require__(0);
            var Bounds = __webpack_require__(1);
            (function() {
                /**
     * Creates a new mouse constraint.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {engine} engine
     * @param {} options
     * @return {MouseConstraint} A new MouseConstraint
     */ MouseConstraint.create = function(engine, options) {
                    var mouse = (engine ? engine.mouse : null) || (options ? options.mouse : null);
                    if (!mouse) {
                        if (engine && engine.render && engine.render.canvas) mouse = Mouse.create(engine.render.canvas);
                        else if (options && options.element) mouse = Mouse.create(options.element);
                        else {
                            mouse = Mouse.create();
                            Common.warn("MouseConstraint.create: options.mouse was undefined, options.element was undefined, may not function as expected");
                        }
                    }
                    var constraint = Constraint.create({
                        label: "Mouse Constraint",
                        pointA: mouse.position,
                        pointB: {
                            x: 0,
                            y: 0
                        },
                        length: 0.01,
                        stiffness: 0.1,
                        angularStiffness: 1,
                        render: {
                            strokeStyle: "#90EE90",
                            lineWidth: 3
                        }
                    });
                    var defaults = {
                        type: "mouseConstraint",
                        mouse: mouse,
                        element: null,
                        body: null,
                        constraint: constraint,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        }
                    };
                    var mouseConstraint = Common.extend(defaults, options);
                    Events.on(engine, "beforeUpdate", function() {
                        var allBodies = Composite.allBodies(engine.world);
                        MouseConstraint.update(mouseConstraint, allBodies);
                        MouseConstraint._triggerEvents(mouseConstraint);
                    });
                    return mouseConstraint;
                };
                /**
     * Updates the given mouse constraint.
     * @private
     * @method update
     * @param {MouseConstraint} mouseConstraint
     * @param {body[]} bodies
     */ MouseConstraint.update = function(mouseConstraint, bodies) {
                    var mouse = mouseConstraint.mouse, constraint = mouseConstraint.constraint, body = mouseConstraint.body;
                    if (mouse.button === 0) {
                        if (!constraint.bodyB) for(var i = 0; i < bodies.length; i++){
                            body = bodies[i];
                            if (Bounds.contains(body.bounds, mouse.position) && Detector.canCollide(body.collisionFilter, mouseConstraint.collisionFilter)) for(var j = body.parts.length > 1 ? 1 : 0; j < body.parts.length; j++){
                                var part = body.parts[j];
                                if (Vertices.contains(part.vertices, mouse.position)) {
                                    constraint.pointA = mouse.position;
                                    constraint.bodyB = mouseConstraint.body = body;
                                    constraint.pointB = {
                                        x: mouse.position.x - body.position.x,
                                        y: mouse.position.y - body.position.y
                                    };
                                    constraint.angleB = body.angle;
                                    Sleeping.set(body, false);
                                    Events.trigger(mouseConstraint, "startdrag", {
                                        mouse: mouse,
                                        body: body
                                    });
                                    break;
                                }
                            }
                        }
                        else {
                            Sleeping.set(constraint.bodyB, false);
                            constraint.pointA = mouse.position;
                        }
                    } else {
                        constraint.bodyB = mouseConstraint.body = null;
                        constraint.pointB = null;
                        if (body) Events.trigger(mouseConstraint, "enddrag", {
                            mouse: mouse,
                            body: body
                        });
                    }
                };
                /**
     * Triggers mouse constraint events.
     * @method _triggerEvents
     * @private
     * @param {mouse} mouseConstraint
     */ MouseConstraint._triggerEvents = function(mouseConstraint) {
                    var mouse = mouseConstraint.mouse, mouseEvents = mouse.sourceEvents;
                    if (mouseEvents.mousemove) Events.trigger(mouseConstraint, "mousemove", {
                        mouse: mouse
                    });
                    if (mouseEvents.mousedown) Events.trigger(mouseConstraint, "mousedown", {
                        mouse: mouse
                    });
                    if (mouseEvents.mouseup) Events.trigger(mouseConstraint, "mouseup", {
                        mouse: mouse
                    });
                    // reset the mouse state ready for the next step
                    Mouse.clearSourceEvents(mouse);
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when the mouse has moved (or a touch moves) during the last step
    *
    * @event mousemove
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the mouse is down (or a touch has started) during the last step
    *
    * @event mousedown
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the mouse is up (or a touch has ended) during the last step
    *
    * @event mouseup
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the user starts dragging a body
    *
    * @event startdrag
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {body} event.body The body being dragged
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the user ends dragging a body
    *
    * @event enddrag
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {body} event.body The body that has stopped being dragged
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "constraint"
     * @readOnly
     */ /**
     * The `Mouse` instance in use. If not supplied in `MouseConstraint.create`, one will be created.
     *
     * @property mouse
     * @type mouse
     * @default mouse
     */ /**
     * The `Body` that is currently being moved by the user, or `null` if no body.
     *
     * @property body
     * @type body
     * @default null
     */ /**
     * The `Constraint` object that is used to move the body during interaction.
     *
     * @property constraint
     * @type constraint
     */ /**
     * An `Object` that specifies the collision filter properties.
     * The collision filter allows the user to define which types of body this mouse constraint can interact with.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter
     * @type object
     */ })();
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Query` module contains methods for performing collision queries.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Query
*/ var Query = {};
            module1.exports = Query;
            var Vector = __webpack_require__(2);
            var Collision = __webpack_require__(8);
            var Bounds = __webpack_require__(1);
            var Bodies = __webpack_require__(12);
            var Vertices = __webpack_require__(3);
            (function() {
                /**
     * Returns a list of collisions between `body` and `bodies`.
     * @method collides
     * @param {body} body
     * @param {body[]} bodies
     * @return {collision[]} Collisions
     */ Query.collides = function(body, bodies) {
                    var collisions = [], bodiesLength = bodies.length, bounds = body.bounds, collides = Collision.collides, overlaps = Bounds.overlaps;
                    for(var i = 0; i < bodiesLength; i++){
                        var bodyA = bodies[i], partsALength = bodyA.parts.length, partsAStart = partsALength === 1 ? 0 : 1;
                        if (overlaps(bodyA.bounds, bounds)) for(var j = partsAStart; j < partsALength; j++){
                            var part = bodyA.parts[j];
                            if (overlaps(part.bounds, bounds)) {
                                var collision = collides(part, body);
                                if (collision) {
                                    collisions.push(collision);
                                    break;
                                }
                            }
                        }
                    }
                    return collisions;
                };
                /**
     * Casts a ray segment against a set of bodies and returns all collisions, ray width is optional. Intersection points are not provided.
     * @method ray
     * @param {body[]} bodies
     * @param {vector} startPoint
     * @param {vector} endPoint
     * @param {number} [rayWidth]
     * @return {collision[]} Collisions
     */ Query.ray = function(bodies, startPoint, endPoint, rayWidth) {
                    rayWidth = rayWidth || 1e-100;
                    var rayAngle = Vector.angle(startPoint, endPoint), rayLength = Vector.magnitude(Vector.sub(startPoint, endPoint)), rayX = (endPoint.x + startPoint.x) * 0.5, rayY = (endPoint.y + startPoint.y) * 0.5, ray = Bodies.rectangle(rayX, rayY, rayLength, rayWidth, {
                        angle: rayAngle
                    }), collisions = Query.collides(ray, bodies);
                    for(var i = 0; i < collisions.length; i += 1){
                        var collision = collisions[i];
                        collision.body = collision.bodyB = collision.bodyA;
                    }
                    return collisions;
                };
                /**
     * Returns all bodies whose bounds are inside (or outside if set) the given set of bounds, from the given set of bodies.
     * @method region
     * @param {body[]} bodies
     * @param {bounds} bounds
     * @param {bool} [outside=false]
     * @return {body[]} The bodies matching the query
     */ Query.region = function(bodies, bounds, outside) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], overlaps = Bounds.overlaps(body.bounds, bounds);
                        if (overlaps && !outside || !overlaps && outside) result.push(body);
                    }
                    return result;
                };
                /**
     * Returns all bodies whose vertices contain the given point, from the given set of bodies.
     * @method point
     * @param {body[]} bodies
     * @param {vector} point
     * @return {body[]} The bodies matching the query
     */ Query.point = function(bodies, point) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (Bounds.contains(body.bounds, point)) for(var j = body.parts.length === 1 ? 0 : 1; j < body.parts.length; j++){
                            var part = body.parts[j];
                            if (Bounds.contains(part.bounds, point) && Vertices.contains(part.vertices, point)) {
                                result.push(body);
                                break;
                            }
                        }
                    }
                    return result;
                };
            })();
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Runner` module is an optional utility which provides a game loop, 
* that handles continuously updating a `Matter.Engine` for you within a browser.
* It is intended for development and debugging purposes, but may also be suitable for simple games.
* If you are using your own game loop instead, then you do not need the `Matter.Runner` module.
* Instead just call `Engine.update(engine, delta)` in your own loop.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Runner
*/ var Runner = {};
            module1.exports = Runner;
            var Events = __webpack_require__(4);
            var Engine = __webpack_require__(18);
            var Common = __webpack_require__(0);
            (function() {
                var _requestAnimationFrame, _cancelAnimationFrame;
                if (typeof window !== "undefined") {
                    _requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame;
                    _cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame;
                }
                if (!_requestAnimationFrame) {
                    var _frameTimeout;
                    _requestAnimationFrame = function(callback) {
                        _frameTimeout = setTimeout(function() {
                            callback(Common.now());
                        }, 1000 / 60);
                    };
                    _cancelAnimationFrame = function() {
                        clearTimeout(_frameTimeout);
                    };
                }
                /**
     * Creates a new Runner. The options parameter is an object that specifies any properties you wish to override the defaults.
     * @method create
     * @param {} options
     */ Runner.create = function(options) {
                    var defaults = {
                        fps: 60,
                        correction: 1,
                        deltaSampleSize: 60,
                        counterTimestamp: 0,
                        frameCounter: 0,
                        deltaHistory: [],
                        timePrev: null,
                        timeScalePrev: 1,
                        frameRequestId: null,
                        isFixed: false,
                        enabled: true
                    };
                    var runner = Common.extend(defaults, options);
                    runner.delta = runner.delta || 1000 / runner.fps;
                    runner.deltaMin = runner.deltaMin || 1000 / runner.fps;
                    runner.deltaMax = runner.deltaMax || 1000 / (runner.fps * 0.5);
                    runner.fps = 1000 / runner.delta;
                    return runner;
                };
                /**
     * Continuously ticks a `Matter.Engine` by calling `Runner.tick` on the `requestAnimationFrame` event.
     * @method run
     * @param {engine} engine
     */ Runner.run = function(runner, engine) {
                    // create runner if engine is first argument
                    if (typeof runner.positionIterations !== "undefined") {
                        engine = runner;
                        runner = Runner.create();
                    }
                    (function render(time) {
                        runner.frameRequestId = _requestAnimationFrame(render);
                        if (time && runner.enabled) Runner.tick(runner, engine, time);
                    })();
                    return runner;
                };
                /**
     * A game loop utility that updates the engine and renderer by one step (a 'tick').
     * Features delta smoothing, time correction and fixed or dynamic timing.
     * Consider just `Engine.update(engine, delta)` if you're using your own loop.
     * @method tick
     * @param {runner} runner
     * @param {engine} engine
     * @param {number} time
     */ Runner.tick = function(runner, engine, time) {
                    var timing = engine.timing, correction = 1, delta;
                    // create an event object
                    var event = {
                        timestamp: timing.timestamp
                    };
                    Events.trigger(runner, "beforeTick", event);
                    if (runner.isFixed) // fixed timestep
                    delta = runner.delta;
                    else {
                        // dynamic timestep based on wall clock between calls
                        delta = time - runner.timePrev || runner.delta;
                        runner.timePrev = time;
                        // optimistically filter delta over a few frames, to improve stability
                        runner.deltaHistory.push(delta);
                        runner.deltaHistory = runner.deltaHistory.slice(-runner.deltaSampleSize);
                        delta = Math.min.apply(null, runner.deltaHistory);
                        // limit delta
                        delta = delta < runner.deltaMin ? runner.deltaMin : delta;
                        delta = delta > runner.deltaMax ? runner.deltaMax : delta;
                        // correction for delta
                        correction = delta / runner.delta;
                        // update engine timing object
                        runner.delta = delta;
                    }
                    // time correction for time scaling
                    if (runner.timeScalePrev !== 0) correction *= timing.timeScale / runner.timeScalePrev;
                    if (timing.timeScale === 0) correction = 0;
                    runner.timeScalePrev = timing.timeScale;
                    runner.correction = correction;
                    // fps counter
                    runner.frameCounter += 1;
                    if (time - runner.counterTimestamp >= 1000) {
                        runner.fps = runner.frameCounter * ((time - runner.counterTimestamp) / 1000);
                        runner.counterTimestamp = time;
                        runner.frameCounter = 0;
                    }
                    Events.trigger(runner, "tick", event);
                    // update
                    Events.trigger(runner, "beforeUpdate", event);
                    Engine.update(engine, delta, correction);
                    Events.trigger(runner, "afterUpdate", event);
                    Events.trigger(runner, "afterTick", event);
                };
                /**
     * Ends execution of `Runner.run` on the given `runner`, by canceling the animation frame request event loop.
     * If you wish to only temporarily pause the engine, see `engine.enabled` instead.
     * @method stop
     * @param {runner} runner
     */ Runner.stop = function(runner) {
                    _cancelAnimationFrame(runner.frameRequestId);
                };
                /**
     * Alias for `Runner.run`.
     * @method start
     * @param {runner} runner
     * @param {engine} engine
     */ Runner.start = function(runner, engine) {
                    Runner.run(runner, engine);
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired at the start of a tick, before any updates to the engine or timing
    *
    * @event beforeTick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine timing updated, but just before update
    *
    * @event tick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired at the end of a tick, after engine update and after rendering
    *
    * @event afterTick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired before update
    *
    * @event beforeUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after update
    *
    * @event afterUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * A flag that specifies whether the runner is running or not.
     *
     * @property enabled
     * @type boolean
     * @default true
     */ /**
     * A `Boolean` that specifies if the runner should use a fixed timestep (otherwise it is variable).
     * If timing is fixed, then the apparent simulation speed will change depending on the frame rate (but behaviour will be deterministic).
     * If the timing is variable, then the apparent simulation speed will be constant (approximately, but at the cost of determininism).
     *
     * @property isFixed
     * @type boolean
     * @default false
     */ /**
     * A `Number` that specifies the time step between updates in milliseconds.
     * If `engine.timing.isFixed` is set to `true`, then `delta` is fixed.
     * If it is `false`, then `delta` can dynamically change to maintain the correct apparent simulation speed.
     *
     * @property delta
     * @type number
     * @default 1000 / 60
     */ })();
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* This module has now been replaced by `Matter.Collision`.
*
* All usage should be migrated to `Matter.Collision`.
* For back-compatibility purposes this module will remain for a short term and then later removed in a future release.
*
* The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
*
* @class SAT
* @deprecated
*/ var SAT = {};
            module1.exports = SAT;
            var Collision = __webpack_require__(8);
            var Common = __webpack_require__(0);
            var deprecated = Common.deprecated;
            (function() {
                /**
     * Detect collision between two bodies using the Separating Axis Theorem.
     * @deprecated replaced by Collision.collides
     * @method collides
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {collision} collision
     */ SAT.collides = function(bodyA, bodyB) {
                    return Collision.collides(bodyA, bodyB);
                };
                deprecated(SAT, "collides", "SAT.collides ➤ replaced by Collision.collides");
            })();
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
*
* To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Svg
*/ var Svg = {};
            module1.exports = Svg;
            var Bounds = __webpack_require__(1);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Converts an SVG path into an array of vector points.
     * If the input path forms a concave shape, you must decompose the result into convex parts before use.
     * See `Bodies.fromVertices` which provides support for this.
     * Note that this function is not guaranteed to support complex paths (such as those with holes).
     * You must load the `pathseg.js` polyfill on newer browsers.
     * @method pathToVertices
     * @param {SVGPathElement} path
     * @param {Number} [sampleLength=15]
     * @return {Vector[]} points
     */ Svg.pathToVertices = function(path, sampleLength) {
                    if (typeof window !== "undefined" && !("SVGPathSeg" in window)) Common.warn("Svg.pathToVertices: SVGPathSeg not defined, a polyfill is required.");
                    // https://github.com/wout/svg.topoly.js/blob/master/svg.topoly.js
                    var i, il, total, point, segment, segments, segmentsQueue, lastSegment, lastPoint, segmentIndex, points = [], lx, ly, length = 0, x = 0, y = 0;
                    sampleLength = sampleLength || 15;
                    var addPoint = function(px, py, pathSegType) {
                        // all odd-numbered path types are relative except PATHSEG_CLOSEPATH (1)
                        var isRelative = pathSegType % 2 === 1 && pathSegType > 1;
                        // when the last point doesn't equal the current point add the current point
                        if (!lastPoint || px != lastPoint.x || py != lastPoint.y) {
                            if (lastPoint && isRelative) {
                                lx = lastPoint.x;
                                ly = lastPoint.y;
                            } else {
                                lx = 0;
                                ly = 0;
                            }
                            var point = {
                                x: lx + px,
                                y: ly + py
                            };
                            // set last point
                            if (isRelative || !lastPoint) lastPoint = point;
                            points.push(point);
                            x = lx + px;
                            y = ly + py;
                        }
                    };
                    var addSegmentPoint = function(segment) {
                        var segType = segment.pathSegTypeAsLetter.toUpperCase();
                        // skip path ends
                        if (segType === "Z") return;
                        // map segment to x and y
                        switch(segType){
                            case "M":
                            case "L":
                            case "T":
                            case "C":
                            case "S":
                            case "Q":
                                x = segment.x;
                                y = segment.y;
                                break;
                            case "H":
                                x = segment.x;
                                break;
                            case "V":
                                y = segment.y;
                                break;
                        }
                        addPoint(x, y, segment.pathSegType);
                    };
                    // ensure path is absolute
                    Svg._svgPathToAbsolute(path);
                    // get total length
                    total = path.getTotalLength();
                    // queue segments
                    segments = [];
                    for(i = 0; i < path.pathSegList.numberOfItems; i += 1)segments.push(path.pathSegList.getItem(i));
                    segmentsQueue = segments.concat();
                    // sample through path
                    while(length < total){
                        // get segment at position
                        segmentIndex = path.getPathSegAtLength(length);
                        segment = segments[segmentIndex];
                        // new segment
                        if (segment != lastSegment) {
                            while(segmentsQueue.length && segmentsQueue[0] != segment)addSegmentPoint(segmentsQueue.shift());
                            lastSegment = segment;
                        }
                        // add points in between when curving
                        // TODO: adaptive sampling
                        switch(segment.pathSegTypeAsLetter.toUpperCase()){
                            case "C":
                            case "T":
                            case "S":
                            case "Q":
                            case "A":
                                point = path.getPointAtLength(length);
                                addPoint(point.x, point.y, 0);
                                break;
                        }
                        // increment by sample value
                        length += sampleLength;
                    }
                    // add remaining segments not passed by sampling
                    for(i = 0, il = segmentsQueue.length; i < il; ++i)addSegmentPoint(segmentsQueue[i]);
                    return points;
                };
                Svg._svgPathToAbsolute = function(path) {
                    // http://phrogz.net/convert-svg-path-to-all-absolute-commands
                    // Copyright (c) Gavin Kistner
                    // http://phrogz.net/js/_ReuseLicense.txt
                    // Modifications: tidy formatting and naming
                    var x0, y0, x1, y1, x2, y2, segs = path.pathSegList, x = 0, y = 0, len = segs.numberOfItems;
                    for(var i = 0; i < len; ++i){
                        var seg = segs.getItem(i), segType = seg.pathSegTypeAsLetter;
                        if (/[MLHVCSQTA]/.test(segType)) {
                            if ("x" in seg) x = seg.x;
                            if ("y" in seg) y = seg.y;
                        } else {
                            if ("x1" in seg) x1 = x + seg.x1;
                            if ("x2" in seg) x2 = x + seg.x2;
                            if ("y1" in seg) y1 = y + seg.y1;
                            if ("y2" in seg) y2 = y + seg.y2;
                            if ("x" in seg) x += seg.x;
                            if ("y" in seg) y += seg.y;
                            switch(segType){
                                case "m":
                                    segs.replaceItem(path.createSVGPathSegMovetoAbs(x, y), i);
                                    break;
                                case "l":
                                    segs.replaceItem(path.createSVGPathSegLinetoAbs(x, y), i);
                                    break;
                                case "h":
                                    segs.replaceItem(path.createSVGPathSegLinetoHorizontalAbs(x), i);
                                    break;
                                case "v":
                                    segs.replaceItem(path.createSVGPathSegLinetoVerticalAbs(y), i);
                                    break;
                                case "c":
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2, y2), i);
                                    break;
                                case "s":
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicSmoothAbs(x, y, x2, y2), i);
                                    break;
                                case "q":
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticAbs(x, y, x1, y1), i);
                                    break;
                                case "t":
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticSmoothAbs(x, y), i);
                                    break;
                                case "a":
                                    segs.replaceItem(path.createSVGPathSegArcAbs(x, y, seg.r1, seg.r2, seg.angle, seg.largeArcFlag, seg.sweepFlag), i);
                                    break;
                                case "z":
                                case "Z":
                                    x = x0;
                                    y = y0;
                                    break;
                            }
                        }
                        if (segType == "M" || segType == "m") {
                            x0 = x;
                            y0 = y;
                        }
                    }
                };
            })();
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* This module has now been replaced by `Matter.Composite`.
*
* All usage should be migrated to the equivalent functions found on `Matter.Composite`.
* For example `World.add(world, body)` now becomes `Composite.add(world, body)`.
*
* The property `world.gravity` has been moved to `engine.gravity`.
*
* For back-compatibility purposes this module will remain as a direct alias to `Matter.Composite` in the short term during migration.
* Eventually this alias module will be marked as deprecated and then later removed in a future release.
*
* @class World
*/ var World = {};
            module1.exports = World;
            var Composite = __webpack_require__(5);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * See above, aliases for back compatibility only
     */ World.create = Composite.create;
                World.add = Composite.add;
                World.remove = Composite.remove;
                World.clear = Composite.clear;
                World.addComposite = Composite.addComposite;
                World.addBody = Composite.addBody;
                World.addConstraint = Composite.addConstraint;
            })();
        /***/ }
    ]);
});

});

parcelRequire.register("68TBk", function(module, exports) {

$parcel$export(module.exports, "Utils", function () { return $478e9ea83339f717$export$d2ca453b913dcdea; });
class $478e9ea83339f717$export$d2ca453b913dcdea {
    /**
	 * Generate random integer based on passed minimum and maximum values
	 *
	 * @param {int} min Minimum value
	 * @param {int} max Maximum value
	 *
	 * @return {int}
	 */ static generateRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    /**
	 * Randomize order of elements in array
	 *
	 * @see https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
	 *
	 * @param {array} target Array to randomize
	 * @return {array}
	 */ static shuffleArray(target) {
        let currentIndex = target.length;
        let randomIndex;
        while(0 !== currentIndex){
            randomIndex = Math.floor(Math.random() * currentIndex);
            // eslint-disable-next-line no-plusplus
            currentIndex--;
            // eslint-disable-next-line no-param-reassign
            [target[currentIndex], target[randomIndex]] = [
                target[randomIndex],
                target[currentIndex]
            ];
        }
        return target;
    }
}

});



parcelRequire.register("a2T1Q", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $7504c6dd85eba060$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $7504c6dd85eba060$var$_hoisted_1 = {
    ref: "nodeMixCompContainer",
    class: "mix-composition"
};
const $7504c6dd85eba060$var$_hoisted_2 = [
    "data-color-data"
];
function $7504c6dd85eba060$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", $7504c6dd85eba060$var$_hoisted_1, [
        (0, $aoXob.createElementVNode)("canvas", {
            ref: "nodeMixCompCanvas",
            class: "mix-composition__canvas",
            "data-color-data": JSON.stringify($setup.colorsForMixComp)
        }, null, 8, $7504c6dd85eba060$var$_hoisted_2)
    ], 512);
}

});

parcelRequire.register("8kSFh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $611a98451be4c81c$export$2e2bcd8739ae039; });
let $611a98451be4c81c$var$NOOP = ()=>{};
var $611a98451be4c81c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("88X7R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5edcef3f3c96635c$export$2e2bcd8739ae039; });
let $5edcef3f3c96635c$var$script;




let $5edcef3f3c96635c$var$initialize = ()=>{
    $5edcef3f3c96635c$var$script = (parcelRequire("23LxU"));
    if ($5edcef3f3c96635c$var$script.__esModule) $5edcef3f3c96635c$var$script = $5edcef3f3c96635c$var$script.default;
    $5edcef3f3c96635c$var$script.render = (parcelRequire("c5Ge5")).render;
    $5edcef3f3c96635c$var$script.__cssModules = {};
    (parcelRequire("js2KX")).default($5edcef3f3c96635c$var$script);
    $5edcef3f3c96635c$var$script.__scopeId = "data-v-5e2543";
    $5edcef3f3c96635c$var$script.__file = "AllBreakouts.vue";
};
$5edcef3f3c96635c$var$initialize();
var $5edcef3f3c96635c$export$2e2bcd8739ae039 = $5edcef3f3c96635c$var$script;

});
parcelRequire.register("23LxU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1800be3938f486d9$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");

var $2jXZo = parcelRequire("2jXZo");

var $ctEFj = parcelRequire("ctEFj");
var $1800be3938f486d9$export$2e2bcd8739ae039 = {
    __name: "AllBreakouts",
    props: {
        activeColors: {
            type: Array,
            required: true
        },
        selectedColors: {
            type: Array,
            required: true
        },
        flyoutInstructions: {
            type: String,
            default: ""
        }
    },
    emits: [
        "breakout:update:percentage",
        "breakout:select:color",
        "breakout:change:color",
        "breakout:trash",
        "breakouts:percentages:equalize",
        "breakouts:view:mixer"
    ],
    setup (__props, { expose: __expose, emit: emit }) {
        __expose();
        const props = __props;
        // eslint-disable-next-line arrow-body-style
        const selectableColors = (0, $aoXob.computed)(()=>{
            return props.activeColors.filter((color)=>!color.selected);
        });
        // eslint-disable-next-line arrow-body-style
        const canAddBreakouts = (0, $aoXob.computed)(()=>{
            return 4 > props.selectedColors.length;
        });
        // eslint-disable-next-line arrow-body-style
        const totalColorPercentage = (0, $aoXob.computed)(()=>{
            return props.selectedColors.reduce((total, breakout)=>total + breakout.percentage, 0);
        });
        const showPercentageTotalWarning = (0, $aoXob.computed)(()=>{
            if (100 === totalColorPercentage.value) return false;
            if (3 === props.selectedColors.length && 99 === totalColorPercentage.value) return false;
            return true;
        });
        /**
 * Calculate if breakout can be trashed depending on certain conditions
 *
 * @param {number} index
 * @return {bool} True, if can trash
 */ const canTrashBreakout = (index)=>{
            // if only one color, can't trash
            if (1 === props.selectedColors.length && 0 === index) return false;
            return true;
        };
        /**
 * Calculate if breakout slider should be frozen/non-interactive
 *
 * @return {number}
 */ const calculateSliderSteps = ()=>{
            if (2 === props.selectedColors.length || 4 === props.selectedColors.length) return 5;
            return 1;
        };
        /**
 * Calculate slider steps based on breakout count
 *
 * @param {number} index
 * @return {bool} True, if should be frozen
 */ // eslint-disable-next-line arrow-body-style
        const freezeSlider = (index)=>{
            return 1 === props.selectedColors.length && 0 === index;
        };
        /**
 * Handle when user changes percentage for breakout
 *
 * @param {number} colorId
 * @param {number} percentage
 *
 * @return {void}
 */ const handleBreakoutPercentageChange = (colorId, percentage)=>{
            emit("breakout:update:percentage", colorId, percentage);
        };
        /**
 * Handle user clearing breakout
 *
 * @param {number} colorId
 * @return {void}
 */ const handleTrashBreakout = (colorId)=>{
            emit("breakout:trash", colorId);
        };
        /**
 * Handle when user adds additional breakouts
 *
 * @param {number} colorId
 * @return {void}
 */ const handleSelectColorForBreakout = (colorId)=>{
            if (!colorId) return;
            // confirm color isn't already selected
            if (props.selectedColors.find((color)=>color.id === colorId)) return;
            // confirm we can add new breakout
            if (3 < props.selectedColors.length) return;
            emit("breakout:select:color", colorId);
        };
        /**
 * Handle user clicking "Equalize" link/button
 *
 * @param {event} e
 * @return {void}
 */ const handleClickEqualize = (e)=>{
            e.preventDefault();
            emit("breakouts:percentages:equalize");
        };
        /**
 * Handle user selecting different color for (already active) breakout
 *
 * @param {number} newColorId
 * @param {number} placementIndex
 * @param {number} percentage
 * @param {number} oldColorId
 *
 * @return {void}
 */ const handleBreakoutChangeColor = (newColorId, placementIndex, percentage, oldColorId)=>{
            emit("breakout:change:color", newColorId, placementIndex, percentage, oldColorId);
        };
        const __returned__ = {
            props: props,
            emit: emit,
            selectableColors: selectableColors,
            canAddBreakouts: canAddBreakouts,
            totalColorPercentage: totalColorPercentage,
            showPercentageTotalWarning: showPercentageTotalWarning,
            canTrashBreakout: canTrashBreakout,
            calculateSliderSteps: calculateSliderSteps,
            freezeSlider: freezeSlider,
            handleBreakoutPercentageChange: handleBreakoutPercentageChange,
            handleTrashBreakout: handleTrashBreakout,
            handleSelectColorForBreakout: handleSelectColorForBreakout,
            handleClickEqualize: handleClickEqualize,
            handleBreakoutChangeColor: handleBreakoutChangeColor,
            computed: $aoXob.computed,
            AddBreakout: $2jXZo.default,
            ColorBreakout: $ctEFj.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRequire.register("2jXZo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b0be3bba287d50c$export$2e2bcd8739ae039; });
let $1b0be3bba287d50c$var$script;




let $1b0be3bba287d50c$var$initialize = ()=>{
    $1b0be3bba287d50c$var$script = (parcelRequire("dq68X"));
    if ($1b0be3bba287d50c$var$script.__esModule) $1b0be3bba287d50c$var$script = $1b0be3bba287d50c$var$script.default;
    $1b0be3bba287d50c$var$script.render = (parcelRequire("9Fxcq")).render;
    $1b0be3bba287d50c$var$script.__cssModules = {};
    (parcelRequire("arxQs")).default($1b0be3bba287d50c$var$script);
    $1b0be3bba287d50c$var$script.__scopeId = "data-v-c7e31f";
    $1b0be3bba287d50c$var$script.__file = "AddBreakout.vue";
};
$1b0be3bba287d50c$var$initialize();
var $1b0be3bba287d50c$export$2e2bcd8739ae039 = $1b0be3bba287d50c$var$script;

});
parcelRequire.register("dq68X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9c527806b8566594$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $94VKa = parcelRequire("94VKa");
var $aoXob = parcelRequire("aoXob");

var $4b4s6 = parcelRequire("4b4s6");

var $3gKlO = parcelRequire("3gKlO");
var $9c527806b8566594$export$2e2bcd8739ae039 = {
    __name: "AddBreakout",
    props: {
        selectableColors: {
            type: Array,
            required: true
        },
        flyoutInstructions: {
            type: String,
            default: ""
        }
    },
    emits: [
        "select:color"
    ],
    setup (__props, { expose: __expose, emit: emit }) {
        __expose();
        const props = __props;
        const showFlyout = (0, $94VKa.ref)(false);
        /**
 * Open flyout for color selection
 *
 * @return {void}
 */ const openFlyout = ()=>{
            showFlyout.value = true;
        };
        /**
 * Close flyout
 *
 * @return {void}
 */ const closeFlyout = ()=>{
            showFlyout.value = false;
        };
        /**
 * Handle user selecting color from flyout
 *
 * @todo validate that color ID isn't already selected
 *
 * @param {number} colorId
 * @return {void}
 */ const handleSelectColor = (colorId)=>{
            emit("select:color", colorId);
            closeFlyout();
        };
        const __returned__ = {
            props: props,
            emit: emit,
            showFlyout: showFlyout,
            openFlyout: openFlyout,
            closeFlyout: closeFlyout,
            handleSelectColor: handleSelectColor,
            computed: $aoXob.computed,
            ref: $94VKa.ref,
            ColorFlyout: $4b4s6.default,
            CircleColorBtn: $3gKlO.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRequire.register("4b4s6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30aba4a6388e5c90$export$2e2bcd8739ae039; });
let $30aba4a6388e5c90$var$script;




let $30aba4a6388e5c90$var$initialize = ()=>{
    $30aba4a6388e5c90$var$script = (parcelRequire("9Yf98"));
    if ($30aba4a6388e5c90$var$script.__esModule) $30aba4a6388e5c90$var$script = $30aba4a6388e5c90$var$script.default;
    $30aba4a6388e5c90$var$script.render = (parcelRequire("fstOU")).render;
    $30aba4a6388e5c90$var$script.__cssModules = {};
    (parcelRequire("hPuUl")).default($30aba4a6388e5c90$var$script);
    $30aba4a6388e5c90$var$script.__scopeId = "data-v-a883e7";
    $30aba4a6388e5c90$var$script.__file = "ColorFlyout.vue";
};
$30aba4a6388e5c90$var$initialize();
var $30aba4a6388e5c90$export$2e2bcd8739ae039 = $30aba4a6388e5c90$var$script;

});
parcelRequire.register("9Yf98", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7425776c7808b7e4$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $94VKa = parcelRequire("94VKa");
var $aoXob = parcelRequire("aoXob");

var $3gKlO = parcelRequire("3gKlO");
var $7425776c7808b7e4$export$2e2bcd8739ae039 = {
    __name: "ColorFlyout",
    props: {
        colorData: {
            type: Array,
            required: true
        },
        text: {
            type: String,
            default: ""
        }
    },
    emits: [
        "select:color",
        "close:flyout"
    ],
    setup (__props, { expose: __expose, emit: emit }) {
        __expose();
        const props = __props;
        const nodeFlyoutContainer = (0, $94VKa.ref)(null);
        /**
 * Close flyout if user clicks "escape"
 *
 * @param {event} e
 * @return {void}
 */ const handleKeyPress = (e)=>{
            if ("Escape" === e.key) emit("close:flyout");
        };
        /**
 * Close flyout if user clicks outside of flyout
 *
 * @param {event} e
 * @return {void}
 */ const handleClick = (e)=>{
            const { target: target } = e;
            if (target.classList.contains("flyout-container")) emit("close:flyout");
        };
        (0, $aoXob.onMounted)(()=>{
            document.querySelector("html").classList.add("is-fixed");
            document.addEventListener("click", handleClick);
            document.addEventListener("keydown", handleKeyPress, {
                once: true
            });
        });
        (0, $aoXob.onBeforeUnmount)(()=>{
            document.querySelector("html").classList.remove("is-fixed");
            document.removeEventListener("click", handleClick);
            document.removeEventListener("keydown", handleKeyPress);
        });
        const __returned__ = {
            props: props,
            emit: emit,
            nodeFlyoutContainer: nodeFlyoutContainer,
            handleKeyPress: handleKeyPress,
            handleClick: handleClick,
            onBeforeUnmount: $aoXob.onBeforeUnmount,
            onMounted: $aoXob.onMounted,
            ref: $94VKa.ref,
            CircleColorBtn: $3gKlO.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRequire.register("3gKlO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2616d20737ef29e4$export$2e2bcd8739ae039; });
let $2616d20737ef29e4$var$script;




let $2616d20737ef29e4$var$initialize = ()=>{
    $2616d20737ef29e4$var$script = (parcelRequire("2Oc5R"));
    if ($2616d20737ef29e4$var$script.__esModule) $2616d20737ef29e4$var$script = $2616d20737ef29e4$var$script.default;
    $2616d20737ef29e4$var$script.render = (parcelRequire("dsZFY")).render;
    $2616d20737ef29e4$var$script.__cssModules = {};
    (parcelRequire("2stt4")).default($2616d20737ef29e4$var$script);
    $2616d20737ef29e4$var$script.__scopeId = "data-v-a9ebb2";
    $2616d20737ef29e4$var$script.__file = "CircleColorBtn.vue";
};
$2616d20737ef29e4$var$initialize();
var $2616d20737ef29e4$export$2e2bcd8739ae039 = $2616d20737ef29e4$var$script;

});
parcelRequire.register("2Oc5R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $20b9a1cf6db92269$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $94VKa = parcelRequire("94VKa");
var $aoXob = parcelRequire("aoXob");

var $20b9a1cf6db92269$export$2e2bcd8739ae039 = {
    __name: "CircleColorBtn",
    props: {
        label: {
            type: String,
            required: true
        },
        image: {
            type: String,
            default: ""
        },
        persistentIcon: {
            type: String,
            default: ""
        },
        iconTooltip: {
            type: String,
            default: ""
        }
    },
    emits: [
        "btn:click"
    ],
    setup (__props, { expose: __expose, emit: emit }) {
        __expose();
        const props = __props;
        const imageHasLoaded = (0, $94VKa.ref)(false);
        const nodeBtn = (0, $94VKa.ref)(null);
        const nodeBtnIcon = (0, $94VKa.ref)(null);
        let btnIconTippy = null;
        /**
 * Handle image load
 *
 * @todo Add loading animation to "smooth" component load?
 *
 * @return {void}
 */ const handleBtnImageLoad = ()=>{
            imageHasLoaded.value = true;
        };
        (0, $aoXob.onMounted)(()=>{
            if (props.iconTooltip) (parcelRequire("2ZWVn")).then((tippy)=>{
                btnIconTippy = tippy.default(nodeBtnIcon.value, {
                    content: props.iconTooltip,
                    placement: "top"
                });
                nodeBtn.value.addEventListener("mouseenter", btnIconTippy.show);
                nodeBtn.value.addEventListener("mouseleave", btnIconTippy.hide);
            });
        });
        (0, $aoXob.onUnmounted)(()=>{
            if (btnIconTippy) btnIconTippy.destroy();
        });
        const __returned__ = {
            props: props,
            emit: emit,
            imageHasLoaded: imageHasLoaded,
            nodeBtn: nodeBtn,
            nodeBtnIcon: nodeBtnIcon,
            get btnIconTippy () {
                return btnIconTippy;
            },
            set btnIconTippy (v){
                btnIconTippy = v;
            },
            handleBtnImageLoad: handleBtnImageLoad,
            onMounted: $aoXob.onMounted,
            onUnmounted: $aoXob.onUnmounted,
            ref: $94VKa.ref
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRequire.register("2ZWVn", function(module, exports) {



module.exports = (parcelRequire("a0MnV"))((parcelRequire("3VV9c")).getBundleURL("8E1Vu") + (parcelRequire("d8HMG")).resolve("7XKT1")).then(()=>parcelRequire("gv1b9"));

});
parcelRequire.register("a0MnV", function(module, exports) {
"use strict";

var $ixYzc = parcelRequire("ixYzc");
module.exports = $ixYzc(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("ixYzc", function(module, exports) {
"use strict";
var $d80a4a5444370561$var$cachedBundles = {};
var $d80a4a5444370561$var$cachedPreloads = {};
var $d80a4a5444370561$var$cachedPrefetches = {};
function $d80a4a5444370561$var$getCache(type) {
    switch(type){
        case "preload":
            return $d80a4a5444370561$var$cachedPreloads;
        case "prefetch":
            return $d80a4a5444370561$var$cachedPrefetches;
        default:
            return $d80a4a5444370561$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $d80a4a5444370561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});



parcelRequire.register("dsZFY", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9cddbb6f76b60f7a$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
var $eGzkv = parcelRequire("eGzkv");
const $9cddbb6f76b60f7a$var$_hoisted_1 = {
    class: "circle-color"
};
const $9cddbb6f76b60f7a$var$_hoisted_2 = {
    ref: "nodeBtnIcon",
    class: "circle-color__btn__icon"
};
const $9cddbb6f76b60f7a$var$_hoisted_3 = [
    "src",
    "alt"
];
const $9cddbb6f76b60f7a$var$_hoisted_4 = {
    class: "circle-color__label"
};
function $9cddbb6f76b60f7a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", $9cddbb6f76b60f7a$var$_hoisted_1, [
        (0, $aoXob.createElementVNode)("button", {
            ref: "nodeBtn",
            class: (0, $eGzkv.normalizeClass)([
                "circle-color__btn",
                {
                    "circle-color__btn--show-icon": "1" === $props.persistentIcon
                }
            ]),
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.emit("btn:click"))
        }, [
            (0, $aoXob.createElementVNode)("div", $9cddbb6f76b60f7a$var$_hoisted_2, [
                (0, $aoXob.renderSlot)(_ctx.$slots, "icon")
            ], 512),
            $props.image ? ((0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("img", {
                key: 0,
                class: (0, $eGzkv.normalizeClass)([
                    {
                        "has-loaded": $setup.imageHasLoaded
                    },
                    "circle-color__btn__img"
                ]),
                src: $props.image,
                alt: $props.label,
                onLoad: $setup.handleBtnImageLoad
            }, null, 42, $9cddbb6f76b60f7a$var$_hoisted_3)) : (0, $aoXob.createCommentVNode)("", true)
        ], 2),
        (0, $aoXob.createElementVNode)("div", $9cddbb6f76b60f7a$var$_hoisted_4, (0, $eGzkv.toDisplayString)($props.label), 1)
    ]);
}

});

parcelRequire.register("2stt4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca50dfa4c8fe64b$export$2e2bcd8739ae039; });
let $1ca50dfa4c8fe64b$var$NOOP = ()=>{};
var $1ca50dfa4c8fe64b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("fstOU", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b4109a359772f0a8$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $b4109a359772f0a8$var$_hoisted_1 = {
    ref: "nodeFlyoutContainer",
    class: "flyout-container"
};
const $b4109a359772f0a8$var$_hoisted_2 = {
    class: "flyout"
};
const $b4109a359772f0a8$var$_hoisted_3 = [
    "innerHTML"
];
const $b4109a359772f0a8$var$_hoisted_4 = {
    class: "flyout__colors"
};
function $b4109a359772f0a8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", $b4109a359772f0a8$var$_hoisted_1, [
        (0, $aoXob.createElementVNode)("div", $b4109a359772f0a8$var$_hoisted_2, [
            (0, $aoXob.createElementVNode)("div", {
                class: "flyout__instructions",
                innerHTML: $props.text
            }, null, 8, $b4109a359772f0a8$var$_hoisted_3),
            (0, $aoXob.createElementVNode)("div", $b4109a359772f0a8$var$_hoisted_4, [
                ((0, $aoXob.openBlock)(true), (0, $aoXob.createElementBlock)((0, $aoXob.Fragment), null, (0, $aoXob.renderList)($setup.props.colorData, (color)=>{
                    return (0, $aoXob.openBlock)(), (0, $aoXob.createBlock)($setup["CircleColorBtn"], {
                        key: color.id,
                        label: color.title,
                        image: color.thumb_url,
                        onClick: ($event)=>$setup.emit("select:color", color.id)
                    }, null, 8, [
                        "label",
                        "image",
                        "onClick"
                    ]);
                }), 128))
            ]),
            (0, $aoXob.createElementVNode)("button", {
                class: "flyout__close",
                onClick: _cache[0] || (_cache[0] = ($event)=>$setup.emit("close:flyout"))
            }, " \xd7 ")
        ])
    ], 512);
}

});

parcelRequire.register("hPuUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfaf2cb9647da738$export$2e2bcd8739ae039; });
let $cfaf2cb9647da738$var$NOOP = ()=>{};
var $cfaf2cb9647da738$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("9Fxcq", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $70a1b21fc4332358$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $70a1b21fc4332358$var$_hoisted_1 = {
    class: "add-breakout"
};
const $70a1b21fc4332358$var$_hoisted_2 = /*#__PURE__*/ (0, $aoXob.createElementVNode)("svg", {
    width: "24",
    height: "24",
    version: "1.1",
    viewBox: "0 0 6.35 6.35",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ (0, $aoXob.createElementVNode)("path", {
        d: "m1.2123 3.5936h1.5441v1.5441c0 0.23118 0.1874 0.41858 0.41858 0.41858s0.41858-0.1874 0.41858-0.41858v-1.5441h1.5441c0.23118 0 0.41858-0.1874 0.41858-0.41858s-0.1874-0.41858-0.41858-0.41858h-1.5441v-1.5441c0-0.23118-0.1874-0.41858-0.41858-0.41858s-0.41858 0.1874-0.41858 0.41858v1.5441h-1.5441c-0.23118 0-0.41858 0.1874-0.41858 0.41858s0.1874 0.41858 0.41858 0.41858z",
        fill: "#b8b8b8",
        "stroke-width": ".0093018"
    })
], -1);
function $70a1b21fc4332358$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)((0, $aoXob.Fragment), null, [
        (0, $aoXob.createElementVNode)("div", $70a1b21fc4332358$var$_hoisted_1, [
            (0, $aoXob.createVNode)($setup["CircleColorBtn"], {
                label: "Add a color",
                "persistent-icon": "1",
                onClick: $setup.openFlyout
            }, {
                icon: (0, $aoXob.withCtx)(()=>[
                        $70a1b21fc4332358$var$_hoisted_2
                    ]),
                _: 1
            })
        ]),
        $setup.showFlyout ? ((0, $aoXob.openBlock)(), (0, $aoXob.createBlock)($setup["ColorFlyout"], {
            key: 0,
            "color-data": $props.selectableColors,
            text: $props.flyoutInstructions,
            "onSelect:color": $setup.handleSelectColor,
            "onClose:flyout": $setup.closeFlyout
        }, null, 8, [
            "color-data",
            "text"
        ])) : (0, $aoXob.createCommentVNode)("", true)
    ], 64);
}

});

parcelRequire.register("arxQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79a6adf03ebc2505$export$2e2bcd8739ae039; });
let $79a6adf03ebc2505$var$NOOP = ()=>{};
var $79a6adf03ebc2505$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("ctEFj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9157bcc3d5dd5582$export$2e2bcd8739ae039; });
let $9157bcc3d5dd5582$var$script;




let $9157bcc3d5dd5582$var$initialize = ()=>{
    $9157bcc3d5dd5582$var$script = (parcelRequire("3hdqq"));
    if ($9157bcc3d5dd5582$var$script.__esModule) $9157bcc3d5dd5582$var$script = $9157bcc3d5dd5582$var$script.default;
    $9157bcc3d5dd5582$var$script.render = (parcelRequire("jtc9E")).render;
    $9157bcc3d5dd5582$var$script.__cssModules = {};
    (parcelRequire("eqNmN")).default($9157bcc3d5dd5582$var$script);
    $9157bcc3d5dd5582$var$script.__scopeId = "data-v-d4dff1";
    $9157bcc3d5dd5582$var$script.__file = "ColorBreakout.vue";
};
$9157bcc3d5dd5582$var$initialize();
var $9157bcc3d5dd5582$export$2e2bcd8739ae039 = $9157bcc3d5dd5582$var$script;

});
parcelRequire.register("3hdqq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $262d5f9d548ca437$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $94VKa = parcelRequire("94VKa");
var $aoXob = parcelRequire("aoXob");

var $3gKlO = parcelRequire("3gKlO");

var $4b4s6 = parcelRequire("4b4s6");

var $262d5f9d548ca437$export$2e2bcd8739ae039 = {
    __name: "ColorBreakout",
    props: {
        id: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        percentage: {
            type: Number,
            required: true
        },
        selectableColors: {
            type: Array,
            required: true
        },
        flyoutInstructions: {
            type: String,
            default: ""
        },
        canTrash: {
            type: Boolean,
            default: true
        },
        freezeSlider: {
            type: Boolean,
            default: false
        },
        steps: {
            type: Number,
            default: 1
        }
    },
    emits: [
        "update:percentage",
        "change:color",
        "trash"
    ],
    setup (__props, { expose: __expose, emit: emit }) {
        __expose();
        const props = __props;
        const showFlyout = (0, $94VKa.ref)(false);
        const nodePercentageSlider = (0, $94VKa.ref)(null) // to be populated by HTML element representing slider (see template)
        ;
        const nodeIconTrash = (0, $94VKa.ref)(null);
        let noUiSliderInstance = null;
        let btnTrashTippy = null;
        /**
 * Open flyout for color selection
 *
 * @return {void}
 */ const openFlyout = ()=>{
            showFlyout.value = true;
        };
        /**
 * Close flyout
 *
 * @return {void}
 */ const closeFlyout = ()=>{
            showFlyout.value = false;
        };
        /**
 * Handle user selecting color from flyout
 *
 * @param {number}
 * @return {void}
 */ const handleSelectColor = (colorId)=>{
            emit("change:color", colorId, props.index, props.percentage, props.id);
            closeFlyout();
        };
        // eslint-disable-next-line arrow-body-style
        const disableBtnDecrease = (0, $aoXob.computed)(()=>{
            return 0 >= props.percentage;
        });
        // eslint-disable-next-line arrow-body-style
        const disableBtnIncrease = (0, $aoXob.computed)(()=>{
            return 100 <= props.percentage;
        });
        // if percentage from parent changes, then let's make sure UI slider is updated
        // watch( () => props.percentage, newPercentageValue => {
        // 	if ( noUiSliderInstance && newPercentageValue !== noUiSliderInstance.get() ) {
        // 		noUiSliderInstance.set( newPercentageValue )
        // 		if ( props.freezeSlider ) {
        // 			noUiSliderInstance.disable()
        // 		} else {
        // 			noUiSliderInstance.enable()
        // 		}
        // 	}
        // })
        (0, $aoXob.onMounted)(()=>{
            if (props.canTrash) (parcelRequire("2ZWVn")).then((tippy)=>{
                btnTrashTippy = tippy.default(nodeIconTrash.value, {
                    content: "Remove color",
                    placement: "top"
                });
            });
        // noUiSliderInstance = noUiSlider.create( nodePercentageSlider.value, {
        // 	start: props.percentage,
        // 	connect: 'lower',
        // 	tooltips: [
        // 		wNumb({
        // 			decimals: 0,
        // 			suffix: '%',
        // 		}),
        // 	],
        // 	step: 1,
        // 	range: {
        // 		min: 0,
        // 		max: 100,
        // 	},
        // })
        // noUiSliderInstance.on( 'change', values => {
        // 	const percentage = parseInt( values[0], 10 )
        // 	if ( !Number.isNaN( percentage ) ) {
        // 		emit( 'update:percentage', props.id, percentage )
        // 	}
        // })
        });
        (0, $aoXob.onUnmounted)(()=>{
            if (btnTrashTippy) btnTrashTippy.destroy();
        });
        // onBeforeUpdate( () => {
        // 	noUiSliderInstance.updateOptions({
        // 		step: props.steps,
        // 	}, true )
        // })
        const __returned__ = {
            props: props,
            emit: emit,
            showFlyout: showFlyout,
            nodePercentageSlider: nodePercentageSlider,
            nodeIconTrash: nodeIconTrash,
            get noUiSliderInstance () {
                return noUiSliderInstance;
            },
            set noUiSliderInstance (v){
                noUiSliderInstance = v;
            },
            get btnTrashTippy () {
                return btnTrashTippy;
            },
            set btnTrashTippy (v){
                btnTrashTippy = v;
            },
            openFlyout: openFlyout,
            closeFlyout: closeFlyout,
            handleSelectColor: handleSelectColor,
            disableBtnDecrease: disableBtnDecrease,
            disableBtnIncrease: disableBtnIncrease,
            ref: $94VKa.ref,
            onMounted: $aoXob.onMounted,
            onUnmounted: $aoXob.onUnmounted,
            computed: $aoXob.computed,
            CircleColorBtn: $3gKlO.default,
            ColorFlyout: $4b4s6.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRequire.register("jtc9E", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $e2ca2768855f2b75$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $e2ca2768855f2b75$var$_hoisted_1 = {
    class: "breakout"
};
const $e2ca2768855f2b75$var$_hoisted_2 = /*#__PURE__*/ (0, $aoXob.createElementVNode)("svg", {
    width: "90",
    height: "100",
    version: "1.1",
    viewBox: "0 0 90 100",
    "xml:space": "preserve",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ (0, $aoXob.createElementVNode)("g", {
        transform: "matrix(.18784 0 0 .18385 4.0235 4.9999)"
    }, [
        /*#__PURE__*/ (0, $aoXob.createElementVNode)("path", {
            d: "m241.56 488.16c98.2-11 176.9-89.5 188.1-187.7 14.7-128.4-85.1-237.7-210.2-239.1v-57.6c0-3.2-4-4.9-6.7-2.9l-118.6 87.1c-2 1.5-2 4.4 0 5.9l118.6 87.1c2.7 2 6.7 0.2 6.7-2.9v-57.5c87.9 1.4 158.3 76.2 152.3 165.6-5.1 76.9-67.8 139.3-144.7 144.2-81.5 5.2-150.8-53-163.2-130-2.3-14.3-14.8-24.7-29.2-24.7-17.9 0-31.9 15.9-29.1 33.6 17.4 109.7 118.7 192 236 178.9z",
            fill: "#fff"
        })
    ])
], -1);
const $e2ca2768855f2b75$var$_hoisted_3 = {
    class: "breakout__percentage"
};
const $e2ca2768855f2b75$var$_hoisted_4 = [
    "disabled"
];
const $e2ca2768855f2b75$var$_hoisted_5 = {
    class: "breakout__percentage__value"
};
const $e2ca2768855f2b75$var$_hoisted_6 = [
    "value"
];
const $e2ca2768855f2b75$var$_hoisted_7 = /*#__PURE__*/ (0, $aoXob.createElementVNode)("span", {
    class: "breakout__percentage__value__symbol"
}, "%", -1);
const $e2ca2768855f2b75$var$_hoisted_8 = [
    "disabled"
];
const $e2ca2768855f2b75$var$_hoisted_9 = /*#__PURE__*/ (0, $aoXob.createStaticVNode)('<svg class="breakout__trash__icon" width="20" height="24" version="1.1" viewBox="0 0 5.2917 6.35" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(.010583 0 0 .011369 -.0635 .26458)"><path d="m436 60h-75v-15c0-24.813-20.187-45-45-45h-120c-24.813 0-45 20.187-45 45v15h-75c-24.813 0-45 20.187-45 45 0 19.928 13.025 36.861 31.005 42.761l26.755 322.98c1.927 23.139 21.625 41.264 44.844 41.264h244.79c23.22 0 42.918-18.125 44.846-41.271l26.753-322.97c17.98-5.899 31.005-22.832 31.005-42.76 0-24.813-20.187-45-45-45zm-255-15c0-8.271 6.729-15 15-15h120c8.271 0 15 6.729 15 15v15h-150zm212.34 423.25c-0.643 7.712-7.208 13.754-14.948 13.754h-244.79c-7.739 0-14.305-6.042-14.946-13.747l-26.364-318.25h327.41zm42.656-348.25h-360c-8.271 0-15-6.729-15-15s6.729-15 15-15h360c8.271 0 15 6.729 15 15s-6.729 15-15 15z"></path><path d="m195.97 436.07-15-242c-0.513-8.269-7.67-14.558-15.899-14.043-8.269 0.513-14.556 7.631-14.044 15.899l15 242c0.493 7.953 7.097 14.072 14.957 14.072 8.687 0 15.519-7.316 14.986-15.929z"></path><path d="m256 180c-8.284 0-15 6.716-15 15v242c0 8.284 6.716 15 15 15s15-6.716 15-15v-242c0-8.284-6.716-15-15-15z"></path><path d="m346.93 180.03c-8.25-0.513-15.387 5.774-15.899 14.043l-15 242c-0.511 8.268 5.776 15.386 14.044 15.899 8.273 0.512 15.387-5.778 15.899-14.043l15-242c0.512-8.269-5.775-15.387-14.044-15.899z"></path></g></svg>', 1);
const $e2ca2768855f2b75$var$_hoisted_10 = [
    $e2ca2768855f2b75$var$_hoisted_9
];
function $e2ca2768855f2b75$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)((0, $aoXob.Fragment), null, [
        (0, $aoXob.createElementVNode)("div", $e2ca2768855f2b75$var$_hoisted_1, [
            (0, $aoXob.createVNode)($setup["CircleColorBtn"], {
                image: $props.image,
                label: $props.title,
                "icon-tooltip": "Switch color",
                "onBtn:click": $setup.openFlyout
            }, {
                icon: (0, $aoXob.withCtx)(()=>[
                        $e2ca2768855f2b75$var$_hoisted_2
                    ]),
                _: 1
            }, 8, [
                "image",
                "label"
            ]),
            (0, $aoXob.createElementVNode)("div", $e2ca2768855f2b75$var$_hoisted_3, [
                (0, $aoXob.createElementVNode)("button", {
                    class: "breakout__percentage__btn breakout__percentage__btn--decrease",
                    type: "button",
                    disabled: $setup.disableBtnDecrease,
                    onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("update:percentage", $props.id, $props.percentage - 1))
                }, " - ", 8, $e2ca2768855f2b75$var$_hoisted_4),
                (0, $aoXob.createElementVNode)("div", $e2ca2768855f2b75$var$_hoisted_5, [
                    (0, $aoXob.createElementVNode)("input", {
                        class: "breakout__percentage__value__input",
                        value: $props.percentage,
                        type: "number",
                        onInput: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("update:percentage", $props.id, parseInt($event.target.value, 10)))
                    }, null, 40, $e2ca2768855f2b75$var$_hoisted_6),
                    $e2ca2768855f2b75$var$_hoisted_7
                ]),
                (0, $aoXob.createElementVNode)("button", {
                    class: "breakout__percentage__btn breakout__percentage__btn--increase",
                    type: "button",
                    disabled: $setup.disableBtnIncrease,
                    onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("update:percentage", $props.id, $props.percentage + 1))
                }, " + ", 8, $e2ca2768855f2b75$var$_hoisted_8)
            ]),
            $props.canTrash ? ((0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("button", {
                key: 0,
                ref: "nodeIconTrash",
                class: "breakout__trash",
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event)=>$setup.emit("trash", $props.id))
            }, $e2ca2768855f2b75$var$_hoisted_10, 512)) : (0, $aoXob.createCommentVNode)("", true)
        ]),
        $setup.showFlyout ? ((0, $aoXob.openBlock)(), (0, $aoXob.createBlock)($setup["ColorFlyout"], {
            key: 0,
            "color-data": $props.selectableColors,
            text: $props.flyoutInstructions,
            "onSelect:color": $setup.handleSelectColor,
            "onClose:flyout": $setup.closeFlyout
        }, null, 8, [
            "color-data",
            "text"
        ])) : (0, $aoXob.createCommentVNode)("", true)
    ], 64);
}

});

parcelRequire.register("eqNmN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a819c99cfe4590be$export$2e2bcd8739ae039; });
let $a819c99cfe4590be$var$NOOP = ()=>{};
var $a819c99cfe4590be$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("c5Ge5", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $8cd6b4eadeaedb25$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $8cd6b4eadeaedb25$var$_hoisted_1 = /*#__PURE__*/ (0, $aoXob.createElementVNode)("h5", {
    class: "breakout__description"
}, " Your Color Mix (choose up to 4 colors) ", -1);
const $8cd6b4eadeaedb25$var$_hoisted_2 = {
    class: "breakouts"
};
const $8cd6b4eadeaedb25$var$_hoisted_3 = {
    key: 0,
    class: "breakout__warning"
};
const $8cd6b4eadeaedb25$var$_hoisted_4 = /*#__PURE__*/ (0, $aoXob.createElementVNode)("strong", null, "Click here to equally divide colors.", -1);
const $8cd6b4eadeaedb25$var$_hoisted_5 = [
    $8cd6b4eadeaedb25$var$_hoisted_4
];
const $8cd6b4eadeaedb25$var$_hoisted_6 = {
    class: "view-color-mix"
};
function $8cd6b4eadeaedb25$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)((0, $aoXob.Fragment), null, [
        $8cd6b4eadeaedb25$var$_hoisted_1,
        (0, $aoXob.createElementVNode)("div", $8cd6b4eadeaedb25$var$_hoisted_2, [
            ((0, $aoXob.openBlock)(true), (0, $aoXob.createElementBlock)((0, $aoXob.Fragment), null, (0, $aoXob.renderList)($props.selectedColors, (selectedColor, i)=>{
                return (0, $aoXob.openBlock)(), (0, $aoXob.createBlock)($setup["ColorBreakout"], {
                    id: selectedColor.id,
                    key: selectedColor.id,
                    index: selectedColor.placementIndex,
                    title: selectedColor.title,
                    image: selectedColor.thumb_url,
                    percentage: selectedColor.percentage,
                    "selectable-colors": $setup.selectableColors,
                    "can-trash": $setup.canTrashBreakout(i),
                    "flyout-instructions": $props.flyoutInstructions,
                    "freeze-slider": $setup.freezeSlider(i),
                    steps: $setup.calculateSliderSteps(),
                    "onUpdate:percentage": $setup.handleBreakoutPercentageChange,
                    "onChange:color": $setup.handleBreakoutChangeColor,
                    onTrash: $setup.handleTrashBreakout
                }, null, 8, [
                    "id",
                    "index",
                    "title",
                    "image",
                    "percentage",
                    "selectable-colors",
                    "can-trash",
                    "flyout-instructions",
                    "freeze-slider",
                    "steps"
                ]);
            }), 128)),
            $setup.canAddBreakouts ? ((0, $aoXob.openBlock)(), (0, $aoXob.createBlock)($setup["AddBreakout"], {
                key: 0,
                "selectable-colors": $setup.selectableColors,
                "flyout-instructions": $props.flyoutInstructions,
                "onSelect:color": $setup.handleSelectColorForBreakout
            }, null, 8, [
                "selectable-colors",
                "flyout-instructions"
            ])) : (0, $aoXob.createCommentVNode)("", true)
        ]),
        $setup.showPercentageTotalWarning ? ((0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", $8cd6b4eadeaedb25$var$_hoisted_3, [
            (0, $aoXob.createTextVNode)(" Your breakouts must add up to 100%! "),
            (0, $aoXob.createElementVNode)("a", {
                href: "#",
                class: "breakout__warning__equalize",
                onClick: $setup.handleClickEqualize
            }, $8cd6b4eadeaedb25$var$_hoisted_5)
        ])) : (0, $aoXob.createCommentVNode)("", true),
        (0, $aoXob.createElementVNode)("div", $8cd6b4eadeaedb25$var$_hoisted_6, [
            (0, $aoXob.createElementVNode)("button", {
                class: "btn btn-secondary",
                onClick: _cache[0] || (_cache[0] = ($event)=>$setup.emit("breakouts:view:mixer"))
            }, " View Color Mix ")
        ])
    ], 64);
}

});

parcelRequire.register("js2KX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e292c5383ec16429$export$2e2bcd8739ae039; });
let $e292c5383ec16429$var$NOOP = ()=>{};
var $e292c5383ec16429$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("g6WWX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbaaef1ec2d611ce$export$2e2bcd8739ae039; });
let $bbaaef1ec2d611ce$var$script;



let $bbaaef1ec2d611ce$var$initialize = ()=>{
    $bbaaef1ec2d611ce$var$script = (parcelRequire("bEldA"));
    if ($bbaaef1ec2d611ce$var$script.__esModule) $bbaaef1ec2d611ce$var$script = $bbaaef1ec2d611ce$var$script.default;
    $bbaaef1ec2d611ce$var$script.render = (parcelRequire("i6Ixq")).render;
    (parcelRequire("i6ywM")).default($bbaaef1ec2d611ce$var$script);
    $bbaaef1ec2d611ce$var$script.__scopeId = "data-v-9aa8d4";
    $bbaaef1ec2d611ce$var$script.__file = "BtnGetAQuote.vue";
};
$bbaaef1ec2d611ce$var$initialize();
var $bbaaef1ec2d611ce$export$2e2bcd8739ae039 = $bbaaef1ec2d611ce$var$script;

});
parcelRequire.register("bEldA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $87b3e39c2066808f$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
var $87b3e39c2066808f$export$2e2bcd8739ae039 = {
    __name: "BtnGetAQuote",
    props: {
        colorData: {
            type: Array,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const qetAQuoteUrl = (0, $aoXob.computed)(()=>{
            const url = new URL(window.webfx.colorMixer.addonData.urls.get_a_quote);
            let dataForLink = props.colorData.map((color)=>({
                    c: color.code,
                    p: color.percentage
                }));
            dataForLink = window.btoa(JSON.stringify(dataForLink));
            url.searchParams.set("color_data", dataForLink);
            return url.toString();
        });
        const __returned__ = {
            props: props,
            qetAQuoteUrl: qetAQuoteUrl,
            computed: $aoXob.computed
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRequire.register("i6Ixq", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d2eb55d9e8eae774$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $d2eb55d9e8eae774$var$_hoisted_1 = [
    "href"
];
function $d2eb55d9e8eae774$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("a", {
        class: "btn btn-primary",
        href: $setup.qetAQuoteUrl,
        target: "_blank"
    }, "Get a Quote", 8, $d2eb55d9e8eae774$var$_hoisted_1);
}

});

parcelRequire.register("i6ywM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2e3920392d1a830$export$2e2bcd8739ae039; });
let $d2e3920392d1a830$var$NOOP = ()=>{};
var $d2e3920392d1a830$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("8Wsdf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68299fef44223ce2$export$2e2bcd8739ae039; });
let $68299fef44223ce2$var$script;



let $68299fef44223ce2$var$initialize = ()=>{
    $68299fef44223ce2$var$script = (parcelRequire("aHT1J"));
    if ($68299fef44223ce2$var$script.__esModule) $68299fef44223ce2$var$script = $68299fef44223ce2$var$script.default;
    $68299fef44223ce2$var$script.render = (parcelRequire("md4RY")).render;
    (parcelRequire("kxtMM")).default($68299fef44223ce2$var$script);
    $68299fef44223ce2$var$script.__scopeId = "data-v-5e83e5";
    $68299fef44223ce2$var$script.__file = "BtnDownloadColorMix.vue";
};
$68299fef44223ce2$var$initialize();
var $68299fef44223ce2$export$2e2bcd8739ae039 = $68299fef44223ce2$var$script;

});
parcelRequire.register("aHT1J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7cb89ac07916dc11$export$2e2bcd8739ae039; });

var $9UHhQ = parcelRequire("9UHhQ");
var $7cb89ac07916dc11$export$2e2bcd8739ae039 = {
    __name: "BtnDownloadColorMix",
    props: {
        colorData: {
            type: Array,
            required: true
        },
        siteLogoUrl: {
            type: String,
            required: true
        },
        pdfTextDisclaimer: {
            type: String,
            default: ""
        },
        pdfTextContact: {
            type: String,
            default: ""
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        /**
 * Handle user clicking to download PDF
 *
 * @return {void}
 */ const handleClickDownload = async ()=>{
            const mixComp = window?.webfx?.colorMixer?.mixComp;
            if (!mixComp) {
                console.warn("Mix composition has not yet been created!");
                return;
            }
            const selectedColors = props.colorData.toSorted((a, b)=>a.percentage - b.percentage).toReversed();
            // eslint-disable-next-line arrow-body-style
            const breakoutText = selectedColors.map((color)=>`${color.percentage}% - ${color.title}`).join("\n");
            const downloadablePdf = new (0, $9UHhQ.DownloadablePdf)();
            // for code-splitting, we're using an async dynamic import
            await downloadablePdf.createPdf();
            downloadablePdf.addLogoImage(props.siteLogoUrl).addBreakoutText(breakoutText).addDisclaimerText(props.pdfTextDisclaimer).addContactUsText(props.pdfTextContact);
            // this needs to await because of generating an image
            await downloadablePdf.addMixImage(mixComp.getCanvasDataUrl());
            const fileName = `No Fault - ${selectedColors.map((color)=>color.title).join(", ")}.pdf`;
            // will save to user browser
            downloadablePdf.saveToBrowser(fileName);
        };
        const __returned__ = {
            props: props,
            handleClickDownload: handleClickDownload,
            get DownloadablePdf () {
                return 0, $9UHhQ.DownloadablePdf;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRequire.register("9UHhQ", function(module, exports) {

$parcel$export(module.exports, "DownloadablePdf", function () { return $737aebe6cba4291e$export$edd1fe54a33c465d; });

class $737aebe6cba4291e$export$edd1fe54a33c465d {
    doc = null;
    pageWidth = 8.5;
    pageHeight = 11;
    pageLineHeight = 1.2;
    pagePtsPerInch = 72;
    contactUsTextOffset = null;
    /**
	 * For code-splitting, we're using a dyanmic import to load jsPDF
	 *
	 * @return {<Promise>}
	 */ createPdf() {
        return new Promise((resolve)=>{
            (parcelRequire("6BSI5")).then((jspdfLib)=>{
                const { jsPDF: jsPDF } = jspdfLib;
                // eslint-disable-next-line new-cap
                this.doc = new jsPDF({
                    unit: "in",
                    lineHeight: this.pageLineHeight,
                    format: "letter"
                }).setProperties({
                    title: "No Fault Surfaces - Color Mix"
                });
                resolve();
            });
        });
    }
    /**
	 * Add mix image
	 *
	 * @param {string} image Mix image
	 * @return {self}
	 */ async addMixImage(image) {
        const circularImage = await $737aebe6cba4291e$export$edd1fe54a33c465d.constrainImageInCircle(image);
        this.doc.addImage(circularImage, "PNG", 1, 1, 2.75, 2.75);
        return this;
    }
    /**
	 * Create canvas with circle border
	 *
	 * @param {string} dataUrl
	 * @return {<Promise>} resolves to canvas data URL
	 */ static constrainImageInCircle(imageUrl) {
        return new Promise((resolve)=>{
            const image = new Image();
            image.onload = ()=>{
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                ctx.canvas.width = 400;
                ctx.canvas.height = 400;
                ctx.lineWidth = 0;
                ctx.strokeStyle = "transparent";
                ctx.beginPath();
                ctx.arc(200, 200, 200, 0, Math.PI * 2);
                ctx.stroke();
                ctx.closePath();
                // prevents clipping from affecting other drawings
                ctx.save();
                ctx.clip();
                // adds black background underneath everything
                ctx.globalCompositeOperation = "destination-under";
                ctx.fillStyle = "#000";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                // adds actual pebble image
                ctx.drawImage(image, 0, 0, 400, 400);
                ctx.restore();
                resolve(canvas.toDataURL());
            };
            image.src = imageUrl;
        });
    }
    /**
	 * Add logo image
	 *
	 * @param {string} logoUrl Logo image URL
	 * @param {bool} addLineBelow Add blue line beneath logo (and above breakout text)
	 * @return {self}
	 */ addLogoImage(logoUrl, addLineBelow = true) {
        this.doc.addImage(logoUrl, "PNG", 5.5, 1.15, 1.35, 0.855);
        if (addLineBelow) this.doc.setDrawColor(0).setFillColor(0, 147, 201).rect(4.5, 2.5, 3, 0.01, "F");
        return this;
    }
    /**
	 * Add breakout text
	 *
	 * Text should be a single string, concatenated with "\n" for line breaks.
	 *
	 * @param {string} text Breakout text
	 * @return {self}
	 */ addBreakoutText(text) {
        this.doc.setFont("Times", "bold").setFontSize(16);
        const lines = this.doc.splitTextToSize(text, 3);
        this.doc.text(lines, 4.5, 3);
        return this;
    }
    /**
	 * Add disclaimer text
	 *
	 * Text should be a single string, concatenated with "\n" for line breaks.
	 *
	 * @param {string} text Disclaimer text
	 * @param {bool} addLineBelow Add blue line beneath disclaimer text
	 *
	 * @return {self}
	 */ addDisclaimerText(text, addLineBelow = true) {
        this.doc.setFont("Times", "normal").setFontSize(12);
        const lines = this.doc.splitTextToSize(text, 6.5);
        this.doc.text(lines, 1, 4.5);
        // to help position the contact information *after* disclaimer text
        let offset = lines.length * 12 * this.pageLineHeight / this.pagePtsPerInch + 4.75;
        if (addLineBelow) {
            this.doc.setDrawColor(0).setFillColor(0, 147, 201).rect(1, offset, 6.5, 0.01, "F");
            offset += 0.25;
        }
        this.contactUsTextOffset = offset;
        return this;
    }
    /**
	 * Add contact us text
	 *
	 * Text should be a single string, concatenated with "\n" for line breaks.
	 *
	 * @throws {Error} If contact us text offset is not set
	 *
	 * @param {string} text Contact us text
	 * @return {self}
	 */ addContactUsText(text) {
        if (!this.contactUsTextOffset) throw new Error("Offset for contact us text not set. Call addDisclaimerText() first!");
        this.doc.setFont("Times", "normal").setFontSize(12);
        // text *should* be short so no need to split lines
        this.doc.text(text, 1, this.contactUsTextOffset + 0.4);
        return this;
    }
    /**
	 * Save to user browser
	 *
	 * @param {string} fileName File name
	 * @return {self}
	 */ saveToBrowser(fileName) {
        this.doc.save(fileName);
        return this;
    }
}

});
parcelRequire.register("6BSI5", function(module, exports) {



module.exports = (parcelRequire("a0MnV"))((parcelRequire("3VV9c")).getBundleURL("8E1Vu") + (parcelRequire("d8HMG")).resolve("8Aqq7")).then(()=>parcelRequire("3uzq3"));

});



parcelRequire.register("md4RY", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $042c331dc5551895$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
function $042c331dc5551895$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("button", {
        class: "btn btn-secondary",
        type: "button",
        onClick: $setup.handleClickDownload
    }, " Download Color Mix ");
}

});

parcelRequire.register("kxtMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef3dfe8a6795725f$export$2e2bcd8739ae039; });
let $ef3dfe8a6795725f$var$NOOP = ()=>{};
var $ef3dfe8a6795725f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("4jZAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3258b5fefdd81951$export$2e2bcd8739ae039; });
let $3258b5fefdd81951$var$script;




let $3258b5fefdd81951$var$initialize = ()=>{
    $3258b5fefdd81951$var$script = (parcelRequire("aij9J"));
    if ($3258b5fefdd81951$var$script.__esModule) $3258b5fefdd81951$var$script = $3258b5fefdd81951$var$script.default;
    $3258b5fefdd81951$var$script.render = (parcelRequire("7mkm7")).render;
    $3258b5fefdd81951$var$script.__cssModules = {};
    (parcelRequire("84B4T")).default($3258b5fefdd81951$var$script);
    $3258b5fefdd81951$var$script.__scopeId = "data-v-1326cf";
    $3258b5fefdd81951$var$script.__file = "SelectRubberType.vue";
};
$3258b5fefdd81951$var$initialize();
var $3258b5fefdd81951$export$2e2bcd8739ae039 = $3258b5fefdd81951$var$script;

});
parcelRequire.register("aij9J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $77ea71c870e4bab9$export$2e2bcd8739ae039; });
var $77ea71c870e4bab9$export$2e2bcd8739ae039 = {
    __name: "SelectRubberType",
    props: {
        activeRubberType: {
            type: String,
            required: true
        },
        rubberTypes: {
            type: Array,
            required: true
        }
    },
    emits: [
        "rubber-type:change"
    ],
    setup (__props, { expose: __expose, emit: emit }) {
        __expose();
        const props = __props;
        /**
 * Handle user selecting different rubber type
 *
 * @param {CustomEvent|Event} e
 * @return {void}
 */ const handleUserChangeRubberType = (e)=>{
            const { value: value } = e.target;
            if (value === props.activeRubberType) return;
            emit("rubber-type:change", value);
        };
        const __returned__ = {
            props: props,
            emit: emit,
            handleUserChangeRubberType: handleUserChangeRubberType
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRequire.register("7mkm7", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $55ba60aff32eebc3$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
var $eGzkv = parcelRequire("eGzkv");
const $55ba60aff32eebc3$var$_hoisted_1 = {
    class: "rubber-type-switch"
};
const $55ba60aff32eebc3$var$_hoisted_2 = [
    "selected"
];
function $55ba60aff32eebc3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", $55ba60aff32eebc3$var$_hoisted_1, [
        (0, $aoXob.createElementVNode)("select", {
            class: "rubber-type-switch__select",
            onChange: $setup.handleUserChangeRubberType
        }, [
            ((0, $aoXob.openBlock)(true), (0, $aoXob.createElementBlock)((0, $aoXob.Fragment), null, (0, $aoXob.renderList)($props.rubberTypes, (rubberType)=>{
                return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("option", {
                    key: rubberType,
                    selected: rubberType === $props.activeRubberType
                }, (0, $eGzkv.toDisplayString)(rubberType), 9, $55ba60aff32eebc3$var$_hoisted_2);
            }), 128))
        ], 32)
    ]);
}

});

parcelRequire.register("84B4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e0b755a8d7fea72$export$2e2bcd8739ae039; });
let $5e0b755a8d7fea72$var$NOOP = ()=>{};
var $5e0b755a8d7fea72$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("3jkEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2693298c09de9779$export$2e2bcd8739ae039; });
let $2693298c09de9779$var$script;




let $2693298c09de9779$var$initialize = ()=>{
    $2693298c09de9779$var$script = (parcelRequire("93KfS"));
    if ($2693298c09de9779$var$script.__esModule) $2693298c09de9779$var$script = $2693298c09de9779$var$script.default;
    $2693298c09de9779$var$script.render = (parcelRequire("2lvTJ")).render;
    $2693298c09de9779$var$script.__cssModules = {};
    (parcelRequire("20Yqd")).default($2693298c09de9779$var$script);
    $2693298c09de9779$var$script.__scopeId = "data-v-9f8084";
    $2693298c09de9779$var$script.__file = "DisclaimerAside.vue";
};
$2693298c09de9779$var$initialize();
var $2693298c09de9779$export$2e2bcd8739ae039 = $2693298c09de9779$var$script;

});
parcelRequire.register("93KfS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6988462733736734$export$2e2bcd8739ae039; });
var $6988462733736734$export$2e2bcd8739ae039 = {
    __name: "DisclaimerAside",
    props: {
        text: {
            type: String,
            default: ""
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = {
            props: props
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRequire.register("2lvTJ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $1b564933c3299ff9$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $1b564933c3299ff9$var$_hoisted_1 = [
    "innerHTML"
];
function $1b564933c3299ff9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.text.length ? ((0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", {
        key: 0,
        class: "disclaimer-text",
        innerHTML: $props.text
    }, null, 8, $1b564933c3299ff9$var$_hoisted_1)) : (0, $aoXob.createCommentVNode)("", true);
}

});

parcelRequire.register("20Yqd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $177a736143068cd5$export$2e2bcd8739ae039; });
let $177a736143068cd5$var$NOOP = ()=>{};
var $177a736143068cd5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("4ANt9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3580e5c8f739554f$export$2e2bcd8739ae039; });
let $3580e5c8f739554f$var$script;




let $3580e5c8f739554f$var$initialize = ()=>{
    $3580e5c8f739554f$var$script = (parcelRequire("l3oJV"));
    if ($3580e5c8f739554f$var$script.__esModule) $3580e5c8f739554f$var$script = $3580e5c8f739554f$var$script.default;
    $3580e5c8f739554f$var$script.render = (parcelRequire("c1EUH")).render;
    $3580e5c8f739554f$var$script.__cssModules = {};
    (parcelRequire("cObnv")).default($3580e5c8f739554f$var$script);
    $3580e5c8f739554f$var$script.__scopeId = "data-v-28ad14";
    $3580e5c8f739554f$var$script.__file = "LearnMoreLink.vue";
};
$3580e5c8f739554f$var$initialize();
var $3580e5c8f739554f$export$2e2bcd8739ae039 = $3580e5c8f739554f$var$script;

});
parcelRequire.register("l3oJV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f53d118f3b824cab$export$2e2bcd8739ae039; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
var $f53d118f3b824cab$export$2e2bcd8739ae039 = {
    __name: "LearnMoreLink",
    props: {
        link: {
            type: Object,
            default: ()=>{}
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const linkUrl = (0, $aoXob.computed)(()=>props.link?.url || "");
        const linkTarget = (0, $aoXob.computed)(()=>props.link?.target || "self");
        const linkLabel = (0, $aoXob.computed)(()=>props.link?.title || "");
        const __returned__ = {
            props: props,
            linkUrl: linkUrl,
            linkTarget: linkTarget,
            linkLabel: linkLabel,
            computed: $aoXob.computed
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRequire.register("c1EUH", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $8c155098ef744e6f$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
var $eGzkv = parcelRequire("eGzkv");
const $8c155098ef744e6f$var$_hoisted_1 = {
    key: 0,
    class: "learn-more-link-container"
};
const $8c155098ef744e6f$var$_hoisted_2 = [
    "href",
    "target"
];
function $8c155098ef744e6f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $setup.linkUrl.length && $setup.linkLabel.length ? ((0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", $8c155098ef744e6f$var$_hoisted_1, [
        (0, $aoXob.createElementVNode)("a", {
            href: $setup.linkUrl,
            target: $setup.linkTarget,
            class: "learn-more-link"
        }, (0, $eGzkv.toDisplayString)($setup.linkLabel), 9, $8c155098ef744e6f$var$_hoisted_2)
    ])) : (0, $aoXob.createCommentVNode)("", true);
}

});

parcelRequire.register("cObnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9532faff30929fb8$export$2e2bcd8739ae039; });
let $9532faff30929fb8$var$NOOP = ()=>{};
var $9532faff30929fb8$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("cN0XE", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $94face8235f32de8$export$b3890eb0ae9dca99; });
parcelRequire("ldOcC");
var $aoXob = parcelRequire("aoXob");
const $94face8235f32de8$var$_hoisted_1 = {
    class: "container-fluid"
};
const $94face8235f32de8$var$_hoisted_2 = {
    class: "row"
};
const $94face8235f32de8$var$_hoisted_3 = {
    class: "col-xxs-12 col-md-6"
};
const $94face8235f32de8$var$_hoisted_4 = {
    class: "col-xxs-12 col-md-6"
};
const $94face8235f32de8$var$_hoisted_5 = {
    class: "container-fluid"
};
const $94face8235f32de8$var$_hoisted_6 = {
    class: "row"
};
const $94face8235f32de8$var$_hoisted_7 = {
    class: "col-xxs-12"
};
const $94face8235f32de8$var$_hoisted_8 = {
    class: "row"
};
const $94face8235f32de8$var$_hoisted_9 = {
    class: "col-xxs-12"
};
const $94face8235f32de8$var$_hoisted_10 = {
    class: "supporting-btns"
};
const $94face8235f32de8$var$_hoisted_11 = {
    class: "row"
};
const $94face8235f32de8$var$_hoisted_12 = {
    class: "col-xxs-12"
};
function $94face8235f32de8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $aoXob.openBlock)(), (0, $aoXob.createElementBlock)("div", $94face8235f32de8$var$_hoisted_1, [
        (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_2, [
            (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_3, [
                (0, $aoXob.createVNode)($setup["ColorMixer"], {
                    "scroll-to-mixer": $setup.scrollToMixer,
                    "color-data": $setup.selectedColors
                }, null, 8, [
                    "scroll-to-mixer",
                    "color-data"
                ]),
                (0, $aoXob.createVNode)($setup["LearnMoreLink"], {
                    link: $setup.learnMoreLink
                }, null, 8, [
                    "link"
                ]),
                (0, $aoXob.createVNode)($setup["SelectRubberType"], {
                    "active-rubber-type": $setup.activeRubberType,
                    "rubber-types": $setup.rubberTypes,
                    "onRubberType:change": $setup.handleRubberTypeChange
                }, null, 8, [
                    "active-rubber-type",
                    "rubber-types"
                ])
            ]),
            (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_4, [
                (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_5, [
                    (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_6, [
                        (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_7, [
                            (0, $aoXob.createVNode)($setup["AllBreakouts"], {
                                "active-colors": $setup.activeColors,
                                "selected-colors": $setup.selectedColors,
                                "flyout-instructions": $setup.flyoutInstructions,
                                "onBreakout:select:color": $setup.handleBreakoutSelectColor,
                                "onBreakout:change:color": $setup.handleBreakoutChangeColor,
                                "onBreakout:update:percentage": $setup.handleBreakoutUpdatePercentage,
                                "onBreakout:trash": $setup.handleBreakoutTrashColor,
                                "onBreakouts:percentages:equalize": $setup.handleBreakoutsEqualizePercentages,
                                "onBreakouts:view:mixer": $setup.handleBreakoutsViewMixer
                            }, null, 8, [
                                "active-colors",
                                "selected-colors",
                                "flyout-instructions"
                            ])
                        ])
                    ]),
                    (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_8, [
                        (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_9, [
                            (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_10, [
                                (0, $aoXob.createVNode)($setup["BtnGetAQuote"], {
                                    "color-data": $setup.selectedColors
                                }, null, 8, [
                                    "color-data"
                                ]),
                                (0, $aoXob.createVNode)($setup["BtnDownloadColorMix"], {
                                    "color-data": $setup.selectedColors,
                                    "site-logo-url": $setup.siteLogoUrl,
                                    "pdf-text-disclaimer": $setup.pdfTextDisclaimer,
                                    "pdf-text-contact": $setup.pdfTextContact
                                }, null, 8, [
                                    "color-data",
                                    "site-logo-url",
                                    "pdf-text-disclaimer",
                                    "pdf-text-contact"
                                ])
                            ])
                        ])
                    ]),
                    (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_11, [
                        (0, $aoXob.createElementVNode)("div", $94face8235f32de8$var$_hoisted_12, [
                            (0, $aoXob.createVNode)($setup["DisclaimerAside"], {
                                text: $setup.disclaimerText
                            }, null, 8, [
                                "text"
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

});

parcelRequire.register("2G1u1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f30a78f0f5cac6a$export$2e2bcd8739ae039; });
let $1f30a78f0f5cac6a$var$NOOP = ()=>{};
var $1f30a78f0f5cac6a$export$2e2bcd8739ae039 = (script)=>{};

});

var $34430b858c65c570$exports = {};

(parcelRequire("d8HMG")).register(JSON.parse('{"8E1Vu":"shortcode-color-mixer.js","7XKT1":"tippy.esm.70ad70b7.js","8Aqq7":"jspdf.es.min.41a2f522.js","4HeSv":"html2canvas.0d666092.js","fjg36":"purify.fdaac3b5.js","70eXa":"index.es.609e29d9.js","04IP8":"shortcode-color-mixer.css"}'));

/* eslint-disable no-underscore-dangle */ parcelRequire("ldOcC");
var $br4tA = parcelRequire("br4tA");
let $829adf6691809467$var$script;




let $829adf6691809467$var$initialize = ()=>{
    $829adf6691809467$var$script = (parcelRequire("5x98t"));
    if ($829adf6691809467$var$script.__esModule) $829adf6691809467$var$script = $829adf6691809467$var$script.default;
    $829adf6691809467$var$script.render = (parcelRequire("cN0XE")).render;
    $829adf6691809467$var$script.__cssModules = {};
    (parcelRequire("2G1u1")).default($829adf6691809467$var$script);
    $829adf6691809467$var$script.__scopeId = "data-v-836457";
    $829adf6691809467$var$script.__file = "App.vue";
};
$829adf6691809467$var$initialize();
var $829adf6691809467$export$2e2bcd8739ae039 = $829adf6691809467$var$script;


// @see https://github.com/parcel-bundler/parcel/issues/6628
globalThis.__VUE_OPTIONS_API__ = false;
globalThis.__VUE_PROD_DEVTOOLS__ = false;
const $f3fbf2ee029d8f9e$var$app = (0, $br4tA.createApp)((0, $829adf6691809467$export$2e2bcd8739ae039));
$f3fbf2ee029d8f9e$var$app.mount("#color-mixer");

})();
//# sourceMappingURL=shortcode-color-mixer.js.map
